import { a as e, c as t, i as n, l as r, o as i, r as a, s as o, t as s, u as c } from "./FlxChatWrapper-ChfRUIEo.js";
import { n as l, t as u } from "./PortalContainerContext-Cz7eWR3N.js";
import { i as d, n as f, o as p, r as m, t as h } from "./SuspensePending-BrrR_cQq.js";
import { a as g, d as _, f as v, g as y, h as b, i as x, n as S, o as C, r as w, s as ee, t as te, u as ne, w as re } from "./useVoiceUpload-5WFawI3J.js";
import { t as ie } from "./FlxTaskManager-Dsv5_GJC.js";
import * as ae from "react";
import oe, { Suspense as se, createContext as ce, memo as T, startTransition as le, useCallback as E, useContext as ue, useEffect as de, useLayoutEffect as fe, useMemo as D, useRef as O, useState as pe } from "react";
import * as me from "observable-hooks";
import { useObservable as he, useObservableState as ge, useSubscription as _e } from "observable-hooks";
import * as ve from "@flowx/core-sdk";
import { ChatMessageType as ye, ComponentIdentifierEnum as be, DefaultMessageType as xe, SseMessageType as Se, SseTaskEventType as Ce, SseTaskMessageType as we, TaskActions as Te, activeChatSessionIdStore as Ee, addComponentsToRegistry as De, addInterceptors as Oe, addProcessEndFunc as ke, addProcessStartFunc as Ae, addToNavigationStack as je, allActiveNodesAndContexts$ as Me, buildMessageTimeGroupLabels as Ne, canNavigateToTemplateConfig$ as Pe, canPopSubprocess$ as Fe, chatRendererAnalyticsConfigs as Ie, chatStore as Le, closeModal as Re, config as ze, conversationsListPaginationStore as Be, createCollectionChildDecorationCache as Ve, decorateCollectionChildren as He, dismissProcess as Ue, emitScreenAnalytics as We, fetchBulkAssignees as Ge, fetchDocument as Ke, fetchTaskAssignees as qe, fetchTaskComments as Je, fetchTaskHistory as Ye, fetchView as Xe, fetchViewTasks as Ze, formatDateWithAppSettings as Qe, formatMessageTimestamp as $e, getActiveUiFlowSessionId as et, getComponentDefinition as tt, getCurrentReadOnlyState as nt, getCurrentRootTemplateConfig$ as rt, getCustomComponents as it, getEnumeration as at, getEnumerationOptions as ot, getLastAgentSuggestions as st, getOpenModal as ct, getReusableTestDataStore as lt, getRootTemplateConfigForId as ut, getStaticAsset as dt, getStaticAssetByKey as ft, getStaticAssetByKeyTrimmed as pt, getSubstitutionTag as mt, getTaskManagerResources as ht, getTemplateConfigByFlowxUuid as gt, getUiFlowBlockedLabels as _t, getUiFlowGlobalTemplateConfigs as vt, getUiFlowRestoredProcessEmbedded as yt, getUiFlowTemplateConfigs as bt, getUrlQueryParamValue as xt, groupSessionsByDate as St, hideToast as Ct, initChat as wt, initChatSession as Tt, initProcess as Et, initReusableTest as Dt, initSseConnection as Ot, initTestCustomComponentRuntime as kt, initUiFlow as At, isGlobalConfigVisibleForRoot as jt, isRootTemplateConfig as Mt, isUserTaskRoot as Nt, loadChatSessionHistory as Pt, loadConversationsList as Ft, loadMoreConversations as It, localizeString as k, mockTemplateConfig as Lt, navigateToTemplateConfig as Rt, navigationStack as zt, normalizeSuggestedPrompts as Bt, openModal$ as Vt, popSubprocessFromNavigation as Ht, processNotificationsByActiveProcess$ as Ut, processReloadGenerationStore as Wt, readOnlyScreenTemplateConfig$ as Gt, removeComment as Kt, resetChatStores as qt, resetComponentDefinitionRegistry as Jt, resetNavigationStack as Yt, resetStores as Xt, resetUiFlowStores as Zt, resolveMessageActionsConfig as Qt, resolveMessageTimestamp as $t, resolveRootNavigationQueryParams as en, saveComment as tn, screenAnalyticsOnDisplay$ as nn, screenTemplateConfig$ as rn, setAccessToken as an, setActiveChatSessionId as on, snapshotAndClearNavigationStack as sn, startNewUiFlowSession as cn, templateConfigsByParentTemplateId$ as ln, templateSequenceStore as un, triggerDisplayEvent as dn, uiFlowBlockedReason$ as fn, uiFlowGlobalTemplateConfigsForCurrentRoot$ as pn, uiFlowProcessStore as mn, uiFlowRestoredProcessEmbedded$ as hn, uiFlowTemplates$ as gn, uiStore$ as _n, updateBulkTaskAction as vn, updateTaskAction as yn, updateTaskPriority as bn, updateUrlWithQueryParam as xn, updateUrlWithQueryParams as Sn, urlUpdate$ as Cn, viewNavigationStack$ as wn, whenUiFlowSteady as Tn } from "@flowx/core-sdk";
import * as En from "clsx";
import Dn, { clsx as On } from "clsx";
import kn from "lodash/isEqual";
import * as An from "rxjs";
import { EMPTY as jn, combineLatest as Mn, concatMap as Nn, debounceTime as Pn, defer as Fn, distinctUntilChanged as In, filter as Ln, from as Rn, map as zn, of as Bn, shareReplay as Vn, skip as Hn, switchMap as Un, withLatestFrom as Wn } from "rxjs";
import * as Gn from "@flowx/core-theme";
import { ThemeComponent as A, computePosition as Kn } from "@flowx/core-theme";
import * as qn from "@flowx/react-theme";
import { getIconAsset as Jn, getThemingClassName as j, useCustomStyles as Yn, useLayoutStyles as Xn } from "@flowx/react-theme";
import * as Zn from "@flowx/react-ui-toolkit";
import { FlxBreadcrumbs as Qn, FlxButton as $n, FlxChat as er, FlxChatHeader as tr, FlxChatHistory as nr, FlxChatHistoryItem as rr, FlxChatHistorySection as ir, FlxChatInput as ar, FlxChatMessage as or, FlxChatMessageActions as sr, FlxChatMessageFeedback as cr, FlxChatMessages as lr, FlxChatReasoning as ur, FlxChatSuggestedPrompts as dr, FlxIcon as fr, FlxModal as pr, FlxSpinner as mr, FlxToast as hr, MemoFlxCard as gr, MemoFlxCardContent as _r, MemoFlxIcon as vr, MemoFlxMessage as yr, Tooltip as br, getFileExtension as xr } from "@flowx/react-ui-toolkit";
import * as Sr from "react-dom";
import { createPortal as Cr } from "react-dom";
import { Fragment as wr, jsx as M, jsxs as Tr } from "react/jsx-runtime";
import * as Er from "valtio";
import * as Dr from "lodash";
import { ErrorBoundary as Or, getErrorMessage as kr } from "react-error-boundary";
import * as Ar from "@internationalized/date";
import * as jr from "ag-grid-community";
import * as Mr from "ag-grid-react";
import * as Nr from "date-fns";
import * as Pr from "react-dom/client";
import { AlertDialog as Fr } from "@base-ui/react/alert-dialog";
import './src.css';//#region libs/sdk/react/src/components/ui-wrapper/toast/ToastWrapper.tsx
var Ir = _n.pipe(zn((e) => e.toasts)), Lr = () => {
	let e = ge(Ir, []), t = j(A.Message) || "", n = D(() => {
		let e = Jn(A.Message, "successIcon"), t = Jn(A.Message, "errorIcon");
		return {
			success: /* @__PURE__ */ M(vr, {
				name: "success",
				path: e ? ft(e) : void 0,
				className: "type-icon"
			}),
			error: /* @__PURE__ */ M(vr, {
				name: "error",
				path: t ? ft(t) : void 0,
				className: "type-icon"
			})
		};
	}, []), r = l();
	if (e.length === 0) return null;
	let i = /* @__PURE__ */ M("ul", {
		role: "region",
		"aria-label": "Notifications",
		className: "container-wrapper",
		children: e.map((e, r) => {
			let i = e.withTheme ? n[e.messageType || xe] : null;
			return /* @__PURE__ */ M(hr, {
				data: e,
				"data-testid": e?.title,
				onCloseToast: () => {
					Ct(r);
				},
				className: On({
					[t]: e.withTheme,
					"fill with-theme": e.withTheme
				}),
				iconComponent: i
			}, r);
		})
	});
	return Cr(i, r ?? document.body);
};
//#endregion
//#region libs/sdk/react/src/components/sdk/custom-component/FlxCustomComponentErrorBoundary.tsx
function Rr({ error: e }) {
	let t = kr(e) ?? "Unknown error";
	return /* @__PURE__ */ Tr("div", {
		className: "flx-cc-error",
		children: [/* @__PURE__ */ M("strong", { children: "Component error" }), /* @__PURE__ */ M("div", {
			className: "flx-cc-error-message",
			children: t
		})]
	});
}
var zr = T(function({ componentIdentifier: e, children: t }) {
	let n = D(() => [e], [e]), r = E((t, n) => {
		console.error(`[FlowX] Custom component "${e}" crashed during rendering:`, t, n.componentStack);
	}, [e]);
	return /* @__PURE__ */ M(Or, {
		FallbackComponent: Rr,
		resetKeys: n,
		onError: r,
		children: t
	});
}), N;
(function(e) {
	e[e.NONE = 0] = "NONE", e[e._abstract = 1] = "_abstract", e[e._accessor = 2] = "_accessor", e[e._as = 3] = "_as", e[e._assert = 4] = "_assert", e[e._asserts = 5] = "_asserts", e[e._async = 6] = "_async", e[e._await = 7] = "_await", e[e._checks = 8] = "_checks", e[e._constructor = 9] = "_constructor", e[e._declare = 10] = "_declare", e[e._enum = 11] = "_enum", e[e._exports = 12] = "_exports", e[e._from = 13] = "_from", e[e._get = 14] = "_get", e[e._global = 15] = "_global", e[e._implements = 16] = "_implements", e[e._infer = 17] = "_infer", e[e._interface = 18] = "_interface", e[e._is = 19] = "_is", e[e._keyof = 20] = "_keyof", e[e._mixins = 21] = "_mixins", e[e._module = 22] = "_module", e[e._namespace = 23] = "_namespace", e[e._of = 24] = "_of", e[e._opaque = 25] = "_opaque", e[e._out = 26] = "_out", e[e._override = 27] = "_override", e[e._private = 28] = "_private", e[e._protected = 29] = "_protected", e[e._proto = 30] = "_proto", e[e._public = 31] = "_public", e[e._readonly = 32] = "_readonly", e[e._require = 33] = "_require", e[e._satisfies = 34] = "_satisfies", e[e._set = 35] = "_set", e[e._static = 36] = "_static", e[e._symbol = 37] = "_symbol", e[e._type = 38] = "_type", e[e._unique = 39] = "_unique", e[e._using = 40] = "_using";
})(N ||= {});
//#endregion
//#region node_modules/sucrase/dist/esm/parser/tokenizer/types.js
/* istanbul ignore file */
var P;
(function(e) {
	e[e.PRECEDENCE_MASK = 15] = "PRECEDENCE_MASK", e[e.IS_KEYWORD = 16] = "IS_KEYWORD", e[e.IS_ASSIGN = 32] = "IS_ASSIGN", e[e.IS_RIGHT_ASSOCIATIVE = 64] = "IS_RIGHT_ASSOCIATIVE", e[e.IS_PREFIX = 128] = "IS_PREFIX", e[e.IS_POSTFIX = 256] = "IS_POSTFIX", e[e.IS_EXPRESSION_START = 512] = "IS_EXPRESSION_START", e[e.num = 512] = "num", e[e.bigint = 1536] = "bigint", e[e.decimal = 2560] = "decimal", e[e.regexp = 3584] = "regexp", e[e.string = 4608] = "string", e[e.name = 5632] = "name", e[e.eof = 6144] = "eof", e[e.bracketL = 7680] = "bracketL", e[e.bracketR = 8192] = "bracketR", e[e.braceL = 9728] = "braceL", e[e.braceBarL = 10752] = "braceBarL", e[e.braceR = 11264] = "braceR", e[e.braceBarR = 12288] = "braceBarR", e[e.parenL = 13824] = "parenL", e[e.parenR = 14336] = "parenR", e[e.comma = 15360] = "comma", e[e.semi = 16384] = "semi", e[e.colon = 17408] = "colon", e[e.doubleColon = 18432] = "doubleColon", e[e.dot = 19456] = "dot", e[e.question = 20480] = "question", e[e.questionDot = 21504] = "questionDot", e[e.arrow = 22528] = "arrow", e[e.template = 23552] = "template", e[e.ellipsis = 24576] = "ellipsis", e[e.backQuote = 25600] = "backQuote", e[e.dollarBraceL = 27136] = "dollarBraceL", e[e.at = 27648] = "at", e[e.hash = 29184] = "hash", e[e.eq = 29728] = "eq", e[e.assign = 30752] = "assign", e[e.preIncDec = 32640] = "preIncDec", e[e.postIncDec = 33664] = "postIncDec", e[e.bang = 34432] = "bang", e[e.tilde = 35456] = "tilde", e[e.pipeline = 35841] = "pipeline", e[e.nullishCoalescing = 36866] = "nullishCoalescing", e[e.logicalOR = 37890] = "logicalOR", e[e.logicalAND = 38915] = "logicalAND", e[e.bitwiseOR = 39940] = "bitwiseOR", e[e.bitwiseXOR = 40965] = "bitwiseXOR", e[e.bitwiseAND = 41990] = "bitwiseAND", e[e.equality = 43015] = "equality", e[e.lessThan = 44040] = "lessThan", e[e.greaterThan = 45064] = "greaterThan", e[e.relationalOrEqual = 46088] = "relationalOrEqual", e[e.bitShiftL = 47113] = "bitShiftL", e[e.bitShiftR = 48137] = "bitShiftR", e[e.plus = 49802] = "plus", e[e.minus = 50826] = "minus", e[e.modulo = 51723] = "modulo", e[e.star = 52235] = "star", e[e.slash = 53259] = "slash", e[e.exponent = 54348] = "exponent", e[e.jsxName = 55296] = "jsxName", e[e.jsxText = 56320] = "jsxText", e[e.jsxEmptyText = 57344] = "jsxEmptyText", e[e.jsxTagStart = 58880] = "jsxTagStart", e[e.jsxTagEnd = 59392] = "jsxTagEnd", e[e.typeParameterStart = 60928] = "typeParameterStart", e[e.nonNullAssertion = 61440] = "nonNullAssertion", e[e._break = 62480] = "_break", e[e._case = 63504] = "_case", e[e._catch = 64528] = "_catch", e[e._continue = 65552] = "_continue", e[e._debugger = 66576] = "_debugger", e[e._default = 67600] = "_default", e[e._do = 68624] = "_do", e[e._else = 69648] = "_else", e[e._finally = 70672] = "_finally", e[e._for = 71696] = "_for", e[e._function = 73232] = "_function", e[e._if = 73744] = "_if", e[e._return = 74768] = "_return", e[e._switch = 75792] = "_switch", e[e._throw = 77456] = "_throw", e[e._try = 77840] = "_try", e[e._var = 78864] = "_var", e[e._let = 79888] = "_let", e[e._const = 80912] = "_const", e[e._while = 81936] = "_while", e[e._with = 82960] = "_with", e[e._new = 84496] = "_new", e[e._this = 85520] = "_this", e[e._super = 86544] = "_super", e[e._class = 87568] = "_class", e[e._extends = 88080] = "_extends", e[e._export = 89104] = "_export", e[e._import = 90640] = "_import", e[e._yield = 91664] = "_yield", e[e._null = 92688] = "_null", e[e._true = 93712] = "_true", e[e._false = 94736] = "_false", e[e._in = 95256] = "_in", e[e._instanceof = 96280] = "_instanceof", e[e._typeof = 97936] = "_typeof", e[e._void = 98960] = "_void", e[e._delete = 99984] = "_delete", e[e._async = 100880] = "_async", e[e._get = 101904] = "_get", e[e._set = 102928] = "_set", e[e._declare = 103952] = "_declare", e[e._readonly = 104976] = "_readonly", e[e._abstract = 106e3] = "_abstract", e[e._static = 107024] = "_static", e[e._public = 107536] = "_public", e[e._private = 108560] = "_private", e[e._protected = 109584] = "_protected", e[e._override = 110608] = "_override", e[e._as = 112144] = "_as", e[e._enum = 113168] = "_enum", e[e._type = 114192] = "_type", e[e._implements = 115216] = "_implements";
})(P ||= {});
function Br(e) {
	switch (e) {
		case P.num: return "num";
		case P.bigint: return "bigint";
		case P.decimal: return "decimal";
		case P.regexp: return "regexp";
		case P.string: return "string";
		case P.name: return "name";
		case P.eof: return "eof";
		case P.bracketL: return "[";
		case P.bracketR: return "]";
		case P.braceL: return "{";
		case P.braceBarL: return "{|";
		case P.braceR: return "}";
		case P.braceBarR: return "|}";
		case P.parenL: return "(";
		case P.parenR: return ")";
		case P.comma: return ",";
		case P.semi: return ";";
		case P.colon: return ":";
		case P.doubleColon: return "::";
		case P.dot: return ".";
		case P.question: return "?";
		case P.questionDot: return "?.";
		case P.arrow: return "=>";
		case P.template: return "template";
		case P.ellipsis: return "...";
		case P.backQuote: return "`";
		case P.dollarBraceL: return "${";
		case P.at: return "@";
		case P.hash: return "#";
		case P.eq: return "=";
		case P.assign: return "_=";
		case P.preIncDec: return "++/--";
		case P.postIncDec: return "++/--";
		case P.bang: return "!";
		case P.tilde: return "~";
		case P.pipeline: return "|>";
		case P.nullishCoalescing: return "??";
		case P.logicalOR: return "||";
		case P.logicalAND: return "&&";
		case P.bitwiseOR: return "|";
		case P.bitwiseXOR: return "^";
		case P.bitwiseAND: return "&";
		case P.equality: return "==/!=";
		case P.lessThan: return "<";
		case P.greaterThan: return ">";
		case P.relationalOrEqual: return "<=/>=";
		case P.bitShiftL: return "<<";
		case P.bitShiftR: return ">>/>>>";
		case P.plus: return "+";
		case P.minus: return "-";
		case P.modulo: return "%";
		case P.star: return "*";
		case P.slash: return "/";
		case P.exponent: return "**";
		case P.jsxName: return "jsxName";
		case P.jsxText: return "jsxText";
		case P.jsxEmptyText: return "jsxEmptyText";
		case P.jsxTagStart: return "jsxTagStart";
		case P.jsxTagEnd: return "jsxTagEnd";
		case P.typeParameterStart: return "typeParameterStart";
		case P.nonNullAssertion: return "nonNullAssertion";
		case P._break: return "break";
		case P._case: return "case";
		case P._catch: return "catch";
		case P._continue: return "continue";
		case P._debugger: return "debugger";
		case P._default: return "default";
		case P._do: return "do";
		case P._else: return "else";
		case P._finally: return "finally";
		case P._for: return "for";
		case P._function: return "function";
		case P._if: return "if";
		case P._return: return "return";
		case P._switch: return "switch";
		case P._throw: return "throw";
		case P._try: return "try";
		case P._var: return "var";
		case P._let: return "let";
		case P._const: return "const";
		case P._while: return "while";
		case P._with: return "with";
		case P._new: return "new";
		case P._this: return "this";
		case P._super: return "super";
		case P._class: return "class";
		case P._extends: return "extends";
		case P._export: return "export";
		case P._import: return "import";
		case P._yield: return "yield";
		case P._null: return "null";
		case P._true: return "true";
		case P._false: return "false";
		case P._in: return "in";
		case P._instanceof: return "instanceof";
		case P._typeof: return "typeof";
		case P._void: return "void";
		case P._delete: return "delete";
		case P._async: return "async";
		case P._get: return "get";
		case P._set: return "set";
		case P._declare: return "declare";
		case P._readonly: return "readonly";
		case P._abstract: return "abstract";
		case P._static: return "static";
		case P._public: return "public";
		case P._private: return "private";
		case P._protected: return "protected";
		case P._override: return "override";
		case P._as: return "as";
		case P._enum: return "enum";
		case P._type: return "type";
		case P._implements: return "implements";
		default: return "";
	}
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/tokenizer/state.js
var Vr = class {
	constructor(e, t, n) {
		this.startTokenIndex = e, this.endTokenIndex = t, this.isFunctionScope = n;
	}
}, Hr = class {
	constructor(e, t, n, r, i, a, o, s, c, l, u, d, f) {
		this.potentialArrowAt = e, this.noAnonFunctionType = t, this.inDisallowConditionalTypesContext = n, this.tokensLength = r, this.scopesLength = i, this.pos = a, this.type = o, this.contextualKeyword = s, this.start = c, this.end = l, this.isType = u, this.scopeDepth = d, this.error = f;
	}
}, Ur = class e {
	constructor() {
		e.prototype.__init.call(this), e.prototype.__init2.call(this), e.prototype.__init3.call(this), e.prototype.__init4.call(this), e.prototype.__init5.call(this), e.prototype.__init6.call(this), e.prototype.__init7.call(this), e.prototype.__init8.call(this), e.prototype.__init9.call(this), e.prototype.__init10.call(this), e.prototype.__init11.call(this), e.prototype.__init12.call(this), e.prototype.__init13.call(this);
	}
	__init() {
		this.potentialArrowAt = -1;
	}
	__init2() {
		this.noAnonFunctionType = !1;
	}
	__init3() {
		this.inDisallowConditionalTypesContext = !1;
	}
	__init4() {
		this.tokens = [];
	}
	__init5() {
		this.scopes = [];
	}
	__init6() {
		this.pos = 0;
	}
	__init7() {
		this.type = P.eof;
	}
	__init8() {
		this.contextualKeyword = N.NONE;
	}
	__init9() {
		this.start = 0;
	}
	__init10() {
		this.end = 0;
	}
	__init11() {
		this.isType = !1;
	}
	__init12() {
		this.scopeDepth = 0;
	}
	__init13() {
		this.error = null;
	}
	snapshot() {
		return new Hr(this.potentialArrowAt, this.noAnonFunctionType, this.inDisallowConditionalTypesContext, this.tokens.length, this.scopes.length, this.pos, this.type, this.contextualKeyword, this.start, this.end, this.isType, this.scopeDepth, this.error);
	}
	restoreFromSnapshot(e) {
		this.potentialArrowAt = e.potentialArrowAt, this.noAnonFunctionType = e.noAnonFunctionType, this.inDisallowConditionalTypesContext = e.inDisallowConditionalTypesContext, this.tokens.length = e.tokensLength, this.scopes.length = e.scopesLength, this.pos = e.pos, this.type = e.type, this.contextualKeyword = e.contextualKeyword, this.start = e.start, this.end = e.end, this.isType = e.isType, this.scopeDepth = e.scopeDepth, this.error = e.error;
	}
}, F;
(function(e) {
	e[e.backSpace = 8] = "backSpace", e[e.lineFeed = 10] = "lineFeed", e[e.tab = 9] = "tab", e[e.carriageReturn = 13] = "carriageReturn", e[e.shiftOut = 14] = "shiftOut", e[e.space = 32] = "space", e[e.exclamationMark = 33] = "exclamationMark", e[e.quotationMark = 34] = "quotationMark", e[e.numberSign = 35] = "numberSign", e[e.dollarSign = 36] = "dollarSign", e[e.percentSign = 37] = "percentSign", e[e.ampersand = 38] = "ampersand", e[e.apostrophe = 39] = "apostrophe", e[e.leftParenthesis = 40] = "leftParenthesis", e[e.rightParenthesis = 41] = "rightParenthesis", e[e.asterisk = 42] = "asterisk", e[e.plusSign = 43] = "plusSign", e[e.comma = 44] = "comma", e[e.dash = 45] = "dash", e[e.dot = 46] = "dot", e[e.slash = 47] = "slash", e[e.digit0 = 48] = "digit0", e[e.digit1 = 49] = "digit1", e[e.digit2 = 50] = "digit2", e[e.digit3 = 51] = "digit3", e[e.digit4 = 52] = "digit4", e[e.digit5 = 53] = "digit5", e[e.digit6 = 54] = "digit6", e[e.digit7 = 55] = "digit7", e[e.digit8 = 56] = "digit8", e[e.digit9 = 57] = "digit9", e[e.colon = 58] = "colon", e[e.semicolon = 59] = "semicolon", e[e.lessThan = 60] = "lessThan", e[e.equalsTo = 61] = "equalsTo", e[e.greaterThan = 62] = "greaterThan", e[e.questionMark = 63] = "questionMark", e[e.atSign = 64] = "atSign", e[e.uppercaseA = 65] = "uppercaseA", e[e.uppercaseB = 66] = "uppercaseB", e[e.uppercaseC = 67] = "uppercaseC", e[e.uppercaseD = 68] = "uppercaseD", e[e.uppercaseE = 69] = "uppercaseE", e[e.uppercaseF = 70] = "uppercaseF", e[e.uppercaseG = 71] = "uppercaseG", e[e.uppercaseH = 72] = "uppercaseH", e[e.uppercaseI = 73] = "uppercaseI", e[e.uppercaseJ = 74] = "uppercaseJ", e[e.uppercaseK = 75] = "uppercaseK", e[e.uppercaseL = 76] = "uppercaseL", e[e.uppercaseM = 77] = "uppercaseM", e[e.uppercaseN = 78] = "uppercaseN", e[e.uppercaseO = 79] = "uppercaseO", e[e.uppercaseP = 80] = "uppercaseP", e[e.uppercaseQ = 81] = "uppercaseQ", e[e.uppercaseR = 82] = "uppercaseR", e[e.uppercaseS = 83] = "uppercaseS", e[e.uppercaseT = 84] = "uppercaseT", e[e.uppercaseU = 85] = "uppercaseU", e[e.uppercaseV = 86] = "uppercaseV", e[e.uppercaseW = 87] = "uppercaseW", e[e.uppercaseX = 88] = "uppercaseX", e[e.uppercaseY = 89] = "uppercaseY", e[e.uppercaseZ = 90] = "uppercaseZ", e[e.leftSquareBracket = 91] = "leftSquareBracket", e[e.backslash = 92] = "backslash", e[e.rightSquareBracket = 93] = "rightSquareBracket", e[e.caret = 94] = "caret", e[e.underscore = 95] = "underscore", e[e.graveAccent = 96] = "graveAccent", e[e.lowercaseA = 97] = "lowercaseA", e[e.lowercaseB = 98] = "lowercaseB", e[e.lowercaseC = 99] = "lowercaseC", e[e.lowercaseD = 100] = "lowercaseD", e[e.lowercaseE = 101] = "lowercaseE", e[e.lowercaseF = 102] = "lowercaseF", e[e.lowercaseG = 103] = "lowercaseG", e[e.lowercaseH = 104] = "lowercaseH", e[e.lowercaseI = 105] = "lowercaseI", e[e.lowercaseJ = 106] = "lowercaseJ", e[e.lowercaseK = 107] = "lowercaseK", e[e.lowercaseL = 108] = "lowercaseL", e[e.lowercaseM = 109] = "lowercaseM", e[e.lowercaseN = 110] = "lowercaseN", e[e.lowercaseO = 111] = "lowercaseO", e[e.lowercaseP = 112] = "lowercaseP", e[e.lowercaseQ = 113] = "lowercaseQ", e[e.lowercaseR = 114] = "lowercaseR", e[e.lowercaseS = 115] = "lowercaseS", e[e.lowercaseT = 116] = "lowercaseT", e[e.lowercaseU = 117] = "lowercaseU", e[e.lowercaseV = 118] = "lowercaseV", e[e.lowercaseW = 119] = "lowercaseW", e[e.lowercaseX = 120] = "lowercaseX", e[e.lowercaseY = 121] = "lowercaseY", e[e.lowercaseZ = 122] = "lowercaseZ", e[e.leftCurlyBrace = 123] = "leftCurlyBrace", e[e.verticalBar = 124] = "verticalBar", e[e.rightCurlyBrace = 125] = "rightCurlyBrace", e[e.tilde = 126] = "tilde", e[e.nonBreakingSpace = 160] = "nonBreakingSpace", e[e.oghamSpaceMark = 5760] = "oghamSpaceMark", e[e.lineSeparator = 8232] = "lineSeparator", e[e.paragraphSeparator = 8233] = "paragraphSeparator";
})(F ||= {});
//#endregion
//#region node_modules/sucrase/dist/esm/parser/traverser/base.js
var Wr, I, L, R, z, Gr;
function Kr() {
	return Gr++;
}
function qr(e) {
	if ("pos" in e) {
		let t = Yr(e.pos);
		e.message += ` (${t.line}:${t.column})`, e.loc = t;
	}
	return e;
}
var Jr = class {
	constructor(e, t) {
		this.line = e, this.column = t;
	}
};
function Yr(e) {
	let t = 1, n = 1;
	for (let r = 0; r < e; r++) z.charCodeAt(r) === F.lineFeed ? (t++, n = 1) : n++;
	return new Jr(t, n);
}
function Xr(e, t, n, r) {
	z = e, R = new Ur(), Gr = 1, Wr = t, I = n, L = r;
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/traverser/util.js
function B(e) {
	return R.contextualKeyword === e;
}
function Zr(e) {
	let t = Ei();
	return t.type === P.name && t.contextualKeyword === e;
}
function Qr(e) {
	return R.contextualKeyword === e && q(P.name);
}
function $r(e) {
	Qr(e) || H();
}
function ei() {
	return J(P.eof) || J(P.braceR) || ti();
}
function ti() {
	let e = R.tokens[R.tokens.length - 1], t = e ? e.end : 0;
	for (let e = t; e < R.start; e++) {
		let t = z.charCodeAt(e);
		if (t === F.lineFeed || t === F.carriageReturn || t === 8232 || t === 8233) return !0;
	}
	return !1;
}
function ni() {
	let e = Di();
	for (let t = R.end; t < e; t++) {
		let e = z.charCodeAt(t);
		if (e === F.lineFeed || e === F.carriageReturn || e === 8232 || e === 8233) return !0;
	}
	return !1;
}
function ri() {
	return q(P.semi) || ei();
}
function ii() {
	ri() || H("Unexpected token, expected \";\"");
}
function V(e) {
	q(e) || H(`Unexpected token, expected "${Br(e)}"`);
}
function H(e = "Unexpected token", t = R.start) {
	if (R.error) return;
	let n = SyntaxError(e);
	n.pos = t, R.error = n, R.pos = z.length, Y(P.eof);
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/util/whitespace.js
var ai = [
	9,
	11,
	12,
	F.space,
	F.nonBreakingSpace,
	F.oghamSpaceMark,
	8192,
	8193,
	8194,
	8195,
	8196,
	8197,
	8198,
	8199,
	8200,
	8201,
	8202,
	8239,
	8287,
	12288,
	65279
], oi = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, si = /* @__PURE__ */ new Uint8Array(65536);
for (let e of ai) si[e] = 1;
//#endregion
//#region node_modules/sucrase/dist/esm/parser/util/identifier.js
function ci(e) {
	if (e < 48) return e === 36;
	if (e < 58) return !0;
	if (e < 65) return !1;
	if (e < 91) return !0;
	if (e < 97) return e === 95;
	if (e < 123) return !0;
	if (e < 128) return !1;
	throw Error("Should not be called with non-ASCII char code.");
}
var li = /* @__PURE__ */ new Uint8Array(65536);
for (let e = 0; e < 128; e++) li[e] = +!!ci(e);
for (let e = 128; e < 65536; e++) li[e] = 1;
for (let e of ai) li[e] = 0;
li[8232] = 0, li[8233] = 0;
var ui = li.slice();
for (let e = F.digit0; e <= F.digit9; e++) ui[e] = 0;
//#endregion
//#region node_modules/sucrase/dist/esm/parser/tokenizer/readWordTree.js
var di = new Int32Array([
	-1,
	27,
	783,
	918,
	1755,
	2376,
	2862,
	3483,
	-1,
	3699,
	-1,
	4617,
	4752,
	4833,
	5130,
	5508,
	5940,
	-1,
	6480,
	6939,
	7749,
	8181,
	8451,
	8613,
	-1,
	8829,
	-1,
	-1,
	-1,
	54,
	243,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	432,
	-1,
	-1,
	-1,
	675,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	81,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	108,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	135,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	162,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	189,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	216,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._abstract << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	270,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	297,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	324,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	351,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	378,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	405,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._accessor << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._as << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	459,
	-1,
	-1,
	-1,
	-1,
	-1,
	594,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	486,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	513,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	540,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._assert << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	567,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._asserts << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	621,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	648,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._async << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	702,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	729,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	756,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._await << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	810,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	837,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	864,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	891,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._break << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	945,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1107,
	-1,
	-1,
	-1,
	1242,
	-1,
	-1,
	1350,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	972,
	1026,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	999,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._case << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1053,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1080,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._catch << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1134,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1161,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1188,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1215,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._checks << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1269,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1296,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1323,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._class << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1377,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1404,
	1620,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1431,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._const << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1458,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1485,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1512,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1539,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1566,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1593,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._constructor << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1647,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1674,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1701,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1728,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._continue << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1782,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2349,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1809,
	1971,
	-1,
	-1,
	2106,
	-1,
	-1,
	-1,
	-1,
	-1,
	2241,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1836,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1863,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1890,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1917,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1944,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._debugger << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1998,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2025,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2052,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2079,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._declare << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2133,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2160,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2187,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2214,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._default << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2268,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2295,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2322,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._delete << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._do << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2403,
	-1,
	2484,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2565,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2430,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2457,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._else << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2511,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2538,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._enum << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2592,
	-1,
	-1,
	-1,
	2727,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2619,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2646,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2673,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._export << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2700,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._exports << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2754,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2781,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2808,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2835,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._extends << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2889,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2997,
	-1,
	-1,
	-1,
	-1,
	-1,
	3159,
	-1,
	-1,
	3213,
	-1,
	-1,
	3294,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2916,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2943,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2970,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._false << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3024,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3051,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3078,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3105,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3132,
	-1,
	(P._finally << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3186,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._for << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3240,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3267,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._from << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3321,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3348,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3375,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3402,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3429,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3456,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._function << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3510,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3564,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3537,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._get << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3591,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3618,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3645,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3672,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._global << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3726,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3753,
	4077,
	-1,
	-1,
	-1,
	-1,
	4590,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._if << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3780,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3807,
	-1,
	-1,
	3996,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3834,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3861,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3888,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3915,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3942,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3969,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._implements << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4023,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4050,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._import << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._in << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4104,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4185,
	4401,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4131,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4158,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._infer << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4212,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4239,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4266,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4293,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4320,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4347,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4374,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._instanceof << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4428,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4455,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4482,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4509,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4536,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4563,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._interface << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._is << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4644,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4671,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4698,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4725,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._keyof << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4779,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4806,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._let << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4860,
	-1,
	-1,
	-1,
	-1,
	-1,
	4995,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4887,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4914,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4941,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4968,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._mixins << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5022,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5049,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5076,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5103,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._module << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5157,
	-1,
	-1,
	-1,
	5373,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5427,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5184,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5211,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5238,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5265,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5292,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5319,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5346,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._namespace << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5400,
	-1,
	-1,
	-1,
	(P._new << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5454,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5481,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._null << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5535,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5562,
	-1,
	-1,
	-1,
	-1,
	5697,
	5751,
	-1,
	-1,
	-1,
	-1,
	N._of << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5589,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5616,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5643,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5670,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._opaque << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5724,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._out << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5778,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5805,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5832,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5859,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5886,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5913,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._override << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5967,
	-1,
	-1,
	6345,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5994,
	-1,
	-1,
	-1,
	-1,
	-1,
	6129,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6021,
	-1,
	-1,
	-1,
	-1,
	-1,
	6048,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6075,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6102,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._private << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6156,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6183,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6318,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6210,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6237,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6264,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6291,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._protected << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._proto << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6372,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6399,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6426,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6453,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._public << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6507,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6534,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6696,
	-1,
	-1,
	6831,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6561,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6588,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6615,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6642,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6669,
	-1,
	N._readonly << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6723,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6750,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6777,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6804,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._require << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6858,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6885,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6912,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._return << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6966,
	-1,
	-1,
	-1,
	7182,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7236,
	7371,
	-1,
	7479,
	-1,
	7614,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6993,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7020,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7047,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7074,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7101,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7128,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7155,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._satisfies << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7209,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._set << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7263,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7290,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7317,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7344,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._static << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7398,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7425,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7452,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._super << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7506,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7533,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7560,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7587,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._switch << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7641,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7668,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7695,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7722,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._symbol << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7776,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7938,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8046,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7803,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7857,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7830,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._this << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7884,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7911,
	-1,
	-1,
	-1,
	(P._throw << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7965,
	-1,
	-1,
	-1,
	8019,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7992,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._true << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._try << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8073,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8100,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._type << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8127,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8154,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._typeof << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8208,
	-1,
	-1,
	-1,
	-1,
	8343,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8235,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8262,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8289,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8316,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._unique << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8370,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8397,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8424,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	N._using << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8478,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8532,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8505,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._var << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8559,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8586,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._void << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8640,
	8748,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8667,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8694,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8721,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._while << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8775,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8802,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._with << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8856,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8883,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8910,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8937,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(P._yield << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1
]);
//#endregion
//#region node_modules/sucrase/dist/esm/parser/tokenizer/readWord.js
function fi() {
	let e = 0, t = 0, n = R.pos;
	for (; n < z.length && (t = z.charCodeAt(n), !(t < F.lowercaseA || t > F.lowercaseZ));) {
		let r = di[e + (t - F.lowercaseA) + 1];
		if (r === -1) break;
		e = r, n++;
	}
	let r = di[e];
	if (r > -1 && !li[t]) {
		R.pos = n, r & 1 ? Y(r >>> 1) : Y(P.name, r >>> 1);
		return;
	}
	for (; n < z.length;) {
		let e = z.charCodeAt(n);
		if (li[e]) n++;
		else if (e === F.backslash) {
			if (n += 2, z.charCodeAt(n) === F.leftCurlyBrace) {
				for (; n < z.length && z.charCodeAt(n) !== F.rightCurlyBrace;) n++;
				n++;
			}
		} else if (e === F.atSign && z.charCodeAt(n + 1) === F.atSign) n += 2;
		else break;
	}
	R.pos = n, Y(P.name);
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/tokenizer/index.js
var U;
(function(e) {
	e[e.Access = 0] = "Access", e[e.ExportAccess = 1] = "ExportAccess", e[e.TopLevelDeclaration = 2] = "TopLevelDeclaration", e[e.FunctionScopedDeclaration = 3] = "FunctionScopedDeclaration", e[e.BlockScopedDeclaration = 4] = "BlockScopedDeclaration", e[e.ObjectShorthandTopLevelDeclaration = 5] = "ObjectShorthandTopLevelDeclaration", e[e.ObjectShorthandFunctionScopedDeclaration = 6] = "ObjectShorthandFunctionScopedDeclaration", e[e.ObjectShorthandBlockScopedDeclaration = 7] = "ObjectShorthandBlockScopedDeclaration", e[e.ObjectShorthand = 8] = "ObjectShorthand", e[e.ImportDeclaration = 9] = "ImportDeclaration", e[e.ObjectKey = 10] = "ObjectKey", e[e.ImportAccess = 11] = "ImportAccess";
})(U ||= {});
var pi;
(function(e) {
	e[e.NoChildren = 0] = "NoChildren", e[e.OneChild = 1] = "OneChild", e[e.StaticChildren = 2] = "StaticChildren", e[e.KeyAfterPropSpread = 3] = "KeyAfterPropSpread";
})(pi ||= {});
function mi(e) {
	let t = e.identifierRole;
	return t === U.TopLevelDeclaration || t === U.FunctionScopedDeclaration || t === U.BlockScopedDeclaration || t === U.ObjectShorthandTopLevelDeclaration || t === U.ObjectShorthandFunctionScopedDeclaration || t === U.ObjectShorthandBlockScopedDeclaration;
}
function hi(e) {
	let t = e.identifierRole;
	return t === U.FunctionScopedDeclaration || t === U.BlockScopedDeclaration || t === U.ObjectShorthandFunctionScopedDeclaration || t === U.ObjectShorthandBlockScopedDeclaration;
}
function gi(e) {
	let t = e.identifierRole;
	return t === U.TopLevelDeclaration || t === U.ObjectShorthandTopLevelDeclaration || t === U.ImportDeclaration;
}
function _i(e) {
	let t = e.identifierRole;
	return t === U.TopLevelDeclaration || t === U.BlockScopedDeclaration || t === U.ObjectShorthandTopLevelDeclaration || t === U.ObjectShorthandBlockScopedDeclaration;
}
function vi(e) {
	let t = e.identifierRole;
	return t === U.FunctionScopedDeclaration || t === U.ObjectShorthandFunctionScopedDeclaration;
}
function yi(e) {
	return e.identifierRole === U.ObjectShorthandTopLevelDeclaration || e.identifierRole === U.ObjectShorthandBlockScopedDeclaration || e.identifierRole === U.ObjectShorthandFunctionScopedDeclaration;
}
var bi = class {
	constructor() {
		this.type = R.type, this.contextualKeyword = R.contextualKeyword, this.start = R.start, this.end = R.end, this.scopeDepth = R.scopeDepth, this.isType = R.isType, this.identifierRole = null, this.jsxRole = null, this.shadowsGlobal = !1, this.isAsyncOperation = !1, this.contextId = null, this.rhsEndIndex = null, this.isExpression = !1, this.numNullishCoalesceStarts = 0, this.numNullishCoalesceEnds = 0, this.isOptionalChainStart = !1, this.isOptionalChainEnd = !1, this.subscriptStartIndex = null, this.nullishStartIndex = null;
	}
};
function W() {
	R.tokens.push(new bi()), Ai();
}
function xi() {
	R.tokens.push(new bi()), R.start = R.pos, Qi();
}
function Si() {
	R.type === P.assign && --R.pos, qi();
}
function G(e) {
	for (let t = R.tokens.length - e; t < R.tokens.length; t++) R.tokens[t].isType = !0;
	let t = R.isType;
	return R.isType = !0, t;
}
function K(e) {
	R.isType = e;
}
function q(e) {
	return J(e) ? (W(), !0) : !1;
}
function Ci(e) {
	let t = R.isType;
	R.isType = !0, q(e), R.isType = t;
}
function J(e) {
	return R.type === e;
}
function wi() {
	let e = R.snapshot();
	W();
	let t = R.type;
	return R.restoreFromSnapshot(e), t;
}
var Ti = class {
	constructor(e, t) {
		this.type = e, this.contextualKeyword = t;
	}
};
function Ei() {
	let e = R.snapshot();
	W();
	let t = R.type, n = R.contextualKeyword;
	return R.restoreFromSnapshot(e), new Ti(t, n);
}
function Di() {
	return Oi(R.pos);
}
function Oi(e) {
	return oi.lastIndex = e, e + oi.exec(z)[0].length;
}
function ki() {
	return z.charCodeAt(Di());
}
function Ai() {
	if (Pi(), R.start = R.pos, R.pos >= z.length) {
		let e = R.tokens;
		e.length >= 2 && e[e.length - 1].start >= z.length && e[e.length - 2].start >= z.length && H("Unexpectedly reached the end of input."), Y(P.eof);
		return;
	}
	ji(z.charCodeAt(R.pos));
}
function ji(e) {
	ui[e] || e === F.backslash || e === F.atSign && z.charCodeAt(R.pos + 1) === F.atSign ? fi() : Ki(e);
}
function Mi() {
	for (; z.charCodeAt(R.pos) !== F.asterisk || z.charCodeAt(R.pos + 1) !== F.slash;) if (R.pos++, R.pos > z.length) {
		H("Unterminated comment", R.pos - 2);
		return;
	}
	R.pos += 2;
}
function Ni(e) {
	let t = z.charCodeAt(R.pos += e);
	if (R.pos < z.length) for (; t !== F.lineFeed && t !== F.carriageReturn && t !== F.lineSeparator && t !== F.paragraphSeparator && ++R.pos < z.length;) t = z.charCodeAt(R.pos);
}
function Pi() {
	for (; R.pos < z.length;) {
		let e = z.charCodeAt(R.pos);
		switch (e) {
			case F.carriageReturn: z.charCodeAt(R.pos + 1) === F.lineFeed && ++R.pos;
			case F.lineFeed:
			case F.lineSeparator:
			case F.paragraphSeparator:
				++R.pos;
				break;
			case F.slash:
				switch (z.charCodeAt(R.pos + 1)) {
					case F.asterisk:
						R.pos += 2, Mi();
						break;
					case F.slash:
						Ni(2);
						break;
					default: return;
				}
				break;
			default: if (si[e]) ++R.pos;
			else return;
		}
	}
}
function Y(e, t = N.NONE) {
	R.end = R.pos, R.type = e, R.contextualKeyword = t;
}
function Fi() {
	let e = z.charCodeAt(R.pos + 1);
	if (e >= F.digit0 && e <= F.digit9) {
		Xi(!0);
		return;
	}
	e === F.dot && z.charCodeAt(R.pos + 2) === F.dot ? (R.pos += 3, Y(P.ellipsis)) : (++R.pos, Y(P.dot));
}
function Ii() {
	z.charCodeAt(R.pos + 1) === F.equalsTo ? X(P.assign, 2) : X(P.slash, 1);
}
function Li(e) {
	let t = e === F.asterisk ? P.star : P.modulo, n = 1, r = z.charCodeAt(R.pos + 1);
	e === F.asterisk && r === F.asterisk && (n++, r = z.charCodeAt(R.pos + 2), t = P.exponent), r === F.equalsTo && z.charCodeAt(R.pos + 2) !== F.greaterThan && (n++, t = P.assign), X(t, n);
}
function Ri(e) {
	let t = z.charCodeAt(R.pos + 1);
	if (t === e) {
		z.charCodeAt(R.pos + 2) === F.equalsTo ? X(P.assign, 3) : X(e === F.verticalBar ? P.logicalOR : P.logicalAND, 2);
		return;
	}
	if (e === F.verticalBar) {
		if (t === F.greaterThan) {
			X(P.pipeline, 2);
			return;
		}
		if (t === F.rightCurlyBrace && L) {
			X(P.braceBarR, 2);
			return;
		}
	}
	if (t === F.equalsTo) {
		X(P.assign, 2);
		return;
	}
	X(e === F.verticalBar ? P.bitwiseOR : P.bitwiseAND, 1);
}
function zi() {
	z.charCodeAt(R.pos + 1) === F.equalsTo ? X(P.assign, 2) : X(P.bitwiseXOR, 1);
}
function Bi(e) {
	let t = z.charCodeAt(R.pos + 1);
	if (t === e) {
		X(P.preIncDec, 2);
		return;
	}
	t === F.equalsTo ? X(P.assign, 2) : e === F.plusSign ? X(P.plus, 1) : X(P.minus, 1);
}
function Vi() {
	let e = z.charCodeAt(R.pos + 1);
	if (e === F.lessThan) {
		if (z.charCodeAt(R.pos + 2) === F.equalsTo) {
			X(P.assign, 3);
			return;
		}
		R.isType ? X(P.lessThan, 1) : X(P.bitShiftL, 2);
		return;
	}
	e === F.equalsTo ? X(P.relationalOrEqual, 2) : X(P.lessThan, 1);
}
function Hi() {
	if (R.isType) {
		X(P.greaterThan, 1);
		return;
	}
	let e = z.charCodeAt(R.pos + 1);
	if (e === F.greaterThan) {
		let e = z.charCodeAt(R.pos + 2) === F.greaterThan ? 3 : 2;
		if (z.charCodeAt(R.pos + e) === F.equalsTo) {
			X(P.assign, e + 1);
			return;
		}
		X(P.bitShiftR, e);
		return;
	}
	e === F.equalsTo ? X(P.relationalOrEqual, 2) : X(P.greaterThan, 1);
}
function Ui() {
	R.type === P.greaterThan && (--R.pos, Hi());
}
function Wi(e) {
	let t = z.charCodeAt(R.pos + 1);
	if (t === F.equalsTo) {
		X(P.equality, z.charCodeAt(R.pos + 2) === F.equalsTo ? 3 : 2);
		return;
	}
	if (e === F.equalsTo && t === F.greaterThan) {
		R.pos += 2, Y(P.arrow);
		return;
	}
	X(e === F.equalsTo ? P.eq : P.bang, 1);
}
function Gi() {
	let e = z.charCodeAt(R.pos + 1), t = z.charCodeAt(R.pos + 2);
	e === F.questionMark && !(L && R.isType) ? t === F.equalsTo ? X(P.assign, 3) : X(P.nullishCoalescing, 2) : e === F.dot && !(t >= F.digit0 && t <= F.digit9) ? (R.pos += 2, Y(P.questionDot)) : (++R.pos, Y(P.question));
}
function Ki(e) {
	switch (e) {
		case F.numberSign:
			++R.pos, Y(P.hash);
			return;
		case F.dot:
			Fi();
			return;
		case F.leftParenthesis:
			++R.pos, Y(P.parenL);
			return;
		case F.rightParenthesis:
			++R.pos, Y(P.parenR);
			return;
		case F.semicolon:
			++R.pos, Y(P.semi);
			return;
		case F.comma:
			++R.pos, Y(P.comma);
			return;
		case F.leftSquareBracket:
			++R.pos, Y(P.bracketL);
			return;
		case F.rightSquareBracket:
			++R.pos, Y(P.bracketR);
			return;
		case F.leftCurlyBrace:
			L && z.charCodeAt(R.pos + 1) === F.verticalBar ? X(P.braceBarL, 2) : (++R.pos, Y(P.braceL));
			return;
		case F.rightCurlyBrace:
			++R.pos, Y(P.braceR);
			return;
		case F.colon:
			z.charCodeAt(R.pos + 1) === F.colon ? X(P.doubleColon, 2) : (++R.pos, Y(P.colon));
			return;
		case F.questionMark:
			Gi();
			return;
		case F.atSign:
			++R.pos, Y(P.at);
			return;
		case F.graveAccent:
			++R.pos, Y(P.backQuote);
			return;
		case F.digit0: {
			let e = z.charCodeAt(R.pos + 1);
			if (e === F.lowercaseX || e === F.uppercaseX || e === F.lowercaseO || e === F.uppercaseO || e === F.lowercaseB || e === F.uppercaseB) {
				Yi();
				return;
			}
		}
		case F.digit1:
		case F.digit2:
		case F.digit3:
		case F.digit4:
		case F.digit5:
		case F.digit6:
		case F.digit7:
		case F.digit8:
		case F.digit9:
			Xi(!1);
			return;
		case F.quotationMark:
		case F.apostrophe:
			Zi(e);
			return;
		case F.slash:
			Ii();
			return;
		case F.percentSign:
		case F.asterisk:
			Li(e);
			return;
		case F.verticalBar:
		case F.ampersand:
			Ri(e);
			return;
		case F.caret:
			zi();
			return;
		case F.plusSign:
		case F.dash:
			Bi(e);
			return;
		case F.lessThan:
			Vi();
			return;
		case F.greaterThan:
			Hi();
			return;
		case F.equalsTo:
		case F.exclamationMark:
			Wi(e);
			return;
		case F.tilde:
			X(P.tilde, 1);
			return;
	}
	H(`Unexpected character '${String.fromCharCode(e)}'`, R.pos);
}
function X(e, t) {
	R.pos += t, Y(e);
}
function qi() {
	let e = R.pos, t = !1, n = !1;
	for (;;) {
		if (R.pos >= z.length) {
			H("Unterminated regular expression", e);
			return;
		}
		let r = z.charCodeAt(R.pos);
		if (t) t = !1;
		else {
			if (r === F.leftSquareBracket) n = !0;
			else if (r === F.rightSquareBracket && n) n = !1;
			else if (r === F.slash && !n) break;
			t = r === F.backslash;
		}
		++R.pos;
	}
	++R.pos, $i(), Y(P.regexp);
}
function Ji() {
	for (;;) {
		let e = z.charCodeAt(R.pos);
		if (e >= F.digit0 && e <= F.digit9 || e === F.underscore) R.pos++;
		else break;
	}
}
function Yi() {
	for (R.pos += 2;;) {
		let e = z.charCodeAt(R.pos);
		if (e >= F.digit0 && e <= F.digit9 || e >= F.lowercaseA && e <= F.lowercaseF || e >= F.uppercaseA && e <= F.uppercaseF || e === F.underscore) R.pos++;
		else break;
	}
	z.charCodeAt(R.pos) === F.lowercaseN ? (++R.pos, Y(P.bigint)) : Y(P.num);
}
function Xi(e) {
	let t = !1, n = !1;
	e || Ji();
	let r = z.charCodeAt(R.pos);
	if (r === F.dot && (++R.pos, Ji(), r = z.charCodeAt(R.pos)), (r === F.uppercaseE || r === F.lowercaseE) && (r = z.charCodeAt(++R.pos), (r === F.plusSign || r === F.dash) && ++R.pos, Ji(), r = z.charCodeAt(R.pos)), r === F.lowercaseN ? (++R.pos, t = !0) : r === F.lowercaseM && (++R.pos, n = !0), t) {
		Y(P.bigint);
		return;
	}
	if (n) {
		Y(P.decimal);
		return;
	}
	Y(P.num);
}
function Zi(e) {
	for (R.pos++;;) {
		if (R.pos >= z.length) {
			H("Unterminated string constant");
			return;
		}
		let t = z.charCodeAt(R.pos);
		if (t === F.backslash) R.pos++;
		else if (t === e) break;
		R.pos++;
	}
	R.pos++, Y(P.string);
}
function Qi() {
	for (;;) {
		if (R.pos >= z.length) {
			H("Unterminated template");
			return;
		}
		let e = z.charCodeAt(R.pos);
		if (e === F.graveAccent || e === F.dollarSign && z.charCodeAt(R.pos + 1) === F.leftCurlyBrace) {
			if (R.pos === R.start && J(P.template)) {
				if (e === F.dollarSign) {
					R.pos += 2, Y(P.dollarBraceL);
					return;
				}
				++R.pos, Y(P.backQuote);
				return;
			}
			Y(P.template);
			return;
		}
		e === F.backslash && R.pos++, R.pos++;
	}
}
function $i() {
	for (; R.pos < z.length;) {
		let e = z.charCodeAt(R.pos);
		if (li[e]) R.pos++;
		else if (e === F.backslash) {
			if (R.pos += 2, z.charCodeAt(R.pos) === F.leftCurlyBrace) {
				for (; R.pos < z.length && z.charCodeAt(R.pos) !== F.rightCurlyBrace;) R.pos++;
				R.pos++;
			}
		} else break;
	}
}
//#endregion
//#region node_modules/sucrase/dist/esm/util/getImportExportSpecifierInfo.js
function ea(e, t = e.currentIndex()) {
	let n = t + 1;
	if (ta(e, n)) {
		let r = e.identifierNameAtIndex(t);
		return {
			isType: !1,
			leftName: r,
			rightName: r,
			endIndex: n
		};
	}
	if (n++, ta(e, n)) return {
		isType: !0,
		leftName: null,
		rightName: null,
		endIndex: n
	};
	if (n++, ta(e, n)) return {
		isType: !1,
		leftName: e.identifierNameAtIndex(t),
		rightName: e.identifierNameAtIndex(t + 2),
		endIndex: n
	};
	if (n++, ta(e, n)) return {
		isType: !0,
		leftName: null,
		rightName: null,
		endIndex: n
	};
	throw Error(`Unexpected import/export specifier at ${t}`);
}
function ta(e, t) {
	let n = e.tokens[t];
	return n.type === P.braceR || n.type === P.comma;
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/plugins/jsx/xhtml.js
var na = /* @__PURE__ */ new Map([
	["quot", "\""],
	["amp", "&"],
	["apos", "'"],
	["lt", "<"],
	["gt", ">"],
	["nbsp", "\xA0"],
	["iexcl", "¡"],
	["cent", "¢"],
	["pound", "£"],
	["curren", "¤"],
	["yen", "¥"],
	["brvbar", "¦"],
	["sect", "§"],
	["uml", "¨"],
	["copy", "©"],
	["ordf", "ª"],
	["laquo", "«"],
	["not", "¬"],
	["shy", "­"],
	["reg", "®"],
	["macr", "¯"],
	["deg", "°"],
	["plusmn", "±"],
	["sup2", "²"],
	["sup3", "³"],
	["acute", "´"],
	["micro", "µ"],
	["para", "¶"],
	["middot", "·"],
	["cedil", "¸"],
	["sup1", "¹"],
	["ordm", "º"],
	["raquo", "»"],
	["frac14", "¼"],
	["frac12", "½"],
	["frac34", "¾"],
	["iquest", "¿"],
	["Agrave", "À"],
	["Aacute", "Á"],
	["Acirc", "Â"],
	["Atilde", "Ã"],
	["Auml", "Ä"],
	["Aring", "Å"],
	["AElig", "Æ"],
	["Ccedil", "Ç"],
	["Egrave", "È"],
	["Eacute", "É"],
	["Ecirc", "Ê"],
	["Euml", "Ë"],
	["Igrave", "Ì"],
	["Iacute", "Í"],
	["Icirc", "Î"],
	["Iuml", "Ï"],
	["ETH", "Ð"],
	["Ntilde", "Ñ"],
	["Ograve", "Ò"],
	["Oacute", "Ó"],
	["Ocirc", "Ô"],
	["Otilde", "Õ"],
	["Ouml", "Ö"],
	["times", "×"],
	["Oslash", "Ø"],
	["Ugrave", "Ù"],
	["Uacute", "Ú"],
	["Ucirc", "Û"],
	["Uuml", "Ü"],
	["Yacute", "Ý"],
	["THORN", "Þ"],
	["szlig", "ß"],
	["agrave", "à"],
	["aacute", "á"],
	["acirc", "â"],
	["atilde", "ã"],
	["auml", "ä"],
	["aring", "å"],
	["aelig", "æ"],
	["ccedil", "ç"],
	["egrave", "è"],
	["eacute", "é"],
	["ecirc", "ê"],
	["euml", "ë"],
	["igrave", "ì"],
	["iacute", "í"],
	["icirc", "î"],
	["iuml", "ï"],
	["eth", "ð"],
	["ntilde", "ñ"],
	["ograve", "ò"],
	["oacute", "ó"],
	["ocirc", "ô"],
	["otilde", "õ"],
	["ouml", "ö"],
	["divide", "÷"],
	["oslash", "ø"],
	["ugrave", "ù"],
	["uacute", "ú"],
	["ucirc", "û"],
	["uuml", "ü"],
	["yacute", "ý"],
	["thorn", "þ"],
	["yuml", "ÿ"],
	["OElig", "Œ"],
	["oelig", "œ"],
	["Scaron", "Š"],
	["scaron", "š"],
	["Yuml", "Ÿ"],
	["fnof", "ƒ"],
	["circ", "ˆ"],
	["tilde", "˜"],
	["Alpha", "Α"],
	["Beta", "Β"],
	["Gamma", "Γ"],
	["Delta", "Δ"],
	["Epsilon", "Ε"],
	["Zeta", "Ζ"],
	["Eta", "Η"],
	["Theta", "Θ"],
	["Iota", "Ι"],
	["Kappa", "Κ"],
	["Lambda", "Λ"],
	["Mu", "Μ"],
	["Nu", "Ν"],
	["Xi", "Ξ"],
	["Omicron", "Ο"],
	["Pi", "Π"],
	["Rho", "Ρ"],
	["Sigma", "Σ"],
	["Tau", "Τ"],
	["Upsilon", "Υ"],
	["Phi", "Φ"],
	["Chi", "Χ"],
	["Psi", "Ψ"],
	["Omega", "Ω"],
	["alpha", "α"],
	["beta", "β"],
	["gamma", "γ"],
	["delta", "δ"],
	["epsilon", "ε"],
	["zeta", "ζ"],
	["eta", "η"],
	["theta", "θ"],
	["iota", "ι"],
	["kappa", "κ"],
	["lambda", "λ"],
	["mu", "μ"],
	["nu", "ν"],
	["xi", "ξ"],
	["omicron", "ο"],
	["pi", "π"],
	["rho", "ρ"],
	["sigmaf", "ς"],
	["sigma", "σ"],
	["tau", "τ"],
	["upsilon", "υ"],
	["phi", "φ"],
	["chi", "χ"],
	["psi", "ψ"],
	["omega", "ω"],
	["thetasym", "ϑ"],
	["upsih", "ϒ"],
	["piv", "ϖ"],
	["ensp", " "],
	["emsp", " "],
	["thinsp", " "],
	["zwnj", "‌"],
	["zwj", "‍"],
	["lrm", "‎"],
	["rlm", "‏"],
	["ndash", "–"],
	["mdash", "—"],
	["lsquo", "‘"],
	["rsquo", "’"],
	["sbquo", "‚"],
	["ldquo", "“"],
	["rdquo", "”"],
	["bdquo", "„"],
	["dagger", "†"],
	["Dagger", "‡"],
	["bull", "•"],
	["hellip", "…"],
	["permil", "‰"],
	["prime", "′"],
	["Prime", "″"],
	["lsaquo", "‹"],
	["rsaquo", "›"],
	["oline", "‾"],
	["frasl", "⁄"],
	["euro", "€"],
	["image", "ℑ"],
	["weierp", "℘"],
	["real", "ℜ"],
	["trade", "™"],
	["alefsym", "ℵ"],
	["larr", "←"],
	["uarr", "↑"],
	["rarr", "→"],
	["darr", "↓"],
	["harr", "↔"],
	["crarr", "↵"],
	["lArr", "⇐"],
	["uArr", "⇑"],
	["rArr", "⇒"],
	["dArr", "⇓"],
	["hArr", "⇔"],
	["forall", "∀"],
	["part", "∂"],
	["exist", "∃"],
	["empty", "∅"],
	["nabla", "∇"],
	["isin", "∈"],
	["notin", "∉"],
	["ni", "∋"],
	["prod", "∏"],
	["sum", "∑"],
	["minus", "−"],
	["lowast", "∗"],
	["radic", "√"],
	["prop", "∝"],
	["infin", "∞"],
	["ang", "∠"],
	["and", "∧"],
	["or", "∨"],
	["cap", "∩"],
	["cup", "∪"],
	["int", "∫"],
	["there4", "∴"],
	["sim", "∼"],
	["cong", "≅"],
	["asymp", "≈"],
	["ne", "≠"],
	["equiv", "≡"],
	["le", "≤"],
	["ge", "≥"],
	["sub", "⊂"],
	["sup", "⊃"],
	["nsub", "⊄"],
	["sube", "⊆"],
	["supe", "⊇"],
	["oplus", "⊕"],
	["otimes", "⊗"],
	["perp", "⊥"],
	["sdot", "⋅"],
	["lceil", "⌈"],
	["rceil", "⌉"],
	["lfloor", "⌊"],
	["rfloor", "⌋"],
	["lang", "〈"],
	["rang", "〉"],
	["loz", "◊"],
	["spades", "♠"],
	["clubs", "♣"],
	["hearts", "♥"],
	["diams", "♦"]
]);
//#endregion
//#region node_modules/sucrase/dist/esm/util/getJSXPragmaInfo.js
function ra(e) {
	let [t, n] = ia(e.jsxPragma || "React.createElement"), [r, i] = ia(e.jsxFragmentPragma || "React.Fragment");
	return {
		base: t,
		suffix: n,
		fragmentBase: r,
		fragmentSuffix: i
	};
}
function ia(e) {
	let t = e.indexOf(".");
	return t === -1 && (t = e.length), [e.slice(0, t), e.slice(t)];
}
//#endregion
//#region node_modules/sucrase/dist/esm/transformers/Transformer.js
var aa = class {
	getPrefixCode() {
		return "";
	}
	getHoistedCode() {
		return "";
	}
	getSuffixCode() {
		return "";
	}
}, oa = class e extends aa {
	__init() {
		this.lastLineNumber = 1;
	}
	__init2() {
		this.lastIndex = 0;
	}
	__init3() {
		this.filenameVarName = null;
	}
	__init4() {
		this.esmAutomaticImportNameResolutions = {};
	}
	__init5() {
		this.cjsAutomaticModuleNameResolutions = {};
	}
	constructor(t, n, r, i, a) {
		super(), this.rootTransformer = t, this.tokens = n, this.importProcessor = r, this.nameManager = i, this.options = a, e.prototype.__init.call(this), e.prototype.__init2.call(this), e.prototype.__init3.call(this), e.prototype.__init4.call(this), e.prototype.__init5.call(this), this.jsxPragmaInfo = ra(a), this.isAutomaticRuntime = a.jsxRuntime === "automatic", this.jsxImportSource = a.jsxImportSource || "react";
	}
	process() {
		return this.tokens.matches1(P.jsxTagStart) ? (this.processJSXTag(), !0) : !1;
	}
	getPrefixCode() {
		let e = "";
		if (this.filenameVarName && (e += `const ${this.filenameVarName} = ${JSON.stringify(this.options.filePath || "")};`), this.isAutomaticRuntime) {
			if (this.importProcessor) for (let [t, n] of Object.entries(this.cjsAutomaticModuleNameResolutions)) e += `var ${n} = require("${t}");`;
			else {
				let { createElement: t, ...n } = this.esmAutomaticImportNameResolutions;
				t && (e += `import {createElement as ${t}} from "${this.jsxImportSource}";`);
				let r = Object.entries(n).map(([e, t]) => `${e} as ${t}`).join(", ");
				if (r) {
					let t = this.jsxImportSource + (this.options.production ? "/jsx-runtime" : "/jsx-dev-runtime");
					e += `import {${r}} from "${t}";`;
				}
			}
		}
		return e;
	}
	processJSXTag() {
		let { jsxRole: e, start: t } = this.tokens.currentToken(), n = this.options.production ? null : this.getElementLocationCode(t);
		this.isAutomaticRuntime && e !== pi.KeyAfterPropSpread ? this.transformTagToJSXFunc(n, e) : this.transformTagToCreateElement(n);
	}
	getElementLocationCode(e) {
		return `lineNumber: ${this.getLineNumberForIndex(e)}`;
	}
	getLineNumberForIndex(e) {
		let t = this.tokens.code;
		for (; this.lastIndex < e && this.lastIndex < t.length;) t[this.lastIndex] === "\n" && this.lastLineNumber++, this.lastIndex++;
		return this.lastLineNumber;
	}
	transformTagToJSXFunc(e, t) {
		let n = t === pi.StaticChildren;
		this.tokens.replaceToken(this.getJSXFuncInvocationCode(n));
		let r = null;
		if (this.tokens.matches1(P.jsxTagEnd)) this.tokens.replaceToken(`${this.getFragmentCode()}, {`), this.processAutomaticChildrenAndEndProps(t);
		else {
			if (this.processTagIntro(), this.tokens.appendCode(", {"), r = this.processProps(!0), this.tokens.matches2(P.slash, P.jsxTagEnd)) this.tokens.appendCode("}");
			else if (this.tokens.matches1(P.jsxTagEnd)) this.tokens.removeToken(), this.processAutomaticChildrenAndEndProps(t);
			else throw Error("Expected either /> or > at the end of the tag.");
			r && this.tokens.appendCode(`, ${r}`);
		}
		for (this.options.production || (r === null && this.tokens.appendCode(", void 0"), this.tokens.appendCode(`, ${n}, ${this.getDevSource(e)}, this`)), this.tokens.removeInitialToken(); !this.tokens.matches1(P.jsxTagEnd);) this.tokens.removeToken();
		this.tokens.replaceToken(")");
	}
	transformTagToCreateElement(e) {
		if (this.tokens.replaceToken(this.getCreateElementInvocationCode()), this.tokens.matches1(P.jsxTagEnd)) this.tokens.replaceToken(`${this.getFragmentCode()}, null`), this.processChildren(!0);
		else if (this.processTagIntro(), this.processPropsObjectWithDevInfo(e), !this.tokens.matches2(P.slash, P.jsxTagEnd)) {
			if (this.tokens.matches1(P.jsxTagEnd)) this.tokens.removeToken(), this.processChildren(!0);
			else throw Error("Expected either /> or > at the end of the tag.");
		}
		for (this.tokens.removeInitialToken(); !this.tokens.matches1(P.jsxTagEnd);) this.tokens.removeToken();
		this.tokens.replaceToken(")");
	}
	getJSXFuncInvocationCode(e) {
		return this.options.production ? e ? this.claimAutoImportedFuncInvocation("jsxs", "/jsx-runtime") : this.claimAutoImportedFuncInvocation("jsx", "/jsx-runtime") : this.claimAutoImportedFuncInvocation("jsxDEV", "/jsx-dev-runtime");
	}
	getCreateElementInvocationCode() {
		if (this.isAutomaticRuntime) return this.claimAutoImportedFuncInvocation("createElement", "");
		{
			let { jsxPragmaInfo: e } = this;
			return `${this.importProcessor && this.importProcessor.getIdentifierReplacement(e.base) || e.base}${e.suffix}(`;
		}
	}
	getFragmentCode() {
		if (this.isAutomaticRuntime) return this.claimAutoImportedName("Fragment", this.options.production ? "/jsx-runtime" : "/jsx-dev-runtime");
		{
			let { jsxPragmaInfo: e } = this;
			return (this.importProcessor && this.importProcessor.getIdentifierReplacement(e.fragmentBase) || e.fragmentBase) + e.fragmentSuffix;
		}
	}
	claimAutoImportedFuncInvocation(e, t) {
		let n = this.claimAutoImportedName(e, t);
		return this.importProcessor ? `${n}.call(void 0, ` : `${n}(`;
	}
	claimAutoImportedName(e, t) {
		if (this.importProcessor) {
			let n = this.jsxImportSource + t;
			return this.cjsAutomaticModuleNameResolutions[n] || (this.cjsAutomaticModuleNameResolutions[n] = this.importProcessor.getFreeIdentifierForPath(n)), `${this.cjsAutomaticModuleNameResolutions[n]}.${e}`;
		}
		return this.esmAutomaticImportNameResolutions[e] || (this.esmAutomaticImportNameResolutions[e] = this.nameManager.claimFreeName(`_${e}`)), this.esmAutomaticImportNameResolutions[e];
	}
	processTagIntro() {
		let e = this.tokens.currentIndex() + 1;
		for (; this.tokens.tokens[e].isType || !this.tokens.matches2AtIndex(e - 1, P.jsxName, P.jsxName) && !this.tokens.matches2AtIndex(e - 1, P.greaterThan, P.jsxName) && !this.tokens.matches1AtIndex(e, P.braceL) && !this.tokens.matches1AtIndex(e, P.jsxTagEnd) && !this.tokens.matches2AtIndex(e, P.slash, P.jsxTagEnd);) e++;
		if (e === this.tokens.currentIndex() + 1) {
			let e = this.tokens.identifierName();
			sa(e) && this.tokens.replaceToken(`'${e}'`);
		}
		for (; this.tokens.currentIndex() < e;) this.rootTransformer.processToken();
	}
	processPropsObjectWithDevInfo(e) {
		let t = this.options.production ? "" : `__self: this, __source: ${this.getDevSource(e)}`;
		if (!this.tokens.matches1(P.jsxName) && !this.tokens.matches1(P.braceL)) {
			t ? this.tokens.appendCode(`, {${t}}`) : this.tokens.appendCode(", null");
			return;
		}
		this.tokens.appendCode(", {"), this.processProps(!1), t ? this.tokens.appendCode(` ${t}}`) : this.tokens.appendCode("}");
	}
	processProps(e) {
		let t = null;
		for (;;) {
			if (this.tokens.matches2(P.jsxName, P.eq)) {
				let n = this.tokens.identifierName();
				if (e && n === "key") {
					t !== null && this.tokens.appendCode(t.replace(/[^\n]/g, "")), this.tokens.removeToken(), this.tokens.removeToken();
					let e = this.tokens.snapshot();
					this.processPropValue(), t = this.tokens.dangerouslyGetAndRemoveCodeSinceSnapshot(e);
					continue;
				}
				this.processPropName(n), this.tokens.replaceToken(": "), this.processPropValue();
			} else if (this.tokens.matches1(P.jsxName)) {
				let e = this.tokens.identifierName();
				this.processPropName(e), this.tokens.appendCode(": true");
			} else if (this.tokens.matches1(P.braceL)) this.tokens.replaceToken(""), this.rootTransformer.processBalancedCode(), this.tokens.replaceToken("");
			else break;
			this.tokens.appendCode(",");
		}
		return t;
	}
	processPropName(e) {
		e.includes("-") ? this.tokens.replaceToken(`'${e}'`) : this.tokens.copyToken();
	}
	processPropValue() {
		this.tokens.matches1(P.braceL) ? (this.tokens.replaceToken(""), this.rootTransformer.processBalancedCode(), this.tokens.replaceToken("")) : this.tokens.matches1(P.jsxTagStart) ? this.processJSXTag() : this.processStringPropValue();
	}
	processStringPropValue() {
		let e = this.tokens.currentToken(), t = this.tokens.code.slice(e.start + 1, e.end - 1), n = la(t), r = ua(t);
		this.tokens.replaceToken(r + n);
	}
	processAutomaticChildrenAndEndProps(e) {
		e === pi.StaticChildren ? (this.tokens.appendCode(" children: ["), this.processChildren(!1), this.tokens.appendCode("]}")) : (e === pi.OneChild && this.tokens.appendCode(" children: "), this.processChildren(!1), this.tokens.appendCode("}"));
	}
	processChildren(e) {
		let t = e;
		for (;;) {
			if (this.tokens.matches2(P.jsxTagStart, P.slash)) return;
			let e = !1;
			if (this.tokens.matches1(P.braceL)) this.tokens.matches2(P.braceL, P.braceR) ? (this.tokens.replaceToken(""), this.tokens.replaceToken("")) : (this.tokens.replaceToken(t ? ", " : ""), this.rootTransformer.processBalancedCode(), this.tokens.replaceToken(""), e = !0);
			else if (this.tokens.matches1(P.jsxTagStart)) this.tokens.appendCode(t ? ", " : ""), this.processJSXTag(), e = !0;
			else if (this.tokens.matches1(P.jsxText) || this.tokens.matches1(P.jsxEmptyText)) e = this.processChildTextElement(t);
			else throw Error("Unexpected token when processing JSX children.");
			e && (t = !0);
		}
	}
	processChildTextElement(e) {
		let t = this.tokens.currentToken(), n = this.tokens.code.slice(t.start, t.end), r = la(n), i = ca(n);
		return i === "\"\"" ? (this.tokens.replaceToken(r), !1) : (this.tokens.replaceToken(`${e ? ", " : ""}${i}${r}`), !0);
	}
	getDevSource(e) {
		return `{fileName: ${this.getFilenameVarName()}, ${e}}`;
	}
	getFilenameVarName() {
		return this.filenameVarName ||= this.nameManager.claimFreeName("_jsxFileName"), this.filenameVarName;
	}
};
function sa(e) {
	let t = e.charCodeAt(0);
	return t >= F.lowercaseA && t <= F.lowercaseZ;
}
function ca(e) {
	let t = "", n = "", r = !1, i = !1;
	for (let a = 0; a < e.length; a++) {
		let o = e[a];
		if (o === " " || o === "	" || o === "\r") r || (n += o);
		else if (o === "\n") n = "", r = !0;
		else {
			if (i && r && (t += " "), t += n, n = "", o === "&") {
				let { entity: n, newI: r } = da(e, a + 1);
				a = r - 1, t += n;
			} else t += o;
			i = !0, r = !1;
		}
	}
	return r || (t += n), JSON.stringify(t);
}
function la(e) {
	let t = 0, n = 0;
	for (let r of e) r === "\n" ? (t++, n = 0) : r === " " && n++;
	return "\n".repeat(t) + " ".repeat(n);
}
function ua(e) {
	let t = "";
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		if (r === "\n") {
			if (/\s/.test(e[n + 1])) for (t += " "; n < e.length && /\s/.test(e[n + 1]);) n++;
			else t += "\n";
		} else if (r === "&") {
			let { entity: r, newI: i } = da(e, n + 1);
			t += r, n = i - 1;
		} else t += r;
	}
	return JSON.stringify(t);
}
function da(e, t) {
	let n = "", r = 0, i, a = t;
	if (e[a] === "#") {
		let t = 10;
		a++;
		let n;
		if (e[a] === "x") for (t = 16, a++, n = a; a < e.length && pa(e.charCodeAt(a));) a++;
		else for (n = a; a < e.length && fa(e.charCodeAt(a));) a++;
		if (e[a] === ";") {
			let r = e.slice(n, a);
			r && (a++, i = String.fromCodePoint(parseInt(r, t)));
		}
	} else for (; a < e.length && r++ < 10;) {
		let t = e[a];
		if (a++, t === ";") {
			i = na.get(n);
			break;
		}
		n += t;
	}
	return i ? {
		entity: i,
		newI: a
	} : {
		entity: "&",
		newI: t
	};
}
function fa(e) {
	return e >= F.digit0 && e <= F.digit9;
}
function pa(e) {
	return e >= F.digit0 && e <= F.digit9 || e >= F.lowercaseA && e <= F.lowercaseF || e >= F.uppercaseA && e <= F.uppercaseF;
}
//#endregion
//#region node_modules/sucrase/dist/esm/util/getNonTypeIdentifiers.js
function ma(e, t) {
	let n = ra(t), r = /* @__PURE__ */ new Set();
	for (let t = 0; t < e.tokens.length; t++) {
		let i = e.tokens[t];
		i.type === P.name && !i.isType && (i.identifierRole === U.Access || i.identifierRole === U.ObjectShorthand || i.identifierRole === U.ExportAccess) && !i.shadowsGlobal && r.add(e.identifierNameForToken(i)), i.type === P.jsxTagStart && r.add(n.base), i.type === P.jsxTagStart && t + 1 < e.tokens.length && e.tokens[t + 1].type === P.jsxTagEnd && (r.add(n.base), r.add(n.fragmentBase)), i.type === P.jsxName && i.identifierRole === U.Access && (!sa(e.identifierNameForToken(i)) || e.tokens[t + 1].type === P.dot) && r.add(e.identifierNameForToken(i));
	}
	return r;
}
//#endregion
//#region node_modules/sucrase/dist/esm/CJSImportProcessor.js
var ha = class e {
	__init() {
		this.nonTypeIdentifiers = /* @__PURE__ */ new Set();
	}
	__init2() {
		this.importInfoByPath = /* @__PURE__ */ new Map();
	}
	__init3() {
		this.importsToReplace = /* @__PURE__ */ new Map();
	}
	__init4() {
		this.identifierReplacements = /* @__PURE__ */ new Map();
	}
	__init5() {
		this.exportBindingsByLocalName = /* @__PURE__ */ new Map();
	}
	constructor(t, n, r, i, a, o, s) {
		this.nameManager = t, this.tokens = n, this.enableLegacyTypeScriptModuleInterop = r, this.options = i, this.isTypeScriptTransformEnabled = a, this.keepUnusedImports = o, this.helperManager = s, e.prototype.__init.call(this), e.prototype.__init2.call(this), e.prototype.__init3.call(this), e.prototype.__init4.call(this), e.prototype.__init5.call(this);
	}
	preprocessTokens() {
		for (let e = 0; e < this.tokens.tokens.length; e++) this.tokens.matches1AtIndex(e, P._import) && !this.tokens.matches3AtIndex(e, P._import, P.name, P.eq) && this.preprocessImportAtIndex(e), this.tokens.matches1AtIndex(e, P._export) && !this.tokens.matches2AtIndex(e, P._export, P.eq) && this.preprocessExportAtIndex(e);
		this.generateImportReplacements();
	}
	pruneTypeOnlyImports() {
		this.nonTypeIdentifiers = ma(this.tokens, this.options);
		for (let [e, t] of this.importInfoByPath.entries()) t.hasBareImport || t.hasStarExport || t.exportStarNames.length > 0 || t.namedExports.length > 0 || [
			...t.defaultNames,
			...t.wildcardNames,
			...t.namedImports.map(({ localName: e }) => e)
		].every((e) => this.shouldAutomaticallyElideImportedName(e)) && this.importsToReplace.set(e, "");
	}
	shouldAutomaticallyElideImportedName(e) {
		return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.nonTypeIdentifiers.has(e);
	}
	generateImportReplacements() {
		for (let [e, t] of this.importInfoByPath.entries()) {
			let { defaultNames: n, wildcardNames: r, namedImports: i, namedExports: a, exportStarNames: o, hasStarExport: s } = t;
			if (n.length === 0 && r.length === 0 && i.length === 0 && a.length === 0 && o.length === 0 && !s) {
				this.importsToReplace.set(e, `require('${e}');`);
				continue;
			}
			let c = this.getFreeIdentifierForPath(e), l;
			l = this.enableLegacyTypeScriptModuleInterop ? c : r.length > 0 ? r[0] : this.getFreeIdentifierForPath(e);
			let u = `var ${c} = require('${e}');`;
			if (r.length > 0) for (let e of r) {
				let t = this.enableLegacyTypeScriptModuleInterop ? c : `${this.helperManager.getHelperName("interopRequireWildcard")}(${c})`;
				u += ` var ${e} = ${t};`;
			}
			else o.length > 0 && l !== c ? u += ` var ${l} = ${this.helperManager.getHelperName("interopRequireWildcard")}(${c});` : n.length > 0 && l !== c && (u += ` var ${l} = ${this.helperManager.getHelperName("interopRequireDefault")}(${c});`);
			for (let { importedName: e, localName: t } of a) u += ` ${this.helperManager.getHelperName("createNamedExportFrom")}(${c}, '${t}', '${e}');`;
			for (let e of o) u += ` exports.${e} = ${l};`;
			s && (u += ` ${this.helperManager.getHelperName("createStarExport")}(${c});`), this.importsToReplace.set(e, u);
			for (let e of n) this.identifierReplacements.set(e, `${l}.default`);
			for (let { importedName: e, localName: t } of i) this.identifierReplacements.set(t, `${c}.${e}`);
		}
	}
	getFreeIdentifierForPath(e) {
		let t = e.split("/"), n = t[t.length - 1].replace(/\W/g, "");
		return this.nameManager.claimFreeName(`_${n}`);
	}
	preprocessImportAtIndex(e) {
		let t = [], n = [], r = [];
		if (e++, (this.tokens.matchesContextualAtIndex(e, N._type) || this.tokens.matches1AtIndex(e, P._typeof)) && !this.tokens.matches1AtIndex(e + 1, P.comma) && !this.tokens.matchesContextualAtIndex(e + 1, N._from) || this.tokens.matches1AtIndex(e, P.parenL)) return;
		if (this.tokens.matches1AtIndex(e, P.name) && (t.push(this.tokens.identifierNameAtIndex(e)), e++, this.tokens.matches1AtIndex(e, P.comma) && e++), this.tokens.matches1AtIndex(e, P.star) && (e += 2, n.push(this.tokens.identifierNameAtIndex(e)), e++), this.tokens.matches1AtIndex(e, P.braceL)) {
			let n = this.getNamedImports(e + 1);
			e = n.newIndex;
			for (let e of n.namedImports) e.importedName === "default" ? t.push(e.localName) : r.push(e);
		}
		if (this.tokens.matchesContextualAtIndex(e, N._from) && e++, !this.tokens.matches1AtIndex(e, P.string)) throw Error("Expected string token at the end of import statement.");
		let i = this.tokens.stringValueAtIndex(e), a = this.getImportInfo(i);
		a.defaultNames.push(...t), a.wildcardNames.push(...n), a.namedImports.push(...r), t.length === 0 && n.length === 0 && r.length === 0 && (a.hasBareImport = !0);
	}
	preprocessExportAtIndex(e) {
		if (this.tokens.matches2AtIndex(e, P._export, P._var) || this.tokens.matches2AtIndex(e, P._export, P._let) || this.tokens.matches2AtIndex(e, P._export, P._const)) this.preprocessVarExportAtIndex(e);
		else if (this.tokens.matches2AtIndex(e, P._export, P._function) || this.tokens.matches2AtIndex(e, P._export, P._class)) {
			let t = this.tokens.identifierNameAtIndex(e + 2);
			this.addExportBinding(t, t);
		} else if (this.tokens.matches3AtIndex(e, P._export, P.name, P._function)) {
			let t = this.tokens.identifierNameAtIndex(e + 3);
			this.addExportBinding(t, t);
		} else this.tokens.matches2AtIndex(e, P._export, P.braceL) ? this.preprocessNamedExportAtIndex(e) : this.tokens.matches2AtIndex(e, P._export, P.star) && this.preprocessExportStarAtIndex(e);
	}
	preprocessVarExportAtIndex(e) {
		let t = 0;
		for (let n = e + 2;; n++) if (this.tokens.matches1AtIndex(n, P.braceL) || this.tokens.matches1AtIndex(n, P.dollarBraceL) || this.tokens.matches1AtIndex(n, P.bracketL)) t++;
		else if (this.tokens.matches1AtIndex(n, P.braceR) || this.tokens.matches1AtIndex(n, P.bracketR)) t--;
		else if (t === 0 && !this.tokens.matches1AtIndex(n, P.name)) break;
		else if (this.tokens.matches1AtIndex(1, P.eq)) {
			let e = this.tokens.currentToken().rhsEndIndex;
			if (e == null) throw Error("Expected = token with an end index.");
			n = e - 1;
		} else {
			let e = this.tokens.tokens[n];
			if (mi(e)) {
				let e = this.tokens.identifierNameAtIndex(n);
				this.identifierReplacements.set(e, `exports.${e}`);
			}
		}
	}
	preprocessNamedExportAtIndex(e) {
		e += 2;
		let { newIndex: t, namedImports: n } = this.getNamedImports(e);
		if (e = t, this.tokens.matchesContextualAtIndex(e, N._from)) e++;
		else {
			for (let { importedName: e, localName: t } of n) this.addExportBinding(e, t);
			return;
		}
		if (!this.tokens.matches1AtIndex(e, P.string)) throw Error("Expected string token at the end of import statement.");
		let r = this.tokens.stringValueAtIndex(e);
		this.getImportInfo(r).namedExports.push(...n);
	}
	preprocessExportStarAtIndex(e) {
		let t = null;
		if (this.tokens.matches3AtIndex(e, P._export, P.star, P._as) ? (e += 3, t = this.tokens.identifierNameAtIndex(e), e += 2) : e += 3, !this.tokens.matches1AtIndex(e, P.string)) throw Error("Expected string token at the end of star export statement.");
		let n = this.tokens.stringValueAtIndex(e), r = this.getImportInfo(n);
		t === null ? r.hasStarExport = !0 : r.exportStarNames.push(t);
	}
	getNamedImports(e) {
		let t = [];
		for (;;) {
			if (this.tokens.matches1AtIndex(e, P.braceR)) {
				e++;
				break;
			}
			let n = ea(this.tokens, e);
			if (e = n.endIndex, n.isType || t.push({
				importedName: n.leftName,
				localName: n.rightName
			}), this.tokens.matches2AtIndex(e, P.comma, P.braceR)) {
				e += 2;
				break;
			}
			if (this.tokens.matches1AtIndex(e, P.braceR)) {
				e++;
				break;
			}
			if (this.tokens.matches1AtIndex(e, P.comma)) e++;
			else throw Error(`Unexpected token: ${JSON.stringify(this.tokens.tokens[e])}`);
		}
		return {
			newIndex: e,
			namedImports: t
		};
	}
	getImportInfo(e) {
		let t = this.importInfoByPath.get(e);
		if (t) return t;
		let n = {
			defaultNames: [],
			wildcardNames: [],
			namedImports: [],
			namedExports: [],
			hasBareImport: !1,
			exportStarNames: [],
			hasStarExport: !1
		};
		return this.importInfoByPath.set(e, n), n;
	}
	addExportBinding(e, t) {
		this.exportBindingsByLocalName.has(e) || this.exportBindingsByLocalName.set(e, []), this.exportBindingsByLocalName.get(e).push(t);
	}
	claimImportCode(e) {
		let t = this.importsToReplace.get(e);
		return this.importsToReplace.set(e, ""), t || "";
	}
	getIdentifierReplacement(e) {
		return this.identifierReplacements.get(e) || null;
	}
	resolveExportBinding(e) {
		let t = this.exportBindingsByLocalName.get(e);
		return !t || t.length === 0 ? null : t.map((e) => `exports.${e}`).join(" = ");
	}
	getGlobalNames() {
		return /* @__PURE__ */ new Set([...this.identifierReplacements.keys(), ...this.exportBindingsByLocalName.keys()]);
	}
}, ga = 44, _a = 59, va = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ya = /* @__PURE__ */ new Uint8Array(64), ba = /* @__PURE__ */ new Uint8Array(128);
for (let e = 0; e < va.length; e++) {
	let t = va.charCodeAt(e);
	ya[e] = t, ba[t] = e;
}
function xa(e, t) {
	do {
		let n = t & 31;
		t >>>= 5, t > 0 && (n |= 32), e.write(ya[n]);
	} while (t > 0);
}
function Sa(e) {
	return e < 0 ? -e << 1 | 1 : e << 1;
}
var Ca = 16384, wa = typeof TextDecoder < "u" ? /* @__PURE__ */ new TextDecoder() : typeof Buffer < "u" ? { decode(e) {
	return Buffer.from(e.buffer, e.byteOffset, e.byteLength).toString();
} } : { decode(e) {
	let t = "";
	for (let n = 0; n < e.length; n++) t += String.fromCharCode(e[n]);
	return t;
} }, Ta = class {
	constructor() {
		this.pos = 0, this.out = "", this.buffer = new Uint8Array(Ca);
	}
	write(e) {
		let { buffer: t } = this;
		t[this.pos++] = e, this.pos === Ca && (this.out += wa.decode(t), this.pos = 0);
	}
	flush() {
		let { buffer: e, out: t, pos: n } = this;
		return n > 0 ? t + wa.decode(e.subarray(0, n)) : t;
	}
};
function Ea(e) {
	let t = new Ta(), n = 0, r = 0, i = 0, a = 0;
	for (let o = 0; o < e.length; o++) {
		let s = e[o];
		if (o > 0 && t.write(_a), s.length === 0) continue;
		let c = 0;
		for (let e = 0; e < s.length; e++) {
			let o = s[e];
			e > 0 && t.write(ga), xa(t, Sa(o[0] - c)), c = o[0], o.length !== 1 && (xa(t, Sa(o[1] - n)), xa(t, Sa(o[2] - r)), xa(t, Sa(o[3] - i)), n = o[1], r = o[2], i = o[3], o.length !== 4 && (xa(t, Sa(o[4] - a)), a = o[4]));
		}
	}
	return t.flush();
}
(/* @__PURE__ */ t(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self, n.resolveURI = r());
	})(e, (function() {
		let e = /^[\w+.-]+:\/\//, t = /^([\w+.-]+:)\/\/([^@/#?]*@)?([^:/#?]*)(:\d+)?(\/[^#?]*)?(\?[^#]*)?(#.*)?/, n = /^file:(?:\/\/((?![a-z]:)[^/#?]*)?)?(\/?[^#?]*)(\?[^#]*)?(#.*)?/i;
		function r(t) {
			return e.test(t);
		}
		function i(e) {
			return e.startsWith("//");
		}
		function a(e) {
			return e.startsWith("/");
		}
		function o(e) {
			return e.startsWith("file:");
		}
		function s(e) {
			return /^[.?#]/.test(e);
		}
		function c(e) {
			let n = t.exec(e);
			return u(n[1], n[2] || "", n[3], n[4] || "", n[5] || "/", n[6] || "", n[7] || "");
		}
		function l(e) {
			let t = n.exec(e), r = t[2];
			return u("file:", "", t[1] || "", "", a(r) ? r : "/" + r, t[3] || "", t[4] || "");
		}
		function u(e, t, n, r, i, a, o) {
			return {
				scheme: e,
				user: t,
				host: n,
				port: r,
				path: i,
				query: a,
				hash: o,
				type: 7
			};
		}
		function d(e) {
			if (i(e)) {
				let t = c("http:" + e);
				return t.scheme = "", t.type = 6, t;
			}
			if (a(e)) {
				let t = c("http://foo.com" + e);
				return t.scheme = "", t.host = "", t.type = 5, t;
			}
			if (o(e)) return l(e);
			if (r(e)) return c(e);
			let t = c("http://foo.com/" + e);
			return t.scheme = "", t.host = "", t.type = e ? e.startsWith("?") ? 3 : e.startsWith("#") ? 2 : 4 : 1, t;
		}
		function f(e) {
			if (e.endsWith("/..")) return e;
			let t = e.lastIndexOf("/");
			return e.slice(0, t + 1);
		}
		function p(e, t) {
			m(t, t.type), e.path = e.path === "/" ? t.path : f(t.path) + e.path;
		}
		function m(e, t) {
			let n = t <= 4, r = e.path.split("/"), i = 1, a = 0, o = !1;
			for (let e = 1; e < r.length; e++) {
				let t = r[e];
				if (!t) {
					o = !0;
					continue;
				}
				if (o = !1, t !== ".") {
					if (t === "..") {
						a ? (o = !0, a--, i--) : n && (r[i++] = t);
						continue;
					}
					r[i++] = t, a++;
				}
			}
			let s = "";
			for (let e = 1; e < i; e++) s += "/" + r[e];
			(!s || o && !s.endsWith("/..")) && (s += "/"), e.path = s;
		}
		function h(e, t) {
			if (!e && !t) return "";
			let n = d(e), r = n.type;
			if (t && r !== 7) {
				let e = d(t), i = e.type;
				switch (r) {
					case 1: n.hash = e.hash;
					case 2: n.query = e.query;
					case 3:
					case 4: p(n, e);
					case 5: n.user = e.user, n.host = e.host, n.port = e.port;
					case 6: n.scheme = e.scheme;
				}
				i > r && (r = i);
			}
			m(n, r);
			let i = n.query + n.hash;
			switch (r) {
				case 2:
				case 3: return i;
				case 4: {
					let r = n.path.slice(1);
					return r ? s(t || e) && !s(r) ? "./" + r + i : r + i : i || ".";
				}
				case 5: return n.path + i;
				default: return n.scheme + "//" + n.user + n.host + n.port + n.path + i;
			}
		}
		return h;
	}));
})))();
//#endregion
//#region node_modules/@jridgewell/gen-mapping/dist/gen-mapping.mjs
var Da = class {
	constructor() {
		this._indexes = { __proto__: null }, this.array = [];
	}
};
function Oa(e) {
	return e;
}
function ka(e, t) {
	return Oa(e)._indexes[t];
}
function Aa(e, t) {
	let n = ka(e, t);
	if (n !== void 0) return n;
	let { array: r, _indexes: i } = Oa(e);
	return i[t] = r.push(t) - 1;
}
var ja = 0, Ma = 1, Na = 2, Pa = 3, Fa = 4, Ia = -1, La = class {
	constructor({ file: e, sourceRoot: t } = {}) {
		this._names = new Da(), this._sources = new Da(), this._sourcesContent = [], this._mappings = [], this.file = e, this.sourceRoot = t, this._ignoreList = new Da();
	}
};
function Ra(e) {
	return e;
}
var za = (e, t, n, r, i, a, o, s) => Ha(!0, e, t, n, r, i, a, o, s);
function Ba(e) {
	let { _mappings: t, _sources: n, _sourcesContent: r, _names: i, _ignoreList: a } = Ra(e);
	return Ka(t), {
		version: 3,
		file: e.file || void 0,
		names: i.array,
		sourceRoot: e.sourceRoot || void 0,
		sources: n.array,
		sourcesContent: r,
		mappings: t,
		ignoreList: a.array
	};
}
function Va(e) {
	let t = Ba(e);
	return Object.assign({}, t, { mappings: Ea(t.mappings) });
}
function Ha(e, t, n, r, i, a, o, s, c) {
	let { _mappings: l, _sources: u, _sourcesContent: d, _names: f } = Ra(t), p = Ua(l, n), m = Wa(p, r);
	if (!i) return e && qa(p, m) ? void 0 : Ga(p, m, [r]);
	let h = Aa(u, i), g = s ? Aa(f, s) : Ia;
	if (h === d.length && (d[h] = c ?? null), !(e && Ja(p, m, h, a, o, g))) return Ga(p, m, s ? [
		r,
		h,
		a,
		o,
		g
	] : [
		r,
		h,
		a,
		o
	]);
}
function Ua(e, t) {
	for (let n = e.length; n <= t; n++) e[n] = [];
	return e[t];
}
function Wa(e, t) {
	let n = e.length;
	for (let r = n - 1; r >= 0 && !(t >= e[r][ja]); n = r--);
	return n;
}
function Ga(e, t, n) {
	for (let n = e.length; n > t; n--) e[n] = e[n - 1];
	e[t] = n;
}
function Ka(e) {
	let { length: t } = e, n = t;
	for (let t = n - 1; t >= 0 && !(e[t].length > 0); n = t, t--);
	n < t && (e.length = n);
}
function qa(e, t) {
	return t === 0 || e[t - 1].length === 1;
}
function Ja(e, t, n, r, i, a) {
	if (t === 0) return !1;
	let o = e[t - 1];
	return o.length !== 1 && n === o[Ma] && r === o[Na] && i === o[Pa] && a === (o.length === 5 ? o[Fa] : Ia);
}
//#endregion
//#region node_modules/sucrase/dist/esm/computeSourceMap.js
function Ya({ code: e, mappings: t }, n, r, i, a) {
	let o = Xa(i, a), s = new La({ file: r.compiledFilename }), c = 0, l = t[0];
	for (; l === void 0 && c < t.length - 1;) c++, l = t[c];
	let u = 0, d = 0;
	l !== d && za(s, u, 0, n, u, 0);
	for (let r = 0; r < e.length; r++) {
		if (r === l) {
			let e = l - d, i = o[c];
			for (za(s, u, e, n, u, i); (l === r || l === void 0) && c < t.length - 1;) c++, l = t[c];
		}
		e.charCodeAt(r) === F.lineFeed && (u++, d = r + 1, l !== d && za(s, u, 0, n, u, 0));
	}
	let { sourceRoot: f, sourcesContent: p, ...m } = Va(s);
	return m;
}
function Xa(e, t) {
	let n = Array(t.length), r = 0, i = t[r].start, a = 0;
	for (let o = 0; o < e.length; o++) o === i && (n[r] = i - a, r++, i = t[r].start), e.charCodeAt(o) === F.lineFeed && (a = o + 1);
	return n;
}
//#endregion
//#region node_modules/sucrase/dist/esm/HelperManager.js
var Za = {
	require: "\n    import {createRequire as CREATE_REQUIRE_NAME} from \"module\";\n    const require = CREATE_REQUIRE_NAME(import.meta.url);\n  ",
	interopRequireWildcard: "\n    function interopRequireWildcard(obj) {\n      if (obj && obj.__esModule) {\n        return obj;\n      } else {\n        var newObj = {};\n        if (obj != null) {\n          for (var key in obj) {\n            if (Object.prototype.hasOwnProperty.call(obj, key)) {\n              newObj[key] = obj[key];\n            }\n          }\n        }\n        newObj.default = obj;\n        return newObj;\n      }\n    }\n  ",
	interopRequireDefault: "\n    function interopRequireDefault(obj) {\n      return obj && obj.__esModule ? obj : { default: obj };\n    }\n  ",
	createNamedExportFrom: "\n    function createNamedExportFrom(obj, localName, importedName) {\n      Object.defineProperty(exports, localName, {enumerable: true, configurable: true, get: () => obj[importedName]});\n    }\n  ",
	createStarExport: "\n    function createStarExport(obj) {\n      Object.keys(obj)\n        .filter((key) => key !== \"default\" && key !== \"__esModule\")\n        .forEach((key) => {\n          if (exports.hasOwnProperty(key)) {\n            return;\n          }\n          Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]});\n        });\n    }\n  ",
	nullishCoalesce: "\n    function nullishCoalesce(lhs, rhsFn) {\n      if (lhs != null) {\n        return lhs;\n      } else {\n        return rhsFn();\n      }\n    }\n  ",
	asyncNullishCoalesce: "\n    async function asyncNullishCoalesce(lhs, rhsFn) {\n      if (lhs != null) {\n        return lhs;\n      } else {\n        return await rhsFn();\n      }\n    }\n  ",
	optionalChain: "\n    function optionalChain(ops) {\n      let lastAccessLHS = undefined;\n      let value = ops[0];\n      let i = 1;\n      while (i < ops.length) {\n        const op = ops[i];\n        const fn = ops[i + 1];\n        i += 2;\n        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {\n          return undefined;\n        }\n        if (op === 'access' || op === 'optionalAccess') {\n          lastAccessLHS = value;\n          value = fn(value);\n        } else if (op === 'call' || op === 'optionalCall') {\n          value = fn((...args) => value.call(lastAccessLHS, ...args));\n          lastAccessLHS = undefined;\n        }\n      }\n      return value;\n    }\n  ",
	asyncOptionalChain: "\n    async function asyncOptionalChain(ops) {\n      let lastAccessLHS = undefined;\n      let value = ops[0];\n      let i = 1;\n      while (i < ops.length) {\n        const op = ops[i];\n        const fn = ops[i + 1];\n        i += 2;\n        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {\n          return undefined;\n        }\n        if (op === 'access' || op === 'optionalAccess') {\n          lastAccessLHS = value;\n          value = await fn(value);\n        } else if (op === 'call' || op === 'optionalCall') {\n          value = await fn((...args) => value.call(lastAccessLHS, ...args));\n          lastAccessLHS = undefined;\n        }\n      }\n      return value;\n    }\n  ",
	optionalChainDelete: "\n    function optionalChainDelete(ops) {\n      const result = OPTIONAL_CHAIN_NAME(ops);\n      return result == null ? true : result;\n    }\n  ",
	asyncOptionalChainDelete: "\n    async function asyncOptionalChainDelete(ops) {\n      const result = await ASYNC_OPTIONAL_CHAIN_NAME(ops);\n      return result == null ? true : result;\n    }\n  "
}, Qa = class e {
	__init() {
		this.helperNames = {};
	}
	__init2() {
		this.createRequireName = null;
	}
	constructor(t) {
		this.nameManager = t, e.prototype.__init.call(this), e.prototype.__init2.call(this);
	}
	getHelperName(e) {
		let t = this.helperNames[e];
		return t || (t = this.nameManager.claimFreeName(`_${e}`), this.helperNames[e] = t, t);
	}
	emitHelpers() {
		let e = "";
		this.helperNames.optionalChainDelete && this.getHelperName("optionalChain"), this.helperNames.asyncOptionalChainDelete && this.getHelperName("asyncOptionalChain");
		for (let [t, n] of Object.entries(Za)) {
			let r = this.helperNames[t], i = n;
			t === "optionalChainDelete" ? i = i.replace("OPTIONAL_CHAIN_NAME", this.helperNames.optionalChain) : t === "asyncOptionalChainDelete" ? i = i.replace("ASYNC_OPTIONAL_CHAIN_NAME", this.helperNames.asyncOptionalChain) : t === "require" && (this.createRequireName === null && (this.createRequireName = this.nameManager.claimFreeName("_createRequire")), i = i.replace(/CREATE_REQUIRE_NAME/g, this.createRequireName)), r && (e += " ", e += i.replace(t, r).replace(/\s+/g, " ").trim());
		}
		return e;
	}
};
//#endregion
//#region node_modules/sucrase/dist/esm/identifyShadowedGlobals.js
function $a(e, t, n) {
	eo(e, n) && to(e, t, n);
}
function eo(e, t) {
	for (let n of e.tokens) if (n.type === P.name && !n.isType && hi(n) && t.has(e.identifierNameForToken(n))) return !0;
	return !1;
}
function to(e, t, n) {
	let r = [], i = t.length - 1;
	for (let a = e.tokens.length - 1;; a--) {
		for (; r.length > 0 && r[r.length - 1].startTokenIndex === a + 1;) r.pop();
		for (; i >= 0 && t[i].endTokenIndex === a + 1;) r.push(t[i]), i--;
		if (a < 0) break;
		let o = e.tokens[a], s = e.identifierNameForToken(o);
		if (r.length > 1 && !o.isType && o.type === P.name && n.has(s)) {
			if (_i(o)) no(r[r.length - 1], e, s);
			else if (vi(o)) {
				let t = r.length - 1;
				for (; t > 0 && !r[t].isFunctionScope;) t--;
				if (t < 0) throw Error("Did not find parent function scope.");
				no(r[t], e, s);
			}
		}
	}
	if (r.length > 0) throw Error("Expected empty scope stack after processing file.");
}
function no(e, t, n) {
	for (let r = e.startTokenIndex; r < e.endTokenIndex; r++) {
		let e = t.tokens[r];
		(e.type === P.name || e.type === P.jsxName) && t.identifierNameForToken(e) === n && (e.shadowsGlobal = !0);
	}
}
//#endregion
//#region node_modules/sucrase/dist/esm/util/getIdentifierNames.js
function ro(e, t) {
	let n = [];
	for (let r of t) r.type === P.name && n.push(e.slice(r.start, r.end));
	return n;
}
//#endregion
//#region node_modules/sucrase/dist/esm/NameManager.js
var io = class e {
	__init() {
		this.usedNames = /* @__PURE__ */ new Set();
	}
	constructor(t, n) {
		e.prototype.__init.call(this), this.usedNames = new Set(ro(t, n));
	}
	claimFreeName(e) {
		let t = this.findFreeName(e);
		return this.usedNames.add(t), t;
	}
	findFreeName(e) {
		if (!this.usedNames.has(e)) return e;
		let t = 2;
		for (; this.usedNames.has(e + String(t));) t++;
		return e + String(t);
	}
}, ao = /* @__PURE__ */ t(((e) => {
	var t = e && e.__extends || (function() {
		var e = function(t, n) {
			return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
				e.__proto__ = t;
			} || function(e, t) {
				for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
			}, e(t, n);
		};
		return function(t, n) {
			e(t, n);
			function r() {
				this.constructor = t;
			}
			t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
		};
	})();
	Object.defineProperty(e, "__esModule", { value: !0 }), e.DetailContext = e.NoopContext = e.VError = void 0;
	var n = function(e) {
		t(n, e);
		function n(t, r) {
			var i = e.call(this, r) || this;
			return i.path = t, Object.setPrototypeOf(i, n.prototype), i;
		}
		return n;
	}(Error);
	e.VError = n, e.NoopContext = function() {
		function e() {}
		return e.prototype.fail = function(e, t, n) {
			return !1;
		}, e.prototype.unionResolver = function() {
			return this;
		}, e.prototype.createContext = function() {
			return this;
		}, e.prototype.resolveUnion = function(e) {}, e;
	}();
	var r = function() {
		function e() {
			this._propNames = [""], this._messages = [null], this._score = 0;
		}
		return e.prototype.fail = function(e, t, n) {
			return this._propNames.push(e), this._messages.push(t), this._score += n, !1;
		}, e.prototype.unionResolver = function() {
			return new i();
		}, e.prototype.resolveUnion = function(e) {
			for (var t, n, r = e, i = null, a = 0, o = r.contexts; a < o.length; a++) {
				var s = o[a];
				(!i || s._score >= i._score) && (i = s);
			}
			i && i._score > 0 && ((t = this._propNames).push.apply(t, i._propNames), (n = this._messages).push.apply(n, i._messages));
		}, e.prototype.getError = function(e) {
			for (var t = [], r = this._propNames.length - 1; r >= 0; r--) {
				var i = this._propNames[r];
				e += typeof i == "number" ? "[" + i + "]" : i ? "." + i : "";
				var a = this._messages[r];
				a && t.push(e + " " + a);
			}
			return new n(e, t.join("; "));
		}, e.prototype.getErrorDetail = function(e) {
			for (var t = [], n = this._propNames.length - 1; n >= 0; n--) {
				var r = this._propNames[n];
				e += typeof r == "number" ? "[" + r + "]" : r ? "." + r : "";
				var i = this._messages[n];
				i && t.push({
					path: e,
					message: i
				});
			}
			for (var a = null, n = t.length - 1; n >= 0; n--) a && (t[n].nested = [a]), a = t[n];
			return a;
		}, e;
	}();
	e.DetailContext = r;
	var i = function() {
		function e() {
			this.contexts = [];
		}
		return e.prototype.createContext = function() {
			var e = new r();
			return this.contexts.push(e), e;
		}, e;
	}();
})), oo = /* @__PURE__ */ t(((e) => {
	var t = e && e.__extends || (function() {
		var e = function(t, n) {
			return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
				e.__proto__ = t;
			} || function(e, t) {
				for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
			}, e(t, n);
		};
		return function(t, n) {
			e(t, n);
			function r() {
				this.constructor = t;
			}
			t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
		};
	})();
	Object.defineProperty(e, "__esModule", { value: !0 }), e.basicTypes = e.BasicType = e.TParamList = e.TParam = e.param = e.TFunc = e.func = e.TProp = e.TOptional = e.opt = e.TIface = e.iface = e.TEnumLiteral = e.enumlit = e.TEnumType = e.enumtype = e.TIntersection = e.intersection = e.TUnion = e.union = e.TTuple = e.tuple = e.TArray = e.array = e.TLiteral = e.lit = e.TName = e.name = e.TType = void 0;
	var n = ao(), r = function() {
		function e() {}
		return e;
	}();
	e.TType = r;
	function i(e) {
		return typeof e == "string" ? o(e) : e;
	}
	function a(e, t) {
		var n = e[t];
		if (!n) throw Error("Unknown type " + t);
		return n;
	}
	function o(e) {
		return new s(e);
	}
	e.name = o;
	var s = function(e) {
		t(n, e);
		function n(t) {
			var n = e.call(this) || this;
			return n.name = t, n._failMsg = "is not a " + t, n;
		}
		return n.prototype.getChecker = function(e, t, r) {
			var i = this, o = a(e, this.name), s = o.getChecker(e, t, r);
			return o instanceof T || o instanceof n ? s : function(e, t) {
				return s(e, t) ? !0 : t.fail(null, i._failMsg, 0);
			};
		}, n;
	}(r);
	e.TName = s;
	function c(e) {
		return new l(e);
	}
	e.lit = c;
	var l = function(e) {
		t(n, e);
		function n(t) {
			var n = e.call(this) || this;
			return n.value = t, n.name = JSON.stringify(t), n._failMsg = "is not " + n.name, n;
		}
		return n.prototype.getChecker = function(e, t) {
			var n = this;
			return function(e, t) {
				return e === n.value || t.fail(null, n._failMsg, -1);
			};
		}, n;
	}(r);
	e.TLiteral = l;
	function u(e) {
		return new d(i(e));
	}
	e.array = u;
	var d = function(e) {
		t(n, e);
		function n(t) {
			var n = e.call(this) || this;
			return n.ttype = t, n;
		}
		return n.prototype.getChecker = function(e, t) {
			var n = this.ttype.getChecker(e, t);
			return function(e, t) {
				if (!Array.isArray(e)) return t.fail(null, "is not an array", 0);
				for (var r = 0; r < e.length; r++) if (!n(e[r], t)) return t.fail(r, null, 1);
				return !0;
			};
		}, n;
	}(r);
	e.TArray = d;
	function f() {
		return new p([...arguments].map(function(e) {
			return i(e);
		}));
	}
	e.tuple = f;
	var p = function(e) {
		t(n, e);
		function n(t) {
			var n = e.call(this) || this;
			return n.ttypes = t, n;
		}
		return n.prototype.getChecker = function(e, t) {
			var n = this.ttypes.map(function(n) {
				return n.getChecker(e, t);
			}), r = function(e, t) {
				if (!Array.isArray(e)) return t.fail(null, "is not an array", 0);
				for (var r = 0; r < n.length; r++) if (!n[r](e[r], t)) return t.fail(r, null, 1);
				return !0;
			};
			return t ? function(e, t) {
				return r(e, t) ? e.length <= n.length || t.fail(n.length, "is extraneous", 2) : !1;
			} : r;
		}, n;
	}(r);
	e.TTuple = p;
	function m() {
		return new h([...arguments].map(function(e) {
			return i(e);
		}));
	}
	e.union = m;
	var h = function(e) {
		t(n, e);
		function n(t) {
			var n = e.call(this) || this;
			n.ttypes = t;
			var r = t.map(function(e) {
				return e instanceof s || e instanceof l ? e.name : null;
			}).filter(function(e) {
				return e;
			}), i = t.length - r.length;
			return r.length ? (i > 0 && r.push(i + " more"), n._failMsg = "is none of " + r.join(", ")) : n._failMsg = "is none of " + i + " types", n;
		}
		return n.prototype.getChecker = function(e, t) {
			var n = this, r = this.ttypes.map(function(n) {
				return n.getChecker(e, t);
			});
			return function(e, t) {
				for (var i = t.unionResolver(), a = 0; a < r.length; a++) if (r[a](e, i.createContext())) return !0;
				return t.resolveUnion(i), t.fail(null, n._failMsg, 0);
			};
		}, n;
	}(r);
	e.TUnion = h;
	function g() {
		return new _([...arguments].map(function(e) {
			return i(e);
		}));
	}
	e.intersection = g;
	var _ = function(e) {
		t(n, e);
		function n(t) {
			var n = e.call(this) || this;
			return n.ttypes = t, n;
		}
		return n.prototype.getChecker = function(e, t) {
			var n = /* @__PURE__ */ new Set(), r = this.ttypes.map(function(r) {
				return r.getChecker(e, t, n);
			});
			return function(e, t) {
				return r.every(function(n) {
					return n(e, t);
				}) ? !0 : t.fail(null, null, 0);
			};
		}, n;
	}(r);
	e.TIntersection = _;
	function v(e) {
		return new y(e);
	}
	e.enumtype = v;
	var y = function(e) {
		t(n, e);
		function n(t) {
			var n = e.call(this) || this;
			return n.members = t, n.validValues = /* @__PURE__ */ new Set(), n._failMsg = "is not a valid enum value", n.validValues = new Set(Object.keys(t).map(function(e) {
				return t[e];
			})), n;
		}
		return n.prototype.getChecker = function(e, t) {
			var n = this;
			return function(e, t) {
				return n.validValues.has(e) ? !0 : t.fail(null, n._failMsg, 0);
			};
		}, n;
	}(r);
	e.TEnumType = y;
	function b(e, t) {
		return new x(e, t);
	}
	e.enumlit = b;
	var x = function(e) {
		t(n, e);
		function n(t, n) {
			var r = e.call(this) || this;
			return r.enumName = t, r.prop = n, r._failMsg = "is not " + t + "." + n, r;
		}
		return n.prototype.getChecker = function(e, t) {
			var n = this, r = a(e, this.enumName);
			if (!(r instanceof y)) throw Error("Type " + this.enumName + " used in enumlit is not an enum type");
			var i = r.members[this.prop];
			if (!r.members.hasOwnProperty(this.prop)) throw Error("Unknown value " + this.enumName + "." + this.prop + " used in enumlit");
			return function(e, t) {
				return e === i || t.fail(null, n._failMsg, -1);
			};
		}, n;
	}(r);
	e.TEnumLiteral = x;
	function S(e) {
		return Object.keys(e).map(function(t) {
			return C(t, e[t]);
		});
	}
	function C(e, t) {
		return t instanceof ne ? new re(e, t.ttype, !0) : new re(e, i(t), !1);
	}
	function w(e, t) {
		return new ee(e, S(t));
	}
	e.iface = w;
	var ee = function(e) {
		t(r, e);
		function r(t, n) {
			var r = e.call(this) || this;
			return r.bases = t, r.props = n, r.propSet = new Set(n.map(function(e) {
				return e.name;
			})), r;
		}
		return r.prototype.getChecker = function(e, t, r) {
			var i = this, o = this.bases.map(function(n) {
				return a(e, n).getChecker(e, t);
			}), s = this.props.map(function(n) {
				return n.ttype.getChecker(e, t);
			}), c = new n.NoopContext(), l = this.props.map(function(e, t) {
				return !e.isOpt && !s[t](void 0, c);
			}), u = function(e, t) {
				if (typeof e != "object" || !e) return t.fail(null, "is not an object", 0);
				for (var n = 0; n < o.length; n++) if (!o[n](e, t)) return !1;
				for (var n = 0; n < s.length; n++) {
					var r = i.props[n].name, a = e[r];
					if (a === void 0) {
						if (l[n]) return t.fail(r, "is missing", 1);
					} else if (!s[n](a, t)) return t.fail(r, null, 1);
				}
				return !0;
			};
			if (!t) return u;
			var d = this.propSet;
			return r && (this.propSet.forEach(function(e) {
				return r.add(e);
			}), d = r), function(e, t) {
				if (!u(e, t)) return !1;
				for (var n in e) if (!d.has(n)) return t.fail(n, "is extraneous", 2);
				return !0;
			};
		}, r;
	}(r);
	e.TIface = ee;
	function te(e) {
		return new ne(i(e));
	}
	e.opt = te;
	var ne = function(e) {
		t(n, e);
		function n(t) {
			var n = e.call(this) || this;
			return n.ttype = t, n;
		}
		return n.prototype.getChecker = function(e, t) {
			var n = this.ttype.getChecker(e, t);
			return function(e, t) {
				return e === void 0 || n(e, t);
			};
		}, n;
	}(r);
	e.TOptional = ne;
	var re = function() {
		function e(e, t, n) {
			this.name = e, this.ttype = t, this.isOpt = n;
		}
		return e;
	}();
	e.TProp = re;
	function ie(e) {
		return new ae(new ce([...arguments].slice(1)), i(e));
	}
	e.func = ie;
	var ae = function(e) {
		t(n, e);
		function n(t, n) {
			var r = e.call(this) || this;
			return r.paramList = t, r.result = n, r;
		}
		return n.prototype.getChecker = function(e, t) {
			return function(e, t) {
				return typeof e == "function" || t.fail(null, "is not a function", 0);
			};
		}, n;
	}(r);
	e.TFunc = ae;
	function oe(e, t, n) {
		return new se(e, i(t), !!n);
	}
	e.param = oe;
	var se = function() {
		function e(e, t, n) {
			this.name = e, this.ttype = t, this.isOpt = n;
		}
		return e;
	}();
	e.TParam = se;
	var ce = function(e) {
		t(r, e);
		function r(t) {
			var n = e.call(this) || this;
			return n.params = t, n;
		}
		return r.prototype.getChecker = function(e, t) {
			var r = this, i = this.params.map(function(n) {
				return n.ttype.getChecker(e, t);
			}), a = new n.NoopContext(), o = this.params.map(function(e, t) {
				return !e.isOpt && !i[t](void 0, a);
			}), s = function(e, t) {
				if (!Array.isArray(e)) return t.fail(null, "is not an array", 0);
				for (var n = 0; n < i.length; n++) {
					var a = r.params[n];
					if (e[n] === void 0) {
						if (o[n]) return t.fail(a.name, "is missing", 1);
					} else if (!i[n](e[n], t)) return t.fail(a.name, null, 1);
				}
				return !0;
			};
			return t ? function(e, t) {
				return s(e, t) ? e.length <= i.length || t.fail(i.length, "is extraneous", 2) : !1;
			} : s;
		}, r;
	}(r);
	e.TParamList = ce;
	var T = function(e) {
		t(n, e);
		function n(t, n) {
			var r = e.call(this) || this;
			return r.validator = t, r.message = n, r;
		}
		return n.prototype.getChecker = function(e, t) {
			var n = this;
			return function(e, t) {
				return n.validator(e) ? !0 : t.fail(null, n.message, 0);
			};
		}, n;
	}(r);
	e.BasicType = T, e.basicTypes = {
		any: new T(function(e) {
			return !0;
		}, "is invalid"),
		number: new T(function(e) {
			return typeof e == "number";
		}, "is not a number"),
		object: new T(function(e) {
			return typeof e == "object" && e;
		}, "is not an object"),
		boolean: new T(function(e) {
			return typeof e == "boolean";
		}, "is not a boolean"),
		string: new T(function(e) {
			return typeof e == "string";
		}, "is not a string"),
		symbol: new T(function(e) {
			return typeof e == "symbol";
		}, "is not a symbol"),
		void: new T(function(e) {
			return e == null;
		}, "is not void"),
		undefined: new T(function(e) {
			return e === void 0;
		}, "is not undefined"),
		null: new T(function(e) {
			return e === null;
		}, "is not null"),
		never: new T(function(e) {
			return !1;
		}, "is unexpected"),
		Date: new T(E("[object Date]"), "is not a Date"),
		RegExp: new T(E("[object RegExp]"), "is not a RegExp")
	};
	var le = Object.prototype.toString;
	function E(e) {
		return function(t) {
			return typeof t == "object" && t && le.call(t) === e;
		};
	}
	typeof Buffer < "u" && (e.basicTypes.Buffer = new T(function(e) {
		return Buffer.isBuffer(e);
	}, "is not a Buffer"));
	for (var ue = function(t) {
		e.basicTypes[t.name] = new T(function(e) {
			return e instanceof t;
		}, "is not a " + t.name);
	}, de = 0, fe = [
		Int8Array,
		Uint8Array,
		Uint8ClampedArray,
		Int16Array,
		Uint16Array,
		Int32Array,
		Uint32Array,
		Float32Array,
		Float64Array,
		ArrayBuffer
	]; de < fe.length; de++) {
		var D = fe[de];
		ue(D);
	}
})), so = /* @__PURE__ */ c((/* @__PURE__ */ t(((e) => {
	var t = e && e.__spreadArrays || function() {
		for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
		for (var r = Array(e), i = 0, t = 0; t < n; t++) for (var a = arguments[t], o = 0, s = a.length; o < s; o++, i++) r[i] = a[o];
		return r;
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), e.Checker = e.createCheckers = void 0;
	var n = oo(), r = ao(), i = oo();
	Object.defineProperty(e, "TArray", {
		enumerable: !0,
		get: function() {
			return i.TArray;
		}
	}), Object.defineProperty(e, "TEnumType", {
		enumerable: !0,
		get: function() {
			return i.TEnumType;
		}
	}), Object.defineProperty(e, "TEnumLiteral", {
		enumerable: !0,
		get: function() {
			return i.TEnumLiteral;
		}
	}), Object.defineProperty(e, "TFunc", {
		enumerable: !0,
		get: function() {
			return i.TFunc;
		}
	}), Object.defineProperty(e, "TIface", {
		enumerable: !0,
		get: function() {
			return i.TIface;
		}
	}), Object.defineProperty(e, "TLiteral", {
		enumerable: !0,
		get: function() {
			return i.TLiteral;
		}
	}), Object.defineProperty(e, "TName", {
		enumerable: !0,
		get: function() {
			return i.TName;
		}
	}), Object.defineProperty(e, "TOptional", {
		enumerable: !0,
		get: function() {
			return i.TOptional;
		}
	}), Object.defineProperty(e, "TParam", {
		enumerable: !0,
		get: function() {
			return i.TParam;
		}
	}), Object.defineProperty(e, "TParamList", {
		enumerable: !0,
		get: function() {
			return i.TParamList;
		}
	}), Object.defineProperty(e, "TProp", {
		enumerable: !0,
		get: function() {
			return i.TProp;
		}
	}), Object.defineProperty(e, "TTuple", {
		enumerable: !0,
		get: function() {
			return i.TTuple;
		}
	}), Object.defineProperty(e, "TType", {
		enumerable: !0,
		get: function() {
			return i.TType;
		}
	}), Object.defineProperty(e, "TUnion", {
		enumerable: !0,
		get: function() {
			return i.TUnion;
		}
	}), Object.defineProperty(e, "TIntersection", {
		enumerable: !0,
		get: function() {
			return i.TIntersection;
		}
	}), Object.defineProperty(e, "array", {
		enumerable: !0,
		get: function() {
			return i.array;
		}
	}), Object.defineProperty(e, "enumlit", {
		enumerable: !0,
		get: function() {
			return i.enumlit;
		}
	}), Object.defineProperty(e, "enumtype", {
		enumerable: !0,
		get: function() {
			return i.enumtype;
		}
	}), Object.defineProperty(e, "func", {
		enumerable: !0,
		get: function() {
			return i.func;
		}
	}), Object.defineProperty(e, "iface", {
		enumerable: !0,
		get: function() {
			return i.iface;
		}
	}), Object.defineProperty(e, "lit", {
		enumerable: !0,
		get: function() {
			return i.lit;
		}
	}), Object.defineProperty(e, "name", {
		enumerable: !0,
		get: function() {
			return i.name;
		}
	}), Object.defineProperty(e, "opt", {
		enumerable: !0,
		get: function() {
			return i.opt;
		}
	}), Object.defineProperty(e, "param", {
		enumerable: !0,
		get: function() {
			return i.param;
		}
	}), Object.defineProperty(e, "tuple", {
		enumerable: !0,
		get: function() {
			return i.tuple;
		}
	}), Object.defineProperty(e, "union", {
		enumerable: !0,
		get: function() {
			return i.union;
		}
	}), Object.defineProperty(e, "intersection", {
		enumerable: !0,
		get: function() {
			return i.intersection;
		}
	}), Object.defineProperty(e, "BasicType", {
		enumerable: !0,
		get: function() {
			return i.BasicType;
		}
	});
	var a = ao();
	Object.defineProperty(e, "VError", {
		enumerable: !0,
		get: function() {
			return a.VError;
		}
	});
	function o() {
		for (var e = [...arguments], r = Object.assign.apply(Object, t([{}, n.basicTypes], e)), i = {}, a = 0, o = e; a < o.length; a++) for (var c = o[a], l = 0, u = Object.keys(c); l < u.length; l++) {
			var d = u[l];
			i[d] = new s(r, c[d]);
		}
		return i;
	}
	e.createCheckers = o;
	var s = function() {
		function e(e, t, r) {
			if (r === void 0 && (r = "value"), this.suite = e, this.ttype = t, this._path = r, this.props = /* @__PURE__ */ new Map(), t instanceof n.TIface) for (var i = 0, a = t.props; i < a.length; i++) {
				var o = a[i];
				this.props.set(o.name, o.ttype);
			}
			this.checkerPlain = this.ttype.getChecker(e, !1), this.checkerStrict = this.ttype.getChecker(e, !0);
		}
		return e.prototype.setReportedPath = function(e) {
			this._path = e;
		}, e.prototype.check = function(e) {
			return this._doCheck(this.checkerPlain, e);
		}, e.prototype.test = function(e) {
			return this.checkerPlain(e, new r.NoopContext());
		}, e.prototype.validate = function(e) {
			return this._doValidate(this.checkerPlain, e);
		}, e.prototype.strictCheck = function(e) {
			return this._doCheck(this.checkerStrict, e);
		}, e.prototype.strictTest = function(e) {
			return this.checkerStrict(e, new r.NoopContext());
		}, e.prototype.strictValidate = function(e) {
			return this._doValidate(this.checkerStrict, e);
		}, e.prototype.getProp = function(t) {
			var n = this.props.get(t);
			if (!n) throw Error("Type has no property " + t);
			return new e(this.suite, n, this._path + "." + t);
		}, e.prototype.methodArgs = function(t) {
			var n = this._getMethod(t);
			return new e(this.suite, n.paramList);
		}, e.prototype.methodResult = function(t) {
			var n = this._getMethod(t);
			return new e(this.suite, n.result);
		}, e.prototype.getArgs = function() {
			if (!(this.ttype instanceof n.TFunc)) throw Error("getArgs() applied to non-function");
			return new e(this.suite, this.ttype.paramList);
		}, e.prototype.getResult = function() {
			if (!(this.ttype instanceof n.TFunc)) throw Error("getResult() applied to non-function");
			return new e(this.suite, this.ttype.result);
		}, e.prototype.getType = function() {
			return this.ttype;
		}, e.prototype._doCheck = function(e, t) {
			if (!e(t, new r.NoopContext())) {
				var n = new r.DetailContext();
				throw e(t, n), n.getError(this._path);
			}
		}, e.prototype._doValidate = function(e, t) {
			if (e(t, new r.NoopContext())) return null;
			var n = new r.DetailContext();
			return e(t, n), n.getErrorDetail(this._path);
		}, e.prototype._getMethod = function(e) {
			var t = this.props.get(e);
			if (!t) throw Error("Type has no property " + e);
			if (!(t instanceof n.TFunc)) throw Error("Property " + e + " is not a method");
			return t;
		}, e;
	}();
	e.Checker = s;
})))()), co = {
	Transform: so.union(so.lit("jsx"), so.lit("typescript"), so.lit("flow"), so.lit("imports"), so.lit("react-hot-loader"), so.lit("jest")),
	SourceMapOptions: so.iface([], { compiledFilename: "string" }),
	Options: so.iface([], {
		transforms: so.array("Transform"),
		disableESTransforms: so.opt("boolean"),
		jsxRuntime: so.opt(so.union(so.lit("classic"), so.lit("automatic"), so.lit("preserve"))),
		production: so.opt("boolean"),
		jsxImportSource: so.opt("string"),
		jsxPragma: so.opt("string"),
		jsxFragmentPragma: so.opt("string"),
		keepUnusedImports: so.opt("boolean"),
		preserveDynamicImport: so.opt("boolean"),
		injectCreateRequireForImportRequire: so.opt("boolean"),
		enableLegacyTypeScriptModuleInterop: so.opt("boolean"),
		enableLegacyBabel5ModuleInterop: so.opt("boolean"),
		sourceMapOptions: so.opt("SourceMapOptions"),
		filePath: so.opt("string")
	})
}, { Options: lo } = (0, so.createCheckers)(co);
function uo(e) {
	lo.strictCheck(e);
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/traverser/lval.js
function fo() {
	W(), Ac(!1);
}
function po(e) {
	W(), _o(e);
}
function mo(e) {
	Z(), go(e);
}
function ho() {
	Z(), R.tokens[R.tokens.length - 1].identifierRole = U.ImportDeclaration;
}
function go(e) {
	let t;
	t = R.scopeDepth === 0 ? U.TopLevelDeclaration : e ? U.BlockScopedDeclaration : U.FunctionScopedDeclaration, R.tokens[R.tokens.length - 1].identifierRole = t;
}
function _o(e) {
	switch (R.type) {
		case P._this: {
			let e = G(0);
			W(), K(e);
			return;
		}
		case P._yield:
		case P.name:
			R.type = P.name, mo(e);
			return;
		case P.bracketL:
			W(), vo(P.bracketR, e, !0);
			return;
		case P.braceL:
			ol(!0, e);
			return;
		default: H();
	}
}
function vo(e, t, n = !1, r = !1, i = 0) {
	let a = !0, o = !1, s = R.tokens.length;
	for (; !q(e) && !R.error;) if (a ? a = !1 : (V(P.comma), R.tokens[R.tokens.length - 1].contextId = i, !o && R.tokens[s].isType && (R.tokens[R.tokens.length - 1].isType = !0, o = !0)), !(n && J(P.comma))) {
		if (q(e)) break;
		if (J(P.ellipsis)) {
			po(t), bo(), q(P.comma), V(e);
			break;
		}
		yo(r, t);
	}
}
function yo(e, t) {
	e && To([
		N._public,
		N._protected,
		N._private,
		N._readonly,
		N._override
	]), xo(t), bo(), xo(t, !0);
}
function bo() {
	L ? Ou() : I && uc();
}
function xo(e, t = !1) {
	if (t || _o(e), !q(P.eq)) return;
	let n = R.tokens.length - 1;
	Ac(), R.tokens[n].rhsEndIndex = R.tokens.length;
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/plugins/typescript.js
function So() {
	return J(P.name);
}
function Co() {
	return J(P.name) || !!(R.type & P.IS_KEYWORD) || J(P.string) || J(P.num) || J(P.bigint) || J(P.decimal);
}
function wo() {
	let e = R.snapshot();
	return W(), (J(P.bracketL) || J(P.braceL) || J(P.star) || J(P.ellipsis) || J(P.hash) || Co()) && !ti() ? !0 : (R.restoreFromSnapshot(e), !1);
}
function To(e) {
	for (; Eo(e) !== null;);
}
function Eo(e) {
	if (!J(P.name)) return null;
	let t = R.contextualKeyword;
	if (e.indexOf(t) !== -1 && wo()) {
		switch (t) {
			case N._readonly:
				R.tokens[R.tokens.length - 1].type = P._readonly;
				break;
			case N._abstract:
				R.tokens[R.tokens.length - 1].type = P._abstract;
				break;
			case N._static:
				R.tokens[R.tokens.length - 1].type = P._static;
				break;
			case N._public:
				R.tokens[R.tokens.length - 1].type = P._public;
				break;
			case N._private:
				R.tokens[R.tokens.length - 1].type = P._private;
				break;
			case N._protected:
				R.tokens[R.tokens.length - 1].type = P._protected;
				break;
			case N._override:
				R.tokens[R.tokens.length - 1].type = P._override;
				break;
			case N._declare: R.tokens[R.tokens.length - 1].type = P._declare;
		}
		return t;
	}
	return null;
}
function Do() {
	for (Z(); q(P.dot);) Z();
}
function Oo() {
	Do(), !ti() && J(P.lessThan) && Us();
}
function ko() {
	W(), _s();
}
function Ao() {
	W();
}
function jo() {
	V(P._typeof), J(P._import) ? Mo() : Do(), !ti() && J(P.lessThan) && Us();
}
function Mo() {
	V(P._import), V(P.parenL), V(P.string), V(P.parenR), q(P.dot) && Do(), J(P.lessThan) && Us();
}
function No() {
	q(P._const);
	let e = q(P._in), t = Qr(N._out);
	q(P._const), (e || t) && !J(P.name) ? R.tokens[R.tokens.length - 1].type = P.name : Z(), q(P._extends) && vs(), q(P.eq) && vs();
}
function Po() {
	J(P.lessThan) && Fo();
}
function Fo() {
	let e = G(0);
	for (J(P.lessThan) || J(P.typeParameterStart) ? W() : H(); !q(P.greaterThan) && !R.error;) No(), q(P.comma);
	K(e);
}
function Io(e) {
	let t = e === P.arrow;
	Po(), V(P.parenL), R.scopeDepth++, Lo(!1), R.scopeDepth--, (t || J(e)) && fs(e);
}
function Lo(e) {
	vo(P.parenR, e);
}
function Ro() {
	q(P.comma) || ii();
}
function zo() {
	Io(P.colon), Ro();
}
function Bo() {
	let e = R.snapshot();
	W();
	let t = q(P.name) && J(P.colon);
	return R.restoreFromSnapshot(e), t;
}
function Vo() {
	if (!(J(P.bracketL) && Bo())) return !1;
	let e = G(0);
	return V(P.bracketL), Z(), _s(), V(P.bracketR), ms(), Ro(), K(e), !0;
}
function Ho(e) {
	q(P.question), !e && (J(P.parenL) || J(P.lessThan)) ? (Io(P.colon), Ro()) : (ms(), Ro());
}
function Uo() {
	if (J(P.parenL) || J(P.lessThan)) {
		zo();
		return;
	}
	if (J(P._new)) {
		W(), J(P.parenL) || J(P.lessThan) ? zo() : Ho(!1);
		return;
	}
	let e = !!Eo([N._readonly]);
	Vo() || ((B(N._get) || B(N._set)) && wo(), dl(-1), Ho(e));
}
function Wo() {
	Go();
}
function Go() {
	for (V(P.braceL); !q(P.braceR) && !R.error;) Uo();
}
function Ko() {
	let e = R.snapshot(), t = qo();
	return R.restoreFromSnapshot(e), t;
}
function qo() {
	return W(), q(P.plus) || q(P.minus) ? B(N._readonly) : (B(N._readonly) && W(), !J(P.bracketL) || (W(), !So()) ? !1 : (W(), J(P._in)));
}
function Jo() {
	Z(), V(P._in), vs();
}
function Yo() {
	V(P.braceL), J(P.plus) || J(P.minus) ? (W(), $r(N._readonly)) : Qr(N._readonly), V(P.bracketL), Jo(), Qr(N._as) && vs(), V(P.bracketR), J(P.plus) || J(P.minus) ? (W(), V(P.question)) : q(P.question), hs(), ii(), V(P.braceR);
}
function Xo() {
	for (V(P.bracketL); !q(P.bracketR) && !R.error;) Zo(), q(P.comma);
}
function Zo() {
	q(P.ellipsis) ? vs() : (vs(), q(P.question)), q(P.colon) && vs();
}
function Qo() {
	V(P.parenL), vs(), V(P.parenR);
}
function $o() {
	for (xi(), xi(); !J(P.backQuote) && !R.error;) V(P.dollarBraceL), vs(), xi(), xi();
	W();
}
var es;
(function(e) {
	e[e.TSFunctionType = 0] = "TSFunctionType", e[e.TSConstructorType = 1] = "TSConstructorType", e[e.TSAbstractConstructorType = 2] = "TSAbstractConstructorType";
})(es ||= {});
function ts(e) {
	e === es.TSAbstractConstructorType && $r(N._abstract), (e === es.TSConstructorType || e === es.TSAbstractConstructorType) && V(P._new);
	let t = R.inDisallowConditionalTypesContext;
	R.inDisallowConditionalTypesContext = !1, Io(P.arrow), R.inDisallowConditionalTypesContext = t;
}
function ns() {
	switch (R.type) {
		case P.name:
			Oo();
			return;
		case P._void:
		case P._null:
			W();
			return;
		case P.string:
		case P.num:
		case P.bigint:
		case P.decimal:
		case P._true:
		case P._false:
			Zc();
			return;
		case P.minus:
			W(), Zc();
			return;
		case P._this:
			Ao(), B(N._is) && !ti() && ko();
			return;
		case P._typeof:
			jo();
			return;
		case P._import:
			Mo();
			return;
		case P.braceL:
			Ko() ? Yo() : Wo();
			return;
		case P.bracketL:
			Xo();
			return;
		case P.parenL:
			Qo();
			return;
		case P.backQuote:
			$o();
			return;
		default: if (R.type & P.IS_KEYWORD) {
			W(), R.tokens[R.tokens.length - 1].type = P.name;
			return;
		}
	}
	H();
}
function rs() {
	for (ns(); !ti() && q(P.bracketL);) q(P.bracketR) || (vs(), V(P.bracketR));
}
function is() {
	if ($r(N._infer), Z(), J(P._extends)) {
		let e = R.snapshot();
		V(P._extends);
		let t = R.inDisallowConditionalTypesContext;
		R.inDisallowConditionalTypesContext = !0, vs(), R.inDisallowConditionalTypesContext = t, (R.error || !R.inDisallowConditionalTypesContext && J(P.question)) && R.restoreFromSnapshot(e);
	}
}
function as() {
	if (B(N._keyof) || B(N._unique) || B(N._readonly)) W(), as();
	else if (B(N._infer)) is();
	else {
		let e = R.inDisallowConditionalTypesContext;
		R.inDisallowConditionalTypesContext = !1, rs(), R.inDisallowConditionalTypesContext = e;
	}
}
function os() {
	if (q(P.bitwiseAND), as(), J(P.bitwiseAND)) for (; q(P.bitwiseAND);) as();
}
function ss() {
	if (q(P.bitwiseOR), os(), J(P.bitwiseOR)) for (; q(P.bitwiseOR);) os();
}
function cs() {
	return J(P.lessThan) ? !0 : J(P.parenL) && us();
}
function ls() {
	if (J(P.name) || J(P._this)) return W(), !0;
	if (J(P.braceL) || J(P.bracketL)) {
		let e = 1;
		for (W(); e > 0 && !R.error;) J(P.braceL) || J(P.bracketL) ? e++ : (J(P.braceR) || J(P.bracketR)) && e--, W();
		return !0;
	}
	return !1;
}
function us() {
	let e = R.snapshot(), t = ds();
	return R.restoreFromSnapshot(e), t;
}
function ds() {
	return W(), !!(J(P.parenR) || J(P.ellipsis) || ls() && (J(P.colon) || J(P.comma) || J(P.question) || J(P.eq) || J(P.parenR) && (W(), J(P.arrow))));
}
function fs(e) {
	let t = G(0);
	V(e), gs() || vs(), K(t);
}
function ps() {
	J(P.colon) && fs(P.colon);
}
function ms() {
	J(P.colon) && _s();
}
function hs() {
	q(P.colon) && vs();
}
function gs() {
	let e = R.snapshot();
	return B(N._asserts) ? (W(), Qr(N._is) ? (vs(), !0) : So() || J(P._this) ? (W(), Qr(N._is) && vs(), !0) : (R.restoreFromSnapshot(e), !1)) : So() || J(P._this) ? (W(), B(N._is) && !ti() ? (W(), vs(), !0) : (R.restoreFromSnapshot(e), !1)) : !1;
}
function _s() {
	let e = G(0);
	V(P.colon), vs(), K(e);
}
function vs() {
	if (bs(), R.inDisallowConditionalTypesContext || ti() || !q(P._extends)) return;
	let e = R.inDisallowConditionalTypesContext;
	R.inDisallowConditionalTypesContext = !0, bs(), R.inDisallowConditionalTypesContext = e, V(P.question), vs(), V(P.colon), vs();
}
function ys() {
	return B(N._abstract) && wi() === P._new;
}
function bs() {
	if (cs()) {
		ts(es.TSFunctionType);
		return;
	}
	if (J(P._new)) {
		ts(es.TSConstructorType);
		return;
	}
	if (ys()) {
		ts(es.TSAbstractConstructorType);
		return;
	}
	ss();
}
function xs() {
	let e = G(1);
	vs(), V(P.greaterThan), K(e), Lc();
}
function Ss() {
	if (q(P.jsxTagStart)) {
		R.tokens[R.tokens.length - 1].type = P.typeParameterStart;
		let e = G(1);
		for (; !J(P.greaterThan) && !R.error;) vs(), q(P.comma);
		wc(), K(e);
	}
}
function Cs() {
	for (; !J(P.braceL) && !R.error;) ws(), q(P.comma);
}
function ws() {
	Do(), J(P.lessThan) && Us();
}
function Ts() {
	mo(!1), Po(), q(P._extends) && Cs(), Go();
}
function Es() {
	mo(!1), Po(), V(P.eq), vs(), ii();
}
function Ds() {
	if (J(P.string) ? Zc() : Z(), q(P.eq)) {
		let e = R.tokens.length - 1;
		Ac(), R.tokens[e].rhsEndIndex = R.tokens.length;
	}
}
function Os() {
	for (mo(!1), V(P.braceL); !q(P.braceR) && !R.error;) Ds(), q(P.comma);
}
function ks() {
	V(P.braceL), hd(P.braceR);
}
function As() {
	mo(!1), q(P.dot) ? As() : ks();
}
function js() {
	B(N._global) ? Z() : J(P.string) ? Jc() : H(), J(P.braceL) ? ks() : ii();
}
function Ms() {
	ho(), V(P.eq), Ps(), ii();
}
function Ns() {
	return B(N._require) && wi() === P.parenL;
}
function Ps() {
	Ns() ? Fs() : Do();
}
function Fs() {
	$r(N._require), V(P.parenL), J(P.string) || H(), Zc(), V(P.parenR);
}
function Is() {
	if (ri()) return !1;
	switch (R.type) {
		case P._function: {
			let e = G(1);
			W();
			let t = R.start;
			return bd(t, !0), K(e), !0;
		}
		case P._class: {
			let e = G(1);
			return Sd(!0, !1), K(e), !0;
		}
		case P._const: if (J(P._const) && Zr(N._enum)) {
			let e = G(1);
			return V(P._const), $r(N._enum), R.tokens[R.tokens.length - 1].type = P._enum, Os(), K(e), !0;
		}
		case P._var:
		case P._let: {
			let e = G(1);
			return ld(R.type !== P._var), K(e), !0;
		}
		case P.name: {
			let e = G(1), t = R.contextualKeyword, n = !1;
			return t === N._global ? (js(), n = !0) : n = zs(t, !0), K(e), n;
		}
		default: return !1;
	}
}
function Ls() {
	return zs(R.contextualKeyword, !0);
}
function Rs(e) {
	switch (e) {
		case N._declare: {
			let e = R.tokens.length - 1;
			if (Is()) return R.tokens[e].type = P._declare, !0;
			break;
		}
		case N._global:
			if (J(P.braceL)) return ks(), !0;
			break;
		default: return zs(e, !1);
	}
	return !1;
}
function zs(e, t) {
	switch (e) {
		case N._abstract:
			if (Bs(t) && J(P._class)) return R.tokens[R.tokens.length - 1].type = P._abstract, Sd(!0, !1), !0;
			break;
		case N._enum:
			if (Bs(t) && J(P.name)) return R.tokens[R.tokens.length - 1].type = P._enum, Os(), !0;
			break;
		case N._interface:
			if (Bs(t) && J(P.name)) {
				let e = G(t ? 2 : 1);
				return Ts(), K(e), !0;
			}
			break;
		case N._module:
			if (Bs(t)) {
				if (J(P.string)) {
					let e = G(t ? 2 : 1);
					return js(), K(e), !0;
				}
				if (J(P.name)) {
					let e = G(t ? 2 : 1);
					return As(), K(e), !0;
				}
			}
			break;
		case N._namespace:
			if (Bs(t) && J(P.name)) {
				let e = G(t ? 2 : 1);
				return As(), K(e), !0;
			}
			break;
		case N._type: if (Bs(t) && J(P.name)) {
			let e = G(t ? 2 : 1);
			return Es(), K(e), !0;
		}
	}
	return !1;
}
function Bs(e) {
	return e ? (W(), !0) : !ri();
}
function Vs() {
	let e = R.snapshot();
	return Fo(), xd(), ps(), V(P.arrow), R.error ? (R.restoreFromSnapshot(e), !1) : (hl(!0), !0);
}
function Hs() {
	R.type === P.bitShiftL && (--R.pos, Y(P.lessThan)), Us();
}
function Us() {
	let e = G(0);
	for (V(P.lessThan); !J(P.greaterThan) && !R.error;) vs(), q(P.comma);
	e ? (V(P.greaterThan), K(e)) : (K(e), Ui(), V(P.greaterThan), R.tokens[R.tokens.length - 1].isType = !0);
}
function Ws() {
	if (J(P.name)) switch (R.contextualKeyword) {
		case N._abstract:
		case N._declare:
		case N._enum:
		case N._interface:
		case N._module:
		case N._namespace:
		case N._type: return !0;
	}
	return !1;
}
function Gs(e, t) {
	if (J(P.colon) && fs(P.colon), !J(P.braceL) && ri()) {
		let t = R.tokens.length - 1;
		for (; t >= 0 && (R.tokens[t].start >= e || R.tokens[t].type === P._default || R.tokens[t].type === P._export);) R.tokens[t].isType = !0, t--;
		return;
	}
	hl(!1, t);
}
function Ks(e, t, n) {
	if (!ti() && q(P.bang)) {
		R.tokens[R.tokens.length - 1].type = P.nonNullAssertion;
		return;
	}
	if (J(P.lessThan) || J(P.bitShiftL)) {
		let n = R.snapshot();
		if (!t && Uc() && Vs()) return;
		if (Hs(), !t && q(P.parenL) ? (R.tokens[R.tokens.length - 1].subscriptStartIndex = e, Wc()) : J(P.backQuote) ? al() : (R.type === P.greaterThan || R.type !== P.parenL && R.type & P.IS_EXPRESSION_START && !ti()) && H(), R.error) R.restoreFromSnapshot(n);
		else return;
	} else !t && J(P.questionDot) && wi() === P.lessThan && (W(), R.tokens[e].isOptionalChainStart = !0, R.tokens[R.tokens.length - 1].subscriptStartIndex = e, Us(), V(P.parenL), Wc());
	Hc(e, t, n);
}
function qs() {
	if (q(P._import)) return B(N._type) && wi() !== P.eq && $r(N._type), Ms(), !0;
	if (q(P.eq)) return kc(), ii(), !0;
	if (Qr(N._as)) return $r(N._namespace), Z(), ii(), !0;
	if (B(N._type)) {
		let e = wi();
		(e === P.braceL || e === P.star) && W();
	}
	return !1;
}
function Js() {
	if (Z(), J(P.comma) || J(P.braceR)) {
		R.tokens[R.tokens.length - 1].identifierRole = U.ImportDeclaration;
		return;
	}
	if (Z(), J(P.comma) || J(P.braceR)) {
		R.tokens[R.tokens.length - 1].identifierRole = U.ImportDeclaration, R.tokens[R.tokens.length - 2].isType = !0, R.tokens[R.tokens.length - 1].isType = !0;
		return;
	}
	if (Z(), J(P.comma) || J(P.braceR)) {
		R.tokens[R.tokens.length - 3].identifierRole = U.ImportAccess, R.tokens[R.tokens.length - 1].identifierRole = U.ImportDeclaration;
		return;
	}
	Z(), R.tokens[R.tokens.length - 3].identifierRole = U.ImportAccess, R.tokens[R.tokens.length - 1].identifierRole = U.ImportDeclaration, R.tokens[R.tokens.length - 4].isType = !0, R.tokens[R.tokens.length - 3].isType = !0, R.tokens[R.tokens.length - 2].isType = !0, R.tokens[R.tokens.length - 1].isType = !0;
}
function Ys() {
	if (Z(), J(P.comma) || J(P.braceR)) {
		R.tokens[R.tokens.length - 1].identifierRole = U.ExportAccess;
		return;
	}
	if (Z(), J(P.comma) || J(P.braceR)) {
		R.tokens[R.tokens.length - 1].identifierRole = U.ExportAccess, R.tokens[R.tokens.length - 2].isType = !0, R.tokens[R.tokens.length - 1].isType = !0;
		return;
	}
	if (Z(), J(P.comma) || J(P.braceR)) {
		R.tokens[R.tokens.length - 3].identifierRole = U.ExportAccess;
		return;
	}
	Z(), R.tokens[R.tokens.length - 3].identifierRole = U.ExportAccess, R.tokens[R.tokens.length - 4].isType = !0, R.tokens[R.tokens.length - 3].isType = !0, R.tokens[R.tokens.length - 2].isType = !0, R.tokens[R.tokens.length - 1].isType = !0;
}
function Xs() {
	if (B(N._abstract) && wi() === P._class) return R.type = P._abstract, W(), Sd(!0, !0), !0;
	if (B(N._interface)) {
		let e = G(2);
		return zs(N._interface, !0), K(e), !0;
	}
	return !1;
}
function Zs() {
	if (R.type === P._const) {
		let e = Ei();
		if (e.type === P.name && e.contextualKeyword === N._enum) return V(P._const), $r(N._enum), R.tokens[R.tokens.length - 1].type = P._enum, Os(), !0;
	}
	return !1;
}
function Qs(e) {
	let t = R.tokens.length;
	To([
		N._abstract,
		N._readonly,
		N._declare,
		N._static,
		N._override
	]);
	let n = R.tokens.length;
	if (Vo()) {
		let r = e ? t - 1 : t;
		for (let e = r; e < n; e++) R.tokens[e].isType = !0;
		return !0;
	}
	return !1;
}
function $s(e) {
	Rs(e) || ii();
}
function ec() {
	let e = Qr(N._declare);
	e && (R.tokens[R.tokens.length - 1].type = P._declare);
	let t = !1;
	if (J(P.name)) {
		if (e) {
			let e = G(2);
			t = Ls(), K(e);
		} else t = Ls();
	}
	if (!t) {
		if (e) {
			let e = G(2);
			Uu(!0), K(e);
		} else Uu(!0);
	}
}
function tc(e) {
	if (e && (J(P.lessThan) || J(P.bitShiftL)) && Hs(), Qr(N._implements)) {
		R.tokens[R.tokens.length - 1].type = P._implements;
		let e = G(1);
		Cs(), K(e);
	}
}
function nc() {
	Po();
}
function rc() {
	Po();
}
function ic() {
	let e = G(0);
	ti() || q(P.bang), ms(), K(e);
}
function ac() {
	J(P.colon) && _s();
}
function oc(e, t) {
	return Wr ? sc(e, t) : cc(e, t);
}
function sc(e, t) {
	if (!J(P.lessThan)) return jc(e, t);
	let n = R.snapshot(), r = jc(e, t);
	if (R.error) R.restoreFromSnapshot(n);
	else return r;
	return R.type = P.typeParameterStart, Fo(), r = jc(e, t), r || H(), r;
}
function cc(e, t) {
	if (!J(P.lessThan)) return jc(e, t);
	let n = R.snapshot();
	Fo();
	let r = jc(e, t);
	if (r || H(), R.error) R.restoreFromSnapshot(n);
	else return r;
	return jc(e, t);
}
function lc() {
	if (J(P.colon)) {
		let e = R.snapshot();
		fs(P.colon), ei() && H(), J(P.arrow) || H(), R.error && R.restoreFromSnapshot(e);
	}
	return q(P.arrow);
}
function uc() {
	let e = G(0);
	q(P.question), ms(), K(e);
}
function dc() {
	(J(P.lessThan) || J(P.bitShiftL)) && Hs(), Yu();
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/plugins/jsx/index.js
function fc() {
	let e = !1, t = !1;
	for (;;) {
		if (R.pos >= z.length) {
			H("Unterminated JSX contents");
			return;
		}
		let n = z.charCodeAt(R.pos);
		if (n === F.lessThan || n === F.leftCurlyBrace) {
			if (R.pos === R.start) {
				if (n === F.lessThan) {
					R.pos++, Y(P.jsxTagStart);
					return;
				}
				Ki(n);
				return;
			}
			Y(e && !t ? P.jsxEmptyText : P.jsxText);
			return;
		}
		n === F.lineFeed ? e = !0 : n !== F.space && n !== F.carriageReturn && n !== F.tab && (t = !0), R.pos++;
	}
}
function pc(e) {
	for (R.pos++;;) {
		if (R.pos >= z.length) {
			H("Unterminated string constant");
			return;
		}
		if (z.charCodeAt(R.pos) === e) {
			R.pos++;
			break;
		}
		R.pos++;
	}
	Y(P.string);
}
function mc() {
	let e;
	do {
		if (R.pos > z.length) {
			H("Unexpectedly reached the end of input.");
			return;
		}
		e = z.charCodeAt(++R.pos);
	} while (li[e] || e === F.dash);
	Y(P.jsxName);
}
function hc() {
	wc();
}
function gc(e) {
	if (hc(), !q(P.colon)) {
		R.tokens[R.tokens.length - 1].identifierRole = e;
		return;
	}
	hc();
}
function _c() {
	let e = R.tokens.length;
	gc(U.Access);
	let t = !1;
	for (; J(P.dot);) t = !0, wc(), hc();
	if (!t) {
		let t = R.tokens[e], n = z.charCodeAt(t.start);
		n >= F.lowercaseA && n <= F.lowercaseZ && (t.identifierRole = null);
	}
}
function vc() {
	switch (R.type) {
		case P.braceL:
			W(), kc(), wc();
			return;
		case P.jsxTagStart:
			Cc(), wc();
			return;
		case P.string:
			wc();
			return;
		default: H("JSX value should be either an expression or a quoted JSX text");
	}
}
function yc() {
	V(P.ellipsis), kc();
}
function bc(e) {
	if (J(P.jsxTagEnd)) return !1;
	_c(), I && Ss();
	let t = !1;
	for (; !J(P.slash) && !J(P.jsxTagEnd) && !R.error;) {
		if (q(P.braceL)) {
			t = !0, V(P.ellipsis), Ac(), wc();
			continue;
		}
		t && R.end - R.start === 3 && z.charCodeAt(R.start) === F.lowercaseK && z.charCodeAt(R.start + 1) === F.lowercaseE && z.charCodeAt(R.start + 2) === F.lowercaseY && (R.tokens[e].jsxRole = pi.KeyAfterPropSpread), gc(U.ObjectKey), J(P.eq) && (wc(), vc());
	}
	let n = J(P.slash);
	return n && wc(), n;
}
function xc() {
	J(P.jsxTagEnd) || _c();
}
function Sc() {
	let e = R.tokens.length - 1;
	R.tokens[e].jsxRole = pi.NoChildren;
	let t = 0;
	if (!bc(e)) for (Tc();;) switch (R.type) {
		case P.jsxTagStart:
			if (wc(), J(P.slash)) {
				wc(), xc(), R.tokens[e].jsxRole !== pi.KeyAfterPropSpread && (t === 1 ? R.tokens[e].jsxRole = pi.OneChild : t > 1 && (R.tokens[e].jsxRole = pi.StaticChildren));
				return;
			}
			t++, Sc(), Tc();
			break;
		case P.jsxText:
			t++, Tc();
			break;
		case P.jsxEmptyText:
			Tc();
			break;
		case P.braceL:
			W(), J(P.ellipsis) ? (yc(), Tc(), t += 2) : (J(P.braceR) || (t++, kc()), Tc());
			break;
		// istanbul ignore next - should never happen
		default:
			H();
			return;
	}
}
function Cc() {
	wc(), Sc();
}
function wc() {
	R.tokens.push(new bi()), Pi(), R.start = R.pos;
	let e = z.charCodeAt(R.pos);
	if (ui[e]) mc();
	else if (e === F.quotationMark || e === F.apostrophe) pc(e);
	else switch (++R.pos, e) {
		case F.greaterThan:
			Y(P.jsxTagEnd);
			break;
		case F.lessThan:
			Y(P.jsxTagStart);
			break;
		case F.slash:
			Y(P.slash);
			break;
		case F.equalsTo:
			Y(P.eq);
			break;
		case F.leftCurlyBrace:
			Y(P.braceL);
			break;
		case F.dot:
			Y(P.dot);
			break;
		case F.colon:
			Y(P.colon);
			break;
		default: H();
	}
}
function Tc() {
	R.tokens.push(new bi()), R.start = R.pos, fc();
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/plugins/types.js
function Ec(e) {
	if (J(P.question)) {
		let e = wi();
		if (e === P.colon || e === P.comma || e === P.parenR) return;
	}
	Pc(e);
}
function Dc() {
	Ci(P.question), J(P.colon) && (I ? _s() : L && fu());
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/traverser/expression.js
var Oc = class {
	constructor(e) {
		this.stop = e;
	}
};
function kc(e = !1) {
	if (Ac(e), J(P.comma)) for (; q(P.comma);) Ac(e);
}
function Ac(e = !1, t = !1) {
	return I ? oc(e, t) : L ? Pu(e, t) : jc(e, t);
}
function jc(e, t) {
	if (J(P._yield)) return yl(), !1;
	(J(P.parenL) || J(P.name) || J(P._yield)) && (R.potentialArrowAt = R.start);
	let n = Mc(e);
	return t && nl(), R.type & P.IS_ASSIGN ? (W(), Ac(e), !1) : n;
}
function Mc(e) {
	return Fc(e) ? !0 : (Nc(e), !1);
}
function Nc(e) {
	I || L ? Ec(e) : Pc(e);
}
function Pc(e) {
	q(P.question) && (Ac(), V(P.colon), Ac(e));
}
function Fc(e) {
	let t = R.tokens.length;
	return Lc() ? !0 : (Ic(t, -1, e), !1);
}
function Ic(e, t, n) {
	if (I && (P._in & P.PRECEDENCE_MASK) > t && !ti() && (Qr(N._as) || Qr(N._satisfies))) {
		let r = G(1);
		vs(), K(r), Ui(), Ic(e, t, n);
		return;
	}
	let r = R.type & P.PRECEDENCE_MASK;
	if (r > 0 && (!n || !J(P._in)) && r > t) {
		let i = R.type;
		W(), i === P.nullishCoalescing && (R.tokens[R.tokens.length - 1].nullishStartIndex = e);
		let a = R.tokens.length;
		Lc(), Ic(a, i & P.IS_RIGHT_ASSOCIATIVE ? r - 1 : r, n), i === P.nullishCoalescing && (R.tokens[e].numNullishCoalesceStarts++, R.tokens[R.tokens.length - 1].numNullishCoalesceEnds++), Ic(e, t, n);
	}
}
function Lc() {
	if (I && !Wr && q(P.lessThan)) return xs(), !1;
	if (B(N._module) && ki() === F.leftCurlyBrace && !ni()) return bl(), !1;
	if (R.type & P.IS_PREFIX) return W(), Lc(), !1;
	if (Rc()) return !0;
	for (; R.type & P.IS_POSTFIX && !ei();) R.type === P.preIncDec && (R.type = P.postIncDec), W();
	return !1;
}
function Rc() {
	let e = R.tokens.length;
	return Jc() ? !0 : (zc(e), R.tokens.length > e && R.tokens[e].isOptionalChainStart && (R.tokens[R.tokens.length - 1].isOptionalChainEnd = !0), !1);
}
function zc(e, t = !1) {
	L ? Iu(e, t) : Bc(e, t);
}
function Bc(e, t = !1) {
	let n = new Oc(!1);
	do
		Vc(e, t, n);
	while (!n.stop && !R.error);
}
function Vc(e, t, n) {
	I ? Ks(e, t, n) : L ? gu(e, t, n) : Hc(e, t, n);
}
function Hc(e, t, n) {
	if (!t && q(P.doubleColon)) qc(), n.stop = !0, zc(e, t);
	else if (J(P.questionDot)) {
		if (R.tokens[e].isOptionalChainStart = !0, t && wi() === P.parenL) {
			n.stop = !0;
			return;
		}
		W(), R.tokens[R.tokens.length - 1].subscriptStartIndex = e, q(P.bracketL) ? (kc(), V(P.bracketR)) : q(P.parenL) ? Wc() : Yc();
	} else if (q(P.dot)) R.tokens[R.tokens.length - 1].subscriptStartIndex = e, Yc();
	else if (q(P.bracketL)) R.tokens[R.tokens.length - 1].subscriptStartIndex = e, kc(), V(P.bracketR);
	else if (!t && J(P.parenL)) {
		if (Uc()) {
			let t = R.snapshot(), r = R.tokens.length;
			W(), R.tokens[R.tokens.length - 1].subscriptStartIndex = e;
			let i = Kr();
			R.tokens[R.tokens.length - 1].contextId = i, Wc(), R.tokens[R.tokens.length - 1].contextId = i, Gc() && (R.restoreFromSnapshot(t), n.stop = !0, R.scopeDepth++, xd(), Kc(r));
		} else {
			W(), R.tokens[R.tokens.length - 1].subscriptStartIndex = e;
			let t = Kr();
			R.tokens[R.tokens.length - 1].contextId = t, Wc(), R.tokens[R.tokens.length - 1].contextId = t;
		}
	} else J(P.backQuote) ? al() : n.stop = !0;
}
function Uc() {
	return R.tokens[R.tokens.length - 1].contextualKeyword === N._async && !ei();
}
function Wc() {
	let e = !0;
	for (; !q(P.parenR) && !R.error;) {
		if (e) e = !1;
		else if (V(P.comma), q(P.parenR)) break;
		_l(!1);
	}
}
function Gc() {
	return J(P.colon) || J(P.arrow);
}
function Kc(e) {
	I ? ac() : L && Nu(), V(P.arrow), pl(e);
}
function qc() {
	let e = R.tokens.length;
	Jc(), zc(e, !0);
}
function Jc() {
	if (q(P.modulo)) return Z(), !1;
	if (J(P.jsxText) || J(P.jsxEmptyText)) return Zc(), !1;
	if (J(P.lessThan) && Wr) return R.type = P.jsxTagStart, Cc(), W(), !1;
	let e = R.potentialArrowAt === R.start;
	switch (R.type) {
		case P.slash:
		case P.assign: Si();
		case P._super:
		case P._this:
		case P.regexp:
		case P.num:
		case P.bigint:
		case P.decimal:
		case P.string:
		case P._null:
		case P._true:
		case P._false: return W(), !1;
		case P._import: return W(), J(P.dot) && (R.tokens[R.tokens.length - 1].type = P.name, W(), Z()), !1;
		case P.name: {
			let t = R.tokens.length, n = R.start, r = R.contextualKeyword;
			return Z(), r === N._await ? (vl(), !1) : r === N._async && J(P._function) && !ei() ? (W(), bd(n, !1), !1) : e && r === N._async && !ei() && J(P.name) ? (R.scopeDepth++, mo(!1), V(P.arrow), pl(t), !0) : J(P._do) && !ei() ? (W(), md(), !1) : e && !ei() && J(P.arrow) ? (R.scopeDepth++, go(!1), V(P.arrow), pl(t), !0) : (R.tokens[R.tokens.length - 1].identifierRole = U.Access, !1);
		}
		case P._do: return W(), md(), !1;
		case P.parenL: return $c(e);
		case P.bracketL: return W(), gl(P.bracketR, !0), !1;
		case P.braceL: return ol(!1, !1), !1;
		case P._function: return Xc(), !1;
		case P.at: Ku();
		case P._class: return Sd(!1), !1;
		case P._new: return rl(), !1;
		case P.backQuote: return al(), !1;
		case P.doubleColon: return W(), qc(), !1;
		case P.hash: {
			let e = ki();
			return ui[e] || e === F.backslash ? Yc() : W(), !1;
		}
		default: return H(), !1;
	}
}
function Yc() {
	q(P.hash), Z();
}
function Xc() {
	let e = R.start;
	Z(), q(P.dot) && Z(), bd(e, !1);
}
function Zc() {
	W();
}
function Qc() {
	V(P.parenL), kc(), V(P.parenR);
}
function $c(e) {
	let t = R.snapshot(), n = R.tokens.length;
	V(P.parenL);
	let r = !0;
	for (; !J(P.parenR) && !R.error;) {
		if (r) r = !1;
		else if (V(P.comma), J(P.parenR)) break;
		if (J(P.ellipsis)) {
			po(!1), nl();
			break;
		}
		Ac(!1, !0);
	}
	return V(P.parenR), e && el() && tl() ? (R.restoreFromSnapshot(t), R.scopeDepth++, xd(), tl(), pl(n), !R.error || (R.restoreFromSnapshot(t), $c(!1), !1)) : !1;
}
function el() {
	return J(P.colon) || !ei();
}
function tl() {
	return I ? lc() : L ? Fu() : q(P.arrow);
}
function nl() {
	(I || L) && Dc();
}
function rl() {
	if (V(P._new), q(P.dot)) {
		Z();
		return;
	}
	il(), L && _u(), q(P.parenL) && gl(P.parenR);
}
function il() {
	qc(), q(P.questionDot);
}
function al() {
	for (xi(), xi(); !J(P.backQuote) && !R.error;) V(P.dollarBraceL), kc(), xi(), xi();
	W();
}
function ol(e, t) {
	let n = Kr(), r = !0;
	for (W(), R.tokens[R.tokens.length - 1].contextId = n; !q(P.braceR) && !R.error;) {
		if (r) r = !1;
		else if (V(P.comma), q(P.braceR)) break;
		let i = !1;
		if (J(P.ellipsis)) {
			let n = R.tokens.length;
			if (fo(), e && (R.tokens.length === n + 2 && go(t), q(P.braceR))) break;
			continue;
		}
		e || (i = q(P.star)), !e && B(N._async) ? (i && H(), Z(), J(P.colon) || J(P.parenL) || J(P.braceR) || J(P.eq) || J(P.comma) || (J(P.star) && (W(), i = !0), dl(n))) : dl(n), ul(e, t, n);
	}
	R.tokens[R.tokens.length - 1].contextId = n;
}
function sl(e) {
	return !e && (J(P.string) || J(P.num) || J(P.bracketL) || J(P.name) || !!(R.type & P.IS_KEYWORD));
}
function cl(e, t) {
	let n = R.start;
	return J(P.parenL) ? (e && H(), fl(n, !1), !0) : sl(e) ? (dl(t), fl(n, !1), !0) : !1;
}
function ll(e, t) {
	if (q(P.colon)) {
		e ? xo(t) : Ac(!1);
		return;
	}
	let n;
	n = e ? R.scopeDepth === 0 ? U.ObjectShorthandTopLevelDeclaration : t ? U.ObjectShorthandBlockScopedDeclaration : U.ObjectShorthandFunctionScopedDeclaration : U.ObjectShorthand, R.tokens[R.tokens.length - 1].identifierRole = n, xo(t, !0);
}
function ul(e, t, n) {
	I ? nc() : L && Du(), cl(e, n) || ll(e, t);
}
function dl(e) {
	L && mu(), q(P.bracketL) ? (R.tokens[R.tokens.length - 1].contextId = e, Ac(), V(P.bracketR), R.tokens[R.tokens.length - 1].contextId = e) : (J(P.num) || J(P.string) || J(P.bigint) || J(P.decimal) ? Jc() : Yc(), R.tokens[R.tokens.length - 1].identifierRole = U.ObjectKey, R.tokens[R.tokens.length - 1].contextId = e);
}
function fl(e, t) {
	let n = Kr();
	R.scopeDepth++;
	let r = R.tokens.length;
	xd(t, n), ml(e, n);
	let i = R.tokens.length;
	R.scopes.push(new Vr(r, i, !0)), R.scopeDepth--;
}
function pl(e) {
	hl(!0);
	let t = R.tokens.length;
	R.scopes.push(new Vr(e, t, !0)), R.scopeDepth--;
}
function ml(e, t = 0) {
	I ? Gs(e, t) : L ? hu(t) : hl(!1, t);
}
function hl(e, t = 0) {
	e && !J(P.braceL) ? Ac() : md(!0, t);
}
function gl(e, t = !1) {
	let n = !0;
	for (; !q(e) && !R.error;) {
		if (n) n = !1;
		else if (V(P.comma), q(e)) break;
		_l(t);
	}
}
function _l(e) {
	e && J(P.comma) || (J(P.ellipsis) ? (fo(), nl()) : J(P.question) ? W() : Ac(!1, !0));
}
function Z() {
	W(), R.tokens[R.tokens.length - 1].type = P.name;
}
function vl() {
	Lc();
}
function yl() {
	W(), !J(P.semi) && !ei() && (q(P.star), Ac());
}
function bl() {
	$r(N._module), V(P.braceL), hd(P.braceR);
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/plugins/flow.js
function xl(e) {
	return (e.type === P.name || !!(e.type & P.IS_KEYWORD)) && e.contextualKeyword !== N._from;
}
function Sl(e) {
	let t = G(0);
	V(e || P.colon), du(), K(t);
}
function Cl() {
	V(P.modulo), $r(N._checks), q(P.parenL) && (kc(), V(P.parenR));
}
function wl() {
	let e = G(0);
	V(P.colon), J(P.modulo) ? Cl() : (du(), J(P.modulo) && Cl()), K(e);
}
function Tl() {
	W(), Fl(!0);
}
function El() {
	W(), Z(), J(P.lessThan) && Hl(), V(P.parenL), iu(), V(P.parenR), wl(), ii();
}
function Dl() {
	J(P._class) ? Tl() : J(P._function) ? El() : J(P._var) ? Ol() : Qr(N._module) ? q(P.dot) ? jl() : kl() : B(N._type) ? Ml() : B(N._opaque) ? Nl() : B(N._interface) ? Pl() : J(P._export) ? Al() : H();
}
function Ol() {
	W(), pu(), ii();
}
function kl() {
	for (J(P.string) ? Jc() : Z(), V(P.braceL); !J(P.braceR) && !R.error;) J(P._import) ? (W(), Yd()) : H();
	V(P.braceR);
}
function Al() {
	V(P._export), q(P._default) ? J(P._function) || J(P._class) ? Dl() : (du(), ii()) : J(P._var) || J(P._function) || J(P._class) || B(N._opaque) ? Dl() : J(P.star) || J(P.braceL) || B(N._interface) || B(N._type) || B(N._opaque) ? Pd() : H();
}
function jl() {
	$r(N._exports), fu(), ii();
}
function Ml() {
	W(), zl();
}
function Nl() {
	W(), Bl(!0);
}
function Pl() {
	W(), Fl();
}
function Fl(e = !1) {
	if (Rl(), J(P.lessThan) && Hl(), q(P._extends)) do
		Il();
	while (!e && q(P.comma));
	if (B(N._mixins)) {
		W();
		do
			Il();
		while (q(P.comma));
	}
	if (B(N._implements)) {
		W();
		do
			Il();
		while (q(P.comma));
	}
	Xl(e, !1, e);
}
function Il() {
	$l(!1), J(P.lessThan) && Ul();
}
function Ll() {
	Fl();
}
function Rl() {
	Z();
}
function zl() {
	Rl(), J(P.lessThan) && Hl(), Sl(P.eq), ii();
}
function Bl(e) {
	$r(N._type), Rl(), J(P.lessThan) && Hl(), J(P.colon) && Sl(P.colon), e || Sl(P.eq), ii();
}
function Vl() {
	mu(), pu(), q(P.eq) && du();
}
function Hl() {
	let e = G(0);
	// istanbul ignore else: this condition is already checked at all call sites
	J(P.lessThan) || J(P.typeParameterStart) ? W() : H();
	do
		Vl(), J(P.greaterThan) || V(P.comma);
	while (!J(P.greaterThan) && !R.error);
	V(P.greaterThan), K(e);
}
function Ul() {
	let e = G(0);
	for (V(P.lessThan); !J(P.greaterThan) && !R.error;) du(), J(P.greaterThan) || V(P.comma);
	V(P.greaterThan), K(e);
}
function Wl() {
	if ($r(N._interface), q(P._extends)) do
		Il();
	while (q(P.comma));
	Xl(!1, !1, !1);
}
function Gl() {
	J(P.num) || J(P.string) ? Jc() : Z();
}
function Kl() {
	wi() === P.colon ? (Gl(), Sl()) : du(), V(P.bracketR), Sl();
}
function ql() {
	Gl(), V(P.bracketR), V(P.bracketR), J(P.lessThan) || J(P.parenL) ? Jl() : (q(P.question), Sl());
}
function Jl() {
	for (J(P.lessThan) && Hl(), V(P.parenL); !J(P.parenR) && !J(P.ellipsis) && !R.error;) ru(), J(P.parenR) || V(P.comma);
	q(P.ellipsis) && ru(), V(P.parenR), Sl();
}
function Yl() {
	Jl();
}
function Xl(e, t, n) {
	let r;
	for (t && J(P.braceBarL) ? (V(P.braceBarL), r = P.braceBarR) : (V(P.braceL), r = P.braceR); !J(r) && !R.error;) {
		if (n && B(N._proto)) {
			let t = wi();
			t !== P.colon && t !== P.question && (W(), e = !1);
		}
		if (e && B(N._static)) {
			let e = wi();
			e !== P.colon && e !== P.question && W();
		}
		if (mu(), q(P.bracketL)) q(P.bracketL) ? ql() : Kl();
		else if (J(P.parenL) || J(P.lessThan)) Yl();
		else {
			if (B(N._get) || B(N._set)) {
				let e = wi();
				(e === P.name || e === P.string || e === P.num) && W();
			}
			Zl();
		}
		Ql();
	}
	V(r);
}
function Zl() {
	if (J(P.ellipsis)) {
		if (V(P.ellipsis), q(P.comma) || q(P.semi), J(P.braceR)) return;
		du();
	} else Gl(), J(P.lessThan) || J(P.parenL) ? Jl() : (q(P.question), Sl());
}
function Ql() {
	!q(P.semi) && !q(P.comma) && !J(P.braceR) && !J(P.braceBarR) && H();
}
function $l(e) {
	for (e || Z(); q(P.dot);) Z();
}
function eu() {
	$l(!0), J(P.lessThan) && Ul();
}
function tu() {
	V(P._typeof), au();
}
function nu() {
	for (V(P.bracketL); R.pos < z.length && !J(P.bracketR) && (du(), !J(P.bracketR));) V(P.comma);
	V(P.bracketR);
}
function ru() {
	let e = wi();
	e === P.colon || e === P.question ? (Z(), q(P.question), Sl()) : du();
}
function iu() {
	for (; !J(P.parenR) && !J(P.ellipsis) && !R.error;) ru(), J(P.parenR) || V(P.comma);
	q(P.ellipsis) && ru();
}
function au() {
	let e = !1, t = R.noAnonFunctionType;
	switch (R.type) {
		case P.name:
			if (B(N._interface)) {
				Wl();
				return;
			}
			Z(), eu();
			return;
		case P.braceL:
			Xl(!1, !1, !1);
			return;
		case P.braceBarL:
			Xl(!1, !0, !1);
			return;
		case P.bracketL:
			nu();
			return;
		case P.lessThan:
			Hl(), V(P.parenL), iu(), V(P.parenR), V(P.arrow), du();
			return;
		case P.parenL:
			if (W(), !J(P.parenR) && !J(P.ellipsis)) {
				if (J(P.name)) {
					let t = wi();
					e = t !== P.question && t !== P.colon;
				} else e = !0;
			}
			if (e) {
				if (R.noAnonFunctionType = !1, du(), R.noAnonFunctionType = t, R.noAnonFunctionType || !(J(P.comma) || J(P.parenR) && wi() === P.arrow)) {
					V(P.parenR);
					return;
				}
				q(P.comma);
			}
			iu(), V(P.parenR), V(P.arrow), du();
			return;
		case P.minus:
			W(), Zc();
			return;
		case P.string:
		case P.num:
		case P._true:
		case P._false:
		case P._null:
		case P._this:
		case P._void:
		case P.star:
			W();
			return;
		default:
			if (R.type === P._typeof) {
				tu();
				return;
			}
			if (R.type & P.IS_KEYWORD) {
				W(), R.tokens[R.tokens.length - 1].type = P.name;
				return;
			}
	}
	H();
}
function ou() {
	for (au(); !ei() && (J(P.bracketL) || J(P.questionDot));) q(P.questionDot), V(P.bracketL), q(P.bracketR) || (du(), V(P.bracketR));
}
function su() {
	q(P.question) ? su() : ou();
}
function cu() {
	su(), !R.noAnonFunctionType && q(P.arrow) && du();
}
function lu() {
	for (q(P.bitwiseAND), cu(); q(P.bitwiseAND);) cu();
}
function uu() {
	for (q(P.bitwiseOR), lu(); q(P.bitwiseOR);) lu();
}
function du() {
	uu();
}
function fu() {
	Sl();
}
function pu() {
	Z(), J(P.colon) && fu();
}
function mu() {
	(J(P.plus) || J(P.minus)) && (W(), R.tokens[R.tokens.length - 1].isType = !0);
}
function hu(e) {
	J(P.colon) && wl(), hl(!1, e);
}
function gu(e, t, n) {
	if (J(P.questionDot) && wi() === P.lessThan) {
		if (t) {
			n.stop = !0;
			return;
		}
		W(), Ul(), V(P.parenL), Wc();
		return;
	}
	if (!t && J(P.lessThan)) {
		let e = R.snapshot();
		if (Ul(), V(P.parenL), Wc(), R.error) R.restoreFromSnapshot(e);
		else return;
	}
	Hc(e, t, n);
}
function _u() {
	if (J(P.lessThan)) {
		let e = R.snapshot();
		Ul(), R.error && R.restoreFromSnapshot(e);
	}
}
function vu() {
	if (J(P.name) && R.contextualKeyword === N._interface) {
		let e = G(0);
		return W(), Ll(), K(e), !0;
	}
	return B(N._enum) ? (Ru(), !0) : !1;
}
function yu() {
	return B(N._enum) ? (Ru(), !0) : !1;
}
function bu(e) {
	if (e === N._declare) {
		if (J(P._class) || J(P.name) || J(P._function) || J(P._var) || J(P._export)) {
			let e = G(1);
			Dl(), K(e);
		}
	} else if (J(P.name)) {
		if (e === N._interface) {
			let e = G(1);
			Ll(), K(e);
		} else if (e === N._type) {
			let e = G(1);
			zl(), K(e);
		} else if (e === N._opaque) {
			let e = G(1);
			Bl(!1), K(e);
		}
	}
	ii();
}
function xu() {
	return B(N._type) || B(N._interface) || B(N._opaque) || B(N._enum);
}
function Su() {
	return J(P.name) && (R.contextualKeyword === N._type || R.contextualKeyword === N._interface || R.contextualKeyword === N._opaque || R.contextualKeyword === N._enum);
}
function Cu() {
	if (B(N._type)) {
		let e = G(1);
		W(), J(P.braceL) ? (Gd(), zd()) : zl(), K(e);
	} else if (B(N._opaque)) {
		let e = G(1);
		W(), Bl(!1), K(e);
	} else if (B(N._interface)) {
		let e = G(1);
		W(), Ll(), K(e);
	} else Uu(!0);
}
function wu() {
	return J(P.star) || B(N._type) && wi() === P.star;
}
function Tu() {
	if (Qr(N._type)) {
		let e = G(2);
		Hd(), K(e);
	} else Hd();
}
function Eu(e) {
	if (e && J(P.lessThan) && Ul(), B(N._implements)) {
		let e = G(0);
		W(), R.tokens[R.tokens.length - 1].type = P._implements;
		do
			Rl(), J(P.lessThan) && Ul();
		while (q(P.comma));
		K(e);
	}
}
function Du() {
	J(P.lessThan) && (Hl(), J(P.parenL) || H());
}
function Ou() {
	let e = G(0);
	q(P.question), J(P.colon) && fu(), K(e);
}
function ku() {
	if (J(P._typeof) || B(N._type)) {
		let e = Ei();
		(xl(e) || e.type === P.braceL || e.type === P.star) && W();
	}
}
function Au() {
	let e = R.contextualKeyword === N._type || R.type === P._typeof;
	e ? W() : Z(), B(N._as) && !Zr(N._as) ? (Z(), e && !J(P.name) && !(R.type & P.IS_KEYWORD) || Z()) : (e && (J(P.name) || R.type & P.IS_KEYWORD) && Z(), Qr(N._as) && Z());
}
function ju() {
	if (J(P.lessThan)) {
		let e = G(0);
		Hl(), K(e);
	}
}
function Mu() {
	J(P.colon) && fu();
}
function Nu() {
	if (J(P.colon)) {
		let e = R.noAnonFunctionType;
		R.noAnonFunctionType = !0, fu(), R.noAnonFunctionType = e;
	}
}
function Pu(e, t) {
	if (J(P.lessThan)) {
		let n = R.snapshot(), r = jc(e, t);
		if (R.error) R.restoreFromSnapshot(n), R.type = P.typeParameterStart;
		else return r;
		let i = G(0);
		if (Hl(), K(i), r = jc(e, t), r) return !0;
		H();
	}
	return jc(e, t);
}
function Fu() {
	if (J(P.colon)) {
		let e = G(0), t = R.snapshot(), n = R.noAnonFunctionType;
		R.noAnonFunctionType = !0, wl(), R.noAnonFunctionType = n, ei() && H(), J(P.arrow) || H(), R.error && R.restoreFromSnapshot(t), K(e);
	}
	return q(P.arrow);
}
function Iu(e, t = !1) {
	if (R.tokens[R.tokens.length - 1].contextualKeyword === N._async && J(P.lessThan)) {
		let e = R.snapshot();
		if (Lu() && !R.error) return;
		R.restoreFromSnapshot(e);
	}
	Bc(e, t);
}
function Lu() {
	R.scopeDepth++;
	let e = R.tokens.length;
	return xd(), tl() ? (pl(e), !0) : !1;
}
function Ru() {
	$r(N._enum), R.tokens[R.tokens.length - 1].type = P._enum, Z(), zu();
}
function zu() {
	Qr(N._of) && W(), V(P.braceL), Bu(), V(P.braceR);
}
function Bu() {
	for (; !J(P.braceR) && !R.error && !q(P.ellipsis);) Vu(), J(P.braceR) || V(P.comma);
}
function Vu() {
	Z(), q(P.eq) && W();
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/traverser/statement.js
function Hu() {
	if (hd(P.eof), R.scopes.push(new Vr(0, R.tokens.length, !0)), R.scopeDepth !== 0) throw Error(`Invalid scope depth at end of file: ${R.scopeDepth}`);
	return new nf(R.tokens, R.scopes);
}
function Uu(e) {
	L && vu() || (J(P.at) && Ku(), Wu(e));
}
function Wu(e) {
	if (I && Zs()) return;
	let t = R.type;
	switch (t) {
		case P._break:
		case P._continue:
			Xu();
			return;
		case P._debugger:
			Zu();
			return;
		case P._do:
			Qu();
			return;
		case P._for:
			$u();
			return;
		case P._function:
			if (wi() === P.dot) break;
			e || H(), nd();
			return;
		case P._class:
			e || H(), Sd(!0);
			return;
		case P._if:
			rd();
			return;
		case P._return:
			id();
			return;
		case P._switch:
			ad();
			return;
		case P._throw:
			od();
			return;
		case P._try:
			cd();
			return;
		case P._let:
		case P._const: e || H();
		case P._var:
			ld(t !== P._var);
			return;
		case P._while:
			ud();
			return;
		case P.braceL:
			md();
			return;
		case P.semi:
			dd();
			return;
		case P._export:
		case P._import: {
			let e = wi();
			if (e === P.parenL || e === P.dot) break;
			W(), t === P._import ? Yd() : Pd();
			return;
		}
		case P.name: if (R.contextualKeyword === N._async) {
			let e = R.start, t = R.snapshot();
			if (W(), J(P._function) && !ei()) {
				V(P._function), bd(e, !0);
				return;
			}
			R.restoreFromSnapshot(t);
		} else if (R.contextualKeyword === N._using && !ni() && wi() === P.name) {
			ld(!0);
			return;
		} else if (Gu()) {
			$r(N._await), ld(!0);
			return;
		}
	}
	let n = R.tokens.length;
	kc();
	let r = null;
	if (R.tokens.length === n + 1) {
		let e = R.tokens[R.tokens.length - 1];
		e.type === P.name && (r = e.contextualKeyword);
	}
	if (r == null) {
		ii();
		return;
	}
	q(P.colon) ? fd() : pd(r);
}
function Gu() {
	if (!B(N._await)) return !1;
	let e = R.snapshot();
	return W(), !B(N._using) || ti() || (W(), !J(P.name) || ti()) ? (R.restoreFromSnapshot(e), !1) : (R.restoreFromSnapshot(e), !0);
}
function Ku() {
	for (; J(P.at);) qu();
}
function qu() {
	if (W(), q(P.parenL)) kc(), V(P.parenR);
	else {
		for (Z(); q(P.dot);) Z();
		Ju();
	}
}
function Ju() {
	I ? dc() : Yu();
}
function Yu() {
	q(P.parenL) && Wc();
}
function Xu() {
	W(), ri() || (Z(), ii());
}
function Zu() {
	W(), ii();
}
function Qu() {
	W(), Uu(!1), V(P._while), Qc(), q(P.semi);
}
function $u() {
	R.scopeDepth++;
	let e = R.tokens.length;
	td();
	let t = R.tokens.length;
	R.scopes.push(new Vr(e, t, !1)), R.scopeDepth--;
}
function ed() {
	return !(!B(N._using) || Zr(N._of));
}
function td() {
	W();
	let e = !1;
	if (B(N._await) && (e = !0, W()), V(P.parenL), J(P.semi)) {
		e && H(), gd();
		return;
	}
	let t = Gu();
	if (t || J(P._var) || J(P._let) || J(P._const) || ed()) {
		if (t && $r(N._await), W(), vd(!0, R.type !== P._var), J(P._in) || B(N._of)) {
			_d(e);
			return;
		}
		gd();
		return;
	}
	if (kc(!0), J(P._in) || B(N._of)) {
		_d(e);
		return;
	}
	e && H(), gd();
}
function nd() {
	let e = R.start;
	W(), bd(e, !0);
}
function rd() {
	W(), Qc(), Uu(!1), q(P._else) && Uu(!1);
}
function id() {
	W(), ri() || (kc(), ii());
}
function ad() {
	W(), Qc(), R.scopeDepth++;
	let e = R.tokens.length;
	for (V(P.braceL); !J(P.braceR) && !R.error;) if (J(P._case) || J(P._default)) {
		let e = J(P._case);
		W(), e && kc(), V(P.colon);
	} else Uu(!0);
	W();
	let t = R.tokens.length;
	R.scopes.push(new Vr(e, t, !1)), R.scopeDepth--;
}
function od() {
	W(), kc(), ii();
}
function sd() {
	_o(!0), I && ms();
}
function cd() {
	if (W(), md(), J(P._catch)) {
		W();
		let e = null;
		if (J(P.parenL) && (R.scopeDepth++, e = R.tokens.length, V(P.parenL), sd(), V(P.parenR)), md(), e != null) {
			let t = R.tokens.length;
			R.scopes.push(new Vr(e, t, !1)), R.scopeDepth--;
		}
	}
	q(P._finally) && md();
}
function ld(e) {
	W(), vd(!1, e), ii();
}
function ud() {
	W(), Qc(), Uu(!1);
}
function dd() {
	W();
}
function fd() {
	Uu(!0);
}
function pd(e) {
	I ? $s(e) : L ? bu(e) : ii();
}
function md(e = !1, t = 0) {
	let n = R.tokens.length;
	R.scopeDepth++, V(P.braceL), t && (R.tokens[R.tokens.length - 1].contextId = t), hd(P.braceR), t && (R.tokens[R.tokens.length - 1].contextId = t);
	let r = R.tokens.length;
	R.scopes.push(new Vr(n, r, e)), R.scopeDepth--;
}
function hd(e) {
	for (; !q(e) && !R.error;) Uu(!0);
}
function gd() {
	V(P.semi), J(P.semi) || kc(), V(P.semi), J(P.parenR) || kc(), V(P.parenR), Uu(!1);
}
function _d(e) {
	e ? Qr(N._of) : W(), kc(), V(P.parenR), Uu(!1);
}
function vd(e, t) {
	for (;;) {
		if (yd(t), q(P.eq)) {
			let t = R.tokens.length - 1;
			Ac(e), R.tokens[t].rhsEndIndex = R.tokens.length;
		}
		if (!q(P.comma)) break;
	}
}
function yd(e) {
	_o(e), I ? ic() : L && Mu();
}
function bd(e, t, n = !1) {
	J(P.star) && W(), t && !n && !J(P.name) && !J(P._yield) && H();
	let r = null;
	J(P.name) && (t || (r = R.tokens.length, R.scopeDepth++), mo(!1));
	let i = R.tokens.length;
	R.scopeDepth++, xd(), ml(e);
	let a = R.tokens.length;
	R.scopes.push(new Vr(i, a, !0)), R.scopeDepth--, r !== null && (R.scopes.push(new Vr(r, a, !0)), R.scopeDepth--);
}
function xd(e = !1, t = 0) {
	I ? rc() : L && ju(), V(P.parenL), t && (R.tokens[R.tokens.length - 1].contextId = t), vo(P.parenR, !1, !1, e, t), t && (R.tokens[R.tokens.length - 1].contextId = t);
}
function Sd(e, t = !1) {
	let n = Kr();
	W(), R.tokens[R.tokens.length - 1].contextId = n, R.tokens[R.tokens.length - 1].isExpression = !e;
	let r = null;
	e || (r = R.tokens.length, R.scopeDepth++), Md(e, t), Nd();
	let i = R.tokens.length;
	if (Td(n), !R.error && (R.tokens[i].contextId = n, R.tokens[R.tokens.length - 1].contextId = n, r !== null)) {
		let e = R.tokens.length;
		R.scopes.push(new Vr(r, e, !1)), R.scopeDepth--;
	}
}
function Cd() {
	return J(P.eq) || J(P.semi) || J(P.braceR) || J(P.bang) || J(P.colon);
}
function wd() {
	return J(P.parenL) || J(P.lessThan);
}
function Td(e) {
	for (V(P.braceL); !q(P.braceR) && !R.error;) {
		if (q(P.semi)) continue;
		if (J(P.at)) {
			qu();
			continue;
		}
		let t = R.start;
		Ed(t, e);
	}
}
function Ed(e, t) {
	I && To([
		N._declare,
		N._public,
		N._protected,
		N._private,
		N._override
	]);
	let n = !1;
	if (J(P.name) && R.contextualKeyword === N._static) {
		if (Z(), wd()) {
			Od(e, !1);
			return;
		}
		if (Cd()) {
			jd();
			return;
		}
		if (R.tokens[R.tokens.length - 1].type = P._static, n = !0, J(P.braceL)) {
			R.tokens[R.tokens.length - 1].contextId = t, md();
			return;
		}
	}
	Dd(e, n, t);
}
function Dd(e, t, n) {
	if (I && Qs(t)) return;
	if (q(P.star)) {
		kd(n), Od(e, !1);
		return;
	}
	kd(n);
	let r = !1, i = R.tokens[R.tokens.length - 1];
	i.contextualKeyword === N._constructor && (r = !0), Ad(), wd() ? Od(e, r) : Cd() ? jd() : i.contextualKeyword === N._async && !ri() ? (R.tokens[R.tokens.length - 1].type = P._async, J(P.star) && W(), kd(n), Ad(), Od(e, !1)) : (i.contextualKeyword === N._get || i.contextualKeyword === N._set) && !(ri() && J(P.star)) ? (i.contextualKeyword === N._get ? R.tokens[R.tokens.length - 1].type = P._get : R.tokens[R.tokens.length - 1].type = P._set, kd(n), Od(e, !1)) : i.contextualKeyword === N._accessor && !ri() ? (kd(n), jd()) : ri() ? jd() : H();
}
function Od(e, t) {
	I ? Po() : L && J(P.lessThan) && Hl(), fl(e, t);
}
function kd(e) {
	dl(e);
}
function Ad() {
	if (I) {
		let e = G(0);
		q(P.question), K(e);
	}
}
function jd() {
	if (I ? (Ci(P.bang), ms()) : L && J(P.colon) && fu(), J(P.eq)) {
		let e = R.tokens.length;
		W(), Ac(), R.tokens[e].rhsEndIndex = R.tokens.length;
	}
	ii();
}
function Md(e, t = !1) {
	(!I || e && !t || !B(N._implements)) && (J(P.name) && mo(!0), I ? Po() : L && J(P.lessThan) && Hl());
}
function Nd() {
	let e = !1;
	q(P._extends) ? (Rc(), e = !0) : e = !1, I ? tc(e) : L && Eu(e);
}
function Pd() {
	let e = R.tokens.length - 1;
	I && qs() || (Bd() ? Vd() : Ld() ? (Z(), J(P.comma) && wi() === P.star ? (V(P.comma), V(P.star), $r(N._as), Z()) : Rd(), zd()) : q(P._default) ? Fd() : Wd() ? Id() : (Gd(), zd()), R.tokens[e].rhsEndIndex = R.tokens.length);
}
function Fd() {
	if (I && Xs() || L && yu()) return;
	let e = R.start;
	q(P._function) ? bd(e, !0, !0) : B(N._async) && wi() === P._function ? (Qr(N._async), q(P._function), bd(e, !0, !0)) : J(P._class) ? Sd(!0, !0) : J(P.at) ? (Ku(), Sd(!0, !0)) : (Ac(), ii());
}
function Id() {
	I ? ec() : L ? Cu() : Uu(!0);
}
function Ld() {
	if (I && Ws() || L && Su()) return !1;
	if (J(P.name)) return R.contextualKeyword !== N._async;
	if (!J(P._default)) return !1;
	let e = Di(), t = Ei(), n = t.type === P.name && t.contextualKeyword === N._from;
	if (t.type === P.comma) return !0;
	if (n) {
		let t = z.charCodeAt(Oi(e + 4));
		return t === F.quotationMark || t === F.apostrophe;
	}
	return !1;
}
function Rd() {
	q(P.comma) && Gd();
}
function zd() {
	Qr(N._from) && (Jc(), ef()), ii();
}
function Bd() {
	return L ? wu() : J(P.star);
}
function Vd() {
	L ? Tu() : Hd();
}
function Hd() {
	V(P.star), B(N._as) ? Ud() : zd();
}
function Ud() {
	W(), R.tokens[R.tokens.length - 1].type = P._as, Z(), Rd(), zd();
}
function Wd() {
	return I && Ws() || L && xu() || R.type === P._var || R.type === P._const || R.type === P._let || R.type === P._function || R.type === P._class || B(N._async) || J(P.at);
}
function Gd() {
	let e = !0;
	for (V(P.braceL); !q(P.braceR) && !R.error;) {
		if (e) e = !1;
		else if (V(P.comma), q(P.braceR)) break;
		Kd();
	}
}
function Kd() {
	if (I) {
		Ys();
		return;
	}
	Z(), R.tokens[R.tokens.length - 1].identifierRole = U.ExportAccess, Qr(N._as) && Z();
}
function qd() {
	let e = R.snapshot();
	return $r(N._module), Qr(N._from) ? B(N._from) ? (R.restoreFromSnapshot(e), !0) : (R.restoreFromSnapshot(e), !1) : J(P.comma) ? (R.restoreFromSnapshot(e), !1) : (R.restoreFromSnapshot(e), !0);
}
function Jd() {
	B(N._module) && qd() && W();
}
function Yd() {
	if (I && J(P.name) && wi() === P.eq) {
		Ms();
		return;
	}
	if (I && B(N._type)) {
		let e = Ei();
		if (e.type === P.name && e.contextualKeyword !== N._from) {
			if ($r(N._type), wi() === P.eq) {
				Ms();
				return;
			}
		} else (e.type === P.star || e.type === P.braceL) && $r(N._type);
	}
	J(P.string) ? Jc() : (Jd(), Qd(), $r(N._from), Jc()), ef(), ii();
}
function Xd() {
	return J(P.name);
}
function Zd() {
	ho();
}
function Qd() {
	L && ku();
	let e = !0;
	if (!(Xd() && (Zd(), !q(P.comma)))) {
		if (J(P.star)) {
			W(), $r(N._as), Zd();
			return;
		}
		for (V(P.braceL); !q(P.braceR) && !R.error;) {
			if (e) e = !1;
			else if (q(P.colon) && H("ES2015 named imports do not destructure. Use another statement for destructuring after the import."), V(P.comma), q(P.braceR)) break;
			$d();
		}
	}
}
function $d() {
	if (I) {
		Js();
		return;
	}
	if (L) {
		Au();
		return;
	}
	ho(), B(N._as) && (R.tokens[R.tokens.length - 1].identifierRole = U.ImportAccess, W(), ho());
}
function ef() {
	(J(P._with) || B(N._assert) && !ti()) && (W(), ol(!1, !1));
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/traverser/index.js
function tf() {
	return R.pos === 0 && z.charCodeAt(0) === F.numberSign && z.charCodeAt(1) === F.exclamationMark && Ni(2), Ai(), Hu();
}
//#endregion
//#region node_modules/sucrase/dist/esm/parser/index.js
var nf = class {
	constructor(e, t) {
		this.tokens = e, this.scopes = t;
	}
};
function rf(e, t, n, r) {
	if (r && n) throw Error("Cannot combine flow and typescript plugins.");
	Xr(e, t, n, r);
	let i = tf();
	if (R.error) throw qr(R.error);
	return i;
}
//#endregion
//#region node_modules/sucrase/dist/esm/util/isAsyncOperation.js
function af(e) {
	let t = e.currentIndex(), n = 0, r = e.currentToken();
	do {
		let i = e.tokens[t];
		if (i.isOptionalChainStart && n++, i.isOptionalChainEnd && n--, n += i.numNullishCoalesceStarts, n -= i.numNullishCoalesceEnds, i.contextualKeyword === N._await && i.identifierRole == null && i.scopeDepth === r.scopeDepth) return !0;
		t += 1;
	} while (n > 0 && t < e.tokens.length);
	return !1;
}
//#endregion
//#region node_modules/sucrase/dist/esm/TokenProcessor.js
var of = class e {
	__init() {
		this.resultCode = "";
	}
	__init2() {
		this.resultMappings = Array(this.tokens.length);
	}
	__init3() {
		this.tokenIndex = 0;
	}
	constructor(t, n, r, i, a) {
		this.code = t, this.tokens = n, this.isFlowEnabled = r, this.disableESTransforms = i, this.helperManager = a, e.prototype.__init.call(this), e.prototype.__init2.call(this), e.prototype.__init3.call(this);
	}
	snapshot() {
		return {
			resultCode: this.resultCode,
			tokenIndex: this.tokenIndex
		};
	}
	restoreToSnapshot(e) {
		this.resultCode = e.resultCode, this.tokenIndex = e.tokenIndex;
	}
	dangerouslyGetAndRemoveCodeSinceSnapshot(e) {
		let t = this.resultCode.slice(e.resultCode.length);
		return this.resultCode = e.resultCode, t;
	}
	reset() {
		this.resultCode = "", this.resultMappings = Array(this.tokens.length), this.tokenIndex = 0;
	}
	matchesContextualAtIndex(e, t) {
		return this.matches1AtIndex(e, P.name) && this.tokens[e].contextualKeyword === t;
	}
	identifierNameAtIndex(e) {
		return this.identifierNameForToken(this.tokens[e]);
	}
	identifierNameAtRelativeIndex(e) {
		return this.identifierNameForToken(this.tokenAtRelativeIndex(e));
	}
	identifierName() {
		return this.identifierNameForToken(this.currentToken());
	}
	identifierNameForToken(e) {
		return this.code.slice(e.start, e.end);
	}
	rawCodeForToken(e) {
		return this.code.slice(e.start, e.end);
	}
	stringValueAtIndex(e) {
		return this.stringValueForToken(this.tokens[e]);
	}
	stringValue() {
		return this.stringValueForToken(this.currentToken());
	}
	stringValueForToken(e) {
		return this.code.slice(e.start + 1, e.end - 1);
	}
	matches1AtIndex(e, t) {
		return this.tokens[e].type === t;
	}
	matches2AtIndex(e, t, n) {
		return this.tokens[e].type === t && this.tokens[e + 1].type === n;
	}
	matches3AtIndex(e, t, n, r) {
		return this.tokens[e].type === t && this.tokens[e + 1].type === n && this.tokens[e + 2].type === r;
	}
	matches1(e) {
		return this.tokens[this.tokenIndex].type === e;
	}
	matches2(e, t) {
		return this.tokens[this.tokenIndex].type === e && this.tokens[this.tokenIndex + 1].type === t;
	}
	matches3(e, t, n) {
		return this.tokens[this.tokenIndex].type === e && this.tokens[this.tokenIndex + 1].type === t && this.tokens[this.tokenIndex + 2].type === n;
	}
	matches4(e, t, n, r) {
		return this.tokens[this.tokenIndex].type === e && this.tokens[this.tokenIndex + 1].type === t && this.tokens[this.tokenIndex + 2].type === n && this.tokens[this.tokenIndex + 3].type === r;
	}
	matches5(e, t, n, r, i) {
		return this.tokens[this.tokenIndex].type === e && this.tokens[this.tokenIndex + 1].type === t && this.tokens[this.tokenIndex + 2].type === n && this.tokens[this.tokenIndex + 3].type === r && this.tokens[this.tokenIndex + 4].type === i;
	}
	matchesContextual(e) {
		return this.matchesContextualAtIndex(this.tokenIndex, e);
	}
	matchesContextIdAndLabel(e, t) {
		return this.matches1(e) && this.currentToken().contextId === t;
	}
	previousWhitespaceAndComments() {
		let e = this.code.slice(this.tokenIndex > 0 ? this.tokens[this.tokenIndex - 1].end : 0, this.tokenIndex < this.tokens.length ? this.tokens[this.tokenIndex].start : this.code.length);
		return this.isFlowEnabled && (e = e.replace(/@flow/g, "")), e;
	}
	replaceToken(e) {
		this.resultCode += this.previousWhitespaceAndComments(), this.appendTokenPrefix(), this.resultMappings[this.tokenIndex] = this.resultCode.length, this.resultCode += e, this.appendTokenSuffix(), this.tokenIndex++;
	}
	replaceTokenTrimmingLeftWhitespace(e) {
		this.resultCode += this.previousWhitespaceAndComments().replace(/[^\r\n]/g, ""), this.appendTokenPrefix(), this.resultMappings[this.tokenIndex] = this.resultCode.length, this.resultCode += e, this.appendTokenSuffix(), this.tokenIndex++;
	}
	removeInitialToken() {
		this.replaceToken("");
	}
	removeToken() {
		this.replaceTokenTrimmingLeftWhitespace("");
	}
	removeBalancedCode() {
		let e = 0;
		for (; !this.isAtEnd();) {
			if (this.matches1(P.braceL)) e++;
			else if (this.matches1(P.braceR)) {
				if (e === 0) return;
				e--;
			}
			this.removeToken();
		}
	}
	copyExpectedToken(e) {
		if (this.tokens[this.tokenIndex].type !== e) throw Error(`Expected token ${e}`);
		this.copyToken();
	}
	copyToken() {
		this.resultCode += this.previousWhitespaceAndComments(), this.appendTokenPrefix(), this.resultMappings[this.tokenIndex] = this.resultCode.length, this.resultCode += this.code.slice(this.tokens[this.tokenIndex].start, this.tokens[this.tokenIndex].end), this.appendTokenSuffix(), this.tokenIndex++;
	}
	copyTokenWithPrefix(e) {
		this.resultCode += this.previousWhitespaceAndComments(), this.appendTokenPrefix(), this.resultCode += e, this.resultMappings[this.tokenIndex] = this.resultCode.length, this.resultCode += this.code.slice(this.tokens[this.tokenIndex].start, this.tokens[this.tokenIndex].end), this.appendTokenSuffix(), this.tokenIndex++;
	}
	appendTokenPrefix() {
		let e = this.currentToken();
		if ((e.numNullishCoalesceStarts || e.isOptionalChainStart) && (e.isAsyncOperation = af(this)), !this.disableESTransforms) {
			if (e.numNullishCoalesceStarts) for (let t = 0; t < e.numNullishCoalesceStarts; t++) e.isAsyncOperation ? (this.resultCode += "await ", this.resultCode += this.helperManager.getHelperName("asyncNullishCoalesce")) : this.resultCode += this.helperManager.getHelperName("nullishCoalesce"), this.resultCode += "(";
			e.isOptionalChainStart && (e.isAsyncOperation && (this.resultCode += "await "), this.tokenIndex > 0 && this.tokenAtRelativeIndex(-1).type === P._delete ? e.isAsyncOperation ? this.resultCode += this.helperManager.getHelperName("asyncOptionalChainDelete") : this.resultCode += this.helperManager.getHelperName("optionalChainDelete") : e.isAsyncOperation ? this.resultCode += this.helperManager.getHelperName("asyncOptionalChain") : this.resultCode += this.helperManager.getHelperName("optionalChain"), this.resultCode += "([");
		}
	}
	appendTokenSuffix() {
		let e = this.currentToken();
		if (e.isOptionalChainEnd && !this.disableESTransforms && (this.resultCode += "])"), e.numNullishCoalesceEnds && !this.disableESTransforms) for (let t = 0; t < e.numNullishCoalesceEnds; t++) this.resultCode += "))";
	}
	appendCode(e) {
		this.resultCode += e;
	}
	currentToken() {
		return this.tokens[this.tokenIndex];
	}
	currentTokenCode() {
		let e = this.currentToken();
		return this.code.slice(e.start, e.end);
	}
	tokenAtRelativeIndex(e) {
		return this.tokens[this.tokenIndex + e];
	}
	currentIndex() {
		return this.tokenIndex;
	}
	nextToken() {
		if (this.tokenIndex === this.tokens.length) throw Error("Unexpectedly reached end of input.");
		this.tokenIndex++;
	}
	previousToken() {
		this.tokenIndex--;
	}
	finish() {
		if (this.tokenIndex !== this.tokens.length) throw Error("Tried to finish processing tokens before reaching the end.");
		return this.resultCode += this.previousWhitespaceAndComments(), {
			code: this.resultCode,
			mappings: this.resultMappings
		};
	}
	isAtEnd() {
		return this.tokenIndex === this.tokens.length;
	}
};
//#endregion
//#region node_modules/sucrase/dist/esm/util/getClassInfo.js
function sf(e, t, n, r) {
	let i = t.snapshot(), a = lf(t), o = [], s = [], c = [], l = null, u = [], d = [], f = t.currentToken().contextId;
	if (f == null) throw Error("Expected non-null class context ID on class open-brace.");
	for (t.nextToken(); !t.matchesContextIdAndLabel(P.braceR, f);) if (t.matchesContextual(N._constructor) && !t.currentToken().isType) ({constructorInitializerStatements: o, constructorInsertPos: l} = uf(t));
	else if (t.matches1(P.semi)) r || d.push({
		start: t.currentIndex(),
		end: t.currentIndex() + 1
	}), t.nextToken();
	else if (t.currentToken().isType) t.nextToken();
	else {
		let i = t.currentIndex(), a = !1, p = !1, m = !1;
		for (; df(t.currentToken());) t.matches1(P._static) && (a = !0), t.matches1(P.hash) && (p = !0), (t.matches1(P._declare) || t.matches1(P._abstract)) && (m = !0), t.nextToken();
		if (a && t.matches1(P.braceL)) {
			cf(t, f);
			continue;
		}
		if (p) {
			cf(t, f);
			continue;
		}
		if (t.matchesContextual(N._constructor) && !t.currentToken().isType) {
			({constructorInitializerStatements: o, constructorInsertPos: l} = uf(t));
			continue;
		}
		let h = t.currentIndex();
		if (ff(t), t.matches1(P.lessThan) || t.matches1(P.parenL)) {
			cf(t, f);
			continue;
		}
		for (; t.currentToken().isType;) t.nextToken();
		if (t.matches1(P.eq)) {
			let r = t.currentIndex(), i = t.currentToken().rhsEndIndex;
			if (i == null) throw Error("Expected rhsEndIndex on class field assignment.");
			for (t.nextToken(); t.currentIndex() < i;) e.processToken();
			let o;
			a ? (o = n.claimFreeName("__initStatic"), c.push(o)) : (o = n.claimFreeName("__init"), s.push(o)), u.push({
				initializerName: o,
				equalsIndex: r,
				start: h,
				end: t.currentIndex()
			});
		} else (!r || m) && d.push({
			start: i,
			end: t.currentIndex()
		});
	}
	return t.restoreToSnapshot(i), r ? {
		headerInfo: a,
		constructorInitializerStatements: o,
		instanceInitializerNames: [],
		staticInitializerNames: [],
		constructorInsertPos: l,
		fields: [],
		rangesToRemove: d
	} : {
		headerInfo: a,
		constructorInitializerStatements: o,
		instanceInitializerNames: s,
		staticInitializerNames: c,
		constructorInsertPos: l,
		fields: u,
		rangesToRemove: d
	};
}
function cf(e, t) {
	for (e.nextToken(); e.currentToken().contextId !== t;) e.nextToken();
	for (; df(e.tokenAtRelativeIndex(-1));) e.previousToken();
}
function lf(e) {
	let t = e.currentToken(), n = t.contextId;
	if (n == null) throw Error("Expected context ID on class token.");
	let r = t.isExpression;
	if (r == null) throw Error("Expected isExpression on class token.");
	let i = null, a = !1;
	for (e.nextToken(), e.matches1(P.name) && (i = e.identifierName()); !e.matchesContextIdAndLabel(P.braceL, n);) e.matches1(P._extends) && !e.currentToken().isType && (a = !0), e.nextToken();
	return {
		isExpression: r,
		className: i,
		hasSuperclass: a
	};
}
function uf(e) {
	let t = [];
	e.nextToken();
	let n = e.currentToken().contextId;
	if (n == null) throw Error("Expected context ID on open-paren starting constructor params.");
	for (; !e.matchesContextIdAndLabel(P.parenR, n);) if (e.currentToken().contextId === n) {
		if (e.nextToken(), df(e.currentToken())) {
			for (e.nextToken(); df(e.currentToken());) e.nextToken();
			let n = e.currentToken();
			if (n.type !== P.name) throw Error("Expected identifier after access modifiers in constructor arg.");
			let r = e.identifierNameForToken(n);
			t.push(`this.${r} = ${r}`);
		}
	} else e.nextToken();
	for (e.nextToken(); e.currentToken().isType;) e.nextToken();
	let r = e.currentIndex(), i = !1;
	for (; !e.matchesContextIdAndLabel(P.braceR, n);) {
		if (!i && e.matches2(P._super, P.parenL)) {
			e.nextToken();
			let t = e.currentToken().contextId;
			if (t == null) throw Error("Expected a context ID on the super call");
			for (; !e.matchesContextIdAndLabel(P.parenR, t);) e.nextToken();
			r = e.currentIndex(), i = !0;
		}
		e.nextToken();
	}
	return e.nextToken(), {
		constructorInitializerStatements: t,
		constructorInsertPos: r
	};
}
function df(e) {
	return [
		P._async,
		P._get,
		P._set,
		P.plus,
		P.minus,
		P._readonly,
		P._static,
		P._public,
		P._private,
		P._protected,
		P._override,
		P._abstract,
		P.star,
		P._declare,
		P.hash
	].includes(e.type);
}
function ff(e) {
	if (e.matches1(P.bracketL)) {
		let t = e.currentToken().contextId;
		if (t == null) throw Error("Expected class context ID on computed name open bracket.");
		for (; !e.matchesContextIdAndLabel(P.bracketR, t);) e.nextToken();
		e.nextToken();
	} else e.nextToken();
}
//#endregion
//#region node_modules/sucrase/dist/esm/util/elideImportEquals.js
function pf(e) {
	if (e.removeInitialToken(), e.removeToken(), e.removeToken(), e.removeToken(), e.matches1(P.parenL)) e.removeToken(), e.removeToken(), e.removeToken();
	else for (; e.matches1(P.dot);) e.removeToken(), e.removeToken();
}
//#endregion
//#region node_modules/sucrase/dist/esm/util/getDeclarationInfo.js
var mf = {
	typeDeclarations: /* @__PURE__ */ new Set(),
	valueDeclarations: /* @__PURE__ */ new Set()
};
function hf(e) {
	let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
	for (let r = 0; r < e.tokens.length; r++) {
		let i = e.tokens[r];
		i.type === P.name && gi(i) && (i.isType ? t.add(e.identifierNameForToken(i)) : n.add(e.identifierNameForToken(i)));
	}
	return {
		typeDeclarations: t,
		valueDeclarations: n
	};
}
//#endregion
//#region node_modules/sucrase/dist/esm/util/isExportFrom.js
function gf(e) {
	let t = e.currentIndex();
	for (; !e.matches1AtIndex(t, P.braceR);) t++;
	return e.matchesContextualAtIndex(t + 1, N._from) && e.matches1AtIndex(t + 2, P.string);
}
//#endregion
//#region node_modules/sucrase/dist/esm/util/removeMaybeImportAttributes.js
function _f(e) {
	(e.matches2(P._with, P.braceL) || e.matches2(P.name, P.braceL) && e.matchesContextual(N._assert)) && (e.removeToken(), e.removeToken(), e.removeBalancedCode(), e.removeToken());
}
//#endregion
//#region node_modules/sucrase/dist/esm/util/shouldElideDefaultExport.js
function vf(e, t, n, r) {
	if (!e || t) return !1;
	let i = n.currentToken();
	if (i.rhsEndIndex == null) throw Error("Expected non-null rhsEndIndex on export token.");
	let a = i.rhsEndIndex - n.currentIndex();
	if (a !== 3 && !(a === 4 && n.matches1AtIndex(i.rhsEndIndex - 1, P.semi))) return !1;
	let o = n.tokenAtRelativeIndex(2);
	if (o.type !== P.name) return !1;
	let s = n.identifierNameForToken(o);
	return r.typeDeclarations.has(s) && !r.valueDeclarations.has(s);
}
//#endregion
//#region node_modules/sucrase/dist/esm/transformers/CJSImportTransformer.js
var yf = class e extends aa {
	__init() {
		this.hadExport = !1;
	}
	__init2() {
		this.hadNamedExport = !1;
	}
	__init3() {
		this.hadDefaultExport = !1;
	}
	constructor(t, n, r, i, a, o, s, c, l, u, d, f) {
		super(), this.rootTransformer = t, this.tokens = n, this.importProcessor = r, this.nameManager = i, this.helperManager = a, this.reactHotLoaderTransformer = o, this.enableLegacyBabel5ModuleInterop = s, this.enableLegacyTypeScriptModuleInterop = c, this.isTypeScriptTransformEnabled = l, this.isFlowTransformEnabled = u, this.preserveDynamicImport = d, this.keepUnusedImports = f, e.prototype.__init.call(this), e.prototype.__init2.call(this), e.prototype.__init3.call(this), this.declarationInfo = l ? hf(n) : mf;
	}
	getPrefixCode() {
		let e = "";
		return this.hadExport && (e += "Object.defineProperty(exports, \"__esModule\", {value: true});"), e;
	}
	getSuffixCode() {
		return this.enableLegacyBabel5ModuleInterop && this.hadDefaultExport && !this.hadNamedExport ? "\nmodule.exports = exports.default;\n" : "";
	}
	process() {
		return this.tokens.matches3(P._import, P.name, P.eq) ? this.processImportEquals() : this.tokens.matches1(P._import) ? (this.processImport(), !0) : this.tokens.matches2(P._export, P.eq) ? (this.tokens.replaceToken("module.exports"), !0) : this.tokens.matches1(P._export) && !this.tokens.currentToken().isType ? (this.hadExport = !0, this.processExport()) : this.tokens.matches2(P.name, P.postIncDec) && this.processPostIncDec() ? !0 : this.tokens.matches1(P.name) || this.tokens.matches1(P.jsxName) ? this.processIdentifier() : this.tokens.matches1(P.eq) ? this.processAssignment() : this.tokens.matches1(P.assign) ? this.processComplexAssignment() : this.tokens.matches1(P.preIncDec) ? this.processPreIncDec() : !1;
	}
	processImportEquals() {
		let e = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
		return this.importProcessor.shouldAutomaticallyElideImportedName(e) ? pf(this.tokens) : this.tokens.replaceToken("const"), !0;
	}
	processImport() {
		if (this.tokens.matches2(P._import, P.parenL)) {
			if (this.preserveDynamicImport) {
				this.tokens.copyToken();
				return;
			}
			let e = this.enableLegacyTypeScriptModuleInterop ? "" : `${this.helperManager.getHelperName("interopRequireWildcard")}(`;
			this.tokens.replaceToken(`Promise.resolve().then(() => ${e}require`);
			let t = this.tokens.currentToken().contextId;
			if (t == null) throw Error("Expected context ID on dynamic import invocation.");
			for (this.tokens.copyToken(); !this.tokens.matchesContextIdAndLabel(P.parenR, t);) this.rootTransformer.processToken();
			this.tokens.replaceToken(e ? ")))" : "))");
			return;
		}
		if (this.removeImportAndDetectIfShouldElide()) this.tokens.removeToken();
		else {
			let e = this.tokens.stringValue();
			this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(e)), this.tokens.appendCode(this.importProcessor.claimImportCode(e));
		}
		_f(this.tokens), this.tokens.matches1(P.semi) && this.tokens.removeToken();
	}
	removeImportAndDetectIfShouldElide() {
		if (this.tokens.removeInitialToken(), this.tokens.matchesContextual(N._type) && !this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, P.comma) && !this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, N._from)) return this.removeRemainingImport(), !0;
		if (this.tokens.matches1(P.name) || this.tokens.matches1(P.star)) return this.removeRemainingImport(), !1;
		if (this.tokens.matches1(P.string)) return !1;
		let e = !1, t = !1;
		for (; !this.tokens.matches1(P.string);) (!e && this.tokens.matches1(P.braceL) || this.tokens.matches1(P.comma)) && (this.tokens.removeToken(), this.tokens.matches1(P.braceR) || (t = !0), (this.tokens.matches2(P.name, P.comma) || this.tokens.matches2(P.name, P.braceR) || this.tokens.matches4(P.name, P.name, P.name, P.comma) || this.tokens.matches4(P.name, P.name, P.name, P.braceR)) && (e = !0)), this.tokens.removeToken();
		return this.keepUnusedImports ? !1 : this.isTypeScriptTransformEnabled ? !e : this.isFlowTransformEnabled ? t && !e : !1;
	}
	removeRemainingImport() {
		for (; !this.tokens.matches1(P.string);) this.tokens.removeToken();
	}
	processIdentifier() {
		let e = this.tokens.currentToken();
		if (e.shadowsGlobal) return !1;
		if (e.identifierRole === U.ObjectShorthand) return this.processObjectShorthand();
		if (e.identifierRole !== U.Access) return !1;
		let t = this.importProcessor.getIdentifierReplacement(this.tokens.identifierNameForToken(e));
		if (!t) return !1;
		let n = this.tokens.currentIndex() + 1;
		for (; n < this.tokens.tokens.length && this.tokens.tokens[n].type === P.parenR;) n++;
		return this.tokens.tokens[n].type === P.parenL ? this.tokens.tokenAtRelativeIndex(1).type === P.parenL && this.tokens.tokenAtRelativeIndex(-1).type !== P._new ? (this.tokens.replaceToken(`${t}.call(void 0, `), this.tokens.removeToken(), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(P.parenR)) : this.tokens.replaceToken(`(0, ${t})`) : this.tokens.replaceToken(t), !0;
	}
	processObjectShorthand() {
		let e = this.tokens.identifierName(), t = this.importProcessor.getIdentifierReplacement(e);
		return t ? (this.tokens.replaceToken(`${e}: ${t}`), !0) : !1;
	}
	processExport() {
		if (this.tokens.matches2(P._export, P._enum) || this.tokens.matches3(P._export, P._const, P._enum)) return this.hadNamedExport = !0, !1;
		if (this.tokens.matches2(P._export, P._default)) return this.tokens.matches3(P._export, P._default, P._enum) ? (this.hadDefaultExport = !0, !1) : (this.processExportDefault(), !0);
		if (this.tokens.matches2(P._export, P.braceL)) return this.processExportBindings(), !0;
		if (this.tokens.matches2(P._export, P.name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, N._type)) {
			if (this.tokens.removeInitialToken(), this.tokens.removeToken(), this.tokens.matches1(P.braceL)) {
				for (; !this.tokens.matches1(P.braceR);) this.tokens.removeToken();
				this.tokens.removeToken();
			} else this.tokens.removeToken(), this.tokens.matches1(P._as) && (this.tokens.removeToken(), this.tokens.removeToken());
			return this.tokens.matchesContextual(N._from) && this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, P.string) && (this.tokens.removeToken(), this.tokens.removeToken(), _f(this.tokens)), !0;
		}
		if (this.hadNamedExport = !0, this.tokens.matches2(P._export, P._var) || this.tokens.matches2(P._export, P._let) || this.tokens.matches2(P._export, P._const)) return this.processExportVar(), !0;
		if (this.tokens.matches2(P._export, P._function) || this.tokens.matches3(P._export, P.name, P._function)) return this.processExportFunction(), !0;
		if (this.tokens.matches2(P._export, P._class) || this.tokens.matches3(P._export, P._abstract, P._class) || this.tokens.matches2(P._export, P.at)) return this.processExportClass(), !0;
		if (this.tokens.matches2(P._export, P.star)) return this.processExportStar(), !0;
		throw Error("Unrecognized export syntax.");
	}
	processAssignment() {
		let e = this.tokens.currentIndex(), t = this.tokens.tokens[e - 1];
		if (t.isType || t.type !== P.name || t.shadowsGlobal || e >= 2 && this.tokens.matches1AtIndex(e - 2, P.dot) || e >= 2 && [
			P._var,
			P._let,
			P._const
		].includes(this.tokens.tokens[e - 2].type)) return !1;
		let n = this.importProcessor.resolveExportBinding(this.tokens.identifierNameForToken(t));
		return n ? (this.tokens.copyToken(), this.tokens.appendCode(` ${n} =`), !0) : !1;
	}
	processComplexAssignment() {
		let e = this.tokens.currentIndex(), t = this.tokens.tokens[e - 1];
		if (t.type !== P.name || t.shadowsGlobal || e >= 2 && this.tokens.matches1AtIndex(e - 2, P.dot)) return !1;
		let n = this.importProcessor.resolveExportBinding(this.tokens.identifierNameForToken(t));
		return n ? (this.tokens.appendCode(` = ${n}`), this.tokens.copyToken(), !0) : !1;
	}
	processPreIncDec() {
		let e = this.tokens.currentIndex(), t = this.tokens.tokens[e + 1];
		if (t.type !== P.name || t.shadowsGlobal || e + 2 < this.tokens.tokens.length && (this.tokens.matches1AtIndex(e + 2, P.dot) || this.tokens.matches1AtIndex(e + 2, P.bracketL) || this.tokens.matches1AtIndex(e + 2, P.parenL))) return !1;
		let n = this.tokens.identifierNameForToken(t), r = this.importProcessor.resolveExportBinding(n);
		return r ? (this.tokens.appendCode(`${r} = `), this.tokens.copyToken(), !0) : !1;
	}
	processPostIncDec() {
		let e = this.tokens.currentIndex(), t = this.tokens.tokens[e], n = this.tokens.tokens[e + 1];
		if (t.type !== P.name || t.shadowsGlobal || e >= 1 && this.tokens.matches1AtIndex(e - 1, P.dot)) return !1;
		let r = this.tokens.identifierNameForToken(t), i = this.importProcessor.resolveExportBinding(r);
		if (!i) return !1;
		let a = this.tokens.rawCodeForToken(n), o = this.importProcessor.getIdentifierReplacement(r) || r;
		if (a === "++") this.tokens.replaceToken(`(${o} = ${i} = ${o} + 1, ${o} - 1)`);
		else if (a === "--") this.tokens.replaceToken(`(${o} = ${i} = ${o} - 1, ${o} + 1)`);
		else throw Error(`Unexpected operator: ${a}`);
		return this.tokens.removeToken(), !0;
	}
	processExportDefault() {
		let e = !0;
		if (this.tokens.matches4(P._export, P._default, P._function, P.name) || this.tokens.matches5(P._export, P._default, P.name, P._function, P.name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, N._async)) {
			this.tokens.removeInitialToken(), this.tokens.removeToken();
			let e = this.processNamedFunction();
			this.tokens.appendCode(` exports.default = ${e};`);
		} else if (this.tokens.matches4(P._export, P._default, P._class, P.name) || this.tokens.matches5(P._export, P._default, P._abstract, P._class, P.name) || this.tokens.matches3(P._export, P._default, P.at)) {
			this.tokens.removeInitialToken(), this.tokens.removeToken(), this.copyDecorators(), this.tokens.matches1(P._abstract) && this.tokens.removeToken();
			let e = this.rootTransformer.processNamedClass();
			this.tokens.appendCode(` exports.default = ${e};`);
		} else if (vf(this.isTypeScriptTransformEnabled, this.keepUnusedImports, this.tokens, this.declarationInfo)) e = !1, this.tokens.removeInitialToken(), this.tokens.removeToken(), this.tokens.removeToken();
		else if (this.reactHotLoaderTransformer) {
			let e = this.nameManager.claimFreeName("_default");
			this.tokens.replaceToken(`let ${e}; exports.`), this.tokens.copyToken(), this.tokens.appendCode(` = ${e} =`), this.reactHotLoaderTransformer.setExtractedDefaultExportName(e);
		} else this.tokens.replaceToken("exports."), this.tokens.copyToken(), this.tokens.appendCode(" =");
		e && (this.hadDefaultExport = !0);
	}
	copyDecorators() {
		for (; this.tokens.matches1(P.at);) if (this.tokens.copyToken(), this.tokens.matches1(P.parenL)) this.tokens.copyExpectedToken(P.parenL), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(P.parenR);
		else {
			for (this.tokens.copyExpectedToken(P.name); this.tokens.matches1(P.dot);) this.tokens.copyExpectedToken(P.dot), this.tokens.copyExpectedToken(P.name);
			this.tokens.matches1(P.parenL) && (this.tokens.copyExpectedToken(P.parenL), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(P.parenR));
		}
	}
	processExportVar() {
		this.isSimpleExportVar() ? this.processSimpleExportVar() : this.processComplexExportVar();
	}
	isSimpleExportVar() {
		let e = this.tokens.currentIndex();
		if (e++, e++, !this.tokens.matches1AtIndex(e, P.name)) return !1;
		for (e++; e < this.tokens.tokens.length && this.tokens.tokens[e].isType;) e++;
		return !!this.tokens.matches1AtIndex(e, P.eq);
	}
	processSimpleExportVar() {
		this.tokens.removeInitialToken(), this.tokens.copyToken();
		let e = this.tokens.identifierName();
		for (; !this.tokens.matches1(P.eq);) this.rootTransformer.processToken();
		let t = this.tokens.currentToken().rhsEndIndex;
		if (t == null) throw Error("Expected = token with an end index.");
		for (; this.tokens.currentIndex() < t;) this.rootTransformer.processToken();
		this.tokens.appendCode(`; exports.${e} = ${e}`);
	}
	processComplexExportVar() {
		this.tokens.removeInitialToken(), this.tokens.removeToken();
		let e = this.tokens.matches1(P.braceL);
		e && this.tokens.appendCode("(");
		let t = 0;
		for (;;) if (this.tokens.matches1(P.braceL) || this.tokens.matches1(P.dollarBraceL) || this.tokens.matches1(P.bracketL)) t++, this.tokens.copyToken();
		else if (this.tokens.matches1(P.braceR) || this.tokens.matches1(P.bracketR)) t--, this.tokens.copyToken();
		else if (t === 0 && !this.tokens.matches1(P.name) && !this.tokens.currentToken().isType) break;
		else if (this.tokens.matches1(P.eq)) {
			let e = this.tokens.currentToken().rhsEndIndex;
			if (e == null) throw Error("Expected = token with an end index.");
			for (; this.tokens.currentIndex() < e;) this.rootTransformer.processToken();
		} else {
			let e = this.tokens.currentToken();
			if (mi(e)) {
				let t = this.tokens.identifierName(), n = this.importProcessor.getIdentifierReplacement(t);
				if (n === null) throw Error(`Expected a replacement for ${t} in \`export var\` syntax.`);
				yi(e) && (n = `${t}: ${n}`), this.tokens.replaceToken(n);
			} else this.rootTransformer.processToken();
		}
		if (e) {
			let e = this.tokens.currentToken().rhsEndIndex;
			if (e == null) throw Error("Expected = token with an end index.");
			for (; this.tokens.currentIndex() < e;) this.rootTransformer.processToken();
			this.tokens.appendCode(")");
		}
	}
	processExportFunction() {
		this.tokens.replaceToken("");
		let e = this.processNamedFunction();
		this.tokens.appendCode(` exports.${e} = ${e};`);
	}
	processNamedFunction() {
		if (this.tokens.matches1(P._function)) this.tokens.copyToken();
		else if (this.tokens.matches2(P.name, P._function)) {
			if (!this.tokens.matchesContextual(N._async)) throw Error("Expected async keyword in function export.");
			this.tokens.copyToken(), this.tokens.copyToken();
		}
		if (this.tokens.matches1(P.star) && this.tokens.copyToken(), !this.tokens.matches1(P.name)) throw Error("Expected identifier for exported function name.");
		let e = this.tokens.identifierName();
		if (this.tokens.copyToken(), this.tokens.currentToken().isType) for (this.tokens.removeInitialToken(); this.tokens.currentToken().isType;) this.tokens.removeToken();
		return this.tokens.copyExpectedToken(P.parenL), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(P.parenR), this.rootTransformer.processPossibleTypeRange(), this.tokens.copyExpectedToken(P.braceL), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(P.braceR), e;
	}
	processExportClass() {
		this.tokens.removeInitialToken(), this.copyDecorators(), this.tokens.matches1(P._abstract) && this.tokens.removeToken();
		let e = this.rootTransformer.processNamedClass();
		this.tokens.appendCode(` exports.${e} = ${e};`);
	}
	processExportBindings() {
		this.tokens.removeInitialToken(), this.tokens.removeToken();
		let e = gf(this.tokens), t = [];
		for (;;) {
			if (this.tokens.matches1(P.braceR)) {
				this.tokens.removeToken();
				break;
			}
			let n = ea(this.tokens);
			for (; this.tokens.currentIndex() < n.endIndex;) this.tokens.removeToken();
			if (!(n.isType || !e && this.shouldElideExportedIdentifier(n.leftName))) {
				let e = n.rightName;
				e === "default" ? this.hadDefaultExport = !0 : this.hadNamedExport = !0;
				let r = n.leftName, i = this.importProcessor.getIdentifierReplacement(r);
				t.push(`exports.${e} = ${i || r};`);
			}
			if (this.tokens.matches1(P.braceR)) {
				this.tokens.removeToken();
				break;
			}
			if (this.tokens.matches2(P.comma, P.braceR)) {
				this.tokens.removeToken(), this.tokens.removeToken();
				break;
			}
			if (this.tokens.matches1(P.comma)) this.tokens.removeToken();
			else throw Error(`Unexpected token: ${JSON.stringify(this.tokens.currentToken())}`);
		}
		if (this.tokens.matchesContextual(N._from)) {
			this.tokens.removeToken();
			let e = this.tokens.stringValue();
			this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(e)), _f(this.tokens);
		} else this.tokens.appendCode(t.join(" "));
		this.tokens.matches1(P.semi) && this.tokens.removeToken();
	}
	processExportStar() {
		for (this.tokens.removeInitialToken(); !this.tokens.matches1(P.string);) this.tokens.removeToken();
		let e = this.tokens.stringValue();
		this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(e)), _f(this.tokens), this.tokens.matches1(P.semi) && this.tokens.removeToken();
	}
	shouldElideExportedIdentifier(e) {
		return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.declarationInfo.valueDeclarations.has(e);
	}
}, bf = class extends aa {
	constructor(e, t, n, r, i, a, o, s) {
		super(), this.tokens = e, this.nameManager = t, this.helperManager = n, this.reactHotLoaderTransformer = r, this.isTypeScriptTransformEnabled = i, this.isFlowTransformEnabled = a, this.keepUnusedImports = o, this.nonTypeIdentifiers = i && !o ? ma(e, s) : /* @__PURE__ */ new Set(), this.declarationInfo = i && !o ? hf(e) : mf, this.injectCreateRequireForImportRequire = !!s.injectCreateRequireForImportRequire;
	}
	process() {
		if (this.tokens.matches3(P._import, P.name, P.eq)) return this.processImportEquals();
		if (this.tokens.matches4(P._import, P.name, P.name, P.eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, N._type)) {
			this.tokens.removeInitialToken();
			for (let e = 0; e < 7; e++) this.tokens.removeToken();
			return !0;
		}
		if (this.tokens.matches2(P._export, P.eq)) return this.tokens.replaceToken("module.exports"), !0;
		if (this.tokens.matches5(P._export, P._import, P.name, P.name, P.eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, N._type)) {
			this.tokens.removeInitialToken();
			for (let e = 0; e < 8; e++) this.tokens.removeToken();
			return !0;
		}
		if (this.tokens.matches1(P._import)) return this.processImport();
		if (this.tokens.matches2(P._export, P._default)) return this.processExportDefault();
		if (this.tokens.matches2(P._export, P.braceL)) return this.processNamedExports();
		if (this.tokens.matches2(P._export, P.name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, N._type)) {
			if (this.tokens.removeInitialToken(), this.tokens.removeToken(), this.tokens.matches1(P.braceL)) {
				for (; !this.tokens.matches1(P.braceR);) this.tokens.removeToken();
				this.tokens.removeToken();
			} else this.tokens.removeToken(), this.tokens.matches1(P._as) && (this.tokens.removeToken(), this.tokens.removeToken());
			return this.tokens.matchesContextual(N._from) && this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, P.string) && (this.tokens.removeToken(), this.tokens.removeToken(), _f(this.tokens)), !0;
		}
		return !1;
	}
	processImportEquals() {
		let e = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
		return this.shouldAutomaticallyElideImportedName(e) ? pf(this.tokens) : this.injectCreateRequireForImportRequire ? (this.tokens.replaceToken("const"), this.tokens.copyToken(), this.tokens.copyToken(), this.tokens.replaceToken(this.helperManager.getHelperName("require"))) : this.tokens.replaceToken("const"), !0;
	}
	processImport() {
		if (this.tokens.matches2(P._import, P.parenL)) return !1;
		let e = this.tokens.snapshot();
		if (this.removeImportTypeBindings()) {
			for (this.tokens.restoreToSnapshot(e); !this.tokens.matches1(P.string);) this.tokens.removeToken();
			this.tokens.removeToken(), _f(this.tokens), this.tokens.matches1(P.semi) && this.tokens.removeToken();
		}
		return !0;
	}
	removeImportTypeBindings() {
		if (this.tokens.copyExpectedToken(P._import), this.tokens.matchesContextual(N._type) && !this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, P.comma) && !this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, N._from)) return !0;
		if (this.tokens.matches1(P.string)) return this.tokens.copyToken(), !1;
		this.tokens.matchesContextual(N._module) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, N._from) && this.tokens.copyToken();
		let e = !1, t = !1, n = !1;
		if (this.tokens.matches1(P.name) && (this.shouldAutomaticallyElideImportedName(this.tokens.identifierName()) ? (this.tokens.removeToken(), this.tokens.matches1(P.comma) && this.tokens.removeToken()) : (e = !0, this.tokens.copyToken(), this.tokens.matches1(P.comma) && (n = !0, this.tokens.removeToken()))), this.tokens.matches1(P.star)) this.shouldAutomaticallyElideImportedName(this.tokens.identifierNameAtRelativeIndex(2)) ? (this.tokens.removeToken(), this.tokens.removeToken(), this.tokens.removeToken()) : (n && this.tokens.appendCode(","), e = !0, this.tokens.copyExpectedToken(P.star), this.tokens.copyExpectedToken(P.name), this.tokens.copyExpectedToken(P.name));
		else if (this.tokens.matches1(P.braceL)) {
			for (n && this.tokens.appendCode(","), this.tokens.copyToken(); !this.tokens.matches1(P.braceR);) {
				t = !0;
				let n = ea(this.tokens);
				if (n.isType || this.shouldAutomaticallyElideImportedName(n.rightName)) {
					for (; this.tokens.currentIndex() < n.endIndex;) this.tokens.removeToken();
					this.tokens.matches1(P.comma) && this.tokens.removeToken();
				} else {
					for (e = !0; this.tokens.currentIndex() < n.endIndex;) this.tokens.copyToken();
					this.tokens.matches1(P.comma) && this.tokens.copyToken();
				}
			}
			this.tokens.copyExpectedToken(P.braceR);
		}
		return this.keepUnusedImports ? !1 : this.isTypeScriptTransformEnabled ? !e : this.isFlowTransformEnabled ? t && !e : !1;
	}
	shouldAutomaticallyElideImportedName(e) {
		return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.nonTypeIdentifiers.has(e);
	}
	processExportDefault() {
		if (vf(this.isTypeScriptTransformEnabled, this.keepUnusedImports, this.tokens, this.declarationInfo)) return this.tokens.removeInitialToken(), this.tokens.removeToken(), this.tokens.removeToken(), !0;
		if (!(this.tokens.matches4(P._export, P._default, P._function, P.name) || this.tokens.matches5(P._export, P._default, P.name, P._function, P.name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, N._async) || this.tokens.matches4(P._export, P._default, P._class, P.name) || this.tokens.matches5(P._export, P._default, P._abstract, P._class, P.name)) && this.reactHotLoaderTransformer) {
			let e = this.nameManager.claimFreeName("_default");
			return this.tokens.replaceToken(`let ${e}; export`), this.tokens.copyToken(), this.tokens.appendCode(` ${e} =`), this.reactHotLoaderTransformer.setExtractedDefaultExportName(e), !0;
		}
		return !1;
	}
	processNamedExports() {
		if (!this.isTypeScriptTransformEnabled) return !1;
		this.tokens.copyExpectedToken(P._export), this.tokens.copyExpectedToken(P.braceL);
		let e = gf(this.tokens), t = !1;
		for (; !this.tokens.matches1(P.braceR);) {
			let n = ea(this.tokens);
			if (n.isType || !e && this.shouldElideExportedName(n.leftName)) {
				for (; this.tokens.currentIndex() < n.endIndex;) this.tokens.removeToken();
				this.tokens.matches1(P.comma) && this.tokens.removeToken();
			} else {
				for (t = !0; this.tokens.currentIndex() < n.endIndex;) this.tokens.copyToken();
				this.tokens.matches1(P.comma) && this.tokens.copyToken();
			}
		}
		return this.tokens.copyExpectedToken(P.braceR), !this.keepUnusedImports && e && !t && (this.tokens.removeToken(), this.tokens.removeToken(), _f(this.tokens)), !0;
	}
	shouldElideExportedName(e) {
		return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && this.declarationInfo.typeDeclarations.has(e) && !this.declarationInfo.valueDeclarations.has(e);
	}
}, xf = class extends aa {
	constructor(e, t, n) {
		super(), this.rootTransformer = e, this.tokens = t, this.isImportsTransformEnabled = n;
	}
	process() {
		return this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange() ? !0 : this.tokens.matches1(P._enum) ? (this.processEnum(), !0) : this.tokens.matches2(P._export, P._enum) ? (this.processNamedExportEnum(), !0) : this.tokens.matches3(P._export, P._default, P._enum) ? (this.processDefaultExportEnum(), !0) : !1;
	}
	processNamedExportEnum() {
		if (this.isImportsTransformEnabled) {
			this.tokens.removeInitialToken();
			let e = this.tokens.identifierNameAtRelativeIndex(1);
			this.processEnum(), this.tokens.appendCode(` exports.${e} = ${e};`);
		} else this.tokens.copyToken(), this.processEnum();
	}
	processDefaultExportEnum() {
		this.tokens.removeInitialToken(), this.tokens.removeToken();
		let e = this.tokens.identifierNameAtRelativeIndex(1);
		this.processEnum(), this.isImportsTransformEnabled ? this.tokens.appendCode(` exports.default = ${e};`) : this.tokens.appendCode(` export default ${e};`);
	}
	processEnum() {
		this.tokens.replaceToken("const"), this.tokens.copyExpectedToken(P.name);
		let e = !1;
		this.tokens.matchesContextual(N._of) && (this.tokens.removeToken(), e = this.tokens.matchesContextual(N._symbol), this.tokens.removeToken());
		let t = this.tokens.matches3(P.braceL, P.name, P.eq);
		this.tokens.appendCode(" = require(\"flow-enums-runtime\")");
		let n = !e && !t;
		for (this.tokens.replaceTokenTrimmingLeftWhitespace(n ? ".Mirrored([" : "({"); !this.tokens.matches1(P.braceR);) {
			if (this.tokens.matches1(P.ellipsis)) {
				this.tokens.removeToken();
				break;
			}
			this.processEnumElement(e, t), this.tokens.matches1(P.comma) && this.tokens.copyToken();
		}
		this.tokens.replaceToken(n ? "]);" : "});");
	}
	processEnumElement(e, t) {
		if (e) {
			let e = this.tokens.identifierName();
			this.tokens.copyToken(), this.tokens.appendCode(`: Symbol("${e}")`);
		} else t ? (this.tokens.copyToken(), this.tokens.replaceTokenTrimmingLeftWhitespace(":"), this.tokens.copyToken()) : this.tokens.replaceToken(`"${this.tokens.identifierName()}"`);
	}
};
//#endregion
//#region node_modules/sucrase/dist/esm/transformers/JestHoistTransformer.js
function Sf(e) {
	let t, n = e[0], r = 1;
	for (; r < e.length;) {
		let i = e[r], a = e[r + 1];
		if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null) return;
		i === "access" || i === "optionalAccess" ? (t = n, n = a(n)) : (i === "call" || i === "optionalCall") && (n = a((...e) => n.call(t, ...e)), t = void 0);
	}
	return n;
}
var Cf = "jest", wf = [
	"mock",
	"unmock",
	"enableAutomock",
	"disableAutomock"
], Tf = class e extends aa {
	__init() {
		this.hoistedFunctionNames = [];
	}
	constructor(t, n, r, i) {
		super(), this.rootTransformer = t, this.tokens = n, this.nameManager = r, this.importProcessor = i, e.prototype.__init.call(this);
	}
	process() {
		return this.tokens.currentToken().scopeDepth === 0 && this.tokens.matches4(P.name, P.dot, P.name, P.parenL) && this.tokens.identifierName() === Cf ? !Sf([
			this,
			"access",
			(e) => e.importProcessor,
			"optionalAccess",
			(e) => e.getGlobalNames,
			"call",
			(e) => e(),
			"optionalAccess",
			(e) => e.has,
			"call",
			(e) => e(Cf)
		]) && this.extractHoistedCalls() : !1;
	}
	getHoistedCode() {
		return this.hoistedFunctionNames.length > 0 ? this.hoistedFunctionNames.map((e) => `${e}();`).join("") : "";
	}
	extractHoistedCalls() {
		this.tokens.removeToken();
		let e = !1;
		for (; this.tokens.matches3(P.dot, P.name, P.parenL);) {
			let t = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
			if (wf.includes(t)) {
				let t = this.nameManager.claimFreeName("__jestHoist");
				this.hoistedFunctionNames.push(t), this.tokens.replaceToken(`function ${t}(){${Cf}.`), this.tokens.copyToken(), this.tokens.copyToken(), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(P.parenR), this.tokens.appendCode(";}"), e = !1;
			} else e ? this.tokens.copyToken() : this.tokens.replaceToken(`${Cf}.`), this.tokens.copyToken(), this.tokens.copyToken(), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(P.parenR), e = !0;
		}
		return !0;
	}
}, Ef = class extends aa {
	constructor(e) {
		super(), this.tokens = e;
	}
	process() {
		if (this.tokens.matches1(P.num)) {
			let e = this.tokens.currentTokenCode();
			if (e.includes("_")) return this.tokens.replaceToken(e.replace(/_/g, "")), !0;
		}
		return !1;
	}
}, Df = class extends aa {
	constructor(e, t) {
		super(), this.tokens = e, this.nameManager = t;
	}
	process() {
		return this.tokens.matches2(P._catch, P.braceL) ? (this.tokens.copyToken(), this.tokens.appendCode(` (${this.nameManager.claimFreeName("e")})`), !0) : !1;
	}
}, Of = class extends aa {
	constructor(e, t) {
		super(), this.tokens = e, this.nameManager = t;
	}
	process() {
		if (this.tokens.matches1(P.nullishCoalescing)) {
			let e = this.tokens.currentToken();
			return this.tokens.tokens[e.nullishStartIndex].isAsyncOperation ? this.tokens.replaceTokenTrimmingLeftWhitespace(", async () => (") : this.tokens.replaceTokenTrimmingLeftWhitespace(", () => ("), !0;
		}
		if (this.tokens.matches1(P._delete) && this.tokens.tokenAtRelativeIndex(1).isOptionalChainStart) return this.tokens.removeInitialToken(), !0;
		let e = this.tokens.currentToken().subscriptStartIndex;
		if (e != null && this.tokens.tokens[e].isOptionalChainStart && this.tokens.tokenAtRelativeIndex(-1).type !== P._super) {
			let t = this.nameManager.claimFreeName("_"), n;
			if (n = e > 0 && this.tokens.matches1AtIndex(e - 1, P._delete) && this.isLastSubscriptInChain() ? `${t} => delete ${t}` : `${t} => ${t}`, this.tokens.tokens[e].isAsyncOperation && (n = `async ${n}`), this.tokens.matches2(P.questionDot, P.parenL) || this.tokens.matches2(P.questionDot, P.lessThan)) this.justSkippedSuper() && this.tokens.appendCode(".bind(this)"), this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalCall', ${n}`);
			else if (this.tokens.matches2(P.questionDot, P.bracketL)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalAccess', ${n}`);
			else if (this.tokens.matches1(P.questionDot)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalAccess', ${n}.`);
			else if (this.tokens.matches1(P.dot)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'access', ${n}.`);
			else if (this.tokens.matches1(P.bracketL)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'access', ${n}[`);
			else if (this.tokens.matches1(P.parenL)) this.justSkippedSuper() && this.tokens.appendCode(".bind(this)"), this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'call', ${n}(`);
			else throw Error("Unexpected subscript operator in optional chain.");
			return !0;
		}
		return !1;
	}
	isLastSubscriptInChain() {
		let e = 0;
		for (let t = this.tokens.currentIndex() + 1;; t++) {
			if (t >= this.tokens.tokens.length) throw Error("Reached the end of the code while finding the end of the access chain.");
			if (this.tokens.tokens[t].isOptionalChainStart ? e++ : this.tokens.tokens[t].isOptionalChainEnd && e--, e < 0) return !0;
			if (e === 0 && this.tokens.tokens[t].subscriptStartIndex != null) return !1;
		}
	}
	justSkippedSuper() {
		let e = 0, t = this.tokens.currentIndex() - 1;
		for (;;) {
			if (t < 0) throw Error("Reached the start of the code while finding the start of the access chain.");
			if (this.tokens.tokens[t].isOptionalChainStart ? e-- : this.tokens.tokens[t].isOptionalChainEnd && e++, e < 0) return !1;
			if (e === 0 && this.tokens.tokens[t].subscriptStartIndex != null) return this.tokens.tokens[t - 1].type === P._super;
			t--;
		}
	}
}, kf = class extends aa {
	constructor(e, t, n, r) {
		super(), this.rootTransformer = e, this.tokens = t, this.importProcessor = n, this.options = r;
	}
	process() {
		let e = this.tokens.currentIndex();
		if (this.tokens.identifierName() === "createReactClass") {
			let t = this.importProcessor && this.importProcessor.getIdentifierReplacement("createReactClass");
			return t ? this.tokens.replaceToken(`(0, ${t})`) : this.tokens.copyToken(), this.tryProcessCreateClassCall(e), !0;
		}
		if (this.tokens.matches3(P.name, P.dot, P.name) && this.tokens.identifierName() === "React" && this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 2) === "createClass") {
			let t = this.importProcessor && this.importProcessor.getIdentifierReplacement("React") || "React";
			return t ? (this.tokens.replaceToken(t), this.tokens.copyToken(), this.tokens.copyToken()) : (this.tokens.copyToken(), this.tokens.copyToken(), this.tokens.copyToken()), this.tryProcessCreateClassCall(e), !0;
		}
		return !1;
	}
	tryProcessCreateClassCall(e) {
		let t = this.findDisplayName(e);
		t && this.classNeedsDisplayName() && (this.tokens.copyExpectedToken(P.parenL), this.tokens.copyExpectedToken(P.braceL), this.tokens.appendCode(`displayName: '${t}',`), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(P.braceR), this.tokens.copyExpectedToken(P.parenR));
	}
	findDisplayName(e) {
		return e < 2 ? null : this.tokens.matches2AtIndex(e - 2, P.name, P.eq) || e >= 2 && this.tokens.tokens[e - 2].identifierRole === U.ObjectKey ? this.tokens.identifierNameAtIndex(e - 2) : this.tokens.matches2AtIndex(e - 2, P._export, P._default) ? this.getDisplayNameFromFilename() : null;
	}
	getDisplayNameFromFilename() {
		let e = (this.options.filePath || "unknown").split("/"), t = e[e.length - 1], n = t.lastIndexOf("."), r = n === -1 ? t : t.slice(0, n);
		return r === "index" && e[e.length - 2] ? e[e.length - 2] : r;
	}
	classNeedsDisplayName() {
		let e = this.tokens.currentIndex();
		if (!this.tokens.matches2(P.parenL, P.braceL)) return !1;
		let t = e + 1, n = this.tokens.tokens[t].contextId;
		if (n == null) throw Error("Expected non-null context ID on object open-brace.");
		for (; e < this.tokens.tokens.length; e++) {
			let t = this.tokens.tokens[e];
			if (t.type === P.braceR && t.contextId === n) {
				e++;
				break;
			}
			if (this.tokens.identifierNameAtIndex(e) === "displayName" && this.tokens.tokens[e].identifierRole === U.ObjectKey && t.contextId === n) return !1;
		}
		if (e === this.tokens.tokens.length) throw Error("Unexpected end of input when processing React class.");
		return this.tokens.matches1AtIndex(e, P.parenR) || this.tokens.matches2AtIndex(e, P.comma, P.parenR);
	}
}, Af = class e extends aa {
	__init() {
		this.extractedDefaultExportName = null;
	}
	constructor(t, n) {
		super(), this.tokens = t, this.filePath = n, e.prototype.__init.call(this);
	}
	setExtractedDefaultExportName(e) {
		this.extractedDefaultExportName = e;
	}
	getPrefixCode() {
		return "\n      (function () {\n        var enterModule = require('react-hot-loader').enterModule;\n        enterModule && enterModule(module);\n      })();".replace(/\s+/g, " ").trim();
	}
	getSuffixCode() {
		let e = /* @__PURE__ */ new Set();
		for (let t of this.tokens.tokens) !t.isType && gi(t) && t.identifierRole !== U.ImportDeclaration && e.add(this.tokens.identifierNameForToken(t));
		let t = Array.from(e).map((e) => ({
			variableName: e,
			uniqueLocalName: e
		}));
		return this.extractedDefaultExportName && t.push({
			variableName: this.extractedDefaultExportName,
			uniqueLocalName: "default"
		}), `
;(function () {
  var reactHotLoader = require('react-hot-loader').default;
  var leaveModule = require('react-hot-loader').leaveModule;
  if (!reactHotLoader) {
    return;
  }
${t.map(({ variableName: e, uniqueLocalName: t }) => `  reactHotLoader.register(${e}, "${t}", ${JSON.stringify(this.filePath || "")});`).join("\n")}
  leaveModule(module);
})();`;
	}
	process() {
		return !1;
	}
}, jf = /* @__PURE__ */ new Set(/* @__PURE__ */ "break.case.catch.class.const.continue.debugger.default.delete.do.else.export.extends.finally.for.function.if.import.in.instanceof.new.return.super.switch.this.throw.try.typeof.var.void.while.with.yield.enum.implements.interface.let.package.private.protected.public.static.await.false.null.true".split("."));
function Mf(e) {
	if (e.length === 0 || !ui[e.charCodeAt(0)]) return !1;
	for (let t = 1; t < e.length; t++) if (!li[e.charCodeAt(t)]) return !1;
	return !jf.has(e);
}
//#endregion
//#region node_modules/sucrase/dist/esm/transformers/TypeScriptTransformer.js
var Nf = class extends aa {
	constructor(e, t, n) {
		super(), this.rootTransformer = e, this.tokens = t, this.isImportsTransformEnabled = n;
	}
	process() {
		return this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange() ? !0 : this.tokens.matches1(P._public) || this.tokens.matches1(P._protected) || this.tokens.matches1(P._private) || this.tokens.matches1(P._abstract) || this.tokens.matches1(P._readonly) || this.tokens.matches1(P._override) || this.tokens.matches1(P.nonNullAssertion) ? (this.tokens.removeInitialToken(), !0) : this.tokens.matches1(P._enum) || this.tokens.matches2(P._const, P._enum) ? (this.processEnum(), !0) : this.tokens.matches2(P._export, P._enum) || this.tokens.matches3(P._export, P._const, P._enum) ? (this.processEnum(!0), !0) : !1;
	}
	processEnum(e = !1) {
		for (this.tokens.removeInitialToken(); this.tokens.matches1(P._const) || this.tokens.matches1(P._enum);) this.tokens.removeToken();
		let t = this.tokens.identifierName();
		this.tokens.removeToken(), e && !this.isImportsTransformEnabled && this.tokens.appendCode("export "), this.tokens.appendCode(`var ${t}; (function (${t})`), this.tokens.copyExpectedToken(P.braceL), this.processEnumBody(t), this.tokens.copyExpectedToken(P.braceR), e && this.isImportsTransformEnabled ? this.tokens.appendCode(`)(${t} || (exports.${t} = ${t} = {}));`) : this.tokens.appendCode(`)(${t} || (${t} = {}));`);
	}
	processEnumBody(e) {
		let t = null;
		for (; !this.tokens.matches1(P.braceR);) {
			let { nameStringCode: n, variableName: r } = this.extractEnumKeyInfo(this.tokens.currentToken());
			this.tokens.removeInitialToken(), this.tokens.matches3(P.eq, P.string, P.comma) || this.tokens.matches3(P.eq, P.string, P.braceR) ? this.processStringLiteralEnumMember(e, n, r) : this.tokens.matches1(P.eq) ? this.processExplicitValueEnumMember(e, n, r) : this.processImplicitValueEnumMember(e, n, r, t), this.tokens.matches1(P.comma) && this.tokens.removeToken(), t = r ?? `${e}[${n}]`;
		}
	}
	extractEnumKeyInfo(e) {
		if (e.type === P.name) {
			let t = this.tokens.identifierNameForToken(e);
			return {
				nameStringCode: `"${t}"`,
				variableName: Mf(t) ? t : null
			};
		}
		if (e.type === P.string) {
			let t = this.tokens.stringValueForToken(e);
			return {
				nameStringCode: this.tokens.code.slice(e.start, e.end),
				variableName: Mf(t) ? t : null
			};
		}
		throw Error("Expected name or string at beginning of enum element.");
	}
	processStringLiteralEnumMember(e, t, n) {
		n == null ? (this.tokens.appendCode(`${e}[${t}]`), this.tokens.copyToken(), this.tokens.copyToken(), this.tokens.appendCode(";")) : (this.tokens.appendCode(`const ${n}`), this.tokens.copyToken(), this.tokens.copyToken(), this.tokens.appendCode(`; ${e}[${t}] = ${n};`));
	}
	processExplicitValueEnumMember(e, t, n) {
		let r = this.tokens.currentToken().rhsEndIndex;
		if (r == null) throw Error("Expected rhsEndIndex on enum assign.");
		if (n != null) {
			for (this.tokens.appendCode(`const ${n}`), this.tokens.copyToken(); this.tokens.currentIndex() < r;) this.rootTransformer.processToken();
			this.tokens.appendCode(`; ${e}[${e}[${t}] = ${n}] = ${t};`);
		} else {
			for (this.tokens.appendCode(`${e}[${e}[${t}]`), this.tokens.copyToken(); this.tokens.currentIndex() < r;) this.rootTransformer.processToken();
			this.tokens.appendCode(`] = ${t};`);
		}
	}
	processImplicitValueEnumMember(e, t, n, r) {
		let i = r == null ? "0" : `${r} + 1`;
		n != null && (this.tokens.appendCode(`const ${n} = ${i}; `), i = n), this.tokens.appendCode(`${e}[${e}[${t}] = ${i}] = ${t};`);
	}
}, Pf = class e {
	__init() {
		this.transformers = [];
	}
	__init2() {
		this.generatedVariables = [];
	}
	constructor(t, n, r, i) {
		e.prototype.__init.call(this), e.prototype.__init2.call(this), this.nameManager = t.nameManager, this.helperManager = t.helperManager;
		let { tokenProcessor: a, importProcessor: o } = t;
		this.tokens = a, this.isImportsTransformEnabled = n.includes("imports"), this.isReactHotLoaderTransformEnabled = n.includes("react-hot-loader"), this.disableESTransforms = !!i.disableESTransforms, i.disableESTransforms || (this.transformers.push(new Of(a, this.nameManager)), this.transformers.push(new Ef(a)), this.transformers.push(new Df(a, this.nameManager))), n.includes("jsx") && (i.jsxRuntime !== "preserve" && this.transformers.push(new oa(this, a, o, this.nameManager, i)), this.transformers.push(new kf(this, a, o, i)));
		let s = null;
		if (n.includes("react-hot-loader")) {
			if (!i.filePath) throw Error("filePath is required when using the react-hot-loader transform.");
			s = new Af(a, i.filePath), this.transformers.push(s);
		}
		if (n.includes("imports")) {
			if (o === null) throw Error("Expected non-null importProcessor with imports transform enabled.");
			this.transformers.push(new yf(this, a, o, this.nameManager, this.helperManager, s, r, !!i.enableLegacyTypeScriptModuleInterop, n.includes("typescript"), n.includes("flow"), !!i.preserveDynamicImport, !!i.keepUnusedImports));
		} else this.transformers.push(new bf(a, this.nameManager, this.helperManager, s, n.includes("typescript"), n.includes("flow"), !!i.keepUnusedImports, i));
		n.includes("flow") && this.transformers.push(new xf(this, a, n.includes("imports"))), n.includes("typescript") && this.transformers.push(new Nf(this, a, n.includes("imports"))), n.includes("jest") && this.transformers.push(new Tf(this, a, this.nameManager, o));
	}
	transform() {
		this.tokens.reset(), this.processBalancedCode();
		let e = this.isImportsTransformEnabled ? "\"use strict\";" : "";
		for (let t of this.transformers) e += t.getPrefixCode();
		e += this.helperManager.emitHelpers(), e += this.generatedVariables.map((e) => ` var ${e};`).join("");
		for (let t of this.transformers) e += t.getHoistedCode();
		let t = "";
		for (let e of this.transformers) t += e.getSuffixCode();
		let n = this.tokens.finish(), { code: r } = n;
		if (r.startsWith("#!")) {
			let i = r.indexOf("\n");
			return i === -1 && (i = r.length, r += "\n"), {
				code: r.slice(0, i + 1) + e + r.slice(i + 1) + t,
				mappings: this.shiftMappings(n.mappings, e.length)
			};
		}
		return {
			code: e + r + t,
			mappings: this.shiftMappings(n.mappings, e.length)
		};
	}
	processBalancedCode() {
		let e = 0, t = 0;
		for (; !this.tokens.isAtEnd();) {
			if (this.tokens.matches1(P.braceL) || this.tokens.matches1(P.dollarBraceL)) e++;
			else if (this.tokens.matches1(P.braceR)) {
				if (e === 0) return;
				e--;
			}
			if (this.tokens.matches1(P.parenL)) t++;
			else if (this.tokens.matches1(P.parenR)) {
				if (t === 0) return;
				t--;
			}
			this.processToken();
		}
	}
	processToken() {
		if (this.tokens.matches1(P._class)) {
			this.processClass();
			return;
		}
		for (let e of this.transformers) if (e.process()) return;
		this.tokens.copyToken();
	}
	processNamedClass() {
		if (!this.tokens.matches2(P._class, P.name)) throw Error("Expected identifier for exported class name.");
		let e = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
		return this.processClass(), e;
	}
	processClass() {
		let e = sf(this, this.tokens, this.nameManager, this.disableESTransforms), t = (e.headerInfo.isExpression || !e.headerInfo.className) && e.staticInitializerNames.length + e.instanceInitializerNames.length > 0, n = e.headerInfo.className;
		t && (n = this.nameManager.claimFreeName("_class"), this.generatedVariables.push(n), this.tokens.appendCode(` (${n} =`));
		let r = this.tokens.currentToken().contextId;
		if (r == null) throw Error("Expected class to have a context ID.");
		for (this.tokens.copyExpectedToken(P._class); !this.tokens.matchesContextIdAndLabel(P.braceL, r);) this.processToken();
		this.processClassBody(e, n);
		let i = e.staticInitializerNames.map((e) => `${n}.${e}()`);
		t ? this.tokens.appendCode(`, ${i.map((e) => `${e}, `).join("")}${n})`) : e.staticInitializerNames.length > 0 && this.tokens.appendCode(` ${i.map((e) => `${e};`).join(" ")}`);
	}
	processClassBody(e, t) {
		let { headerInfo: n, constructorInsertPos: r, constructorInitializerStatements: i, fields: a, instanceInitializerNames: o, rangesToRemove: s } = e, c = 0, l = 0, u = this.tokens.currentToken().contextId;
		if (u == null) throw Error("Expected non-null context ID on class.");
		this.tokens.copyExpectedToken(P.braceL), this.isReactHotLoaderTransformEnabled && this.tokens.appendCode("__reactstandin__regenerateByEval(key, code) {this[key] = eval(code);}");
		let d = i.length + o.length > 0;
		if (r === null && d) {
			let e = this.makeConstructorInitCode(i, o, t);
			if (n.hasSuperclass) {
				let t = this.nameManager.claimFreeName("args");
				this.tokens.appendCode(`constructor(...${t}) { super(...${t}); ${e}; }`);
			} else this.tokens.appendCode(`constructor() { ${e}; }`);
		}
		for (; !this.tokens.matchesContextIdAndLabel(P.braceR, u);) if (c < a.length && this.tokens.currentIndex() === a[c].start) {
			let e = !1;
			for (this.tokens.matches1(P.bracketL) ? this.tokens.copyTokenWithPrefix(`${a[c].initializerName}() {this`) : this.tokens.matches1(P.string) || this.tokens.matches1(P.num) ? (this.tokens.copyTokenWithPrefix(`${a[c].initializerName}() {this[`), e = !0) : this.tokens.copyTokenWithPrefix(`${a[c].initializerName}() {this.`); this.tokens.currentIndex() < a[c].end;) e && this.tokens.currentIndex() === a[c].equalsIndex && this.tokens.appendCode("]"), this.processToken();
			this.tokens.appendCode("}"), c++;
		} else if (l < s.length && this.tokens.currentIndex() >= s[l].start) {
			for (this.tokens.currentIndex() < s[l].end && this.tokens.removeInitialToken(); this.tokens.currentIndex() < s[l].end;) this.tokens.removeToken();
			l++;
		} else this.tokens.currentIndex() === r ? (this.tokens.copyToken(), d && this.tokens.appendCode(`;${this.makeConstructorInitCode(i, o, t)};`), this.processToken()) : this.processToken();
		this.tokens.copyExpectedToken(P.braceR);
	}
	makeConstructorInitCode(e, t, n) {
		return [...e, ...t.map((e) => `${n}.prototype.${e}.call(this)`)].join(";");
	}
	processPossibleArrowParamEnd() {
		if (this.tokens.matches2(P.parenR, P.colon) && this.tokens.tokenAtRelativeIndex(1).isType) {
			let e = this.tokens.currentIndex() + 1;
			for (; this.tokens.tokens[e].isType;) e++;
			if (this.tokens.matches1AtIndex(e, P.arrow)) {
				for (this.tokens.removeInitialToken(); this.tokens.currentIndex() < e;) this.tokens.removeToken();
				return this.tokens.replaceTokenTrimmingLeftWhitespace(") =>"), !0;
			}
		}
		return !1;
	}
	processPossibleAsyncArrowWithTypeParams() {
		if (!this.tokens.matchesContextual(N._async) && !this.tokens.matches1(P._async)) return !1;
		let e = this.tokens.tokenAtRelativeIndex(1);
		if (e.type !== P.lessThan || !e.isType) return !1;
		let t = this.tokens.currentIndex() + 1;
		for (; this.tokens.tokens[t].isType;) t++;
		if (this.tokens.matches1AtIndex(t, P.parenL)) {
			for (this.tokens.replaceToken("async ("), this.tokens.removeInitialToken(); this.tokens.currentIndex() < t;) this.tokens.removeToken();
			return this.tokens.removeToken(), this.processBalancedCode(), this.processToken(), !0;
		}
		return !1;
	}
	processPossibleTypeRange() {
		if (this.tokens.currentToken().isType) {
			for (this.tokens.removeInitialToken(); this.tokens.currentToken().isType;) this.tokens.removeToken();
			return !0;
		}
		return !1;
	}
	shiftMappings(e, t) {
		for (let n = 0; n < e.length; n++) {
			let r = e[n];
			r !== void 0 && (e[n] = r + t);
		}
		return e;
	}
};
(/* @__PURE__ */ t(((e) => {
	e.__esModule = !0, e.LinesAndColumns = void 0;
	var t = "\n", n = "\r";
	e.LinesAndColumns = function() {
		function e(e) {
			this.string = e;
			for (var r = [0], i = 0; i < e.length;) switch (e[i]) {
				case t:
					i += t.length, r.push(i);
					break;
				case n:
					i += n.length, e[i] === t && (i += t.length), r.push(i);
					break;
				default: i++;
			}
			this.offsets = r;
		}
		return e.prototype.locationForIndex = function(e) {
			if (e < 0 || e > this.string.length) return null;
			for (var t = 0, n = this.offsets; n[t + 1] <= e;) t++;
			var r = e - n[t];
			return {
				line: t,
				column: r
			};
		}, e.prototype.indexForLocation = function(e) {
			var t = e.line, n = e.column;
			return t < 0 || t >= this.offsets.length || n < 0 || n > this.lengthOfLine(t) ? null : this.offsets[t] + n;
		}, e.prototype.lengthOfLine = function(e) {
			var t = this.offsets[e];
			return (e === this.offsets.length - 1 ? this.string.length : this.offsets[e + 1]) - t;
		}, e;
	}();
})))();
//#endregion
//#region node_modules/sucrase/dist/esm/util/getTSImportedNames.js
function Ff(e) {
	let t = /* @__PURE__ */ new Set();
	for (let n = 0; n < e.tokens.length; n++) e.matches1AtIndex(n, P._import) && !e.matches3AtIndex(n, P._import, P.name, P.eq) && If(e, n, t);
	return t;
}
function If(e, t, n) {
	t++, !e.matches1AtIndex(t, P.parenL) && (e.matches1AtIndex(t, P.name) && (n.add(e.identifierNameAtIndex(t)), t++, e.matches1AtIndex(t, P.comma) && t++), e.matches1AtIndex(t, P.star) && (t += 2, n.add(e.identifierNameAtIndex(t)), t++), e.matches1AtIndex(t, P.braceL) && (t++, Lf(e, t, n)));
}
function Lf(e, t, n) {
	for (;;) {
		if (e.matches1AtIndex(t, P.braceR)) return;
		let r = ea(e, t);
		if (t = r.endIndex, r.isType || n.add(r.rightName), e.matches2AtIndex(t, P.comma, P.braceR) || e.matches1AtIndex(t, P.braceR)) return;
		if (e.matches1AtIndex(t, P.comma)) t++;
		else throw Error(`Unexpected token: ${JSON.stringify(e.tokens[t])}`);
	}
}
//#endregion
//#region node_modules/sucrase/dist/esm/index.js
function Rf(e, t) {
	uo(t);
	try {
		let n = zf(e, t), r = new Pf(n, t.transforms, !!t.enableLegacyBabel5ModuleInterop, t).transform(), i = { code: r.code };
		if (t.sourceMapOptions) {
			if (!t.filePath) throw Error("filePath must be specified when generating a source map.");
			i = {
				...i,
				sourceMap: Ya(r, t.filePath, t.sourceMapOptions, e, n.tokenProcessor.tokens)
			};
		}
		return i;
	} catch (e) {
		throw t.filePath && (e.message = `Error transforming ${t.filePath}: ${e.message}`), e;
	}
}
function zf(e, t) {
	let n = t.transforms.includes("jsx"), r = t.transforms.includes("typescript"), i = t.transforms.includes("flow"), a = t.disableESTransforms === !0, o = rf(e, n, r, i), s = o.tokens, c = o.scopes, l = new io(e, s), u = new Qa(l), d = new of(e, s, i, a, u), f = !!t.enableLegacyTypeScriptModuleInterop, p = null;
	return t.transforms.includes("imports") ? (p = new ha(l, d, f, t, t.transforms.includes("typescript"), !!t.keepUnusedImports, u), p.preprocessTokens(), $a(d, c, p.getGlobalNames()), t.transforms.includes("typescript") && !t.keepUnusedImports && p.pruneTypeOnlyImports()) : t.transforms.includes("typescript") && !t.keepUnusedImports && $a(d, c, Ff(d)), {
		tokenProcessor: d,
		scopes: c,
		nameManager: l,
		importProcessor: p,
		helperManager: u
	};
}
//#endregion
//#region node_modules/stylis/src/Enum.js
var Bf = "comm", Vf = "rule", Hf = "decl", Uf = "@media", Wf = "@import", Gf = "@supports", Kf = "@namespace", qf = "@keyframes", Jf = "@font-face", Yf = "@layer", Xf = Math.abs, Zf = String.fromCharCode;
function Qf(e) {
	return e.trim();
}
function $f(e, t, n) {
	return e.replace(t, n);
}
function ep(e, t) {
	return e.charCodeAt(t) | 0;
}
function tp(e, t, n) {
	return e.slice(t, n);
}
function np(e) {
	return e.length;
}
function rp(e) {
	return e.length;
}
function ip(e, t) {
	return t.push(e), e;
}
//#endregion
//#region node_modules/stylis/src/Tokenizer.js
var ap = 1, op = 1, sp = 0, cp = 0, lp = 0, up = "";
function dp(e, t, n, r, i, a, o, s) {
	return {
		value: e,
		root: t,
		parent: n,
		type: r,
		props: i,
		children: a,
		line: ap,
		column: op,
		length: o,
		return: "",
		siblings: s
	};
}
function fp() {
	return lp;
}
function pp() {
	return lp = cp > 0 ? ep(up, --cp) : 0, op--, lp === 10 && (op = 1, ap--), lp;
}
function mp() {
	return lp = cp < sp ? ep(up, cp++) : 0, op++, lp === 10 && (op = 1, ap++), lp;
}
function hp() {
	return ep(up, cp);
}
function gp() {
	return cp;
}
function _p(e, t) {
	return tp(up, e, t);
}
function vp(e) {
	switch (e) {
		case 0:
		case 9:
		case 10:
		case 13:
		case 32: return 5;
		case 33:
		case 43:
		case 44:
		case 47:
		case 62:
		case 64:
		case 126:
		case 59:
		case 123:
		case 125: return 4;
		case 58: return 3;
		case 34:
		case 39:
		case 40:
		case 91: return 2;
		case 41:
		case 93: return 1;
	}
	return 0;
}
function yp(e) {
	return ap = op = 1, sp = np(up = e), cp = 0, [];
}
function bp(e) {
	return up = "", e;
}
function xp(e) {
	return Qf(_p(cp - 1, wp(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Sp(e) {
	for (; (lp = hp()) && lp < 33;) mp();
	return vp(e) > 2 || vp(lp) > 3 ? "" : " ";
}
function Cp(e, t) {
	for (; --t && mp() && !(lp < 48 || lp > 102 || lp > 57 && lp < 65 || lp > 70 && lp < 97););
	return _p(e, gp() + (t < 6 && hp() == 32 && mp() == 32));
}
function wp(e) {
	for (; mp();) switch (lp) {
		case e: return cp;
		case 34:
		case 39:
			e !== 34 && e !== 39 && wp(lp);
			break;
		case 40:
			e === 41 && wp(e);
			break;
		case 92: mp();
	}
	return cp;
}
function Tp(e, t) {
	for (; mp() && e + lp !== 57 && (e + lp !== 84 || hp() !== 47););
	return "/*" + _p(t, cp - 1) + "*" + Zf(e === 47 ? e : mp());
}
function Ep(e) {
	for (; !vp(hp());) mp();
	return _p(e, cp);
}
//#endregion
//#region node_modules/stylis/src/Parser.js
function Dp(e) {
	return bp(Op("", null, null, null, [""], e = yp(e), 0, [0], e));
}
function Op(e, t, n, r, i, a, o, s, c) {
	for (var l = 0, u = 0, d = o, f = 0, p = 0, m = 0, h = 1, g = 1, _ = 1, v = 0, y = 0, b = "", x = i, S = a, C = r, w = b; g;) switch (m = y, y = mp()) {
		case 40:
			m != 108 && ep(w, d - 1) == 58 ? (v++, w += "(") : w += xp(y);
			break;
		case 41:
			v--, w += ")";
			break;
		case 34:
		case 39:
		case 91:
			w += xp(y);
			break;
		case 9:
		case 10:
		case 13:
		case 32:
			if (v > 0) {
				w += Zf(y);
				break;
			}
			w += Sp(m);
			break;
		case 92:
			w += Cp(gp() - 1, 7);
			continue;
		case 47:
			switch (hp()) {
				case 42:
				case 47:
					ip(Ap(Tp(mp(), gp()), t, n, c), c), (vp(m || 1) == 5 || vp(hp() || 1) == 5) && np(w) && tp(w, -1, void 0) !== " " && (w += " ");
					break;
				default: w += "/";
			}
			break;
		case 123 * h: s[l++] = np(w) * _;
		case 125 * h:
		case 59:
		case 0:
			if (v > 0 && y) {
				w += Zf(y);
				break;
			}
			switch (y) {
				case 0:
				case 125: g = 0;
				case 59 + u:
					_ == -1 && (w = $f(w, /\f/g, "")), p > 0 && (np(w) - d || h === 0) && ip(p > 32 ? jp(w + ";", r, n, d - 1, c) : jp($f(w, " ", "") + ";", r, n, d - 2, c), c);
					break;
				case 59: w += ";";
				default: if (ip(C = kp(w, t, n, l, u, i, s, b, x = [], S = [], d, a), a), y === 123) {
					if (u === 0) Op(w, t, C, C, x, a, d, s, S);
					else {
						switch (f) {
							case 99: if (ep(w, 3) === 110) break;
							case 108: if (ep(w, 2) === 97) break;
							default: u = 0;
							case 100:
							case 109:
							case 115:
						}
						u ? Op(e, C, C, r && ip(kp(e, C, C, 0, 0, i, s, b, i, x = [], d, S), S), i, S, d, s, r ? x : S) : Op(w, C, C, C, [""], S, 0, s, S);
					}
				}
			}
			l = u = p = 0, h = _ = 1, b = w = "", d = o;
			break;
		case 58: d = 1 + np(w), p = m;
		default:
			if (h < 1) {
				if (y == 123) --h;
				else if (y == 125 && h++ == 0 && pp() == 125) continue;
			}
			switch (w += Zf(y), y * h) {
				case 38:
					_ = u > 0 ? 1 : (w += "\f", -1);
					break;
				case 44:
					if (v > 0) break;
					s[l++] = (np(w) - 1) * _, _ = 1;
					break;
				case 64:
					hp() === 45 && (w += xp(mp())), f = hp(), u = d = np(b = w += Ep(gp())), y++;
					break;
				case 45: m === 45 && np(w) == 2 && (h = 0);
			}
	}
	return a;
}
function kp(e, t, n, r, i, a, o, s, c, l, u, d) {
	for (var f = i - 1, p = i === 0 ? a : [""], m = rp(p), h = 0, g = 0, _ = 0; h < r; ++h) for (var v = 0, y = tp(e, f + 1, f = Xf(g = o[h])), b = e; v < m; ++v) (b = Qf(g > 0 ? p[v] + " " + y : $f(y, /&\f/g, p[v]))) && (c[_++] = b);
	return dp(e, t, n, i === 0 ? Vf : s, c, l, u, d);
}
function Ap(e, t, n, r) {
	return dp(e, t, n, Bf, Zf(fp()), tp(e, 2, -2), 0, r);
}
function jp(e, t, n, r, i) {
	return dp(e, t, n, Hf, tp(e, 0, r), tp(e, r + 1, -1), r, i);
}
//#endregion
//#region node_modules/stylis/src/Serializer.js
function Mp(e, t) {
	for (var n = "", r = 0; r < e.length; r++) n += t(e[r], r, e, t) || "";
	return n;
}
function Np(e, t, n, r) {
	switch (e.type) {
		case Yf: if (e.children.length) break;
		case Wf:
		case Kf:
		case Hf: return e.return = e.return || e.value;
		case Bf: return "";
		case qf: return e.return = e.value + "{" + Mp(e.children, r) + "}";
		case Vf: if (!np(e.value = e.props.join(","))) return "";
	}
	return np(n = Mp(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
//#endregion
//#region libs/sdk/react/src/lib/custom-component-runtime/utils.ts
function Pp(e) {
	let t = 5381;
	for (let n = 0; n < e.length; n++) t = (t << 5) + t + e.charCodeAt(n) >>> 0;
	return t;
}
function Fp(e) {
	return Pp(e).toString(16).padStart(8, "0").slice(0, 6);
}
function Ip(e) {
	return Pp(e).toString(16).padStart(8, "0");
}
//#endregion
//#region libs/sdk/react/src/lib/custom-component-runtime/css-scoper.ts
function Lp(e) {
	return `flx-cc-${Fp(e)}`;
}
function Rp(e, t) {
	if (!e || !e.trim()) return "";
	let n = `.${t}`, r = Dp(e), i = [], a = /* @__PURE__ */ new Map();
	zp(r, t, a);
	let o = Bp(r, n, t, a, i);
	return i.length > 0 ? i.join("") + o : o;
}
function zp(e, t, n) {
	for (let r of e) if (r.type === "@keyframes") {
		let e = r.props[0];
		e && n.set(e, `${t}-${e}`);
	} else (r.type === "@media" || r.type === "@supports") && Array.isArray(r.children) && zp(r.children, t, n);
}
function Bp(e, t, n, r, i) {
	let a = "";
	for (let o of e) switch (o.type) {
		case Bf: break;
		case Wf:
			i.push(o.value + "");
			break;
		case Jf:
			a += Mp([o], Np);
			break;
		case qf: {
			let e = o.props[0], t = r.get(e) ?? e;
			a += `@keyframes ${t}{`, a += Mp(o.children, Np), a += "}";
			break;
		}
		case Uf:
		case Gf: {
			let e = [], s = Bp(o.children, t, n, r, e);
			i.push(...e), a += `${o.value}{${s}}`;
			break;
		}
		case Vf: {
			let e = o.props.map((e) => `${t} ${e}`).join(","), n = Vp(o.children, r);
			a += `${e}{${n}}`;
			break;
		}
		default: a += Mp([o], Np);
	}
	return a;
}
function Vp(e, t) {
	let n = "";
	for (let r of e) if (r.type === "decl") {
		let e = r.props;
		t.size > 0 && (e === "animation" || e === "animation-name") ? n += Hp(r.value, t) : n += r.value;
	}
	return n;
}
function Hp(e, t) {
	let n = e.indexOf(":");
	if (n === -1) return e;
	let r = e.slice(0, n + 1), i = e.slice(n + 1);
	for (let [e, n] of t) {
		let t = RegExp(`\\b${Up(e)}\\b`, "g");
		i = i.replace(t, n);
	}
	return r + i;
}
function Up(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var Wp = /* @__PURE__ */ new Map();
function Gp(e, t) {
	let n = O(t);
	n.current = t, de(() => {
		if (!e) return;
		let t = n.current, r = Wp.get(t);
		if (r) r.count++, r.element.textContent = e;
		else {
			let n = document.createElement("style");
			n.setAttribute("data-flx-cc", t), n.textContent = e, document.head.appendChild(n), Wp.set(t, {
				element: n,
				count: 1
			});
		}
		return () => {
			let e = Wp.get(t);
			e && (e.count--, e.count <= 0 && (e.element.remove(), Wp.delete(t)));
		};
	}, [e, t]);
}
//#endregion
//#region node_modules/@emotion/sheet/dist/emotion-sheet.esm.js
function Kp(e) {
	if (e.sheet) return e.sheet;
	/* istanbul ignore next */
	for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
}
function qp(e) {
	var t = document.createElement("style");
	return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Jp = /*#__PURE__*/ function() {
	function e(e) {
		var t = this;
		this._insertTag = function(e) {
			var n = t.tags.length === 0 ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling;
			t.container.insertBefore(e, n), t.tags.push(e);
		}, this.isSpeedy = e.speedy === void 0 || e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
	}
	var t = e.prototype;
	return t.hydrate = function(e) {
		e.forEach(this._insertTag);
	}, t.insert = function(e) {
		this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(qp(this));
		var t = this.tags[this.tags.length - 1];
		if (this.isSpeedy) {
			var n = Kp(t);
			try {
				n.insertRule(e, n.cssRules.length);
			} catch {}
		} else t.appendChild(document.createTextNode(e));
		this.ctr++;
	}, t.flush = function() {
		this.tags.forEach(function(e) {
			return e.parentNode?.removeChild(e);
		}), this.tags = [], this.ctr = 0;
	}, e;
}(), Yp = "-ms-", Xp = "-moz-", Zp = "-webkit-", Qp = "comm", $p = "rule", em = "decl", tm = "@import", nm = "@keyframes", rm = "@layer", im = Math.abs, am = String.fromCharCode, om = Object.assign;
function sm(e, t) {
	return fm(e, 0) ^ 45 ? (((t << 2 ^ fm(e, 0)) << 2 ^ fm(e, 1)) << 2 ^ fm(e, 2)) << 2 ^ fm(e, 3) : 0;
}
function cm(e) {
	return e.trim();
}
function lm(e, t) {
	return (e = t.exec(e)) ? e[0] : e;
}
function um(e, t, n) {
	return e.replace(t, n);
}
function dm(e, t) {
	return e.indexOf(t);
}
function fm(e, t) {
	return e.charCodeAt(t) | 0;
}
function pm(e, t, n) {
	return e.slice(t, n);
}
function mm(e) {
	return e.length;
}
function hm(e) {
	return e.length;
}
function gm(e, t) {
	return t.push(e), e;
}
function _m(e, t) {
	return e.map(t).join("");
}
//#endregion
//#region node_modules/@emotion/cache/node_modules/stylis/src/Tokenizer.js
var vm = 1, ym = 1, bm = 0, xm = 0, Sm = 0, Cm = "";
function wm(e, t, n, r, i, a, o) {
	return {
		value: e,
		root: t,
		parent: n,
		type: r,
		props: i,
		children: a,
		line: vm,
		column: ym,
		length: o,
		return: ""
	};
}
function Tm(e, t) {
	return om(wm("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Em() {
	return Sm;
}
function Dm() {
	return Sm = xm > 0 ? fm(Cm, --xm) : 0, ym--, Sm === 10 && (ym = 1, vm--), Sm;
}
function Om() {
	return Sm = xm < bm ? fm(Cm, xm++) : 0, ym++, Sm === 10 && (ym = 1, vm++), Sm;
}
function km() {
	return fm(Cm, xm);
}
function Am() {
	return xm;
}
function jm(e, t) {
	return pm(Cm, e, t);
}
function Mm(e) {
	switch (e) {
		case 0:
		case 9:
		case 10:
		case 13:
		case 32: return 5;
		case 33:
		case 43:
		case 44:
		case 47:
		case 62:
		case 64:
		case 126:
		case 59:
		case 123:
		case 125: return 4;
		case 58: return 3;
		case 34:
		case 39:
		case 40:
		case 91: return 2;
		case 41:
		case 93: return 1;
	}
	return 0;
}
function Nm(e) {
	return vm = ym = 1, bm = mm(Cm = e), xm = 0, [];
}
function Pm(e) {
	return Cm = "", e;
}
function Fm(e) {
	return cm(jm(xm - 1, Rm(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Im(e) {
	for (; (Sm = km()) && Sm < 33;) Om();
	return Mm(e) > 2 || Mm(Sm) > 3 ? "" : " ";
}
function Lm(e, t) {
	for (; --t && Om() && !(Sm < 48 || Sm > 102 || Sm > 57 && Sm < 65 || Sm > 70 && Sm < 97););
	return jm(e, Am() + (t < 6 && km() == 32 && Om() == 32));
}
function Rm(e) {
	for (; Om();) switch (Sm) {
		case e: return xm;
		case 34:
		case 39:
			e !== 34 && e !== 39 && Rm(Sm);
			break;
		case 40:
			e === 41 && Rm(e);
			break;
		case 92: Om();
	}
	return xm;
}
function zm(e, t) {
	for (; Om() && e + Sm !== 57 && (e + Sm !== 84 || km() !== 47););
	return "/*" + jm(t, xm - 1) + "*" + am(e === 47 ? e : Om());
}
function Bm(e) {
	for (; !Mm(km());) Om();
	return jm(e, xm);
}
//#endregion
//#region node_modules/@emotion/cache/node_modules/stylis/src/Parser.js
function Vm(e) {
	return Pm(Hm("", null, null, null, [""], e = Nm(e), 0, [0], e));
}
function Hm(e, t, n, r, i, a, o, s, c) {
	for (var l = 0, u = 0, d = o, f = 0, p = 0, m = 0, h = 1, g = 1, _ = 1, v = 0, y = "", b = i, x = a, S = r, C = y; g;) switch (m = v, v = Om()) {
		case 40: if (m != 108 && fm(C, d - 1) == 58) {
			dm(C += um(Fm(v), "&", "&\f"), "&\f") != -1 && (_ = -1);
			break;
		}
		case 34:
		case 39:
		case 91:
			C += Fm(v);
			break;
		case 9:
		case 10:
		case 13:
		case 32:
			C += Im(m);
			break;
		case 92:
			C += Lm(Am() - 1, 7);
			continue;
		case 47:
			switch (km()) {
				case 42:
				case 47:
					gm(Wm(zm(Om(), Am()), t, n), c);
					break;
				default: C += "/";
			}
			break;
		case 123 * h: s[l++] = mm(C) * _;
		case 125 * h:
		case 59:
		case 0:
			switch (v) {
				case 0:
				case 125: g = 0;
				case 59 + u:
					_ == -1 && (C = um(C, /\f/g, "")), p > 0 && mm(C) - d && gm(p > 32 ? Gm(C + ";", r, n, d - 1) : Gm(um(C, " ", "") + ";", r, n, d - 2), c);
					break;
				case 59: C += ";";
				default: if (gm(S = Um(C, t, n, l, u, i, s, y, b = [], x = [], d), a), v === 123) {
					if (u === 0) Hm(C, t, S, S, b, a, d, s, x);
					else switch (f === 99 && fm(C, 3) === 110 ? 100 : f) {
						case 100:
						case 108:
						case 109:
						case 115:
							Hm(e, S, S, r && gm(Um(e, S, S, 0, 0, i, s, y, i, b = [], d), x), i, x, d, s, r ? b : x);
							break;
						default: Hm(C, S, S, S, [""], x, 0, s, x);
					}
				}
			}
			l = u = p = 0, h = _ = 1, y = C = "", d = o;
			break;
		case 58: d = 1 + mm(C), p = m;
		default:
			if (h < 1) {
				if (v == 123) --h;
				else if (v == 125 && h++ == 0 && Dm() == 125) continue;
			}
			switch (C += am(v), v * h) {
				case 38:
					_ = u > 0 ? 1 : (C += "\f", -1);
					break;
				case 44:
					s[l++] = (mm(C) - 1) * _, _ = 1;
					break;
				case 64:
					km() === 45 && (C += Fm(Om())), f = km(), u = d = mm(y = C += Bm(Am())), v++;
					break;
				case 45: m === 45 && mm(C) == 2 && (h = 0);
			}
	}
	return a;
}
function Um(e, t, n, r, i, a, o, s, c, l, u) {
	for (var d = i - 1, f = i === 0 ? a : [""], p = hm(f), m = 0, h = 0, g = 0; m < r; ++m) for (var _ = 0, v = pm(e, d + 1, d = im(h = o[m])), y = e; _ < p; ++_) (y = cm(h > 0 ? f[_] + " " + v : um(v, /&\f/g, f[_]))) && (c[g++] = y);
	return wm(e, t, n, i === 0 ? $p : s, c, l, u);
}
function Wm(e, t, n) {
	return wm(e, t, n, Qp, am(Em()), pm(e, 2, -2), 0);
}
function Gm(e, t, n, r) {
	return wm(e, t, n, em, pm(e, 0, r), pm(e, r + 1, -1), r);
}
//#endregion
//#region node_modules/@emotion/cache/node_modules/stylis/src/Serializer.js
function Km(e, t) {
	for (var n = "", r = hm(e), i = 0; i < r; i++) n += t(e[i], i, e, t) || "";
	return n;
}
function qm(e, t, n, r) {
	switch (e.type) {
		case rm: if (e.children.length) break;
		case tm:
		case em: return e.return = e.return || e.value;
		case Qp: return "";
		case nm: return e.return = e.value + "{" + Km(e.children, r) + "}";
		case $p: e.value = e.props.join(",");
	}
	return mm(n = Km(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
//#endregion
//#region node_modules/@emotion/cache/node_modules/stylis/src/Middleware.js
function Jm(e) {
	var t = hm(e);
	return function(n, r, i, a) {
		for (var o = "", s = 0; s < t; s++) o += e[s](n, r, i, a) || "";
		return o;
	};
}
function Ym(e) {
	return function(t) {
		t.root || (t = t.return) && e(t);
	};
}
//#endregion
//#region node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function Xm(e) {
	var t = Object.create(null);
	return function(n) {
		return t[n] === void 0 && (t[n] = e(n)), t[n];
	};
}
//#endregion
//#region node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js
var Zm = function(e, t, n) {
	for (var r = 0, i = 0; r = i, i = km(), r === 38 && i === 12 && (t[n] = 1), !Mm(i);) Om();
	return jm(e, xm);
}, Qm = function(e, t) {
	var n = -1, r = 44;
	do
		switch (Mm(r)) {
			case 0:
				r === 38 && km() === 12 && (t[n] = 1), e[n] += Zm(xm - 1, t, n);
				break;
			case 2:
				e[n] += Fm(r);
				break;
			case 4: if (r === 44) {
				e[++n] = km() === 58 ? "&\f" : "", t[n] = e[n].length;
				break;
			}
			default: e[n] += am(r);
		}
	while (r = Om());
	return e;
}, $m = function(e, t) {
	return Pm(Qm(Nm(e), t));
}, eh = /* #__PURE__ */ new WeakMap(), th = function(e) {
	if (!(e.type !== "rule" || !e.parent || e.length < 1)) {
		for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; n.type !== "rule";) if (n = n.parent, !n) return;
		if ((e.props.length !== 1 || t.charCodeAt(0) === 58 || eh.get(n)) && !r) {
			eh.set(e, !0);
			for (var i = [], a = $m(t, i), o = n.props, s = 0, c = 0; s < a.length; s++) for (var l = 0; l < o.length; l++, c++) e.props[c] = i[s] ? a[s].replace(/&\f/g, o[l]) : o[l] + " " + a[s];
		}
	}
}, nh = function(e) {
	if (e.type === "decl") {
		var t = e.value;
		t.charCodeAt(0) === 108 && t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
	}
};
function rh(e, t) {
	switch (sm(e, t)) {
		case 5103: return Zp + "print-" + e + e;
		case 5737:
		case 4201:
		case 3177:
		case 3433:
		case 1641:
		case 4457:
		case 2921:
		case 5572:
		case 6356:
		case 5844:
		case 3191:
		case 6645:
		case 3005:
		case 6391:
		case 5879:
		case 5623:
		case 6135:
		case 4599:
		case 4855:
		case 4215:
		case 6389:
		case 5109:
		case 5365:
		case 5621:
		case 3829: return Zp + e + e;
		case 5349:
		case 4246:
		case 4810:
		case 6968:
		case 2756: return Zp + e + Xp + e + Yp + e + e;
		case 6828:
		case 4268: return Zp + e + Yp + e + e;
		case 6165: return Zp + e + Yp + "flex-" + e + e;
		case 5187: return Zp + e + um(e, /(\w+).+(:[^]+)/, Zp + "box-$1$2" + Yp + "flex-$1$2") + e;
		case 5443: return Zp + e + Yp + "flex-item-" + um(e, /flex-|-self/, "") + e;
		case 4675: return Zp + e + Yp + "flex-line-pack" + um(e, /align-content|flex-|-self/, "") + e;
		case 5548: return Zp + e + Yp + um(e, "shrink", "negative") + e;
		case 5292: return Zp + e + Yp + um(e, "basis", "preferred-size") + e;
		case 6060: return Zp + "box-" + um(e, "-grow", "") + Zp + e + Yp + um(e, "grow", "positive") + e;
		case 4554: return Zp + um(e, /([^-])(transform)/g, "$1" + Zp + "$2") + e;
		case 6187: return um(um(um(e, /(zoom-|grab)/, Zp + "$1"), /(image-set)/, Zp + "$1"), e, "") + e;
		case 5495:
		case 3959: return um(e, /(image-set\([^]*)/, Zp + "$1$`$1");
		case 4968: return um(um(e, /(.+:)(flex-)?(.*)/, Zp + "box-pack:$3" + Yp + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Zp + e + e;
		case 4095:
		case 3583:
		case 4068:
		case 2532: return um(e, /(.+)-inline(.+)/, Zp + "$1$2") + e;
		case 8116:
		case 7059:
		case 5753:
		case 5535:
		case 5445:
		case 5701:
		case 4933:
		case 4677:
		case 5533:
		case 5789:
		case 5021:
		case 4765:
			if (mm(e) - 1 - t > 6) switch (fm(e, t + 1)) {
				case 109: if (fm(e, t + 4) !== 45) break;
				case 102: return um(e, /(.+:)(.+)-([^]+)/, "$1" + Zp + "$2-$3$1" + Xp + (fm(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
				case 115: return ~dm(e, "stretch") ? rh(um(e, "stretch", "fill-available"), t) + e : e;
			}
			break;
		case 4949: if (fm(e, t + 1) !== 115) break;
		case 6444:
			switch (fm(e, mm(e) - 3 - (~dm(e, "!important") && 10))) {
				case 107: return um(e, ":", ":" + Zp) + e;
				case 101: return um(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Zp + (fm(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Zp + "$2$3$1" + Yp + "$2box$3") + e;
			}
			break;
		case 5936:
			switch (fm(e, t + 11)) {
				case 114: return Zp + e + Yp + um(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
				case 108: return Zp + e + Yp + um(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
				case 45: return Zp + e + Yp + um(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
			}
			return Zp + e + Yp + e + e;
	}
	return e;
}
var ih = [function(e, t, n, r) {
	if (e.length > -1 && !e.return) switch (e.type) {
		case em:
			e.return = rh(e.value, e.length);
			break;
		case nm: return Km([Tm(e, { value: um(e.value, "@", "@" + Zp) })], r);
		case $p: if (e.length) return _m(e.props, function(t) {
			switch (lm(t, /(::plac\w+|:read-\w+)/)) {
				case ":read-only":
				case ":read-write": return Km([Tm(e, { props: [um(t, /:(read-\w+)/, ":" + Xp + "$1")] })], r);
				case "::placeholder": return Km([
					Tm(e, { props: [um(t, /:(plac\w+)/, ":" + Zp + "input-$1")] }),
					Tm(e, { props: [um(t, /:(plac\w+)/, ":" + Xp + "$1")] }),
					Tm(e, { props: [um(t, /:(plac\w+)/, Yp + "input-$1")] })
				], r);
			}
			return "";
		});
	}
}], ah = function(e) {
	var t = e.key;
	if (t === "css") {
		var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
		Array.prototype.forEach.call(n, function(e) {
			e.getAttribute("data-emotion").indexOf(" ") !== -1 && (document.head.appendChild(e), e.setAttribute("data-s", ""));
		});
	}
	var r = e.stylisPlugins || ih, i = {}, a, o = [];
	a = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll("style[data-emotion^=\"" + t + " \"]"), function(e) {
		for (var t = e.getAttribute("data-emotion").split(" "), n = 1; n < t.length; n++) i[t[n]] = !0;
		o.push(e);
	});
	var s, c = [th, nh], l, u = [qm, Ym(function(e) {
		l.insert(e);
	})], d = Jm(c.concat(r, u)), f = function(e) {
		return Km(Vm(e), d);
	};
	s = function(e, t, n, r) {
		l = n, f(e ? e + "{" + t.styles + "}" : t.styles), r && (p.inserted[t.name] = !0);
	};
	var p = {
		key: t,
		sheet: new Jp({
			key: t,
			container: a,
			nonce: e.nonce,
			speedy: e.speedy,
			prepend: e.prepend,
			insertionPoint: e.insertionPoint
		}),
		nonce: e.nonce,
		inserted: i,
		registered: {},
		insert: s
	};
	return p.sheet.hydrate(o), p;
};
//#endregion
//#region node_modules/@emotion/hash/dist/emotion-hash.esm.js
function oh(e) {
	for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4) n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= n >>> 24, t = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	switch (i) {
		case 3: t ^= (e.charCodeAt(r + 2) & 255) << 16;
		case 2: t ^= (e.charCodeAt(r + 1) & 255) << 8;
		case 1: t ^= e.charCodeAt(r) & 255, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	}
	return t ^= t >>> 13, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
//#endregion
//#region node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var sh = {
	animationIterationCount: 1,
	aspectRatio: 1,
	borderImageOutset: 1,
	borderImageSlice: 1,
	borderImageWidth: 1,
	boxFlex: 1,
	boxFlexGroup: 1,
	boxOrdinalGroup: 1,
	columnCount: 1,
	columns: 1,
	flex: 1,
	flexGrow: 1,
	flexPositive: 1,
	flexShrink: 1,
	flexNegative: 1,
	flexOrder: 1,
	gridRow: 1,
	gridRowEnd: 1,
	gridRowSpan: 1,
	gridRowStart: 1,
	gridColumn: 1,
	gridColumnEnd: 1,
	gridColumnSpan: 1,
	gridColumnStart: 1,
	msGridRow: 1,
	msGridRowSpan: 1,
	msGridColumn: 1,
	msGridColumnSpan: 1,
	fontWeight: 1,
	lineHeight: 1,
	opacity: 1,
	order: 1,
	orphans: 1,
	scale: 1,
	tabSize: 1,
	widows: 1,
	zIndex: 1,
	zoom: 1,
	WebkitLineClamp: 1,
	fillOpacity: 1,
	floodOpacity: 1,
	stopOpacity: 1,
	strokeDasharray: 1,
	strokeDashoffset: 1,
	strokeMiterlimit: 1,
	strokeOpacity: 1,
	strokeWidth: 1
}, ch = /[A-Z]|^ms/g, lh = /_EMO_([^_]+?)_([^]*?)_EMO_/g, uh = function(e) {
	return e.charCodeAt(1) === 45;
}, dh = function(e) {
	return e != null && typeof e != "boolean";
}, fh = /* #__PURE__ */ Xm(function(e) {
	return uh(e) ? e : e.replace(ch, "-$&").toLowerCase();
}), ph = function(e, t) {
	switch (e) {
		case "animation":
		case "animationName": if (typeof t == "string") return t.replace(lh, function(e, t, n) {
			return _h = {
				name: t,
				styles: n,
				next: _h
			}, t;
		});
	}
	return sh[e] !== 1 && !uh(e) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
function mh(e, t, n) {
	if (n == null) return "";
	var r = n;
	if (r.__emotion_styles !== void 0) return r;
	switch (typeof n) {
		case "boolean": return "";
		case "object":
			var i = n;
			if (i.anim === 1) return _h = {
				name: i.name,
				styles: i.styles,
				next: _h
			}, i.name;
			var a = n;
			if (a.styles !== void 0) {
				var o = a.next;
				if (o !== void 0) for (; o !== void 0;) _h = {
					name: o.name,
					styles: o.styles,
					next: _h
				}, o = o.next;
				return a.styles + ";";
			}
			return hh(e, t, n);
		case "function": if (e !== void 0) {
			var s = _h, c = n(e);
			return _h = s, mh(e, t, c);
		}
	}
	var l = n;
	if (t == null) return l;
	var u = t[l];
	return u === void 0 ? l : u;
}
function hh(e, t, n) {
	var r = "";
	if (Array.isArray(n)) for (var i = 0; i < n.length; i++) r += mh(e, t, n[i]) + ";";
	else for (var a in n) {
		var o = n[a];
		if (typeof o != "object") {
			var s = o;
			t != null && t[s] !== void 0 ? r += a + "{" + t[s] + "}" : dh(s) && (r += fh(a) + ":" + ph(a, s) + ";");
		} else if (Array.isArray(o) && typeof o[0] == "string" && (t == null || t[o[0]] === void 0)) for (var c = 0; c < o.length; c++) dh(o[c]) && (r += fh(a) + ":" + ph(a, o[c]) + ";");
		else {
			var l = mh(e, t, o);
			switch (a) {
				case "animation":
				case "animationName":
					r += fh(a) + ":" + l + ";";
					break;
				default: r += a + "{" + l + "}";
			}
		}
	}
	return r;
}
var gh = /label:\s*([^\s;{]+)\s*(;|$)/g, _h;
function vh(e, t, n) {
	if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0) return e[0];
	var r = !0, i = "";
	_h = void 0;
	var a = e[0];
	a == null || a.raw === void 0 ? (r = !1, i += mh(n, t, a)) : i += a[0];
	for (var o = 1; o < e.length; o++) i += mh(n, t, e[o]), r && (i += a[o]);
	gh.lastIndex = 0;
	for (var s = "", c; (c = gh.exec(i)) !== null;) s += "-" + c[1];
	return {
		name: oh(i) + s,
		styles: i,
		next: _h
	};
}
//#endregion
//#region node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
function yh(e, t, n) {
	var r = "";
	return n.split(" ").forEach(function(n) {
		e[n] === void 0 ? n && (r += n + " ") : t.push(e[n] + ";");
	}), r;
}
var bh = function(e, t, n) {
	var r = e.key + "-" + t.name;
	n === !1 && e.registered[r] === void 0 && (e.registered[r] = t.styles);
}, xh = function(e, t, n) {
	bh(e, t, n);
	var r = e.key + "-" + t.name;
	if (e.inserted[t.name] === void 0) {
		var i = t;
		do
			e.insert(t === i ? "." + r : "", i, e.sheet, !0), i = i.next;
		while (i !== void 0);
	}
};
//#endregion
//#region node_modules/@emotion/css/create-instance/dist/emotion-css-create-instance.esm.js
function Sh(e, t) {
	if (e.inserted[t.name] === void 0) return e.insert("", t, e.sheet, !0);
}
function Ch(e, t, n) {
	var r = [], i = yh(e, r, n);
	return r.length < 2 ? n : i + t(r);
}
var wh = function(e) {
	var t = ah(e);
	t.sheet.speedy = function(e) {
		this.isSpeedy = e;
	}, t.compat = !0;
	var n = function() {
		var e = vh([...arguments], t.registered, void 0);
		return xh(t, e, !1), t.key + "-" + e.name;
	};
	return {
		css: n,
		cx: function() {
			var e = [...arguments];
			return Ch(t.registered, n, Th(e));
		},
		injectGlobal: function() {
			Sh(t, vh([...arguments], t.registered));
		},
		keyframes: function() {
			var e = vh([...arguments], t.registered), n = "animation-" + e.name;
			return Sh(t, {
				name: e.name,
				styles: "@keyframes " + n + "{" + e.styles + "}"
			}), n;
		},
		hydrate: function(e) {
			e.forEach(function(e) {
				t.inserted[e] = !0;
			});
		},
		flush: function() {
			t.registered = {}, t.inserted = {}, t.sheet.flush();
		},
		sheet: t.sheet,
		cache: t,
		getRegisteredStyles: yh.bind(null, t.registered),
		merge: Ch.bind(null, t.registered, n)
	};
}, Th = function e(t) {
	for (var n = "", r = 0; r < t.length; r++) {
		var i = t[r];
		if (i != null) {
			var a = void 0;
			switch (typeof i) {
				case "boolean": break;
				case "object":
					if (Array.isArray(i)) a = e(i);
					else for (var o in a = "", i) i[o] && o && (a && (a += " "), a += o);
					break;
				default: a = i;
			}
			a && (n && (n += " "), n += a);
		}
	}
	return n;
}, Eh = /* @__PURE__ */ r({
	cache: () => Lh,
	css: () => Fh,
	cx: () => Ah,
	flush: () => Oh,
	getRegisteredStyles: () => Mh,
	hydrate: () => kh,
	injectGlobal: () => Nh,
	keyframes: () => Ph,
	merge: () => jh,
	sheet: () => Ih
}), Dh = wh({ key: "css" }), Oh = Dh.flush, kh = Dh.hydrate, Ah = Dh.cx, jh = Dh.merge, Mh = Dh.getRegisteredStyles, Nh = Dh.injectGlobal, Ph = Dh.keyframes, Fh = Dh.css, Ih = Dh.sheet, Lh = Dh.cache, Rh = /* @__PURE__ */ new Map(), zh = !1;
try {
	zh = new Intl.NumberFormat("de-DE", { signDisplay: "exceptZero" }).resolvedOptions().signDisplay === "exceptZero";
} catch {}
var Bh = !1;
try {
	Bh = new Intl.NumberFormat("de-DE", {
		style: "unit",
		unit: "degree"
	}).resolvedOptions().style === "unit";
} catch {}
var Vh = { degree: { narrow: {
	default: "°",
	"ja-JP": " 度",
	"zh-TW": "度",
	"sl-SI": " °"
} } }, Hh = class {
	constructor(e, t = {}) {
		this.numberFormatter = Uh(e, t), this.options = t;
	}
	format(e) {
		let t = "";
		if (t = !zh && this.options.signDisplay != null ? Wh(this.numberFormatter, this.options.signDisplay, e) : this.numberFormatter.format(e), this.options.style === "unit" && !Bh) {
			let { unit: e, unitDisplay: n = "short", locale: r } = this.resolvedOptions();
			if (!e) return t;
			let i = Vh[e]?.[n];
			t += i[r] || i.default;
		}
		return t;
	}
	formatToParts(e) {
		return this.numberFormatter.formatToParts(e);
	}
	formatRange(e, t) {
		if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(e, t);
		if (t < e) throw RangeError("End date must be >= start date");
		return `${this.format(e)} \u{2013} ${this.format(t)}`;
	}
	formatRangeToParts(e, t) {
		if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(e, t);
		if (t < e) throw RangeError("End date must be >= start date");
		let n = this.numberFormatter.formatToParts(e), r = this.numberFormatter.formatToParts(t);
		return [
			...n.map((e) => ({
				...e,
				source: "startRange"
			})),
			{
				type: "literal",
				value: " – ",
				source: "shared"
			},
			...r.map((e) => ({
				...e,
				source: "endRange"
			}))
		];
	}
	resolvedOptions() {
		let e = this.numberFormatter.resolvedOptions();
		return !zh && this.options.signDisplay != null && (e = {
			...e,
			signDisplay: this.options.signDisplay
		}), !Bh && this.options.style === "unit" && (e = {
			...e,
			style: "unit",
			unit: this.options.unit,
			unitDisplay: this.options.unitDisplay
		}), e;
	}
};
function Uh(e, t = {}) {
	let { numberingSystem: n } = t;
	if (n && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${n}`), t.style === "unit" && !Bh) {
		let { unit: e, unitDisplay: n = "short" } = t;
		if (!e) throw Error("unit option must be provided with style: \"unit\"");
		if (!Vh[e]?.[n]) throw Error(`Unsupported unit ${e} with unitDisplay = ${n}`);
		t = {
			...t,
			style: "decimal"
		};
	}
	let r = e + (t ? Object.entries(t).sort((e, t) => e[0] < t[0] ? -1 : 1).join() : "");
	if (Rh.has(r)) return Rh.get(r);
	let i = new Intl.NumberFormat(e, t);
	return Rh.set(r, i), i;
}
function Wh(e, t, n) {
	if (t === "auto") return e.format(n);
	if (t === "never") return e.format(Math.abs(n));
	{
		let r = !1;
		if (t === "always" ? r = n > 0 || Object.is(n, 0) : t === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
			let t = e.format(-n), r = e.format(n), i = t.replace(r, "").replace(/\u200e|\u061C/, "");
			return [...i].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), t.replace(r, "!!!").replace(i, "+").replace("!!!", r);
		}
		return e.format(n);
	}
}
//#endregion
//#region node_modules/@internationalized/number/dist/private/NumberParser.mjs
var Gh = /* @__PURE__ */ RegExp("^.*\\(.*\\).*$"), Kh = [
	"latn",
	"arab",
	"hanidec",
	"deva",
	"beng",
	"fullwide"
], qh = class {
	constructor(e, t = {}) {
		this.locale = e, this.options = t;
	}
	parse(e) {
		return Yh(this.locale, this.options, e).parse(e);
	}
	isValidPartialNumber(e, t, n) {
		return Yh(this.locale, this.options, e).isValidPartialNumber(e, t, n);
	}
	getNumberingSystem(e) {
		return Yh(this.locale, this.options, e).options.numberingSystem;
	}
}, Jh = /* @__PURE__ */ new Map();
function Yh(e, t, n) {
	let r = Xh(e, t);
	if (!e.includes("-nu-") && !r.isValidPartialNumber(n)) {
		for (let i of Kh) if (i !== r.options.numberingSystem) {
			let r = Xh(e + (e.includes("-u-") ? "-nu-" : "-u-nu-") + i, t);
			if (r.isValidPartialNumber(n)) return r;
		}
	}
	return r;
}
function Xh(e, t) {
	let n = e + (t ? Object.entries(t).sort((e, t) => e[0] < t[0] ? -1 : 1).join() : ""), r = Jh.get(n);
	return r || (r = new Zh(e, t), Jh.set(n, r)), r;
}
var Zh = class {
	constructor(e, t = {}) {
		this.locale = e, t.roundingIncrement !== 1 && t.roundingIncrement != null && (t.maximumFractionDigits == null && t.minimumFractionDigits == null ? (t.maximumFractionDigits = 0, t.minimumFractionDigits = 0) : t.maximumFractionDigits == null ? t.maximumFractionDigits = t.minimumFractionDigits : t.minimumFractionDigits ??= t.maximumFractionDigits), this.formatter = new Intl.NumberFormat(e, t), this.options = this.formatter.resolvedOptions(), this.symbols = eg(e, this.formatter, this.options, t), this.options.style === "percent" && ((this.options.minimumFractionDigits ?? 0) > 18 || (this.options.maximumFractionDigits ?? 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
	}
	parse(e) {
		let t = this.formatter.resolvedOptions().useGrouping, n = this.sanitize(e);
		if (!t && this.symbols.group && n.includes(this.symbols.group)) return NaN;
		if (this.symbols.group && (n = n.replaceAll(this.symbols.group, "")), this.symbols.decimal && (n = n.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (n = n.replace(this.symbols.minusSign, "-")), n = n.replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
			let e = n.indexOf("-");
			n = n.replace("-", ""), n = n.replace("+", "");
			let t = n.indexOf(".");
			t === -1 && (t = n.length), n = n.replace(".", ""), n = t - 2 == 0 ? `0.${n}` : t - 2 == -1 ? `0.0${n}` : t - 2 == -2 ? "0.00" : `${n.slice(0, t - 2)}.${n.slice(t - 2)}`, e > -1 && (n = `-${n}`);
		}
		let r = n ? +n : NaN;
		if (isNaN(r)) return NaN;
		if (this.options.style === "percent") {
			let e = {
				...this.options,
				style: "decimal",
				minimumFractionDigits: Math.min((this.options.minimumFractionDigits ?? 0) + 2, 20),
				maximumFractionDigits: Math.min((this.options.maximumFractionDigits ?? 0) + 2, 20)
			};
			return new qh(this.locale, e).parse(new Hh(this.locale, e).format(r));
		}
		return this.options.currencySign === "accounting" && Gh.test(e) && (r = -1 * r), r;
	}
	sanitize(e) {
		let t = this.formatter.resolvedOptions().useGrouping;
		return this.symbols.noNumeralUnits.length > 0 && this.symbols.noNumeralUnits.find((t) => t.unit === e) ? this.symbols.noNumeralUnits.find((t) => t.unit === e).value.toString() : (e = e.replace(this.symbols.literals, ""), this.symbols.minusSign && (e = e.replace("-", this.symbols.minusSign)), this.options.numberingSystem === "arab" && (this.symbols.decimal && (e = tg(e, ",", this.symbols.decimal), e = tg(e, "،", this.symbols.decimal)), this.symbols.group && t && (e = tg(e, ".", this.symbols.group))), this.symbols.group === "’" && e.includes("'") && t && (e = tg(e, "'", this.symbols.group)), this.symbols.group === "'" && e.includes("’") && t && (e = tg(e, "’", this.symbols.group)), this.options.locale === "fr-FR" && this.symbols.group && t && (e = tg(e, " ", this.symbols.group), e = tg(e, /\u00A0/g, this.symbols.group)), e);
	}
	isValidPartialNumber(e, t = -Infinity, n = Infinity) {
		let r = this.formatter.resolvedOptions().useGrouping;
		return e = this.sanitize(e), this.symbols.minusSign && e.startsWith(this.symbols.minusSign) && t < 0 ? e = e.slice(this.symbols.minusSign.length) : this.symbols.plusSign && e.startsWith(this.symbols.plusSign) && n > 0 && (e = e.slice(this.symbols.plusSign.length)), this.symbols.decimal && e.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (this.symbols.group && r && (e = tg(e, this.symbols.group, "")), e = e.replace(this.symbols.numeral, ""), this.symbols.decimal && (e = e.replace(this.symbols.decimal, "")), e.length === 0);
	}
}, Qh = /* @__PURE__ */ new Set([
	"decimal",
	"fraction",
	"integer",
	"minusSign",
	"plusSign",
	"group"
]), $h = [
	0,
	4,
	2,
	1,
	11,
	20,
	3,
	7,
	100,
	21,
	.1,
	1.1
];
function eg(e, t, n, r) {
	let i = new Intl.NumberFormat(e, {
		...n,
		minimumSignificantDigits: 1,
		maximumSignificantDigits: 21,
		roundingIncrement: 1,
		roundingPriority: "auto",
		roundingMode: "halfExpand",
		useGrouping: !0
	}), a = i.formatToParts(-10000.111), o = i.formatToParts(10000.111), s = $h.map((e) => i.formatToParts(e)), c = s.map((e, t) => {
		let n = e.find((e) => e.type === "unit");
		return n && !e.some((e) => e.type === "integer" || e.type === "fraction") ? {
			unit: n.value,
			value: $h[t]
		} : null;
	}).filter((e) => !!e), l = a.find((e) => e.type === "minusSign")?.value ?? "-", u = o.find((e) => e.type === "plusSign")?.value;
	!u && (r?.signDisplay === "exceptZero" || r?.signDisplay === "always") && (u = "+");
	let d = new Intl.NumberFormat(e, {
		...n,
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	}).formatToParts(.001).find((e) => e.type === "decimal")?.value, f = a.find((e) => e.type === "group")?.value, p = a.filter((e) => !Qh.has(e.type)).map((e) => ng(e.value)), m = s.flatMap((e) => e.filter((e) => !Qh.has(e.type)).map((e) => ng(e.value))), h = [.../* @__PURE__ */ new Set([...p, ...m])].sort((e, t) => t.length - e.length), g = h.length === 0 ? /* @__PURE__ */ RegExp("\\p{White_Space}|\\p{Cf}", "gu") : RegExp(`${h.join("|")}|\\p{White_Space}|\\p{Cf}`, "gu"), _ = [...new Intl.NumberFormat(n.locale, { useGrouping: !1 }).format(9876543210)].reverse(), v = new Map(_.map((e, t) => [e, t])), y = RegExp(`[${_.join("")}]`, "g");
	return {
		minusSign: l,
		plusSign: u,
		decimal: d,
		group: f,
		literals: g,
		numeral: y,
		numerals: _,
		index: (e) => String(v.get(e)),
		noNumeralUnits: c
	};
}
function tg(e, t, n) {
	return e.replaceAll ? e.replaceAll(t, n) : e.split(t).join(n);
}
function ng(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
//#endregion
//#region node_modules/@internationalized/number/dist/index.mjs
var rg = /* @__PURE__ */ r({
	NumberFormatter: () => Hh,
	NumberParser: () => qh
});
//#endregion
//#region node_modules/axios/lib/helpers/bind.js
function ig(e, t) {
	return function() {
		return e.apply(t, arguments);
	};
}
//#endregion
//#region node_modules/axios/lib/utils.js
var { toString: ag } = Object.prototype, { getPrototypeOf: og } = Object, { iterator: sg, toStringTag: cg } = Symbol, lg = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), ug = (e) => typeof e == "string" && (e === "__proto__" || e === "constructor" || e === "prototype"), dg = (e, t, n) => e === Object.prototype || !n && t === null, fg = (e) => {
	if (!Object.isExtensible(e)) return !1;
	let t = Object.getOwnPropertyNames(e);
	return Object.getOwnPropertySymbols && t.push(...Object.getOwnPropertySymbols(e)), t.every((t) => {
		if (ug(t)) return !1;
		let n = Object.getOwnPropertyDescriptor(e, t);
		return !!n && n.configurable && n.writable === !0;
	});
}, pg = (e, t) => {
	let n = e, r = [];
	for (; n != null;) {
		if (r.indexOf(n) !== -1) return !1;
		r.push(n);
		let i = og(n);
		if (dg(n, i, n === e)) return !1;
		if (lg(n, t)) return !0;
		n = i;
	}
	return !1;
}, mg = (e, t) => e != null && pg(e, t) ? e[t] : void 0, hg = (e) => {
	if (e == null || typeof e != "object" && typeof e != "function") return e;
	let t = og(e);
	if (t === null && fg(e)) return e;
	let n = Object.create(null), r = Object.create(null), i = [], a = e;
	for (; a != null && i.indexOf(a) === -1;) {
		i.push(a);
		let o = a === e ? t : og(a);
		if (dg(a, o, a === e)) break;
		let s = Object.getOwnPropertyNames(a);
		Object.getOwnPropertySymbols && s.push(...Object.getOwnPropertySymbols(a));
		for (let t of s) ug(t) || lg(r, t) || (n[t] = e[t], r[t] = !0);
		a = o;
	}
	return n;
}, gg = ((e) => (t) => {
	let n = ag.call(t);
	return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(Object.create(null)), _g = (e) => (e = e.toLowerCase(), (t) => gg(t) === e), vg = (e) => (t) => typeof t === e, { isArray: yg } = Array, bg = vg("undefined");
function xg(e) {
	return e !== null && !bg(e) && e.constructor !== null && !bg(e.constructor) && Tg(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
var Sg = _g("ArrayBuffer");
function Cg(e) {
	let t;
	return t = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && Sg(e.buffer), t;
}
var wg = vg("string"), Tg = vg("function"), Eg = vg("number"), Dg = (e) => typeof e == "object" && !!e, Og = (e) => e === !0 || e === !1, kg = (e) => {
	if (!Dg(e)) return !1;
	let t = og(e);
	return (t === null || t === Object.prototype || og(t) === null) && !pg(e, cg) && !pg(e, sg);
}, Ag = (e) => {
	if (!Dg(e) || xg(e)) return !1;
	try {
		return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
	} catch {
		return !1;
	}
}, jg = _g("Date"), Mg = _g("File"), Ng = (e) => !!(e && e.uri !== void 0), Pg = (e) => e && e.getParts !== void 0, Fg = _g("Blob"), Ig = _g("FileList"), Lg = _g("Set"), Rg = (e) => Dg(e) && Tg(e.pipe);
function zg() {
	return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
var Bg = zg(), Vg = Bg.FormData === void 0 ? void 0 : Bg.FormData, Hg = (e) => {
	if (!e) return !1;
	if (Vg && e instanceof Vg) return !0;
	let t = og(e);
	if (!t || t === Object.prototype || !Tg(e.append)) return !1;
	let n = gg(e);
	return n === "formdata" || n === "object" && Tg(e.toString) && e.toString() === "[object FormData]";
}, Ug = _g("URLSearchParams"), [Wg, Gg, Kg, qg] = [
	"ReadableStream",
	"Request",
	"Response",
	"Headers"
].map(_g), Jg = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Yg(e, t, { allOwnKeys: n = !1 } = {}) {
	if (e == null) return;
	let r, i;
	if (typeof e != "object" && (e = [e]), yg(e)) for (r = 0, i = e.length; r < i; r++) t.call(null, e[r], r, e);
	else {
		if (xg(e)) return;
		let i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length, o;
		for (r = 0; r < a; r++) o = i[r], t.call(null, e[o], o, e);
	}
}
function Xg(e, t) {
	if (xg(e)) return null;
	t = t.toLowerCase();
	let n = Object.keys(e), r = n.length, i;
	for (; r-- > 0;) if (i = n[r], t === i.toLowerCase()) return i;
	return null;
}
var Zg = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Qg = (e) => !bg(e) && e !== Zg;
function $g(...e) {
	let { caseless: t, skipUndefined: n } = Qg(this) && this || {}, r = {}, i = (e, i) => {
		if (i === "__proto__" || i === "constructor" || i === "prototype") return;
		let a = t && typeof i == "string" && Xg(r, i) || i, o = lg(r, a) ? r[a] : void 0;
		kg(o) && kg(e) ? r[a] = $g(o, e) : kg(e) ? r[a] = $g({}, e) : yg(e) ? r[a] = e.slice() : (!n || !bg(e)) && (r[a] = e);
	};
	for (let t = 0, n = e.length; t < n; t++) {
		let n = e[t];
		if (!n || xg(n) || (Yg(n, i), typeof n != "object" || yg(n))) continue;
		let r = Object.getOwnPropertySymbols(n);
		for (let e = 0; e < r.length; e++) {
			let t = r[e];
			d_.call(n, t) && i(n[t], t);
		}
	}
	return r;
}
var e_ = (e, t, n, { allOwnKeys: r } = {}) => (Yg(t, (t, r) => {
	n && Tg(t) ? Object.defineProperty(e, r, {
		__proto__: null,
		value: ig(t, n),
		writable: !0,
		enumerable: !0,
		configurable: !0
	}) : Object.defineProperty(e, r, {
		__proto__: null,
		value: t,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}, { allOwnKeys: r }), e), t_ = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), n_ = (e, t, n, r) => {
	e.prototype = Object.create(t.prototype, r), Object.defineProperty(e.prototype, "constructor", {
		__proto__: null,
		value: e,
		writable: !0,
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e, "super", {
		__proto__: null,
		value: t.prototype
	}), n && Object.assign(e.prototype, n);
}, r_ = (e, t, n, r) => {
	let i, a, o, s = {};
	if (t ||= {}, e == null) return t;
	do {
		for (i = Object.getOwnPropertyNames(e), a = i.length; a-- > 0;) o = i[a], (!r || r(o, e, t)) && !s[o] && (t[o] = e[o], s[o] = !0);
		e = n !== !1 && og(e);
	} while (e && (!n || n(e, t)) && e !== Object.prototype);
	return t;
}, i_ = (e, t, n) => {
	e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
	let r = e.indexOf(t, n);
	return r !== -1 && r === n;
}, a_ = (e) => {
	if (!e) return null;
	if (yg(e)) return e;
	let t = e.length;
	if (!Eg(t)) return null;
	let n = Array(t);
	for (; t-- > 0;) n[t] = e[t];
	return n;
}, o_ = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && og(Uint8Array)), s_ = (e, t) => {
	let n = (e && e[sg]).call(e), r;
	for (; (r = n.next()) && !r.done;) {
		let n = r.value;
		t.call(e, n[0], n[1]);
	}
}, c_ = (e, t) => {
	let n, r = [];
	for (; (n = e.exec(t)) !== null;) r.push(n);
	return r;
}, l_ = _g("HTMLFormElement"), u_ = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, t, n) {
	return t.toUpperCase() + n;
}), { propertyIsEnumerable: d_ } = Object.prototype, f_ = _g("RegExp"), p_ = (e, t) => {
	let n = Object.getOwnPropertyDescriptors(e), r = {};
	Yg(n, (n, i) => {
		let a;
		(a = t(n, i, e)) !== !1 && (r[i] = a || n);
	}), Object.defineProperties(e, r);
}, m_ = (e) => {
	p_(e, (t, n) => {
		if (Tg(e) && [
			"arguments",
			"caller",
			"callee"
		].includes(n)) return !1;
		let r = e[n];
		if (Tg(r)) {
			if (t.enumerable = !1, "writable" in t) {
				t.writable = !1;
				return;
			}
			t.set ||= () => {
				throw Error("Can not rewrite read-only method '" + n + "'");
			};
		}
	});
}, h_ = (e, t) => {
	let n = {}, r = (e) => {
		e.forEach((e) => {
			n[e] = !0;
		});
	};
	return yg(e) ? r(e) : r(String(e).split(t)), n;
}, g_ = () => {}, __ = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function v_(e) {
	return !!(e && Tg(e.append) && e[cg] === "FormData" && e[sg]);
}
var y_ = (e) => {
	let t = /* @__PURE__ */ new WeakSet(), n = (e) => {
		if (Dg(e)) {
			if (t.has(e)) return;
			if (xg(e)) return e;
			if (!("toJSON" in e)) {
				t.add(e);
				let r;
				if (Lg(e)) {
					r = [];
					for (let t of e) {
						let e = n(t);
						!bg(e) && r.push(e);
					}
				} else r = yg(e) ? [] : {}, Yg(e, (e, t) => {
					let i = n(e);
					!bg(i) && (r[t] = i);
				});
				return t.delete(e), r;
			}
		}
		return e;
	};
	return n(e);
}, b_ = _g("AsyncFunction"), x_ = (e) => e && (Dg(e) || Tg(e)) && Tg(e.then) && Tg(e.catch), S_ = ((e, t) => e ? setImmediate : t ? ((e, t) => (Zg.addEventListener("message", ({ source: n, data: r }) => {
	n === Zg && r === e && t.length && t.shift()();
}, !1), (n) => {
	t.push(n), Zg.postMessage(e, "*");
}))(`axios@${Math.random()}`, []) : (e) => setTimeout(e))(typeof setImmediate == "function", Tg(Zg.postMessage)), C_ = typeof queueMicrotask < "u" ? queueMicrotask.bind(Zg) : typeof process < "u" && process.nextTick || S_, w_ = (e) => e != null && Tg(e[sg]), Q = {
	isArray: yg,
	isArrayBuffer: Sg,
	isBuffer: xg,
	isFormData: Hg,
	isArrayBufferView: Cg,
	isString: wg,
	isNumber: Eg,
	isBoolean: Og,
	isObject: Dg,
	isPlainObject: kg,
	isEmptyObject: Ag,
	isReadableStream: Wg,
	isRequest: Gg,
	isResponse: Kg,
	isHeaders: qg,
	isUndefined: bg,
	isDate: jg,
	isFile: Mg,
	isReactNativeBlob: Ng,
	isReactNative: Pg,
	isBlob: Fg,
	isRegExp: f_,
	isFunction: Tg,
	isStream: Rg,
	isURLSearchParams: Ug,
	isTypedArray: o_,
	isFileList: Ig,
	forEach: Yg,
	merge: $g,
	extend: e_,
	trim: Jg,
	stripBOM: t_,
	inherits: n_,
	toFlatObject: r_,
	kindOf: gg,
	kindOfTest: _g,
	endsWith: i_,
	toArray: a_,
	forEachEntry: s_,
	matchAll: c_,
	isHTMLForm: l_,
	hasOwnProperty: lg,
	hasOwnProp: lg,
	hasOwnInPrototypeChain: pg,
	getSafeProp: mg,
	toSafeFlatObject: hg,
	reduceDescriptors: p_,
	freezeMethods: m_,
	toObjectSet: h_,
	toCamelCase: u_,
	noop: g_,
	toFiniteNumber: __,
	findKey: Xg,
	global: Zg,
	isContextDefined: Qg,
	isSpecCompliantForm: v_,
	toJSONObject: y_,
	isAsyncFn: b_,
	isThenable: x_,
	setImmediate: S_,
	asap: C_,
	isIterable: w_,
	isSafeIterable: (e) => e != null && pg(e, sg) && w_(e)
}, T_ = Q.toObjectSet([
	"age",
	"authorization",
	"content-length",
	"content-type",
	"etag",
	"expires",
	"from",
	"host",
	"if-modified-since",
	"if-unmodified-since",
	"last-modified",
	"location",
	"max-forwards",
	"proxy-authorization",
	"referer",
	"retry-after",
	"user-agent"
]), E_ = (e) => {
	let t = {}, n, r, i;
	return e && e.split("\n").forEach(function(e) {
		i = e.indexOf(":"), n = e.substring(0, i).trim().toLowerCase(), r = e.substring(i + 1).trim();
		let a = Q.hasOwnProp(t, n);
		!n || a && Q.hasOwnProp(T_, n) || (n === "set-cookie" ? a ? t[n].push(r) : t[n] = [r] : t[n] = a ? t[n] + ", " + r : r);
	}), t;
};
//#endregion
//#region node_modules/axios/lib/helpers/sanitizeHeaderValue.js
function D_(e) {
	let t = 0, n = e.length;
	for (; t < n;) {
		let n = e.charCodeAt(t);
		if (n !== 9 && n !== 32) break;
		t += 1;
	}
	for (; n > t;) {
		let t = e.charCodeAt(n - 1);
		if (t !== 9 && t !== 32) break;
		--n;
	}
	return t === 0 && n === e.length ? e : e.slice(t, n);
}
var O_ = /* @__PURE__ */ RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), k_ = /* @__PURE__ */ RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function A_(e, t) {
	return Q.isArray(e) ? e.map((e) => A_(e, t)) : D_(String(e).replace(t, ""));
}
var j_ = (e) => A_(e, O_), M_ = (e) => A_(e, k_);
function N_(e) {
	let t = Object.create(null);
	return Q.forEach(e.toJSON(), (e, n) => {
		t[n] = M_(e);
	}), t;
}
//#endregion
//#region node_modules/axios/lib/core/AxiosHeaders.js
var P_ = Symbol("internals");
function F_(e) {
	return e && String(e).trim().toLowerCase();
}
function I_(e) {
	return e === !1 || e == null ? e : Q.isArray(e) ? e.map(I_) : j_(String(e));
}
function L_(e) {
	let t = Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g, r;
	for (; r = n.exec(e);) t[r[1]] = r[2];
	return t;
}
var R_ = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function z_(e) {
	let t = 0, n = e.length;
	for (; t < n;) {
		let n = e.charCodeAt(t);
		if (n !== 9 && n !== 32) break;
		t += 1;
	}
	for (; n > t;) {
		let t = e.charCodeAt(n - 1);
		if (t !== 9 && t !== 32) break;
		--n;
	}
	return t === 0 && n === e.length ? e : e.slice(t, n);
}
function B_(e) {
	let t = e.length - 1;
	if (t < 1 || e.charCodeAt(0) !== 34 || e.charCodeAt(t) !== 34) return e;
	let n = "";
	for (let r = 1; r < t; r++) {
		let i = e.charCodeAt(r);
		if (i === 34 || i === 92 && (r += 1, r >= t)) return e;
		n += e[r];
	}
	return n;
}
function V_(e) {
	let t = Object.create(null), n = String(e), r = 0, i = !1, a = !1;
	function o(e) {
		let i = z_(n.slice(r, e)), a = i.indexOf("=");
		if (a < 1) return;
		let o = z_(i.slice(0, a));
		if (!R_.test(o)) return;
		let s = o.toLowerCase();
		if (s === "__proto__" || s === "constructor" || s === "prototype") return;
		let c = z_(i.slice(a + 1));
		t[s] = B_(c);
	}
	for (let e = 0; e < n.length; e++) {
		let t = n.charCodeAt(e);
		i ? a ? a = !1 : t === 92 ? a = !0 : t === 34 && (i = !1) : t === 34 ? i = !0 : (t === 44 || t === 59) && (o(e), r = e + 1);
	}
	return o(n.length), t;
}
var H_ = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function U_(e, t, n, r, i) {
	if (Q.isFunction(r)) return r.call(this, t, n);
	if (i && (t = n), Q.isString(t)) {
		if (Q.isString(r)) return t.indexOf(r) !== -1;
		if (Q.isRegExp(r)) return r.test(t);
	}
}
function W_(e) {
	return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, n) => t.toUpperCase() + n);
}
function G_(e, t) {
	let n = Q.toCamelCase(" " + t);
	[
		"get",
		"set",
		"has"
	].forEach((r) => {
		Object.defineProperty(e, r + n, {
			__proto__: null,
			value: function(e, n, i) {
				return this[r].call(this, t, e, n, i);
			},
			configurable: !0
		});
	});
}
var K_ = class {
	constructor(e) {
		e && this.set(e);
	}
	set(e, t, n) {
		let r = this;
		function i(e, t, n) {
			let i = F_(t);
			if (!i) return;
			let a = Q.findKey(r, i);
			(!a || r[a] === void 0 || n === !0 || n === void 0 && r[a] !== !1) && (r[a || t] = I_(e));
		}
		let a = (e, t) => Q.forEach(e, (e, n) => i(e, n, t));
		if (Q.isPlainObject(e) || e instanceof this.constructor) a(e, t);
		else if (Q.isString(e) && (e = e.trim()) && !H_(e)) a(E_(e), t);
		else if (Q.isObject(e) && Q.isSafeIterable(e)) {
			let n = Object.create(null), r, i;
			for (let t of e) {
				if (!Q.isArray(t)) throw TypeError("Object iterator must return a key-value pair");
				i = t[0], Q.hasOwnProp(n, i) ? (r = n[i], n[i] = Q.isArray(r) ? [...r, t[1]] : [r, t[1]]) : n[i] = t[1];
			}
			a(n, t);
		} else e != null && i(t, e, n);
		return this;
	}
	get(e, t) {
		if (e = F_(e), e) {
			let n = Q.findKey(this, e);
			if (n) {
				let e = this[n];
				if (!t) return e;
				if (t === !0) return L_(e);
				if (Q.isFunction(t)) return t.call(this, e, n);
				if (Q.isRegExp(t)) return t.exec(e);
				throw TypeError("parser must be boolean|regexp|function");
			}
		}
	}
	has(e, t) {
		if (e = F_(e), e) {
			let n = Q.findKey(this, e);
			return !(!n || this[n] === void 0 || t && !U_(this, this[n], n, t));
		}
		return !1;
	}
	delete(e, t) {
		let n = this, r = !1;
		function i(e) {
			if (e = F_(e), e) {
				let i = Q.findKey(n, e);
				i && (!t || U_(n, n[i], i, t)) && (delete n[i], r = !0);
			}
		}
		return Q.isArray(e) ? e.forEach(i) : i(e), r;
	}
	clear(e) {
		let t = Object.keys(this), n = t.length, r = !1;
		for (; n--;) {
			let i = t[n];
			(!e || U_(this, this[i], i, e, !0)) && (delete this[i], r = !0);
		}
		return r;
	}
	normalize(e) {
		let t = this, n = {};
		return Q.forEach(this, (r, i) => {
			let a = Q.findKey(n, i);
			if (a) {
				t[a] = I_(r), delete t[i];
				return;
			}
			let o = e ? W_(i) : String(i).trim();
			o !== i && delete t[i], t[o] = I_(r), n[o] = !0;
		}), this;
	}
	concat(...e) {
		return this.constructor.concat(this, ...e);
	}
	toJSON(e) {
		let t = Object.create(null);
		return Q.forEach(this, (n, r) => {
			n != null && n !== !1 && (t[r] = e && Q.isArray(n) ? n.join(", ") : n);
		}), t;
	}
	[Symbol.iterator]() {
		return Object.entries(this.toJSON())[Symbol.iterator]();
	}
	toString() {
		return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join("\n");
	}
	getSetCookie() {
		let e = this.get("set-cookie");
		return Q.isArray(e) ? e : e == null || e === !1 ? [] : [e];
	}
	get [Symbol.toStringTag]() {
		return "AxiosHeaders";
	}
	static from(e) {
		return e instanceof this ? e : new this(e);
	}
	static parseParameters(e) {
		return V_(e);
	}
	static concat(e, ...t) {
		let n = new this(e);
		return t.forEach((e) => n.set(e)), n;
	}
	static accessor(e) {
		let t = (this[P_] = this[P_] = { accessors: {} }).accessors, n = this.prototype;
		function r(e) {
			let r = F_(e);
			t[r] || (G_(n, e), t[r] = !0);
		}
		return Q.isArray(e) ? e.forEach(r) : r(e), this;
	}
};
K_.accessor([
	"Content-Type",
	"Content-Length",
	"Accept",
	"Accept-Encoding",
	"User-Agent",
	"Authorization"
]), Q.reduceDescriptors(K_.prototype, ({ value: e }, t) => {
	let n = t[0].toUpperCase() + t.slice(1);
	return {
		get: () => e,
		set(e) {
			this[n] = e;
		}
	};
}), Q.freezeMethods(K_);
//#endregion
//#region node_modules/axios/lib/core/AxiosError.js
var q_ = "[REDACTED ****]";
function J_(e) {
	if (Q.hasOwnProp(e, "toJSON")) return !0;
	let t = Object.getPrototypeOf(e);
	for (; t && t !== Object.prototype;) {
		if (Q.hasOwnProp(t, "toJSON")) return !0;
		t = Object.getPrototypeOf(t);
	}
	return !1;
}
function Y_(e, t) {
	let n = new Set(t.map((e) => String(e).toLowerCase())), r = [], i = (e) => {
		if (typeof e != "object" || !e || Q.isBuffer(e)) return e;
		if (r.indexOf(e) !== -1) return;
		e instanceof K_ && (e = e.toJSON()), r.push(e);
		let t;
		if (Q.isArray(e)) t = [], e.forEach((e, n) => {
			let r = i(e);
			Q.isUndefined(r) || (t[n] = r);
		});
		else {
			if (!Q.isPlainObject(e) && J_(e)) return r.pop(), e;
			t = Object.create(null);
			for (let [r, a] of Object.entries(e)) {
				let e = n.has(r.toLowerCase()) ? q_ : i(a);
				Q.isUndefined(e) || (t[r] = e);
			}
		}
		return r.pop(), t;
	};
	return i(e);
}
function X_(e) {
	try {
		return String(e);
	} catch {
		return "";
	}
}
function Z_(e) {
	return e.errors.map((e) => {
		try {
			return e && e.message ? X_(e.message) : X_(e);
		} catch {
			return "";
		}
	}).filter(Boolean).join("; ") || e.name || "AggregateError";
}
var $ = class e extends Error {
	static from(t, n, r, i, a, o) {
		let s = t.message;
		!s && Q.isArray(t.errors) && t.errors.length && (s = Z_(t));
		let c = new e(s, n || t.code, r, i, a);
		return Object.defineProperty(c, "cause", {
			__proto__: null,
			value: t,
			writable: !0,
			enumerable: !1,
			configurable: !0
		}), c.name = t.name, t.status != null && c.status == null && (c.status = t.status), o && Object.assign(c, o), c;
	}
	constructor(e, t, n, r, i) {
		super(e), Object.defineProperty(this, "message", {
			__proto__: null,
			value: e,
			enumerable: !0,
			writable: !0,
			configurable: !0
		}), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i, this.status = i.status);
	}
	toJSON() {
		let e = this.config, t = e && Q.hasOwnProp(e, "redact") ? e.redact : void 0, n = Q.isArray(t) && t.length > 0 ? Y_(e, t) : Q.toJSONObject(e);
		return {
			message: this.message,
			name: this.name,
			description: this.description,
			number: this.number,
			fileName: this.fileName,
			lineNumber: this.lineNumber,
			columnNumber: this.columnNumber,
			stack: this.stack,
			config: n,
			code: this.code,
			status: this.status
		};
	}
};
$.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE", $.ERR_BAD_OPTION = "ERR_BAD_OPTION", $.ECONNABORTED = "ECONNABORTED", $.ETIMEDOUT = "ETIMEDOUT", $.ECONNREFUSED = "ECONNREFUSED", $.ERR_NETWORK = "ERR_NETWORK", $.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS", $.ERR_DEPRECATED = "ERR_DEPRECATED", $.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE", $.ERR_BAD_REQUEST = "ERR_BAD_REQUEST", $.ERR_CANCELED = "ERR_CANCELED", $.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT", $.ERR_INVALID_URL = "ERR_INVALID_URL", $.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
function Q_(e) {
	return Q.isPlainObject(e) || Q.isArray(e);
}
function $_(e) {
	return Q.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function ev(e, t, n) {
	return e ? e.concat(t).map(function(e, t) {
		return e = $_(e), !n && t ? "[" + e + "]" : e;
	}).join(n ? "." : "") : t;
}
function tv(e) {
	return Q.isArray(e) && !e.some(Q_);
}
var nv = Q.toFlatObject(Q, {}, null, function(e) {
	return /^is[A-Z]/.test(e);
});
function rv(e, t, n) {
	if (!Q.isObject(e)) throw TypeError("target must be an object");
	t ||= new FormData();
	let r = (e, t) => {
		let r = Q.getSafeProp(n, e);
		return Q.isUndefined(r) ? t : r;
	}, i = r("metaTokens", !0), a = r("visitor") || h, o = r("dots", !1), s = r("indexes", !1), c = r("Blob") || typeof Blob < "u" && Blob, l = r("maxDepth", 100), u = c && Q.isSpecCompliantForm(t), d = [];
	if (!Q.isFunction(a)) throw TypeError("visitor must be a function");
	function f(e) {
		if (e === null) return "";
		if (Q.isDate(e)) return e.toISOString();
		if (Q.isBoolean(e)) return e.toString();
		if (!u && Q.isBlob(e)) throw new $("Blob is not supported. Use a Buffer instead.");
		if (Q.isArrayBuffer(e) || Q.isTypedArray(e)) {
			if (u && typeof c == "function") return new c([e]);
			throw new $("Blob is not supported. Use a Buffer instead.", $.ERR_NOT_SUPPORT);
		}
		return e;
	}
	function p(e) {
		if (e > l) throw new $("Object is too deeply nested (" + e + " levels). Max depth: " + l, $.ERR_FORM_DATA_DEPTH_EXCEEDED);
	}
	function m(e, t) {
		if (l === Infinity) return JSON.stringify(e);
		let n = [];
		return JSON.stringify(e, function(e, r) {
			if (!Q.isObject(r)) return r;
			for (; n.length && n[n.length - 1] !== this;) n.pop();
			return n.push(r), p(t + n.length - 1), r;
		});
	}
	function h(e, n, r) {
		let a = e;
		if (Q.isReactNative(t) && Q.isReactNativeBlob(e)) return t.append(ev(r, n, o), f(e)), !1;
		if (e && !r && typeof e == "object") {
			if (Q.endsWith(n, "{}")) n = i ? n : n.slice(0, -2), e = m(e, 1);
			else if (Q.isArray(e) && tv(e) || (Q.isFileList(e) || Q.endsWith(n, "[]")) && (a = Q.toArray(e))) return n = $_(n), a.forEach(function(e, r) {
				!(Q.isUndefined(e) || e === null) && t.append(s === !0 ? ev([n], r, o) : s === null ? n : n + "[]", f(e));
			}), !1;
		}
		return Q_(e) ? !0 : (t.append(ev(r, n, o), f(e)), !1);
	}
	let g = Object.assign(nv, {
		defaultVisitor: h,
		convertValue: f,
		isVisitable: Q_
	});
	function _(e, n, r = 0) {
		if (!Q.isUndefined(e)) {
			if (p(r), d.indexOf(e) !== -1) throw Error("Circular reference detected in " + n.join("."));
			d.push(e), Q.forEach(e, function(e, i) {
				(!(Q.isUndefined(e) || e === null) && a.call(t, e, Q.isString(i) ? i.trim() : i, n, g)) === !0 && _(e, n ? n.concat(i) : [i], r + 1);
			}), d.pop();
		}
	}
	if (!Q.isObject(e)) throw TypeError("data must be an object");
	return _(e), t;
}
//#endregion
//#region node_modules/axios/lib/helpers/AxiosURLSearchParams.js
function iv(e) {
	let t = {
		"!": "%21",
		"'": "%27",
		"(": "%28",
		")": "%29",
		"~": "%7E",
		"%20": "+"
	};
	return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(e) {
		return t[e];
	});
}
function av(e, t) {
	this._pairs = [], e && rv(e, this, t);
}
var ov = av.prototype;
ov.append = function(e, t) {
	this._pairs.push([e, t]);
}, ov.toString = function(e) {
	let t = e ? (t) => e.call(this, t, iv) : iv;
	return this._pairs.map(function(e) {
		return t(e[0]) + "=" + t(e[1]);
	}, "").join("&");
};
//#endregion
//#region node_modules/axios/lib/helpers/buildURL.js
function sv(e) {
	return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function cv(e, t, n) {
	if (!t) return e;
	e ||= "";
	let r = Q.isFunction(n) ? { serialize: n } : n, i = Q.getSafeProp(r, "encode") || sv, a = Q.getSafeProp(r, "serialize"), o;
	if (o = a ? a(t, r) : Q.isURLSearchParams(t) ? t.toString() : new av(t, r).toString(i), o) {
		let t = e.indexOf("#");
		t !== -1 && (e = e.slice(0, t)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
	}
	return e;
}
//#endregion
//#region node_modules/axios/lib/core/InterceptorManager.js
var lv = Symbol("internals");
function uv(e) {
	return e ? e.length : 0;
}
function dv(e) {
	if (e) for (; e.length && e[e.length - 1] === null;) e.pop();
}
function fv(e, t) {
	let n = e.handlers, r = uv(n);
	n === t.handlersRef ? r !== t.handlersLength && (r ? t.handlerEntries.forEach(function(e, r) {
		n[e.index] !== e.handler && t.handlerEntries.delete(r);
	}) : t.handlerEntries.clear()) : (t.handlersRef = n, t.handlerEntries.clear()), t.handlersLength = r;
}
var pv = class {
	constructor() {
		this.handlers = [], this[lv] = {
			handlersRef: this.handlers,
			handlersLength: this.handlers.length,
			handlerEntries: /* @__PURE__ */ new Map(),
			iterationDepth: 0,
			nextId: 0
		};
	}
	use(e, t, n) {
		let r = {
			fulfilled: e,
			rejected: t,
			synchronous: n ? n.synchronous : !1,
			runWhen: n ? n.runWhen : null
		}, i = this[lv];
		this.handlers ??= [], fv(this, i);
		let a = i.nextId++;
		return this.handlers.push(r), i.handlerEntries.set(a, {
			handler: r,
			index: this.handlers.length - 1
		}), i.handlersLength = this.handlers.length, a;
	}
	eject(e) {
		let t = this[lv];
		fv(this, t);
		let n = t.handlerEntries.get(e);
		if (n) {
			if (t.handlerEntries.delete(e), this.handlers[n.index] !== n.handler) return;
			this.handlers[n.index] = null, t.iterationDepth || (dv(this.handlers), t.handlersLength = this.handlers.length);
		}
	}
	clear() {
		this.handlers && (this.handlers = [], fv(this, this[lv]));
	}
	forEach(e) {
		let t = this[lv];
		fv(this, t), t.iterationDepth++;
		try {
			Q.forEach(this.handlers, function(t) {
				t !== null && e(t);
			});
		} finally {
			--t.iterationDepth || (fv(this, t), dv(this.handlers), t.handlersLength = uv(this.handlers));
		}
	}
}, mv = {
	silentJSONParsing: !0,
	forcedJSONParsing: !0,
	clarifyTimeoutError: !1,
	legacyInterceptorReqResOrdering: !0,
	advertiseZstdAcceptEncoding: !1,
	validateStatusUndefinedResolves: !0
}, hv = {
	isBrowser: !0,
	classes: {
		URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : av,
		FormData: typeof FormData < "u" ? FormData : null,
		Blob: typeof Blob < "u" ? Blob : null
	},
	protocols: [
		"http",
		"https",
		"file",
		"blob",
		"url",
		"data"
	]
}, gv = /* @__PURE__ */ r({
	hasBrowserEnv: () => _v,
	hasStandardBrowserEnv: () => yv,
	hasStandardBrowserWebWorkerEnv: () => bv,
	navigator: () => vv,
	origin: () => xv
}), _v = typeof window < "u" && typeof document < "u", vv = typeof navigator == "object" && navigator || void 0, yv = _v && (!vv || [
	"ReactNative",
	"NativeScript",
	"NS"
].indexOf(vv.product) < 0), bv = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", xv = _v && window.location.href || "http://localhost", Sv = {
	...gv,
	...hv
};
//#endregion
//#region node_modules/axios/lib/helpers/toURLEncodedForm.js
function Cv(e, t) {
	return rv(e, new Sv.classes.URLSearchParams(), {
		visitor: function(e, t, n, r) {
			return Sv.isNode && Q.isBuffer(e) ? (this.append(t, e.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
		},
		...t
	});
}
//#endregion
//#region node_modules/axios/lib/helpers/formDataToJSON.js
var wv = 100;
function Tv(e) {
	if (e > wv) throw new $("FormData field is too deeply nested (" + e + " levels). Max depth: " + wv, $.ERR_FORM_DATA_DEPTH_EXCEEDED);
}
function Ev(e) {
	let t = [], n = /[^.[\]]+|\[([^.[\]]*)]/g, r;
	for (; (r = n.exec(e)) !== null;) Tv(t.length), t.push(r[0] === "[]" ? "" : r[1] || r[0]);
	return t;
}
function Dv(e) {
	let t = {}, n = Object.keys(e), r, i = n.length, a;
	for (r = 0; r < i; r++) a = n[r], t[a] = e[a];
	return t;
}
function Ov(e) {
	function t(e, n, r, i) {
		Tv(i);
		let a = e[i++];
		if (a === "__proto__") return !0;
		let o = Number.isFinite(+a), s = i >= e.length;
		return a = !a && Q.isArray(r) ? r.length : a, s ? (Q.hasOwnProp(r, a) ? r[a] = Q.isArray(r[a]) ? r[a].concat(n) : [r[a], n] : r[a] = n, !o) : ((!Q.hasOwnProp(r, a) || !Q.isObject(r[a])) && (r[a] = []), t(e, n, r[a], i) && Q.isArray(r[a]) && (r[a] = Dv(r[a])), !o);
	}
	if (Q.isFormData(e) && Q.isFunction(e.entries)) {
		let n = {};
		return Q.forEachEntry(e, (e, r) => {
			t(Ev(e), r, n, 0);
		}), n;
	}
	return null;
}
//#endregion
//#region node_modules/axios/lib/core/methodList.js
var kv = Object.freeze([
	"get",
	"delete",
	"head",
	"options",
	"post",
	"put",
	"patch",
	"purge",
	"link",
	"unlink",
	"query"
]), Av = (e, t) => e != null && Q.hasOwnProp(e, t) ? e[t] : void 0;
function jv(e, t, n) {
	if (Q.isString(e)) try {
		return (t || JSON.parse)(e), Q.trim(e);
	} catch (e) {
		if (e.name !== "SyntaxError") throw e;
	}
	return (n || JSON.stringify)(e);
}
var Mv = {
	transitional: mv,
	adapter: [
		"xhr",
		"http",
		"fetch"
	],
	transformRequest: [function(e, t) {
		let n = t.getContentType() || "", r = n.indexOf("application/json") > -1, i = Q.isObject(e);
		if (i && Q.isHTMLForm(e) && (e = new FormData(e)), Q.isFormData(e)) return r ? JSON.stringify(Ov(e)) : e;
		if (Q.isArrayBuffer(e) || Q.isBuffer(e) || Q.isStream(e) || Q.isFile(e) || Q.isBlob(e) || Q.isReadableStream(e)) return e;
		if (Q.isArrayBufferView(e)) return e.buffer;
		if (Q.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
		let a;
		if (i) {
			let t = Av(this, "formSerializer");
			if (n.indexOf("application/x-www-form-urlencoded") > -1) return Cv(e, t).toString();
			if ((a = Q.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
				let n = Av(this, "env"), r = n && n.FormData;
				return rv(a ? { "files[]": e } : e, r && new r(), t);
			}
		}
		return i || r ? (t.setContentType("application/json", !1), jv(e)) : e;
	}],
	transformResponse: [function(e) {
		let t = Av(this, "transitional") || Mv.transitional, n = t && t.forcedJSONParsing, r = Av(this, "responseType"), i = r === "json";
		if (Q.isResponse(e) || Q.isReadableStream(e)) return e;
		if (e && Q.isString(e) && (n && !r || i)) {
			let n = !(t && t.silentJSONParsing) && i;
			try {
				return JSON.parse(e, Av(this, "parseReviver"));
			} catch (e) {
				if (n) throw e.name === "SyntaxError" ? $.from(e, $.ERR_BAD_RESPONSE, this, null, Av(this, "response")) : e;
			}
		}
		return e;
	}],
	timeout: 0,
	xsrfCookieName: "XSRF-TOKEN",
	xsrfHeaderName: "X-XSRF-TOKEN",
	maxContentLength: -1,
	maxBodyLength: -1,
	env: {
		FormData: Sv.classes.FormData,
		Blob: Sv.classes.Blob
	},
	validateStatus: function(e) {
		return e >= 200 && e < 300;
	},
	headers: { common: {
		Accept: "application/json, text/plain, */*",
		"Content-Type": void 0
	} }
};
Q.forEach(kv, (e) => {
	Mv.headers[e] = {};
});
//#endregion
//#region node_modules/axios/lib/core/transformData.js
function Nv(e, t) {
	let n = this || Mv, r = t || n, i = K_.from(r.headers), a = r.data;
	return Q.forEach(e, function(e) {
		a = e.call(n, a, i.normalize(), t ? t.status : void 0);
	}), i.normalize(), a;
}
//#endregion
//#region node_modules/axios/lib/cancel/isCancel.js
function Pv(e) {
	return !!(e && e.__CANCEL__);
}
//#endregion
//#region node_modules/axios/lib/cancel/CanceledError.js
var Fv = class extends $ {
	constructor(e, t, n) {
		super(e ?? "canceled", $.ERR_CANCELED, t, n), this.name = "CanceledError", this.__CANCEL__ = !0;
	}
};
//#endregion
//#region node_modules/axios/lib/core/settle.js
function Iv(e, t, n) {
	let r = n.config.validateStatus;
	!n.status || !r || r(n.status) ? e(n) : t(new $("Request failed with status code " + n.status, n.status >= 400 && n.status < 500 ? $.ERR_BAD_REQUEST : $.ERR_BAD_RESPONSE, n.config, n.request, n));
}
//#endregion
//#region node_modules/axios/lib/helpers/normalizeURLForProtocolCheck.js
var Lv = /[\t\n\r]/g;
function Rv(e) {
	if (typeof e != "string") return e;
	let t = 0;
	for (; t < e.length && e.charCodeAt(t) <= 32;) t++;
	return e.slice(t).replace(Lv, "");
}
//#endregion
//#region node_modules/axios/lib/helpers/parseProtocol.js
function zv(e) {
	let t = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
	return t && t[1] || "";
}
//#endregion
//#region node_modules/axios/lib/helpers/speedometer.js
function Bv(e, t) {
	e ||= 10;
	let n = Array(e), r = Array(e), i = 0, a = 0, o;
	return t = t === void 0 ? 1e3 : t, function(s) {
		let c = Date.now(), l = r[a];
		o ||= c, n[i] = s, r[i] = c;
		let u = a, d = 0;
		for (; u !== i;) d += n[u++], u %= e;
		if (i = (i + 1) % e, i === a && (a = (a + 1) % e), c - o < t) return;
		let f = l && c - l;
		return f ? Math.round(d * 1e3 / f) : void 0;
	};
}
//#endregion
//#region node_modules/axios/lib/helpers/throttle.js
function Vv(e, t) {
	let n = 0, r = 1e3 / t, i, a, o = (t, r = Date.now()) => {
		n = r, i = null, a &&= (clearTimeout(a), null), e(...t);
	};
	return [
		(...e) => {
			let t = Date.now(), s = t - n;
			s >= r ? o(e, t) : (i = e, a ||= setTimeout(() => {
				a = null, o(i);
			}, r - s));
		},
		() => i && o(i),
		(...e) => o(e)
	];
}
//#endregion
//#region node_modules/axios/lib/helpers/progressEventReducer.js
var Hv = (e, t, n = 3) => {
	let r = 0, i = Bv(50, 250);
	return Vv((n) => {
		if (!n || !Q.isNumber(n.loaded)) return;
		let a = n.loaded, o = n.lengthComputable ? n.total : void 0, s = Math.max(0, o == null ? a : Math.min(a, o)), c = Math.max(0, s - r), l = i(c);
		r = Math.max(r, s), e({
			loaded: s,
			total: o,
			progress: o ? s / o : void 0,
			bytes: c,
			rate: l || void 0,
			estimated: l && o ? (o - s) / l : void 0,
			event: n,
			lengthComputable: o != null,
			[t ? "download" : "upload"]: !0
		});
	}, n);
}, Uv = (e, t) => {
	let n = e != null;
	return [(r) => t[0]({
		lengthComputable: n,
		total: e,
		loaded: r
	}), t[1]];
}, Wv = (e, t = Q.asap) => (...n) => t(() => e(...n)), Gv = Sv.hasStandardBrowserEnv ? ((e, t) => (n) => (n = new URL(n, Sv.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(new URL(Sv.origin), Sv.navigator && /(msie|trident)/i.test(Sv.navigator.userAgent)) : () => !0, Kv = Sv.hasStandardBrowserEnv ? {
	write(e, t, n, r, i, a, o) {
		if (typeof document > "u") return;
		let s = [`${e}=${encodeURIComponent(t)}`];
		Q.isNumber(n) && s.push(`expires=${new Date(n).toUTCString()}`), Q.isString(r) && s.push(`path=${r}`), Q.isString(i) && s.push(`domain=${i}`), a === !0 && s.push("secure"), Q.isString(o) && s.push(`SameSite=${o}`), document.cookie = s.join("; ");
	},
	read(e) {
		if (typeof document > "u") return null;
		let t = document.cookie.split(";");
		for (let n = 0; n < t.length; n++) {
			let r = t[n].replace(/^\s+/, ""), i = r.indexOf("=");
			if (i !== -1 && r.slice(0, i) === e) try {
				return decodeURIComponent(r.slice(i + 1));
			} catch {
				return r.slice(i + 1);
			}
		}
		return null;
	},
	remove(e) {
		this.write(e, "", Date.now() - 864e5, "/");
	}
} : {
	write() {},
	read() {
		return null;
	},
	remove() {}
};
//#endregion
//#region node_modules/axios/lib/helpers/isAbsoluteURL.js
function qv(e) {
	return typeof e == "string" && /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
//#endregion
//#region node_modules/axios/lib/helpers/combineURLs.js
function Jv(e, t) {
	if (!t) return e;
	let n = e.length;
	for (; n > 0 && e.charCodeAt(n - 1) === 47;) n--;
	return e.slice(0, n) + "/" + t.replace(/^\/+/, "");
}
//#endregion
//#region node_modules/axios/lib/core/buildFullPath.js
var Yv = /^https?:(?!\/\/)/i;
function Xv(e) {
	return e && e.replace(/(^|&)([^=&]*=)?[^&]+/g, (e, t, n = "") => `${t}${n}${q_}`);
}
function Zv(e) {
	let t = e.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${q_}@`), n = t.indexOf("#"), r = (n === -1 ? t : t.slice(0, n)).replace(/([?&][^=&#]*=)[^&#]*/g, `$1${q_}`);
	return n === -1 ? r : `${r}#${Xv(t.slice(n + 1))}`;
}
function Qv(e, t) {
	if (typeof e == "string") {
		let n = Rv(e);
		if (Yv.test(n)) throw new $(`Invalid URL ${JSON.stringify(Zv(n))}: missing "//" after protocol`, $.ERR_INVALID_URL, t);
	}
}
function $v(e, t, n, r) {
	Qv(t, r);
	let i = !qv(t);
	return e && (i || n === !1) ? (Qv(e, r), Jv(e, t)) : t;
}
//#endregion
//#region node_modules/axios/lib/core/mergeConfig.js
var ey = (e) => e instanceof K_ ? { ...e } : e, ty = (e) => Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor ? Object.keys(e).concat(Object.getOwnPropertySymbols(e).filter((t) => Object.getOwnPropertyDescriptor(e, t).enumerable)) : Object.keys(e);
function ny(e, t) {
	e ||= {}, t ||= {};
	let n = Object.create(null);
	Object.defineProperty(n, "hasOwnProperty", {
		__proto__: null,
		value: Object.prototype.hasOwnProperty,
		enumerable: !1,
		writable: !0,
		configurable: !0
	});
	function r(e, t, n, r) {
		return Q.isPlainObject(e) && Q.isPlainObject(t) ? Q.merge.call({ caseless: r }, e, t) : Q.isPlainObject(t) ? Q.merge({}, t) : Q.isArray(t) ? t.slice() : t;
	}
	function i(e, t, n, i) {
		if (!Q.isUndefined(t)) return r(e, t, n, i);
		if (!Q.isUndefined(e)) return r(void 0, e, n, i);
	}
	function a(e, t) {
		if (!Q.isUndefined(t)) return r(void 0, t);
	}
	function o(e, t) {
		if (!Q.isUndefined(t)) return r(void 0, t);
		if (!Q.isUndefined(e)) return r(void 0, e);
	}
	function s(n) {
		let r = Q.hasOwnProp(t, "transitional") ? t.transitional : void 0;
		if (!Q.isUndefined(r)) {
			if (Q.isPlainObject(r)) {
				if (Q.hasOwnProp(r, n)) return r[n];
			} else return;
		}
		let i = Q.hasOwnProp(e, "transitional") ? e.transitional : void 0;
		if (Q.isPlainObject(i) && Q.hasOwnProp(i, n)) return i[n];
	}
	function c(n, i, a) {
		if (Q.hasOwnProp(t, a)) return r(n, i);
		if (Q.hasOwnProp(e, a)) return r(void 0, n);
	}
	let l = {
		url: a,
		method: a,
		data: a,
		baseURL: o,
		transformRequest: o,
		transformResponse: o,
		paramsSerializer: o,
		timeout: o,
		timeoutErrorMessage: o,
		withCredentials: o,
		withXSRFToken: o,
		adapter: o,
		responseType: o,
		xsrfCookieName: o,
		xsrfHeaderName: o,
		onUploadProgress: o,
		onDownloadProgress: o,
		decompress: o,
		maxContentLength: o,
		maxBodyLength: o,
		beforeRedirect: o,
		transport: o,
		httpAgent: o,
		httpsAgent: o,
		cancelToken: o,
		socketPath: o,
		allowedSocketPaths: o,
		responseEncoding: o,
		validateStatus: c,
		headers: (e, t, n) => i(ey(e), ey(t), n, !0)
	};
	return Q.forEach(ty({
		...e,
		...t
	}), function(r) {
		if (r === "__proto__" || r === "constructor" || r === "prototype") return;
		let a = Q.hasOwnProp(l, r) ? l[r] : i, o = a(Q.hasOwnProp(e, r) ? e[r] : void 0, Q.hasOwnProp(t, r) ? t[r] : void 0, r);
		Q.isUndefined(o) && a !== c || (n[r] = o);
	}), Q.hasOwnProp(t, "validateStatus") && Q.isUndefined(t.validateStatus) && s("validateStatusUndefinedResolves") === !1 && (Q.hasOwnProp(e, "validateStatus") ? n.validateStatus = r(void 0, e.validateStatus) : delete n.validateStatus), n;
}
//#endregion
//#region node_modules/axios/lib/core/setFormDataHeaders.js
var ry = ["content-type", "content-length"];
function iy(e, t, n) {
	if (n !== "content-only") {
		e.set(t);
		return;
	}
	Object.entries(t || {}).forEach(([t, n]) => {
		ry.includes(t.toLowerCase()) && e.set(t, n);
	});
}
//#endregion
//#region node_modules/axios/lib/helpers/resolveConfig.js
var ay = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16)));
function oy(e) {
	let t = ny({}, e), n = (e) => Q.hasOwnProp(t, e) ? t[e] : void 0, r = n("data"), i = n("withXSRFToken"), a = n("xsrfHeaderName"), o = n("xsrfCookieName"), s = n("headers"), c = n("auth"), l = n("baseURL"), u = n("allowAbsoluteUrls"), d = n("url");
	if (t.headers = s = K_.from(s), t.url = cv($v(l, d, u, t), n("params"), n("paramsSerializer")), c) {
		let t = Q.getSafeProp(c, "username") || "", n = Q.getSafeProp(c, "password") || "";
		try {
			s.set("Authorization", "Basic " + btoa(t + ":" + (n ? ay(n) : "")));
		} catch (t) {
			throw $.from(t, $.ERR_BAD_OPTION_VALUE, e);
		}
	}
	if (Q.isFormData(r)) {
		let e = Q.getSafeProp(r, "getHeaders");
		Sv.hasStandardBrowserEnv || Sv.hasStandardBrowserWebWorkerEnv || Q.isReactNative(r) ? s.setContentType(void 0) : Q.isFunction(e) && iy(s, e.call(r), n("formDataHeaderPolicy"));
	}
	if (Sv.hasStandardBrowserEnv && (Q.isFunction(i) && (i = i(t)), i === !0 || i == null && Gv(t.url))) {
		let e = a && o && Kv.read(o);
		e && s.set(a, e);
	}
	return t;
}
var sy = typeof XMLHttpRequest < "u" && function(e) {
	return new Promise(function(t, n) {
		let r = oy(e), i = r.data, a = K_.from(r.headers).normalize(), { responseType: o, onUploadProgress: s, onDownloadProgress: c } = r, l, u, d, f, p, m;
		function h() {
			f && f(), p && p(), r.cancelToken && r.cancelToken.unsubscribe(l), r.signal && r.signal.removeEventListener("abort", l);
		}
		let g = new XMLHttpRequest();
		g.open(r.method.toUpperCase(), r.url, !0), g.timeout = r.timeout;
		function _(i) {
			if (!g) return;
			if (g.status === 0 && (zv(Rv(r.url)) || zv(Sv.origin)) !== "file" && !(g.responseURL && g.responseURL.startsWith("file:"))) {
				n(new $("Request aborted", $.ECONNABORTED, e, g)), h(), g = null;
				return;
			}
			try {
				i ? m && m(i) : p && p();
			} catch (e) {
				setTimeout(() => {
					throw e;
				});
			}
			if (!g) return;
			let a = K_.from("getAllResponseHeaders" in g && g.getAllResponseHeaders());
			Iv(function(e) {
				t(e), h();
			}, function(e) {
				n(e), h();
			}, {
				data: !o || o === "text" || o === "json" ? g.responseText : g.response,
				status: g.status,
				statusText: g.statusText,
				headers: a,
				config: e,
				request: g
			}), g = null;
		}
		"onloadend" in g ? g.onloadend = _ : g.onreadystatechange = function() {
			g && g.readyState === 4 && (g.status !== 0 || g.responseURL && g.responseURL.startsWith("file:")) && setTimeout(_);
		}, g.onabort = function() {
			g &&= (n(new $("Request aborted", $.ECONNABORTED, e, g)), h(), null);
		}, g.onerror = function(t) {
			let r = new $(t && t.message ? t.message : "Network Error", $.ERR_NETWORK, e, g);
			r.event = t || null, n(r), h(), g = null;
		}, g.ontimeout = function() {
			let t = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded", i = r.transitional || mv;
			r.timeoutErrorMessage && (t = r.timeoutErrorMessage), n(new $(t, i.clarifyTimeoutError ? $.ETIMEDOUT : $.ECONNABORTED, e, g)), h(), g = null;
		}, i === void 0 && a.setContentType(null), "setRequestHeader" in g && Q.forEach(N_(a), function(e, t) {
			g.setRequestHeader(t, e);
		}), Q.isUndefined(r.withCredentials) || (g.withCredentials = !!r.withCredentials), o && o !== "json" && (g.responseType = r.responseType), c && ([d, p, m] = Hv(c, !0), g.addEventListener("progress", d)), s && g.upload && ([u, f] = Hv(s), g.upload.addEventListener("progress", u), g.upload.addEventListener("loadend", f)), (r.cancelToken || r.signal) && (l = (t) => {
			g &&= (n(!t || t.type ? new Fv(null, e, g) : t), g.abort(), h(), null);
		}, r.cancelToken && r.cancelToken.subscribe(l), r.signal && (r.signal.aborted ? l() : r.signal.addEventListener("abort", l)));
		let v = zv(r.url);
		if (v && !Sv.protocols.includes(v)) {
			n(new $("Unsupported protocol " + v + ":", $.ERR_BAD_REQUEST, e)), h();
			return;
		}
		g.send(i || null);
	});
}, cy = (e, t) => {
	if (e = e ? e.filter(Boolean) : [], !t && !e.length) return;
	let n = new AbortController(), r = !1, i = function(e) {
		if (!r) {
			r = !0, o();
			let t = e instanceof Error ? e : this.reason;
			n.abort(t instanceof $ ? t : new Fv(t instanceof Error ? t.message : t));
		}
	}, a = t && setTimeout(() => {
		a = null, i(new $(`timeout of ${t}ms exceeded`, $.ETIMEDOUT));
	}, t), o = () => {
		e &&= (a && clearTimeout(a), a = null, e.forEach((e) => {
			e.unsubscribe ? e.unsubscribe(i) : e.removeEventListener("abort", i);
		}), null);
	};
	e.forEach((e) => {
		if (!r) {
			if (e.aborted) {
				i.call(e);
				return;
			}
			e.addEventListener("abort", i, { once: !0 });
		}
	});
	let { signal: s } = n;
	return s.unsubscribe = () => Q.asap(o), s;
}, ly = function* (e, t) {
	let n = e.byteLength;
	if (!t || n < t) {
		yield e;
		return;
	}
	let r = 0, i;
	for (; r < n;) i = r + t, yield e.slice(r, i), r = i;
}, uy = async function* (e, t) {
	for await (let n of dy(e)) yield* ly(n, t);
}, dy = async function* (e) {
	if (e[Symbol.asyncIterator]) {
		yield* e;
		return;
	}
	let t = e.getReader();
	try {
		for (;;) {
			let { done: e, value: n } = await t.read();
			if (e) break;
			yield n;
		}
	} finally {
		await t.cancel();
	}
}, fy = (e, t, n, r) => {
	let i = uy(e, t), a = 0, o, s = (e) => {
		o || (o = !0, r && r(e));
	};
	return new ReadableStream({
		async pull(e) {
			try {
				let { done: t, value: r } = await i.next();
				if (t) {
					s(), e.close();
					return;
				}
				let o = r.byteLength;
				n && n(a += o), e.enqueue(new Uint8Array(r));
			} catch (e) {
				throw s(e), e;
			}
		},
		cancel(e) {
			return s(e), i.return();
		}
	}, { highWaterMark: 2 });
}, py = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, my = (e, t, n) => t + 2 < n && py(e.charCodeAt(t + 1)) && py(e.charCodeAt(t + 2)), hy = (e) => e <= 57 ? e - 48 : (e & 223) - 55, gy = (e) => e >= 65 && e <= 90 || e >= 97 && e <= 122 || e >= 48 && e <= 57 || e === 43 || e === 47 || e === 45 || e === 95, _y = (e) => e === 9 || e === 10 || e === 12 || e === 13 || e === 32, vy = (e) => {
	let t = Math.floor(e / 4), n = e % 4;
	return t * 3 + (n === 2 ? 1 : n === 3 ? 2 : 0);
}, yy = (e) => {
	let t = e.length, n = 0;
	return t > 0 && e.charCodeAt(t - 1) === 61 && (n++, t > 1 && e.charCodeAt(t - 2) === 61 && n++), Math.floor((t - n) * 3 / 4);
}, by = (e) => {
	let t = e.length, n = 0, r = 0, i = !1;
	for (let a = 0; a < t; a++) {
		let o = e.charCodeAt(a);
		if (o === 37 && my(e, a, t) && (o = hy(e.charCodeAt(a + 1)) * 16 + hy(e.charCodeAt(a + 2)), a += 2), !_y(o)) {
			if (o === 61) {
				r++;
				continue;
			}
			if (!gy(o) || r > 0) {
				i = !0;
				continue;
			}
			n++;
		}
	}
	return i || r > 2 || r > 0 && (n + r) % 4 != 0 || n % 4 == 1 ? yy(e) : vy(n);
}, xy = (e, t) => {
	if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
	let n = e.indexOf(",");
	if (n < 0) return 0;
	let r = e.slice(5, n), i = e.slice(n + 1);
	if (/;base64/i.test(r)) return t(i);
	let a = 0;
	for (let e = 0, t = i.length; e < t; e++) {
		let n = i.charCodeAt(e);
		if (n === 37 && my(i, e, t)) a += 1, e += 2;
		else if (n < 128) a += 1;
		else if (n < 2048) a += 2;
		else if (n >= 55296 && n <= 56319 && e + 1 < t) {
			let t = i.charCodeAt(e + 1);
			t >= 56320 && t <= 57343 ? (a += 4, e++) : a += 3;
		} else a += 3;
	}
	return a;
};
function Sy(e) {
	let t = typeof e == "string" ? e.indexOf("#") : -1;
	return xy(t === -1 ? e : e.slice(0, t), by);
}
//#endregion
//#region node_modules/axios/lib/env/data.js
var Cy = "1.20.0", wy = 65536, Ty = {
	cache: "default",
	redirect: "follow",
	referrer: "about:client",
	referrerPolicy: "",
	mode: "cors",
	integrity: "",
	keepalive: !1,
	priority: "auto",
	window: null
}, { isFunction: Ey } = Q, Dy = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16))), Oy = (e) => {
	if (!Q.isString(e)) return e;
	try {
		return decodeURIComponent(e);
	} catch {
		return e;
	}
}, ky = (e, ...t) => {
	try {
		return !!e(...t);
	} catch {
		return !1;
	}
}, Ay = (e) => {
	let t = e.indexOf("://"), n = e;
	return t !== -1 && (n = n.slice(t + 3)), n.includes("@") || n.includes(":");
}, jy = (e) => {
	let t = Q.global !== void 0 && Q.global !== null ? Q.global : globalThis, { ReadableStream: n, TextEncoder: r } = t;
	e = Q.merge.call({ skipUndefined: !0 }, {
		Request: t.Request,
		Response: t.Response
	}, e);
	let { fetch: i, Request: a, Response: o } = e, s = i ? Ey(i) : typeof fetch == "function", c = Ey(a), l = Ey(o);
	if (!s) return !1;
	let u = s && Ey(n), d = s && (typeof r == "function" ? ((e) => (t) => e.encode(t))(new r()) : async (e) => new Uint8Array(await new a(e).arrayBuffer())), f = c && u && ky(() => {
		let e = !1, t = new a(Sv.origin, {
			body: new n(),
			method: "POST",
			get duplex() {
				return e = !0, "half";
			}
		}), r = t.headers.has("Content-Type");
		return t.body != null && t.body.cancel(), e && !r;
	}), p = l && u && ky(() => Q.isReadableStream(new o("").body)), m = { stream: p && ((e) => e.body) };
	s && [
		"text",
		"arrayBuffer",
		"blob",
		"formData",
		"stream"
	].forEach((e) => {
		!m[e] && (m[e] = (t, n) => {
			let r = t && t[e];
			if (r) return r.call(t);
			throw new $(`Response type '${e}' is not supported`, $.ERR_NOT_SUPPORT, n);
		});
	});
	let h = async (e) => {
		if (e == null) return 0;
		if (Q.isBlob(e)) return e.size;
		if (Q.isSpecCompliantForm(e)) return (await new a(Sv.origin, {
			method: "POST",
			body: e
		}).arrayBuffer()).byteLength;
		if (Q.isArrayBufferView(e) || Q.isArrayBuffer(e)) return e.byteLength;
		if (Q.isURLSearchParams(e) && (e += ""), Q.isString(e)) return (await d(e)).byteLength;
	}, g = async (e, t) => Q.toFiniteNumber(e.getContentLength()) ?? h(t);
	return async (e) => {
		let { url: t, method: n, data: s, signal: l, cancelToken: d, timeout: _, onDownloadProgress: v, onUploadProgress: y, responseType: b, headers: x, withCredentials: S = "same-origin", fetchOptions: C, maxContentLength: w, maxBodyLength: ee, maxRedirects: te } = oy(e), ne = Q.isNumber(w) && w > -1, re = Q.isNumber(ee) && ee > -1, ie = (t) => Q.hasOwnProp(e, t) ? e[t] : void 0, ae = i || fetch;
		b = b ? (b + "").toLowerCase() : "text";
		let oe = cy([l, d && d.toAbortSignal()], _), se = null, ce = oe && oe.unsubscribe && (() => {
			oe.unsubscribe();
		}), T, le = null, E = () => new $("Request body larger than maxBodyLength limit", $.ERR_BAD_REQUEST, e, se);
		try {
			let i, l = ie("auth");
			if (l && (i = {
				username: Q.getSafeProp(l, "username") || "",
				password: Q.getSafeProp(l, "password") || ""
			}), Ay(t)) {
				let e = new URL(t, Sv.origin);
				!i && (e.username || e.password) && (i = {
					username: Oy(e.username),
					password: Oy(e.password)
				}), (e.username || e.password) && (e.username = "", e.password = "", t = e.href);
			}
			if (i && (x.delete("authorization"), x.set("Authorization", "Basic " + btoa(Dy((i.username || "") + ":" + (i.password || ""))))), ne && typeof t == "string" && t.startsWith("data:") && Sy(t) > w) throw new $("maxContentLength size of " + w + " exceeded", $.ERR_BAD_RESPONSE, e, se);
			if (re && n !== "get" && n !== "head") {
				let e = await h(s);
				if (typeof e == "number" && isFinite(e) && (T = e, e > ee)) throw E();
			}
			let d = re && (Q.isReadableStream(s) || Q.isStream(s)), _ = (e, t, n) => fy(e, wy, (e) => {
				if (re && e > ee) throw le = E();
				t && t(e);
			}, n);
			if (f && n !== "get" && n !== "head" && (y || d)) {
				if (T ??= await g(x, s), T !== 0 || d) {
					let e = new a(t, {
						method: "POST",
						body: s,
						duplex: "half"
					}), n;
					if (Q.isFormData(s) && (n = e.headers.get("content-type")) && x.setContentType(n), e.body) {
						let [t, n] = y && Uv(T, Hv(Wv(y))) || [];
						s = _(e.body, t, n);
					}
				}
			} else if (d && !c && u && n !== "get" && n !== "head") s = _(s);
			else if (d && c && !f && n !== "get" && n !== "head") throw new $("Stream request bodies are not supported by the current fetch implementation", $.ERR_NOT_SUPPORT, e, se);
			Q.isString(S) || (S = S ? "include" : "omit");
			let ue = c && "credentials" in a.prototype;
			if (Q.isFormData(s)) {
				let e = x.getContentType();
				e && /^multipart\/form-data/i.test(e) && !/boundary=/i.test(e) && x.delete("content-type");
			}
			x.set("User-Agent", "axios/" + Cy, !1);
			let de = C == null ? C : Object.assign(Object.create(null), C);
			de && (delete de.body, delete de.headers, delete de.method, delete de.signal, delete de.duplex, delete de.credentials);
			let fe = Object.assign(Object.create(null), de, {
				signal: oe,
				method: n.toUpperCase(),
				headers: N_(x.normalize()),
				body: s,
				duplex: "half",
				credentials: ue ? S : void 0
			});
			c && (Q.forEach(Ty, (e, t) => {
				fe[t] === void 0 && (fe[t] = e);
			}), fe.signal === void 0 && (fe.signal = null), fe.body === void 0 && (fe.body = null)), te === 0 && (fe.redirect = "manual", de && (de.redirect = "manual")), se = c && new a(t, fe);
			let D = await (c ? ae(se, de) : ae(t, fe)), O = K_.from(D.headers);
			if (ne) {
				let t = Q.toFiniteNumber(O.getContentLength());
				if (t != null && t > w) throw new $("maxContentLength size of " + w + " exceeded", $.ERR_BAD_RESPONSE, e, se);
			}
			let pe = p && (b === "stream" || b === "response");
			if (p && D.body && (v || ne || pe && ce)) {
				let t = {};
				[
					"status",
					"statusText",
					"headers"
				].forEach((e) => {
					t[e] = D[e];
				});
				let n = Q.toFiniteNumber(O.getContentLength()), [r, i] = v && Uv(n, Hv(Wv(v), !0)) || [], a = 0;
				D = new o(fy(D.body, wy, (t) => {
					if (ne && (a = t, a > w)) throw new $("maxContentLength size of " + w + " exceeded", $.ERR_BAD_RESPONSE, e, se);
					r && r(t);
				}, () => {
					i && i(), ce && ce();
				}), t);
			}
			b ||= "text";
			let me = await m[Q.findKey(m, b) || "text"](D, e);
			if (ne && !p && !pe) {
				let t;
				if (me != null && (typeof me.byteLength == "number" ? t = me.byteLength : typeof me.size == "number" ? t = me.size : typeof me == "string" && (t = typeof r == "function" ? new r().encode(me).byteLength : me.length)), typeof t == "number" && t > w) throw new $("maxContentLength size of " + w + " exceeded", $.ERR_BAD_RESPONSE, e, se);
			}
			return !pe && ce && ce(), await new Promise((t, n) => {
				Iv(t, n, {
					data: me,
					headers: K_.from(D.headers),
					status: D.status,
					statusText: D.statusText,
					config: e,
					request: se
				});
			});
		} catch (t) {
			if (ce && ce(), oe && oe.aborted && oe.reason instanceof $) {
				let n = oe.reason;
				throw n.config = e, se && (n.request = se), t !== n && Object.defineProperty(n, "cause", {
					__proto__: null,
					value: t,
					writable: !0,
					enumerable: !1,
					configurable: !0
				}), n;
			}
			if (le) throw se && !le.request && (le.request = se), le;
			if (t instanceof $) throw se && !t.request && (t.request = se), t;
			if (t && t.name === "TypeError" && /Load failed|fetch/i.test(t.message)) {
				let n = new $("Network Error", $.ERR_NETWORK, e, se, t && t.response);
				throw Object.defineProperty(n, "cause", {
					__proto__: null,
					value: t.cause || t,
					writable: !0,
					enumerable: !1,
					configurable: !0
				}), n;
			}
			throw $.from(t, t && t.code, e, se, t && t.response);
		}
	};
}, My = /* @__PURE__ */ new Map(), Ny = (e) => {
	let t = e && e.env || {}, { fetch: n, Request: r, Response: i } = t, a = [
		r,
		i,
		n
	], o = a.length, s, c, l = My;
	for (; o--;) s = a[o], c = l.get(s), c === void 0 && l.set(s, c = o ? /* @__PURE__ */ new Map() : jy(t)), l = c;
	return c;
};
Ny();
//#endregion
//#region node_modules/axios/lib/adapters/adapters.js
var Py = {
	http: null,
	xhr: sy,
	fetch: { get: Ny }
};
Q.forEach(Py, (e, t) => {
	if (e) {
		try {
			Object.defineProperty(e, "name", {
				__proto__: null,
				value: t
			});
		} catch {}
		Object.defineProperty(e, "adapterName", {
			__proto__: null,
			value: t
		});
	}
});
var Fy = (e) => `- ${e}`, Iy = (e) => Q.isFunction(e) || e === null || e === !1;
function Ly(e, t) {
	e = Q.isArray(e) ? e : [e];
	let { length: n } = e, r, i, a = {};
	for (let o = 0; o < n; o++) {
		r = e[o];
		let n;
		if (i = r, !Iy(r) && (i = Py[(n = String(r)).toLowerCase()], i === void 0)) throw new $(`Unknown adapter '${n}'`);
		if (i && (Q.isFunction(i) || (i = i.get(t)))) break;
		a[n || "#" + o] = i;
	}
	if (!i) {
		let e = Object.entries(a).map(([e, t]) => `adapter ${e} ` + (t === !1 ? "is not supported by the environment" : "is not available in the build"));
		throw new $("There is no suitable adapter to dispatch the request " + (n ? e.length > 1 ? "since :\n" + e.map(Fy).join("\n") : " " + Fy(e[0]) : "as no adapter specified"), $.ERR_NOT_SUPPORT);
	}
	return i;
}
var Ry = {
	getAdapter: Ly,
	adapters: Py
};
//#endregion
//#region node_modules/axios/lib/core/dispatchRequest.js
function zy(e) {
	if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new Fv(null, e);
}
function By(e) {
	let t = Q.toSafeFlatObject(e);
	return zy(t), t.headers = K_.from(Q.getSafeProp(t, "headers")), t.data = Nv.call(t, t.transformRequest), [
		"post",
		"put",
		"patch"
	].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Ry.getAdapter(t.adapter || Mv.adapter, t)(t).then(function(e) {
		zy(t), t.response = e;
		try {
			e.data = Nv.call(t, t.transformResponse, e);
		} finally {
			delete t.response;
		}
		return e.headers = K_.from(e.headers), e;
	}, function(e) {
		if (!Pv(e) && (zy(t), e && e.response)) {
			t.response = e.response;
			try {
				e.response.data = Nv.call(t, t.transformResponse, e.response);
			} finally {
				delete t.response;
			}
			e.response.headers = K_.from(e.response.headers);
		}
		return Promise.reject(e);
	});
}
//#endregion
//#region node_modules/axios/lib/helpers/validator.js
var Vy = {};
[
	"object",
	"boolean",
	"number",
	"function",
	"string",
	"symbol"
].forEach((e, t) => {
	Vy[e] = function(n) {
		return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
	};
});
var Hy = {};
Vy.transitional = function(e, t, n) {
	function r(e, t) {
		return "[Axios v" + Cy + "] Transitional option '" + e + "'" + t + (n ? ". " + n : "");
	}
	return (n, i, a) => {
		if (e === !1) throw new $(r(i, " has been removed" + (t ? " in " + t : "")), $.ERR_DEPRECATED);
		return t && !Hy[i] && (Hy[i] = !0, console.warn(r(i, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(n, i, a);
	};
}, Vy.spelling = function(e) {
	return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function Uy(e, t, n) {
	if (typeof e != "object" || !e) throw new $("options must be an object", $.ERR_BAD_OPTION_VALUE);
	let r = Object.keys(e), i = r.length;
	for (; i-- > 0;) {
		let a = r[i], o = Object.prototype.hasOwnProperty.call(t, a) ? t[a] : void 0;
		if (o) {
			let t = e[a], n = t === void 0 || o(t, a, e);
			if (n !== !0) throw new $("option " + a + " must be " + n, $.ERR_BAD_OPTION_VALUE);
			continue;
		}
		if (n !== !0) throw new $("Unknown option " + a, $.ERR_BAD_OPTION);
	}
}
var Wy = {
	assertOptions: Uy,
	validators: Vy
}, Gy = Wy.validators, Ky = class {
	constructor(e) {
		this.defaults = e || {}, this.interceptors = {
			request: new pv(),
			response: new pv()
		};
	}
	async request(e, t) {
		try {
			return await this._request(e, t);
		} catch (e) {
			if (e instanceof Error) try {
				let t = {};
				Error.captureStackTrace ? Error.captureStackTrace(t) : t = /* @__PURE__ */ Error();
				let n = t.stack, r = "";
				if (typeof n == "string") {
					let e = n.indexOf("\n");
					r = e === -1 ? "" : n.slice(e + 1);
				}
				if (!e.stack) e.stack = r;
				else if (r) {
					let t = r.indexOf("\n"), n = t === -1 ? -1 : r.indexOf("\n", t + 1), i = n === -1 ? "" : r.slice(n + 1);
					String(e.stack).endsWith(i) || (e.stack += "\n" + r);
				}
			} catch {}
			throw e;
		}
	}
	_request(e, t) {
		typeof e == "string" ? (t ||= {}, t.url = e) : t = e || {}, t = ny(this.defaults, t);
		let { transitional: n, paramsSerializer: r, headers: i } = t;
		n !== void 0 && Wy.assertOptions(n, {
			silentJSONParsing: Gy.transitional(Gy.boolean),
			forcedJSONParsing: Gy.transitional(Gy.boolean),
			clarifyTimeoutError: Gy.transitional(Gy.boolean),
			legacyInterceptorReqResOrdering: Gy.transitional(Gy.boolean),
			advertiseZstdAcceptEncoding: Gy.transitional(Gy.boolean),
			validateStatusUndefinedResolves: Gy.transitional(Gy.boolean)
		}, !1), r != null && (Q.isFunction(r) ? t.paramsSerializer = { serialize: r } : Wy.assertOptions(r, {
			encode: Gy.function,
			serialize: Gy.function
		}, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls === void 0 ? t.allowAbsoluteUrls = !0 : t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls), Wy.assertOptions(t, {
			baseUrl: Gy.spelling("baseURL"),
			withXsrfToken: Gy.spelling("withXSRFToken")
		}, !0), t.method = (Q.getSafeProp(t, "method") || Q.getSafeProp(this.defaults, "method") || "get").toLowerCase();
		let a = i && Q.merge(i.common, i[t.method]);
		i && Q.forEach(kv.concat("common"), (e) => {
			delete i[e];
		}), t.headers = K_.concat(a, i);
		let o = [], s = !0;
		this.interceptors.request.forEach(function(e) {
			if (typeof e.runWhen == "function" && e.runWhen(t) === !1) return;
			s &&= e.synchronous;
			let n = t.transitional || mv;
			n && n.legacyInterceptorReqResOrdering ? o.unshift(e.fulfilled, e.rejected) : o.push(e.fulfilled, e.rejected);
		});
		let c = [];
		this.interceptors.response.forEach(function(e) {
			c.push(e.fulfilled, e.rejected);
		});
		let l, u = 0, d;
		if (!s) {
			let e = [By.bind(this), void 0];
			for (e.unshift(...o), e.push(...c), d = e.length, l = Promise.resolve(t); u < d;) l = l.then(e[u++], e[u++]);
			return l;
		}
		d = o.length;
		let f = t;
		for (; u < d;) {
			let e = o[u++], t = o[u++];
			try {
				f = e ? e(f) : f;
			} catch (e) {
				if (!t) {
					l = Promise.reject(e);
					break;
				}
				try {
					let n = t.call(this, e);
					Q.isThenable(n) && (l = Promise.resolve(n).then(() => By.call(this, f)));
				} catch (e) {
					l = Promise.reject(e);
				}
				break;
			}
		}
		if (!l) try {
			l = By.call(this, f);
		} catch (e) {
			l = Promise.reject(e);
		}
		for (u = 0, d = c.length; u < d;) l = l.then(c[u++], c[u++]);
		return l;
	}
	getUri(e) {
		return e = ny(this.defaults, e), cv($v(e.baseURL, e.url, e.allowAbsoluteUrls, e), e.params, e.paramsSerializer);
	}
};
Q.forEach([
	"delete",
	"get",
	"head",
	"options"
], function(e) {
	Ky.prototype[e] = function(t, n) {
		return this.request(ny(n || {}, {
			method: e,
			url: t,
			data: n && Q.hasOwnProp(n, "data") ? n.data : void 0
		}));
	};
}), Q.forEach([
	"post",
	"put",
	"patch",
	"query"
], function(e) {
	function t(t) {
		return function(n, r, i) {
			return this.request(ny(i || {}, {
				method: e,
				headers: t ? { "Content-Type": "multipart/form-data" } : {},
				url: n,
				data: r
			}));
		};
	}
	Ky.prototype[e] = t(), e !== "query" && (Ky.prototype[e + "Form"] = t(!0));
});
//#endregion
//#region node_modules/axios/lib/cancel/CancelToken.js
var qy = class e {
	constructor(e) {
		if (typeof e != "function") throw TypeError("executor must be a function.");
		let t;
		this.promise = new Promise(function(e) {
			t = e;
		});
		let n = this;
		this.promise.then((e) => {
			if (!n._listeners) return;
			let t = n._listeners.length;
			for (; t-- > 0;) n._listeners[t](e);
			n._listeners = null;
		}), this.promise.then = (e) => {
			let t, r = new Promise((e) => {
				n.subscribe(e), t = e;
			}).then(e);
			return r.cancel = function() {
				n.unsubscribe(t);
			}, r;
		}, e(function(e, r, i) {
			n.reason || (n.reason = new Fv(e, r, i), t(n.reason));
		});
	}
	throwIfRequested() {
		if (this.reason) throw this.reason;
	}
	subscribe(e) {
		if (this.reason) {
			e(this.reason);
			return;
		}
		this._listeners ? this._listeners.push(e) : this._listeners = [e];
	}
	unsubscribe(e) {
		if (!this._listeners) return;
		let t = this._listeners.indexOf(e);
		t !== -1 && this._listeners.splice(t, 1);
	}
	toAbortSignal() {
		let e = new AbortController(), t = (t) => {
			e.abort(t);
		};
		return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
	}
	static source() {
		let t;
		return {
			token: new e(function(e) {
				t = e;
			}),
			cancel: t
		};
	}
};
//#endregion
//#region node_modules/axios/lib/helpers/spread.js
function Jy(e) {
	return function(t) {
		return e.apply(null, t);
	};
}
//#endregion
//#region node_modules/axios/lib/helpers/isAxiosError.js
function Yy(e) {
	return Q.isObject(e) && e.isAxiosError === !0;
}
//#endregion
//#region node_modules/axios/lib/helpers/HttpStatusCode.js
var Xy = {
	Continue: 100,
	SwitchingProtocols: 101,
	Processing: 102,
	EarlyHints: 103,
	Ok: 200,
	Created: 201,
	Accepted: 202,
	NonAuthoritativeInformation: 203,
	NoContent: 204,
	ResetContent: 205,
	PartialContent: 206,
	MultiStatus: 207,
	AlreadyReported: 208,
	ImUsed: 226,
	MultipleChoices: 300,
	MovedPermanently: 301,
	Found: 302,
	SeeOther: 303,
	NotModified: 304,
	UseProxy: 305,
	Unused: 306,
	TemporaryRedirect: 307,
	PermanentRedirect: 308,
	BadRequest: 400,
	Unauthorized: 401,
	PaymentRequired: 402,
	Forbidden: 403,
	NotFound: 404,
	MethodNotAllowed: 405,
	NotAcceptable: 406,
	ProxyAuthenticationRequired: 407,
	RequestTimeout: 408,
	Conflict: 409,
	Gone: 410,
	LengthRequired: 411,
	PreconditionFailed: 412,
	PayloadTooLarge: 413,
	ContentTooLarge: 413,
	UriTooLong: 414,
	UnsupportedMediaType: 415,
	RangeNotSatisfiable: 416,
	ExpectationFailed: 417,
	ImATeapot: 418,
	MisdirectedRequest: 421,
	UnprocessableEntity: 422,
	UnprocessableContent: 422,
	Locked: 423,
	FailedDependency: 424,
	TooEarly: 425,
	UpgradeRequired: 426,
	PreconditionRequired: 428,
	TooManyRequests: 429,
	RequestHeaderFieldsTooLarge: 431,
	UnavailableForLegalReasons: 451,
	InternalServerError: 500,
	NotImplemented: 501,
	BadGateway: 502,
	ServiceUnavailable: 503,
	GatewayTimeout: 504,
	HttpVersionNotSupported: 505,
	VariantAlsoNegotiates: 506,
	InsufficientStorage: 507,
	LoopDetected: 508,
	NotExtended: 510,
	NetworkAuthenticationRequired: 511,
	WebServerReturnsAnUnknownError: 520,
	WebServerIsDown: 521,
	ConnectionTimedOut: 522,
	OriginIsUnreachable: 523,
	TimeoutOccurred: 524,
	SslHandshakeFailed: 525,
	InvalidSslCertificate: 526
};
Object.entries(Xy).forEach(([e, t]) => {
	Xy[t] === void 0 && (Xy[t] = e);
});
//#endregion
//#region node_modules/axios/lib/axios.js
function Zy(e) {
	let t = new Ky(e), n = ig(Ky.prototype.request, t);
	return Q.extend(n, Ky.prototype, t, { allOwnKeys: !0 }), Q.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(t) {
		return Zy(ny(e, t));
	}, n;
}
var Qy = Zy(Mv);
Qy.Axios = Ky, Qy.CanceledError = Fv, Qy.CancelToken = qy, Qy.isCancel = Pv, Qy.VERSION = Cy, Qy.toFormData = rv, Qy.AxiosError = $, Qy.Cancel = Qy.CanceledError, Qy.all = function(e) {
	return Promise.all(e);
}, Qy.spread = Jy, Qy.isAxiosError = Yy, Qy.mergeConfig = ny, Qy.AxiosHeaders = K_, Qy.formToJSON = (e) => Ov(Q.isHTMLForm(e) ? new FormData(e) : e), Qy.getAdapter = Ry.getAdapter, Qy.HttpStatusCode = Xy, Qy.default = Qy;
//#endregion
//#region node_modules/axios/index.js
var $y = /* @__PURE__ */ r({
	Axios: () => eb,
	AxiosError: () => tb,
	AxiosHeaders: () => db,
	Cancel: () => sb,
	CancelToken: () => ib,
	CanceledError: () => nb,
	HttpStatusCode: () => fb,
	VERSION: () => ab,
	all: () => ob,
	create: () => gb,
	default: () => Qy,
	formToJSON: () => pb,
	getAdapter: () => mb,
	isAxiosError: () => cb,
	isCancel: () => rb,
	mergeConfig: () => hb,
	spread: () => lb,
	toFormData: () => ub
}), { Axios: eb, AxiosError: tb, CanceledError: nb, isCancel: rb, CancelToken: ib, VERSION: ab, all: ob, Cancel: sb, isAxiosError: cb, spread: lb, toFormData: ub, AxiosHeaders: db, HttpStatusCode: fb, formToJSON: pb, getAdapter: mb, mergeConfig: hb, create: gb } = Qy, _b = /* @__PURE__ */ r({
	Hooks: () => Px,
	Lexer: () => Ax,
	Marked: () => Fx,
	Parser: () => Nx,
	Renderer: () => jx,
	TextRenderer: () => Mx,
	Tokenizer: () => zb,
	defaults: () => yb,
	getDefaults: () => vb,
	lexer: () => Gx,
	marked: () => Lx,
	options: () => Rx,
	parse: () => Ux,
	parseInline: () => Hx,
	parser: () => Wx,
	setOptions: () => zx,
	use: () => Bx,
	walkTokens: () => Vx
});
function vb() {
	return {
		async: !1,
		breaks: !1,
		extensions: null,
		gfm: !0,
		hooks: null,
		pedantic: !1,
		renderer: null,
		silent: !1,
		tokenizer: null,
		walkTokens: null
	};
}
var yb = vb();
function bb(e) {
	yb = e;
}
var xb = /[&<>"']/, Sb = new RegExp(xb.source, "g"), Cb = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, wb = new RegExp(Cb.source, "g"), Tb = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
}, Eb = (e) => Tb[e];
function Db(e, t) {
	if (t) {
		if (xb.test(e)) return e.replace(Sb, Eb);
	} else if (Cb.test(e)) return e.replace(wb, Eb);
	return e;
}
var Ob = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi;
function kb(e) {
	return e.replace(Ob, (e, t) => (t = t.toLowerCase(), t === "colon" ? ":" : t.charAt(0) === "#" ? t.charAt(1) === "x" ? String.fromCharCode(parseInt(t.substring(2), 16)) : String.fromCharCode(+t.substring(1)) : ""));
}
var Ab = /(^|[^\[])\^/g;
function jb(e, t) {
	let n = typeof e == "string" ? e : e.source;
	t ||= "";
	let r = {
		replace: (e, t) => {
			let i = typeof t == "string" ? t : t.source;
			return i = i.replace(Ab, "$1"), n = n.replace(e, i), r;
		},
		getRegex: () => new RegExp(n, t)
	};
	return r;
}
function Mb(e) {
	try {
		e = encodeURI(e).replace(/%25/g, "%");
	} catch {
		return null;
	}
	return e;
}
var Nb = { exec: () => null };
function Pb(e, t) {
	let n = e.replace(/\|/g, (e, t, n) => {
		let r = !1, i = t;
		for (; --i >= 0 && n[i] === "\\";) r = !r;
		return r ? "|" : " |";
	}).split(/ \|/), r = 0;
	if (n[0].trim() || n.shift(), n.length > 0 && !n[n.length - 1].trim() && n.pop(), t) {
		if (n.length > t) n.splice(t);
		else for (; n.length < t;) n.push("");
	}
	for (; r < n.length; r++) n[r] = n[r].trim().replace(/\\\|/g, "|");
	return n;
}
function Fb(e, t, n) {
	let r = e.length;
	if (r === 0) return "";
	let i = 0;
	for (; i < r;) {
		let a = e.charAt(r - i - 1);
		if (a === t && !n) i++;
		else if (a !== t && n) i++;
		else break;
	}
	return e.slice(0, r - i);
}
function Ib(e, t) {
	if (e.indexOf(t[1]) === -1) return -1;
	let n = 0;
	for (let r = 0; r < e.length; r++) if (e[r] === "\\") r++;
	else if (e[r] === t[0]) n++;
	else if (e[r] === t[1] && (n--, n < 0)) return r;
	return -1;
}
function Lb(e, t, n, r) {
	let i = t.href, a = t.title ? Db(t.title) : null, o = e[1].replace(/\\([\[\]])/g, "$1");
	if (e[0].charAt(0) !== "!") {
		r.state.inLink = !0;
		let e = {
			type: "link",
			raw: n,
			href: i,
			title: a,
			text: o,
			tokens: r.inlineTokens(o)
		};
		return r.state.inLink = !1, e;
	}
	return {
		type: "image",
		raw: n,
		href: i,
		title: a,
		text: Db(o)
	};
}
function Rb(e, t) {
	let n = e.match(/^(\s+)(?:```)/);
	if (n === null) return t;
	let r = n[1];
	return t.split("\n").map((e) => {
		let t = e.match(/^\s+/);
		if (t === null) return e;
		let [n] = t;
		return n.length >= r.length ? e.slice(r.length) : e;
	}).join("\n");
}
var zb = class {
	options;
	rules;
	lexer;
	constructor(e) {
		this.options = e || yb;
	}
	space(e) {
		let t = this.rules.block.newline.exec(e);
		if (t && t[0].length > 0) return {
			type: "space",
			raw: t[0]
		};
	}
	code(e) {
		let t = this.rules.block.code.exec(e);
		if (t) {
			let e = t[0].replace(/^ {1,4}/gm, "");
			return {
				type: "code",
				raw: t[0],
				codeBlockStyle: "indented",
				text: this.options.pedantic ? e : Fb(e, "\n")
			};
		}
	}
	fences(e) {
		let t = this.rules.block.fences.exec(e);
		if (t) {
			let e = t[0], n = Rb(e, t[3] || "");
			return {
				type: "code",
				raw: e,
				lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
				text: n
			};
		}
	}
	heading(e) {
		let t = this.rules.block.heading.exec(e);
		if (t) {
			let e = t[2].trim();
			if (/#$/.test(e)) {
				let t = Fb(e, "#");
				(this.options.pedantic || !t || / $/.test(t)) && (e = t.trim());
			}
			return {
				type: "heading",
				raw: t[0],
				depth: t[1].length,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	hr(e) {
		let t = this.rules.block.hr.exec(e);
		if (t) return {
			type: "hr",
			raw: t[0]
		};
	}
	blockquote(e) {
		let t = this.rules.block.blockquote.exec(e);
		if (t) {
			let e = t[0].replace(/\n {0,3}((?:=+|-+) *)(?=\n|$)/g, "\n    $1");
			e = Fb(e.replace(/^ *>[ \t]?/gm, ""), "\n");
			let n = this.lexer.state.top;
			this.lexer.state.top = !0;
			let r = this.lexer.blockTokens(e);
			return this.lexer.state.top = n, {
				type: "blockquote",
				raw: t[0],
				tokens: r,
				text: e
			};
		}
	}
	list(e) {
		let t = this.rules.block.list.exec(e);
		if (t) {
			let n = t[1].trim(), r = n.length > 1, i = {
				type: "list",
				raw: "",
				ordered: r,
				start: r ? +n.slice(0, -1) : "",
				loose: !1,
				items: []
			};
			n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
			let a = RegExp(`^( {0,3}${n})((?:[\t ][^\\n]*)?(?:\\n|$))`), o = "", s = "", c = !1;
			for (; e;) {
				let n = !1;
				if (!(t = a.exec(e)) || this.rules.block.hr.test(e)) break;
				o = t[0], e = e.substring(o.length);
				let r = t[2].split("\n", 1)[0].replace(/^\t+/, (e) => " ".repeat(3 * e.length)), l = e.split("\n", 1)[0], u = 0;
				this.options.pedantic ? (u = 2, s = r.trimStart()) : (u = t[2].search(/[^ ]/), u = u > 4 ? 1 : u, s = r.slice(u), u += t[1].length);
				let d = !1;
				if (!r && /^ *$/.test(l) && (o += l + "\n", e = e.substring(l.length + 1), n = !0), !n) {
					let t = RegExp(`^ {0,${Math.min(3, u - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`), n = RegExp(`^ {0,${Math.min(3, u - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), i = RegExp(`^ {0,${Math.min(3, u - 1)}}(?:\`\`\`|~~~)`), a = RegExp(`^ {0,${Math.min(3, u - 1)}}#`);
					for (; e;) {
						let c = e.split("\n", 1)[0];
						if (l = c, this.options.pedantic && (l = l.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), i.test(l) || a.test(l) || t.test(l) || n.test(e)) break;
						if (l.search(/[^ ]/) >= u || !l.trim()) s += "\n" + l.slice(u);
						else {
							if (d || r.search(/[^ ]/) >= 4 || i.test(r) || a.test(r) || n.test(r)) break;
							s += "\n" + l;
						}
						!d && !l.trim() && (d = !0), o += c + "\n", e = e.substring(c.length + 1), r = l.slice(u);
					}
				}
				i.loose || (c ? i.loose = !0 : /\n *\n *$/.test(o) && (c = !0));
				let f = null, p;
				this.options.gfm && (f = /^\[[ xX]\] /.exec(s), f && (p = f[0] !== "[ ] ", s = s.replace(/^\[[ xX]\] +/, ""))), i.items.push({
					type: "list_item",
					raw: o,
					task: !!f,
					checked: p,
					loose: !1,
					text: s,
					tokens: []
				}), i.raw += o;
			}
			i.items[i.items.length - 1].raw = o.trimEnd(), i.items[i.items.length - 1].text = s.trimEnd(), i.raw = i.raw.trimEnd();
			for (let e = 0; e < i.items.length; e++) if (this.lexer.state.top = !1, i.items[e].tokens = this.lexer.blockTokens(i.items[e].text, []), !i.loose) {
				let t = i.items[e].tokens.filter((e) => e.type === "space");
				i.loose = t.length > 0 && t.some((e) => /\n.*\n/.test(e.raw));
			}
			if (i.loose) for (let e = 0; e < i.items.length; e++) i.items[e].loose = !0;
			return i;
		}
	}
	html(e) {
		let t = this.rules.block.html.exec(e);
		if (t) return {
			type: "html",
			block: !0,
			raw: t[0],
			pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
			text: t[0]
		};
	}
	def(e) {
		let t = this.rules.block.def.exec(e);
		if (t) {
			let e = t[1].toLowerCase().replace(/\s+/g, " "), n = t[2] ? t[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
			return {
				type: "def",
				tag: e,
				raw: t[0],
				href: n,
				title: r
			};
		}
	}
	table(e) {
		let t = this.rules.block.table.exec(e);
		if (!t || !/[:|]/.test(t[2])) return;
		let n = Pb(t[1]), r = t[2].replace(/^\||\| *$/g, "").split("|"), i = t[3] && t[3].trim() ? t[3].replace(/\n[ \t]*$/, "").split("\n") : [], a = {
			type: "table",
			raw: t[0],
			header: [],
			align: [],
			rows: []
		};
		if (n.length === r.length) {
			for (let e of r) /^ *-+: *$/.test(e) ? a.align.push("right") : /^ *:-+: *$/.test(e) ? a.align.push("center") : /^ *:-+ *$/.test(e) ? a.align.push("left") : a.align.push(null);
			for (let e of n) a.header.push({
				text: e,
				tokens: this.lexer.inline(e)
			});
			for (let e of i) a.rows.push(Pb(e, a.header.length).map((e) => ({
				text: e,
				tokens: this.lexer.inline(e)
			})));
			return a;
		}
	}
	lheading(e) {
		let t = this.rules.block.lheading.exec(e);
		if (t) return {
			type: "heading",
			raw: t[0],
			depth: t[2].charAt(0) === "=" ? 1 : 2,
			text: t[1],
			tokens: this.lexer.inline(t[1])
		};
	}
	paragraph(e) {
		let t = this.rules.block.paragraph.exec(e);
		if (t) {
			let e = t[1].charAt(t[1].length - 1) === "\n" ? t[1].slice(0, -1) : t[1];
			return {
				type: "paragraph",
				raw: t[0],
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	text(e) {
		let t = this.rules.block.text.exec(e);
		if (t) return {
			type: "text",
			raw: t[0],
			text: t[0],
			tokens: this.lexer.inline(t[0])
		};
	}
	escape(e) {
		let t = this.rules.inline.escape.exec(e);
		if (t) return {
			type: "escape",
			raw: t[0],
			text: Db(t[1])
		};
	}
	tag(e) {
		let t = this.rules.inline.tag.exec(e);
		if (t) return !this.lexer.state.inLink && /^<a /i.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
			type: "html",
			raw: t[0],
			inLink: this.lexer.state.inLink,
			inRawBlock: this.lexer.state.inRawBlock,
			block: !1,
			text: t[0]
		};
	}
	link(e) {
		let t = this.rules.inline.link.exec(e);
		if (t) {
			let e = t[2].trim();
			if (!this.options.pedantic && /^</.test(e)) {
				if (!/>$/.test(e)) return;
				let t = Fb(e.slice(0, -1), "\\");
				if ((e.length - t.length) % 2 == 0) return;
			} else {
				let e = Ib(t[2], "()");
				if (e > -1) {
					let n = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + e;
					t[2] = t[2].substring(0, e), t[0] = t[0].substring(0, n).trim(), t[3] = "";
				}
			}
			let n = t[2], r = "";
			if (this.options.pedantic) {
				let e = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(n);
				e && (n = e[1], r = e[3]);
			} else r = t[3] ? t[3].slice(1, -1) : "";
			return n = n.trim(), /^</.test(n) && (n = this.options.pedantic && !/>$/.test(e) ? n.slice(1) : n.slice(1, -1)), Lb(t, {
				href: n && n.replace(this.rules.inline.anyPunctuation, "$1"),
				title: r && r.replace(this.rules.inline.anyPunctuation, "$1")
			}, t[0], this.lexer);
		}
	}
	reflink(e, t) {
		let n;
		if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
			let e = t[(n[2] || n[1]).replace(/\s+/g, " ").toLowerCase()];
			if (!e) {
				let e = n[0].charAt(0);
				return {
					type: "text",
					raw: e,
					text: e
				};
			}
			return Lb(n, e, n[0], this.lexer);
		}
	}
	emStrong(e, t, n = "") {
		let r = this.rules.inline.emStrongLDelim.exec(e);
		if (r && !(r[3] && n.match(/[\p{L}\p{N}]/u)) && (!(r[1] || r[2]) || !n || this.rules.inline.punctuation.exec(n))) {
			let n = [...r[0]].length - 1, i, a, o = n, s = 0, c = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
			for (c.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = c.exec(t)) != null;) {
				if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i) continue;
				if (a = [...i].length, r[3] || r[4]) {
					o += a;
					continue;
				}
				if ((r[5] || r[6]) && n % 3 && !((n + a) % 3)) {
					s += a;
					continue;
				}
				if (o -= a, o > 0) continue;
				a = Math.min(a, a + o + s);
				let t = [...r[0]][0].length, c = e.slice(0, n + r.index + t + a);
				if (Math.min(n, a) % 2) {
					let e = c.slice(1, -1);
					return {
						type: "em",
						raw: c,
						text: e,
						tokens: this.lexer.inlineTokens(e)
					};
				}
				let l = c.slice(2, -2);
				return {
					type: "strong",
					raw: c,
					text: l,
					tokens: this.lexer.inlineTokens(l)
				};
			}
		}
	}
	codespan(e) {
		let t = this.rules.inline.code.exec(e);
		if (t) {
			let e = t[2].replace(/\n/g, " "), n = /[^ ]/.test(e), r = /^ /.test(e) && / $/.test(e);
			return n && r && (e = e.substring(1, e.length - 1)), e = Db(e, !0), {
				type: "codespan",
				raw: t[0],
				text: e
			};
		}
	}
	br(e) {
		let t = this.rules.inline.br.exec(e);
		if (t) return {
			type: "br",
			raw: t[0]
		};
	}
	del(e) {
		let t = this.rules.inline.del.exec(e);
		if (t) return {
			type: "del",
			raw: t[0],
			text: t[2],
			tokens: this.lexer.inlineTokens(t[2])
		};
	}
	autolink(e) {
		let t = this.rules.inline.autolink.exec(e);
		if (t) {
			let e, n;
			return t[2] === "@" ? (e = Db(t[1]), n = "mailto:" + e) : (e = Db(t[1]), n = e), {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	url(e) {
		let t;
		if (t = this.rules.inline.url.exec(e)) {
			let e, n;
			if (t[2] === "@") e = Db(t[0]), n = "mailto:" + e;
			else {
				let r;
				do
					r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
				while (r !== t[0]);
				e = Db(t[0]), n = t[1] === "www." ? "http://" + t[0] : t[0];
			}
			return {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	inlineText(e) {
		let t = this.rules.inline.text.exec(e);
		if (t) {
			let e;
			return e = this.lexer.state.inRawBlock ? t[0] : Db(t[0]), {
				type: "text",
				raw: t[0],
				text: e
			};
		}
	}
}, Bb = /^(?: *(?:\n|$))+/, Vb = /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/, Hb = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, Ub = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, Wb = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, Gb = /(?:[*+-]|\d{1,9}[.)])/, Kb = jb(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, Gb).replace(/blockCode/g, / {4}/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).getRegex(), qb = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, Jb = /^[^\n]+/, Yb = /(?!\s*\])(?:\\.|[^\[\]\\])+/, Xb = jb(/^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/).replace("label", Yb).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Zb = jb(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, Gb).getRegex(), Qb = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", $b = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, ex = jb("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))", "i").replace("comment", $b).replace("tag", Qb).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), tx = jb(qb).replace("hr", Ub).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Qb).getRegex(), nx = {
	blockquote: jb(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", tx).getRegex(),
	code: Vb,
	def: Xb,
	fences: Hb,
	heading: Wb,
	hr: Ub,
	html: ex,
	lheading: Kb,
	list: Zb,
	newline: Bb,
	paragraph: tx,
	table: Nb,
	text: Jb
}, rx = jb("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", Ub).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Qb).getRegex(), ix = {
	...nx,
	table: rx,
	paragraph: jb(qb).replace("hr", Ub).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", rx).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Qb).getRegex()
}, ax = {
	...nx,
	html: jb("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", $b).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
	def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
	heading: /^(#{1,6})(.*)(?:\n+|$)/,
	fences: Nb,
	lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
	paragraph: jb(qb).replace("hr", Ub).replace("heading", " *#{1,6} *[^\n]").replace("lheading", Kb).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, ox = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, sx = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, cx = /^( {2,}|\\)\n(?!\s*$)/, lx = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, ux = "\\p{P}\\p{S}", dx = jb(/^((?![*_])[\spunctuation])/, "u").replace(/punctuation/g, ux).getRegex(), fx = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g, px = jb(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, "u").replace(/punct/g, ux).getRegex(), mx = jb("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)[punct](\\*+)(?=[\\s]|$)|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])|[\\s](\\*+)(?!\\*)(?=[punct])|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])|[^punct\\s](\\*+)(?=[^punct\\s])", "gu").replace(/punct/g, ux).getRegex(), hx = jb("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\\s]|$)|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)|(?!_)[punct\\s](_+)(?=[^punct\\s])|[\\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])", "gu").replace(/punct/g, ux).getRegex(), gx = jb(/\\([punct])/, "gu").replace(/punct/g, ux).getRegex(), _x = jb(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), vx = jb($b).replace("(?:-->|$)", "-->").getRegex(), yx = jb("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", vx).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), bx = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, xx = jb(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", bx).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), Sx = jb(/^!?\[(label)\]\[(ref)\]/).replace("label", bx).replace("ref", Yb).getRegex(), Cx = jb(/^!?\[(ref)\](?:\[\])?/).replace("ref", Yb).getRegex(), wx = {
	_backpedal: Nb,
	anyPunctuation: gx,
	autolink: _x,
	blockSkip: fx,
	br: cx,
	code: sx,
	del: Nb,
	emStrongLDelim: px,
	emStrongRDelimAst: mx,
	emStrongRDelimUnd: hx,
	escape: ox,
	link: xx,
	nolink: Cx,
	punctuation: dx,
	reflink: Sx,
	reflinkSearch: jb("reflink|nolink(?!\\()", "g").replace("reflink", Sx).replace("nolink", Cx).getRegex(),
	tag: yx,
	text: lx,
	url: Nb
}, Tx = {
	...wx,
	link: jb(/^!?\[(label)\]\((.*?)\)/).replace("label", bx).getRegex(),
	reflink: jb(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", bx).getRegex()
}, Ex = {
	...wx,
	escape: jb(ox).replace("])", "~|])").getRegex(),
	url: jb(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
	_backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
	del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
	text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
}, Dx = {
	...Ex,
	br: jb(cx).replace("{2,}", "*").getRegex(),
	text: jb(Ex.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, Ox = {
	normal: nx,
	gfm: ix,
	pedantic: ax
}, kx = {
	normal: wx,
	gfm: Ex,
	breaks: Dx,
	pedantic: Tx
}, Ax = class e {
	tokens;
	options;
	state;
	tokenizer;
	inlineQueue;
	constructor(e) {
		this.tokens = [], this.tokens.links = Object.create(null), this.options = e || yb, this.options.tokenizer = this.options.tokenizer || new zb(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
			inLink: !1,
			inRawBlock: !1,
			top: !0
		};
		let t = {
			block: Ox.normal,
			inline: kx.normal
		};
		this.options.pedantic ? (t.block = Ox.pedantic, t.inline = kx.pedantic) : this.options.gfm && (t.block = Ox.gfm, t.inline = this.options.breaks ? kx.breaks : kx.gfm), this.tokenizer.rules = t;
	}
	static get rules() {
		return {
			block: Ox,
			inline: kx
		};
	}
	static lex(t, n) {
		return new e(n).lex(t);
	}
	static lexInline(t, n) {
		return new e(n).inlineTokens(t);
	}
	lex(e) {
		e = e.replace(/\r\n|\r/g, "\n"), this.blockTokens(e, this.tokens);
		for (let e = 0; e < this.inlineQueue.length; e++) {
			let t = this.inlineQueue[e];
			this.inlineTokens(t.src, t.tokens);
		}
		return this.inlineQueue = [], this.tokens;
	}
	blockTokens(e, t = []) {
		e = this.options.pedantic ? e.replace(/\t/g, "    ").replace(/^ +$/gm, "") : e.replace(/^( *)(\t+)/gm, (e, t, n) => t + "    ".repeat(n.length));
		let n, r, i, a;
		for (; e;) if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((r) => (n = r.call({ lexer: this }, e, t)) ? (e = e.substring(n.raw.length), t.push(n), !0) : !1))) {
			if (n = this.tokenizer.space(e)) {
				e = e.substring(n.raw.length), n.raw.length === 1 && t.length > 0 ? t[t.length - 1].raw += "\n" : t.push(n);
				continue;
			}
			if (n = this.tokenizer.code(e)) {
				e = e.substring(n.raw.length), r = t[t.length - 1], r && (r.type === "paragraph" || r.type === "text") ? (r.raw += "\n" + n.raw, r.text += "\n" + n.text, this.inlineQueue[this.inlineQueue.length - 1].src = r.text) : t.push(n);
				continue;
			}
			if (n = this.tokenizer.fences(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.heading(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.hr(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.blockquote(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.list(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.html(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.def(e)) {
				e = e.substring(n.raw.length), r = t[t.length - 1], r && (r.type === "paragraph" || r.type === "text") ? (r.raw += "\n" + n.raw, r.text += "\n" + n.raw, this.inlineQueue[this.inlineQueue.length - 1].src = r.text) : this.tokens.links[n.tag] || (this.tokens.links[n.tag] = {
					href: n.href,
					title: n.title
				});
				continue;
			}
			if (n = this.tokenizer.table(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.lheading(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (i = e, this.options.extensions && this.options.extensions.startBlock) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startBlock.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (i = e.substring(0, t + 1));
			}
			if (this.state.top && (n = this.tokenizer.paragraph(i))) {
				r = t[t.length - 1], a && r.type === "paragraph" ? (r.raw += "\n" + n.raw, r.text += "\n" + n.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = r.text) : t.push(n), a = i.length !== e.length, e = e.substring(n.raw.length);
				continue;
			}
			if (n = this.tokenizer.text(e)) {
				e = e.substring(n.raw.length), r = t[t.length - 1], r && r.type === "text" ? (r.raw += "\n" + n.raw, r.text += "\n" + n.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = r.text) : t.push(n);
				continue;
			}
			if (e) {
				let t = "Infinite loop on byte: " + e.charCodeAt(0);
				if (this.options.silent) {
					console.error(t);
					break;
				}
				throw Error(t);
			}
		}
		return this.state.top = !0, t;
	}
	inline(e, t = []) {
		return this.inlineQueue.push({
			src: e,
			tokens: t
		}), t;
	}
	inlineTokens(e, t = []) {
		let n, r, i, a = e, o, s, c;
		if (this.tokens.links) {
			let e = Object.keys(this.tokens.links);
			if (e.length > 0) for (; (o = this.tokenizer.rules.inline.reflinkSearch.exec(a)) != null;) e.includes(o[0].slice(o[0].lastIndexOf("[") + 1, -1)) && (a = a.slice(0, o.index) + "[" + "a".repeat(o[0].length - 2) + "]" + a.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
		}
		for (; (o = this.tokenizer.rules.inline.blockSkip.exec(a)) != null;) a = a.slice(0, o.index) + "[" + "a".repeat(o[0].length - 2) + "]" + a.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
		for (; (o = this.tokenizer.rules.inline.anyPunctuation.exec(a)) != null;) a = a.slice(0, o.index) + "++" + a.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
		for (; e;) if (s || (c = ""), s = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((r) => (n = r.call({ lexer: this }, e, t)) ? (e = e.substring(n.raw.length), t.push(n), !0) : !1))) {
			if (n = this.tokenizer.escape(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.tag(e)) {
				e = e.substring(n.raw.length), r = t[t.length - 1], r && n.type === "text" && r.type === "text" ? (r.raw += n.raw, r.text += n.text) : t.push(n);
				continue;
			}
			if (n = this.tokenizer.link(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.reflink(e, this.tokens.links)) {
				e = e.substring(n.raw.length), r = t[t.length - 1], r && n.type === "text" && r.type === "text" ? (r.raw += n.raw, r.text += n.text) : t.push(n);
				continue;
			}
			if (n = this.tokenizer.emStrong(e, a, c)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.codespan(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.br(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.del(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (n = this.tokenizer.autolink(e)) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (!this.state.inLink && (n = this.tokenizer.url(e))) {
				e = e.substring(n.raw.length), t.push(n);
				continue;
			}
			if (i = e, this.options.extensions && this.options.extensions.startInline) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startInline.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (i = e.substring(0, t + 1));
			}
			if (n = this.tokenizer.inlineText(i)) {
				e = e.substring(n.raw.length), n.raw.slice(-1) !== "_" && (c = n.raw.slice(-1)), s = !0, r = t[t.length - 1], r && r.type === "text" ? (r.raw += n.raw, r.text += n.text) : t.push(n);
				continue;
			}
			if (e) {
				let t = "Infinite loop on byte: " + e.charCodeAt(0);
				if (this.options.silent) {
					console.error(t);
					break;
				}
				throw Error(t);
			}
		}
		return t;
	}
}, jx = class {
	options;
	constructor(e) {
		this.options = e || yb;
	}
	code(e, t, n) {
		let r = (t || "").match(/^\S*/)?.[0];
		return e = e.replace(/\n$/, "") + "\n", r ? "<pre><code class=\"language-" + Db(r) + "\">" + (n ? e : Db(e, !0)) + "</code></pre>\n" : "<pre><code>" + (n ? e : Db(e, !0)) + "</code></pre>\n";
	}
	blockquote(e) {
		return `<blockquote>\n${e}</blockquote>\n`;
	}
	html(e, t) {
		return e;
	}
	heading(e, t, n) {
		return `<h${t}>${e}</h${t}>\n`;
	}
	hr() {
		return "<hr>\n";
	}
	list(e, t, n) {
		let r = t ? "ol" : "ul", i = t && n !== 1 ? " start=\"" + n + "\"" : "";
		return "<" + r + i + ">\n" + e + "</" + r + ">\n";
	}
	listitem(e, t, n) {
		return `<li>${e}</li>\n`;
	}
	checkbox(e) {
		return "<input " + (e ? "checked=\"\" " : "") + "disabled=\"\" type=\"checkbox\">";
	}
	paragraph(e) {
		return `<p>${e}</p>\n`;
	}
	table(e, t) {
		return t &&= `<tbody>${t}</tbody>`, "<table>\n<thead>\n" + e + "</thead>\n" + t + "</table>\n";
	}
	tablerow(e) {
		return `<tr>\n${e}</tr>\n`;
	}
	tablecell(e, t) {
		let n = t.header ? "th" : "td";
		return (t.align ? `<${n} align="${t.align}">` : `<${n}>`) + e + `</${n}>\n`;
	}
	strong(e) {
		return `<strong>${e}</strong>`;
	}
	em(e) {
		return `<em>${e}</em>`;
	}
	codespan(e) {
		return `<code>${e}</code>`;
	}
	br() {
		return "<br>";
	}
	del(e) {
		return `<del>${e}</del>`;
	}
	link(e, t, n) {
		let r = Mb(e);
		if (r === null) return n;
		e = r;
		let i = "<a href=\"" + e + "\"";
		return t && (i += " title=\"" + t + "\""), i += ">" + n + "</a>", i;
	}
	image(e, t, n) {
		let r = Mb(e);
		if (r === null) return n;
		e = r;
		let i = `<img src="${e}" alt="${n}"`;
		return t && (i += ` title="${t}"`), i += ">", i;
	}
	text(e) {
		return e;
	}
}, Mx = class {
	strong(e) {
		return e;
	}
	em(e) {
		return e;
	}
	codespan(e) {
		return e;
	}
	del(e) {
		return e;
	}
	html(e) {
		return e;
	}
	text(e) {
		return e;
	}
	link(e, t, n) {
		return "" + n;
	}
	image(e, t, n) {
		return "" + n;
	}
	br() {
		return "";
	}
}, Nx = class e {
	options;
	renderer;
	textRenderer;
	constructor(e) {
		this.options = e || yb, this.options.renderer = this.options.renderer || new jx(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new Mx();
	}
	static parse(t, n) {
		return new e(n).parse(t);
	}
	static parseInline(t, n) {
		return new e(n).parseInline(t);
	}
	parse(e, t = !0) {
		let n = "";
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type]) {
				let e = i, t = this.options.extensions.renderers[e.type].call({ parser: this }, e);
				if (t !== !1 || ![
					"space",
					"hr",
					"heading",
					"code",
					"table",
					"blockquote",
					"list",
					"html",
					"paragraph",
					"text"
				].includes(e.type)) {
					n += t || "";
					continue;
				}
			}
			switch (i.type) {
				case "space": continue;
				case "hr":
					n += this.renderer.hr();
					continue;
				case "heading": {
					let e = i;
					n += this.renderer.heading(this.parseInline(e.tokens), e.depth, kb(this.parseInline(e.tokens, this.textRenderer)));
					continue;
				}
				case "code": {
					let e = i;
					n += this.renderer.code(e.text, e.lang, !!e.escaped);
					continue;
				}
				case "table": {
					let e = i, t = "", r = "";
					for (let t = 0; t < e.header.length; t++) r += this.renderer.tablecell(this.parseInline(e.header[t].tokens), {
						header: !0,
						align: e.align[t]
					});
					t += this.renderer.tablerow(r);
					let a = "";
					for (let t = 0; t < e.rows.length; t++) {
						let n = e.rows[t];
						r = "";
						for (let t = 0; t < n.length; t++) r += this.renderer.tablecell(this.parseInline(n[t].tokens), {
							header: !1,
							align: e.align[t]
						});
						a += this.renderer.tablerow(r);
					}
					n += this.renderer.table(t, a);
					continue;
				}
				case "blockquote": {
					let e = i, t = this.parse(e.tokens);
					n += this.renderer.blockquote(t);
					continue;
				}
				case "list": {
					let e = i, t = e.ordered, r = e.start, a = e.loose, o = "";
					for (let t = 0; t < e.items.length; t++) {
						let n = e.items[t], r = n.checked, i = n.task, s = "";
						if (n.task) {
							let e = this.renderer.checkbox(!!r);
							a ? n.tokens.length > 0 && n.tokens[0].type === "paragraph" ? (n.tokens[0].text = e + " " + n.tokens[0].text, n.tokens[0].tokens && n.tokens[0].tokens.length > 0 && n.tokens[0].tokens[0].type === "text" && (n.tokens[0].tokens[0].text = e + " " + n.tokens[0].tokens[0].text)) : n.tokens.unshift({
								type: "text",
								text: e + " "
							}) : s += e + " ";
						}
						s += this.parse(n.tokens, a), o += this.renderer.listitem(s, i, !!r);
					}
					n += this.renderer.list(o, t, r);
					continue;
				}
				case "html": {
					let e = i;
					n += this.renderer.html(e.text, e.block);
					continue;
				}
				case "paragraph": {
					let e = i;
					n += this.renderer.paragraph(this.parseInline(e.tokens));
					continue;
				}
				case "text": {
					let a = i, o = a.tokens ? this.parseInline(a.tokens) : a.text;
					for (; r + 1 < e.length && e[r + 1].type === "text";) a = e[++r], o += "\n" + (a.tokens ? this.parseInline(a.tokens) : a.text);
					n += t ? this.renderer.paragraph(o) : o;
					continue;
				}
				default: {
					let e = "Token with \"" + i.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return n;
	}
	parseInline(e, t) {
		t ||= this.renderer;
		let n = "";
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type]) {
				let e = this.options.extensions.renderers[i.type].call({ parser: this }, i);
				if (e !== !1 || ![
					"escape",
					"html",
					"link",
					"image",
					"strong",
					"em",
					"codespan",
					"br",
					"del",
					"text"
				].includes(i.type)) {
					n += e || "";
					continue;
				}
			}
			switch (i.type) {
				case "escape": {
					let e = i;
					n += t.text(e.text);
					break;
				}
				case "html": {
					let e = i;
					n += t.html(e.text);
					break;
				}
				case "link": {
					let e = i;
					n += t.link(e.href, e.title, this.parseInline(e.tokens, t));
					break;
				}
				case "image": {
					let e = i;
					n += t.image(e.href, e.title, e.text);
					break;
				}
				case "strong": {
					let e = i;
					n += t.strong(this.parseInline(e.tokens, t));
					break;
				}
				case "em": {
					let e = i;
					n += t.em(this.parseInline(e.tokens, t));
					break;
				}
				case "codespan": {
					let e = i;
					n += t.codespan(e.text);
					break;
				}
				case "br":
					n += t.br();
					break;
				case "del": {
					let e = i;
					n += t.del(this.parseInline(e.tokens, t));
					break;
				}
				case "text": {
					let e = i;
					n += t.text(e.text);
					break;
				}
				default: {
					let e = "Token with \"" + i.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return n;
	}
}, Px = class {
	options;
	constructor(e) {
		this.options = e || yb;
	}
	static passThroughHooks = /* @__PURE__ */ new Set([
		"preprocess",
		"postprocess",
		"processAllTokens"
	]);
	preprocess(e) {
		return e;
	}
	postprocess(e) {
		return e;
	}
	processAllTokens(e) {
		return e;
	}
}, Fx = class {
	defaults = vb();
	options = this.setOptions;
	parse = this.#e(Ax.lex, Nx.parse);
	parseInline = this.#e(Ax.lexInline, Nx.parseInline);
	Parser = Nx;
	Renderer = jx;
	TextRenderer = Mx;
	Lexer = Ax;
	Tokenizer = zb;
	Hooks = Px;
	constructor(...e) {
		this.use(...e);
	}
	walkTokens(e, t) {
		let n = [];
		for (let r of e) switch (n = n.concat(t.call(this, r)), r.type) {
			case "table": {
				let e = r;
				for (let r of e.header) n = n.concat(this.walkTokens(r.tokens, t));
				for (let r of e.rows) for (let e of r) n = n.concat(this.walkTokens(e.tokens, t));
				break;
			}
			case "list": {
				let e = r;
				n = n.concat(this.walkTokens(e.items, t));
				break;
			}
			default: {
				let e = r;
				this.defaults.extensions?.childTokens?.[e.type] ? this.defaults.extensions.childTokens[e.type].forEach((r) => {
					let i = e[r].flat(Infinity);
					n = n.concat(this.walkTokens(i, t));
				}) : e.tokens && (n = n.concat(this.walkTokens(e.tokens, t)));
			}
		}
		return n;
	}
	use(...e) {
		let t = this.defaults.extensions || {
			renderers: {},
			childTokens: {}
		};
		return e.forEach((e) => {
			let n = { ...e };
			if (n.async = this.defaults.async || n.async || !1, e.extensions && (e.extensions.forEach((e) => {
				if (!e.name) throw Error("extension name required");
				if ("renderer" in e) {
					let n = t.renderers[e.name];
					n ? t.renderers[e.name] = function(...t) {
						let r = e.renderer.apply(this, t);
						return r === !1 && (r = n.apply(this, t)), r;
					} : t.renderers[e.name] = e.renderer;
				}
				if ("tokenizer" in e) {
					if (!e.level || e.level !== "block" && e.level !== "inline") throw Error("extension level must be 'block' or 'inline'");
					let n = t[e.level];
					n ? n.unshift(e.tokenizer) : t[e.level] = [e.tokenizer], e.start && (e.level === "block" ? t.startBlock ? t.startBlock.push(e.start) : t.startBlock = [e.start] : e.level === "inline" && (t.startInline ? t.startInline.push(e.start) : t.startInline = [e.start]));
				}
				"childTokens" in e && e.childTokens && (t.childTokens[e.name] = e.childTokens);
			}), n.extensions = t), e.renderer) {
				let t = this.defaults.renderer || new jx(this.defaults);
				for (let n in e.renderer) {
					if (!(n in t)) throw Error(`renderer '${n}' does not exist`);
					if (n === "options") continue;
					let r = n, i = e.renderer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n || "";
					};
				}
				n.renderer = t;
			}
			if (e.tokenizer) {
				let t = this.defaults.tokenizer || new zb(this.defaults);
				for (let n in e.tokenizer) {
					if (!(n in t)) throw Error(`tokenizer '${n}' does not exist`);
					if ([
						"options",
						"rules",
						"lexer"
					].includes(n)) continue;
					let r = n, i = e.tokenizer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.tokenizer = t;
			}
			if (e.hooks) {
				let t = this.defaults.hooks || new Px();
				for (let n in e.hooks) {
					if (!(n in t)) throw Error(`hook '${n}' does not exist`);
					if (n === "options") continue;
					let r = n, i = e.hooks[r], a = t[r];
					t[r] = Px.passThroughHooks.has(n) ? (e) => {
						if (this.defaults.async) return Promise.resolve(i.call(t, e)).then((e) => a.call(t, e));
						let n = i.call(t, e);
						return a.call(t, n);
					} : (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.hooks = t;
			}
			if (e.walkTokens) {
				let t = this.defaults.walkTokens, r = e.walkTokens;
				n.walkTokens = function(e) {
					let n = [];
					return n.push(r.call(this, e)), t && (n = n.concat(t.call(this, e))), n;
				};
			}
			this.defaults = {
				...this.defaults,
				...n
			};
		}), this;
	}
	setOptions(e) {
		return this.defaults = {
			...this.defaults,
			...e
		}, this;
	}
	lexer(e, t) {
		return Ax.lex(e, t ?? this.defaults);
	}
	parser(e, t) {
		return Nx.parse(e, t ?? this.defaults);
	}
	#e(e, t) {
		return (n, r) => {
			let i = { ...r }, a = {
				...this.defaults,
				...i
			};
			this.defaults.async === !0 && i.async === !1 && (a.silent || console.warn("marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored."), a.async = !0);
			let o = this.#t(!!a.silent, !!a.async);
			if (n == null) return o(/* @__PURE__ */ Error("marked(): input parameter is undefined or null"));
			if (typeof n != "string") return o(/* @__PURE__ */ Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
			if (a.hooks && (a.hooks.options = a), a.async) return Promise.resolve(a.hooks ? a.hooks.preprocess(n) : n).then((t) => e(t, a)).then((e) => a.hooks ? a.hooks.processAllTokens(e) : e).then((e) => a.walkTokens ? Promise.all(this.walkTokens(e, a.walkTokens)).then(() => e) : e).then((e) => t(e, a)).then((e) => a.hooks ? a.hooks.postprocess(e) : e).catch(o);
			try {
				a.hooks && (n = a.hooks.preprocess(n));
				let r = e(n, a);
				a.hooks && (r = a.hooks.processAllTokens(r)), a.walkTokens && this.walkTokens(r, a.walkTokens);
				let i = t(r, a);
				return a.hooks && (i = a.hooks.postprocess(i)), i;
			} catch (e) {
				return o(e);
			}
		};
	}
	#t(e, t) {
		return (n) => {
			if (n.message += "\nPlease report this to https://github.com/markedjs/marked.", e) {
				let e = "<p>An error occurred:</p><pre>" + Db(n.message + "", !0) + "</pre>";
				return t ? Promise.resolve(e) : e;
			}
			if (t) return Promise.reject(n);
			throw n;
		};
	}
}, Ix = new Fx();
function Lx(e, t) {
	return Ix.parse(e, t);
}
Lx.options = Lx.setOptions = function(e) {
	return Ix.setOptions(e), Lx.defaults = Ix.defaults, bb(Lx.defaults), Lx;
}, Lx.getDefaults = vb, Lx.defaults = yb, Lx.use = function(...e) {
	return Ix.use(...e), Lx.defaults = Ix.defaults, bb(Lx.defaults), Lx;
}, Lx.walkTokens = function(e, t) {
	return Ix.walkTokens(e, t);
}, Lx.parseInline = Ix.parseInline, Lx.Parser = Nx, Lx.parser = Nx.parse, Lx.Renderer = jx, Lx.TextRenderer = Mx, Lx.Lexer = Ax, Lx.lexer = Ax.lex, Lx.Tokenizer = zb, Lx.Hooks = Px, Lx.parse = Lx;
var Rx = Lx.options, zx = Lx.setOptions, Bx = Lx.use, Vx = Lx.walkTokens, Hx = Lx.parseInline, Ux = Lx, Wx = Nx.parse, Gx = Ax.lex, Kx = {
	react: ae,
	"react-dom": Sr,
	"react-dom/client": Pr,
	rxjs: An,
	"observable-hooks": me,
	clsx: En,
	valtio: Er,
	lodash: Dr,
	"date-fns": Nr,
	axios: $y,
	marked: _b,
	"ag-grid-community": jr,
	"ag-grid-react": Mr,
	"@emotion/css": Eh,
	"@internationalized/date": Ar,
	"@internationalized/number": rg,
	"@flowx/core-sdk": ve,
	"@flowx/react-sdk": zC,
	"@flowx/core-theme": Gn,
	"@flowx/react-theme": qn,
	"@flowx/react-ui-toolkit": Zn
};
function qx(e) {
	if (e.startsWith("@")) {
		let t = e.split("/");
		return t.length < 2 ? [e, void 0] : [`${t[0]}/${t[1]}`, t.length > 2 ? t.slice(2).join("/") : void 0];
	}
	let t = e.indexOf("/");
	return t === -1 ? [e, void 0] : [e.substring(0, t), e.substring(t + 1)];
}
function Jx(e) {
	if (e in Kx) {
		let [t] = qx(e);
		return {
			module: Kx[e],
			packageName: t,
			subPath: void 0
		};
	}
	let [t, n] = qx(e);
	if (t in Kx) {
		let e = Kx[t];
		return !n || e != null && n in e ? {
			module: e,
			packageName: t,
			subPath: n
		} : {
			module: void 0,
			packageName: t,
			subPath: n
		};
	}
	return {
		module: void 0,
		packageName: t,
		subPath: n
	};
}
//#endregion
//#region libs/sdk/react/src/lib/custom-component-runtime/import-rewriter.ts
function Yx(e) {
	return typeof e == "object" && e && "default" in e && typeof e.default == "function" ? Object.assign(e.default, e) : e;
}
function Xx(e) {
	let t = /* @__PURE__ */ new Set(), n = [], r = e.replace(Zx, (e) => {
		let t = n.length;
		return n.push(e), `\0PLACEHOLDER_${t}\0`;
	});
	return r = r.replace(Qx, ""), r = r.replace($x, (e, n, r) => {
		let i = Jx(r), a = i.module !== void 0;
		a || t.add(r);
		let o = oS(n);
		return !o.defaultImport && !o.namedImports?.length && !o.namespaceImport ? "" : a ? dS(o, r, i) : fS(o, r);
	}), r = r.replace(eS, (e, n) => Jx(n).module === void 0 ? (t.add(n), `await __import('${n}');`) : ""), r = r.replace(tS, (e, n, r) => {
		let i = Jx(r), a = i.module !== void 0;
		if (a || t.add(r), n.trim().startsWith("*")) return `/* unsupported: export ${n.trim()} from '${r}' */`;
		let o = n.match(/\{([\s\S]*)\}/);
		if (o) {
			let e = sS(o[1]), t = a ? cS(r, i) : `await __import('${r}')`;
			return `const { ${lS(e)} } = ${t};`;
		}
		return "";
	}), r = r.replace(rS, "__defaultExport = "), r = r.replace(iS, (e, t) => {
		let n = t.split(",").map((e) => e.trim()).filter(Boolean).find((e) => /\bas\s+default\b/.test(e));
		return n ? `__defaultExport = ${n.split(/\s+as\s+/)[0].trim()};` : "";
	}), r = r.replace(aS, (e, t) => t), r = r.replace(nS, (e, n) => {
		let r = Jx(n);
		return r.module === void 0 ? (t.add(n), `__import('${n}')`) : `Promise.resolve(${cS(n, r)})`;
	}), r = r.replace(/\0PLACEHOLDER_(\d+)\0/g, (e, t) => n[Number(t)]), {
		code: r,
		externalSpecifiers: t
	};
}
var Zx = /\/\/[^\n]*|\/\*[\s\S]*?\*\/|`(?:[^`\\]|\\.)*`|"(?:[^"\\\n]|\\.)*(?:import|export)(?:[^"\\\n]|\\.)*"|'(?:[^'\\\n]|\\.)*(?:import|export)(?:[^'\\\n]|\\.)*'/g, Qx = /\bimport\s+type\s+[\s\S]*?\s+from\s+['"][^'"]+['"]\s*;?/g, $x = /\bimport\s+([\s\S]*?)\s+from\s+['"]([^'"]+)['"]\s*;?/g, eS = /\bimport\s+['"]([^'"]+)['"]\s*;?/g, tS = /\bexport\s+([\s\S]*?)\s+from\s+['"]([^'"]+)['"]\s*;?/g, nS = /\bimport\s*\(\s*['"]([^'"]+)['"]\s*\)/g, rS = /\bexport\s+default\s+/g, iS = /\bexport\s+\{([^}]+)\}\s*;?/g, aS = /\bexport\s+((?:const|let|var|function\s*\*?|class)\s+)/g;
function oS(e) {
	let t = e.trim(), n = {}, r = t.match(/^\*\s+as\s+([\w$]+)$/);
	if (r) return n.namespaceImport = r[1], n;
	let i = t.match(/^([\w$]+)\s*,\s*\*\s+as\s+([\w$]+)$/);
	if (i) return n.defaultImport = i[1], n.namespaceImport = i[2], n;
	let a = t.match(/^([\w$]+)\s*,\s*\{([\s\S]*)\}$/);
	if (a) return n.defaultImport = a[1], n.namedImports = sS(a[2]), n;
	let o = t.match(/^\{([\s\S]*)\}$/);
	if (o) return n.namedImports = sS(o[1]), n;
	let s = t.match(/^([\w$]+)$/);
	return s && (n.defaultImport = s[1]), n;
}
function sS(e) {
	return e.split(",").map((e) => e.trim()).filter(Boolean).filter((e) => !e.startsWith("type ")).map((e) => {
		let t = e.split(/\s+as\s+/);
		return {
			imported: t[0].trim(),
			local: (t[1] ?? t[0]).trim()
		};
	});
}
function cS(e, t) {
	return t.subPath ? `__modules['${t.packageName}']['${t.subPath}']` : `__modules['${e}']`;
}
function lS(e) {
	return e.map((e) => e.imported === e.local ? e.local : `${e.imported}: ${e.local}`).join(", ");
}
function uS(e) {
	return "__" + e.replace(/[^a-zA-Z0-9_$]/g, "_");
}
function dS(e, t, n) {
	let r = cS(t, n), i = [], a = n.subPath ? `__modules['${n.packageName}']` : r;
	return e.namespaceImport && i.push(`const ${e.namespaceImport} = __resolveNamespace(${r});`), e.defaultImport && i.push(n.subPath ? `const ${e.defaultImport} = ${r};` : `const ${e.defaultImport} = ${r}.default;`), e.namedImports?.length && i.push(`const { ${lS(e.namedImports)} } = ${a};`), i.join("\n");
}
function fS(e, t) {
	let n = [];
	if ([
		e.defaultImport,
		e.namedImports?.length,
		e.namespaceImport
	].filter(Boolean).length > 1) {
		let r = uS(t);
		n.push(`const ${r} = await __import('${t}');`), e.namespaceImport && n.push(`const ${e.namespaceImport} = ${r};`), e.defaultImport && n.push(`const ${e.defaultImport} = ${r}.default;`), e.namedImports?.length && n.push(`const { ${lS(e.namedImports)} } = ${r};`);
	} else e.namespaceImport && n.push(`const ${e.namespaceImport} = await __import('${t}');`), e.defaultImport && n.push(`const ${e.defaultImport} = (await __import('${t}')).default;`), e.namedImports?.length && n.push(`const { ${lS(e.namedImports)} } = await __import('${t}');`);
	return n.join("\n");
}
//#endregion
//#region libs/sdk/react/src/lib/custom-component-runtime/component-loader.ts
var pS = /* @__PURE__ */ new Map();
function mS(e) {
	let t = [...e.dependencies].sort((e, t) => e.name.localeCompare(t.name)), n = JSON.stringify(t);
	return Ip(`${e.sourceCode}\0${e.styles}\0${n}`);
}
function hS() {
	pS.clear(), gS.clear(), vS(), TS();
}
var gS = /* @__PURE__ */ new Map(), _S = /* @__PURE__ */ new Map();
function vS() {
	for (let e of _S.values()) e.remove();
	_S.clear();
}
var yS = "https://esm.sh", bS = 15e3, xS = [
	"react",
	"react-dom",
	"@emotion/css",
	"lodash",
	"axios",
	"date-fns"
], SS = !1, CS = null, wS = [];
function TS() {
	CS &&= (CS.remove(), null);
	for (let e of wS) URL.revokeObjectURL(e);
	wS.length = 0, delete window.__FLOWX_MODULES__, SS = !1;
}
function ES(e) {
	let t = Kx[e];
	if (!t) return "";
	let n = Object.keys(t).filter((e) => e !== "default" && e !== "__esModule" && /^[a-zA-Z_$][\w$]*$/.test(e)), r = [
		`const __m = window.__FLOWX_MODULES__['${e}'];`,
		"export default __m.default ?? __m;",
		...n.map((e) => `export const ${e} = __m['${e}'];`)
	].join("\n"), i = URL.createObjectURL(new Blob([r], { type: "application/javascript" }));
	return wS.push(i), i;
}
function DS() {
	let e = [
		"const React = window.__FLOWX_MODULES__['react'];",
		"const R = React.default ?? React;",
		"export const jsx = R.createElement;",
		"export const jsxs = R.createElement;",
		"export const jsxDEV = R.createElement;",
		"export const Fragment = R.Fragment;"
	].join("\n"), t = URL.createObjectURL(new Blob([e], { type: "application/javascript" }));
	return wS.push(t), t;
}
function OS(e, t) {
	if (SS) return;
	SS = !0, window.__FLOWX_MODULES__ = Kx;
	let n = {};
	for (let e of xS) {
		let t = ES(e);
		t && (n[e] = t);
	}
	let r = DS();
	n["react/jsx-runtime"] = r, n["react/jsx-dev-runtime"] = r;
	let i = ES("react-dom/client");
	i && (n["react-dom/client"] = i), e && t && t.map((e) => qx(e)[0]).filter((e) => !(e in n) && !(e in Kx)).forEach((r) => {
		n[r] = kS(r, e, t);
	});
	let a = document.createElement("script");
	a.type = "importmap", a.textContent = JSON.stringify({ imports: n }), document.head.appendChild(a), CS = a;
}
function kS(e, t, n) {
	let [r, i] = qx(e), a = t.get(r);
	return `${yS}/${r}${a ? `@${a}` : ""}${i ? `/${i}` : ""}?external=${(n ?? xS).filter((e) => e !== r).join(",")}`;
}
function AS(e) {
	return fetch(e).then((e) => {
		if (!e.ok) throw Error(`HTTP ${e.status}`);
		return e.text();
	}).then((t) => {
		let n = document.createElement("style");
		return n.setAttribute("data-flx-cc-css", e), n.textContent = t, document.head.appendChild(n), _S.set(e, n), {};
	});
}
function jS(e, t) {
	return OS(e, t), (n) => {
		let r = kS(n, e, t), i = gS.get(r);
		if (i) return i;
		let a = n.endsWith(".css") ? AS(r) : import(
			/* webpackIgnore: true */
			/* @vite-ignore */
			r
), o, s = new Promise((e, t) => {
			o = setTimeout(() => t(/* @__PURE__ */ Error(`Timed out after ${bS / 1e3}s`)), bS);
		}), c = Promise.race([a, s]).then((e) => (clearTimeout(o), e), (e) => {
			throw clearTimeout(o), e;
		}).catch((e) => {
			throw gS.delete(r), Error(`[FlowX] Failed to load external dependency "${n}" from ${r}: ${e.message}`);
		});
		return gS.set(r, c), c;
	};
}
function MS(e) {
	return [
		"export default (async function(__modules, __import, __resolveNamespace) {",
		"  let __defaultExport;",
		e,
		"  return __defaultExport;",
		"})"
	].join("\n");
}
async function NS(e) {
	let t = new Blob([e], { type: "application/javascript" }), n = URL.createObjectURL(t);
	try {
		return (await import(
			/* webpackIgnore: true */
			/* @vite-ignore */
			n
)).default;
	} finally {
		URL.revokeObjectURL(n);
	}
}
function PS(e) {
	let t = mS(e), n = pS.get(t);
	if (n) return n;
	let r = FS(e);
	return pS.set(t, r), r.catch(() => pS.delete(t)), r;
}
async function FS(e) {
	let { sourceCode: t, uniqueIdentifier: n, styles: r, dependencies: i } = e, a = new Map(i.map((e) => [e.name, e.version])), { code: o, externalSpecifiers: s } = Xx(t), { code: c } = Rf(MS((/\bconst\s+React\s*=/.test(o) ? "" : "const React = __modules['react'].default ?? __modules['react'];\n") + o), {
		transforms: ["typescript", "jsx"],
		jsxRuntime: "classic",
		jsxPragma: "React.createElement",
		jsxFragmentPragma: "React.Fragment",
		production: !1
	}), l = Lp(n), u = r ? Rp(r, l) : "", d = Array.from(s).map((e) => qx(e)[0]), f = jS(a, [...xS, ...d.filter((e) => !xS.includes(e) && !(e in Kx))]);
	s.size > 0 && await Promise.all(Array.from(s).map((e) => f(e)));
	let p = await NS(c), m;
	try {
		m = await p(Kx, f, Yx);
	} catch (e) {
		let t = e instanceof Error ? e.message : String(e);
		throw Error(`[FlowX] Custom component "${n}" threw during initialization: ${t}`);
	}
	let h = typeof m == "function", g = typeof m == "object" && !!m && !!m.prototype && m.prototype?.isReactComponent != null;
	if (!h && !g) throw Error(`[FlowX] Custom component "${n}" did not export a default React component. Got: ${m === null ? "null" : typeof m}`);
	return {
		Component: m,
		scopeId: l,
		scopedCss: u
	};
}
function IS(e) {
	let { Component: t, scopeId: n, scopedCss: r } = e, i = oe.memo(({ flowxUuid: e, ...i }) => (Gp(r, n), oe.createElement("div", {
		className: n,
		style: { display: "contents" },
		"data-uniqueid": e
	}, oe.createElement(t, i))));
	return i.displayName = `Scoped(${t.displayName || t.name || "Component"})`, i;
}
//#endregion
//#region libs/sdk/react/src/components/sdk/custom-component/FlxRuntimeCustomComponent.tsx
var LS = /* @__PURE__ */ r({
	FlxRuntimeCustomComponent: () => HS,
	clearPendingCompilations: () => VS
}), RS = T(function() {
	return /* @__PURE__ */ M("div", {
		className: "flx-cc-skeleton",
		"data-flx-cc": "skeleton"
	});
}), zS = /* @__PURE__ */ new Map(), BS = 0;
function VS() {
	zS.clear(), BS++;
}
function HS({ config: e }) {
	let t = tt(e.displayOptions.flowxProps.appId, e.displayOptions.flowxProps.resDefId);
	return t ? /* @__PURE__ */ M(US, {
		config: e,
		definition: t
	}) : null;
}
var US = T(function({ config: e, definition: t }) {
	let [n, r] = pe(!1), [i, a] = pe(null), o = `${t.appId}_${t.resourceDefinitionId}`;
	de(() => {
		let e = !1, n = zS.get(o);
		if (!n) {
			let e = BS;
			n = PS(t).then((t) => {
				if (BS !== e) return;
				let n = IS(t);
				De({ [o]: n });
			}).finally(() => {
				zS.delete(o);
			}), zS.set(o, n);
		}
		return n.then(() => {
			e || r(!0);
		}, (t) => {
			e || a(t.message);
		}), () => {
			e = !0;
		};
	}, [t, o]);
	let s = n ? it()[o] : null, c = he((e) => e.pipe(Un(([e]) => v(e))), [e]), l = E((t, n, r, i) => s ? /* @__PURE__ */ M(s, {
		input: t,
		registerValidation: n,
		saveData: r,
		isSubmitted: i,
		flowxUuid: e.flowxUuid
	}) : null, [s, e.flowxUuid]);
	return i ? /* @__PURE__ */ Tr("div", {
		className: "flx-cc-error",
		children: [
			"Failed to load component: ",
			i,
			" with identifier: ",
			t.uniqueIdentifier
		]
	}) : n ? s ? /* @__PURE__ */ M(zr, {
		componentIdentifier: o,
		children: /* @__PURE__ */ M(_, {
			uuid: e.reusableUiTemplateContext ? `${e.reusableUiTemplateContext}_${e.flowxUuid}` : e.flowxUuid,
			viewUuid: e.flowxUuid,
			data$: c,
			children: l
		})
	}) : null : /* @__PURE__ */ M(RS, {});
}), WS = (e, t) => {
	let n = O(e);
	n.current = e;
	let r = O(t);
	r.current = t;
	let i = he(() => nn(n.current));
	_e(i, () => We(n.current, r.current));
}, GS = (e) => ({
	...d,
	...m
})[e], KS = T(({ config: e, collectionPrototypeInstanceMeta: t, ref: n }) => {
	let r = D(() => t || void 0, [t]), i = ge(un.stream$, []), a = D(() => {
		let e = i[i.length - 1];
		return new Set(e?.map((e) => `${e.id}_${e.context}`) ?? []);
	}, [i]), o = O(Ve()).current, s = D(() => He({
		templateConfig: e?.templateConfig,
		parentFlowxUuid: e?.flowxUuid,
		prototypeInstanceMeta: r,
		cache: o
	}), [
		e?.templateConfig,
		e?.flowxUuid,
		r,
		o
	]), c = D(() => nt() ? s?.filter((e) => {
		if (Nt(e) && (e.componentIdentifier === be.CARD || e.componentIdentifier === be.CONTAINER)) {
			let t = `${e.id}_${e.context}`;
			return a.has(t);
		}
		return !0;
	}) : s, [s, a]);
	return /* @__PURE__ */ M(se, {
		fallback: /* @__PURE__ */ M(h, {}),
		children: c && c.length > 0 ? c.map((e) => {
			if (e.type === "CUSTOM") {
				if (e.displayOptions.flowxProps.type === "BUNDLED") return /* @__PURE__ */ M(HS, { config: e }, e.id);
				let t = it()[e.componentIdentifier];
				if (t) {
					let n = v(e);
					return /* @__PURE__ */ M(zr, {
						componentIdentifier: e.componentIdentifier,
						children: /* @__PURE__ */ M(_, {
							uuid: e.flowxUuid,
							data$: n,
							children: (e, n, r, i) => /* @__PURE__ */ M(t, {
								input: e,
								registerValidation: n,
								saveData: r,
								isSubmitted: i
							})
						})
					}, e.id);
				}
				return null;
			}
			let t = GS(e.componentIdentifier), r = [
				e.id,
				e?.reusableUiTemplateContext,
				e.context
			].filter(Boolean).join("_");
			return t ? /* @__PURE__ */ M(f, {
				config: e,
				ref: n,
				children: /* @__PURE__ */ M(t, { config: e })
			}, r) : null;
		}) : null
	});
});
KS.displayName = "FlxTreeNode";
//#endregion
//#region libs/sdk/react/src/lib/utils/stableProjection.ts
var qS = (e, t) => {
	let n = Object.keys(e);
	return n.length === Object.keys(t).length && n.every((n) => e[n] === t[n]);
}, JS = (e) => (t) => {
	let n;
	return t.pipe(zn((t) => {
		let r = e(t);
		return n = n && qS(n, r) ? n : r, n;
	}));
}, YS = (e) => {
	if (e?.url) window.open(e.url, "_blank");
	else if (e?.src) {
		let t = ze();
		window.open(`${t.apiUrl}/documents/${e.src}`, "_blank");
	}
}, XS = () => {
	let e = he(() => Ut()), t = ge(e, []), n = j(A.Message);
	return t.map((e) => {
		let t = e.displayOptions?.flowxProps, r = e.action;
		return /* @__PURE__ */ Tr(yr, {
			className: n,
			type: t?.messageType,
			display: t?.displayType || "fill",
			layout: t?.layoutType || "row",
			style: { width: "100%" },
			children: [k(t?.text || ""), r && /* @__PURE__ */ M("button", {
				name: r.label,
				onClick: () => YS(r),
				children: k(r.label)
			})]
		}, e.identifier);
	});
}, ZS = { templateConfig: [] }, QS = (e) => Fn(() => {
	let t = !1;
	return e.pipe(Nn((e) => {
		let n = [...e?.rootTemplates?.templateConfig ?? [], ...e?.modalTemplates?.templateConfig ?? []];
		return t || n.length === 0 ? Bn(e) : (t = !0, Rn(p(n)).pipe(zn(() => e)));
	}));
}), $S = T(({ customLoader: e }) => {
	let t = he(() => (nt() ? Gt : rn).pipe(QS, Vn({
		bufferSize: 1,
		refCount: !0
	}))), n = he(() => t.pipe(zn((e) => e?.rootTemplates ?? ZS), In((e, t) => kn(e, t)), Vn({
		bufferSize: 1,
		refCount: !0
	}))), r = he(() => t.pipe(zn((e) => e?.modalTemplates ?? ZS), In((e, t) => kn(e, t)), Vn({
		bufferSize: 1,
		refCount: !0
	}))), i = ge(n, ZS), a = ge(r, ZS), o = he(() => _n.pipe(JS(({ showLoader: e, loaderType: t, loaderText: n }) => ({
		showLoader: e,
		loaderType: t,
		loaderText: n
	})), In())), { showLoader: s, loaderType: c, loaderText: u } = ge(o, {
		showLoader: void 0,
		loaderType: void 0,
		loaderText: void 0
	}), d = j(A.Button), f = j(A.Card), p = j(A.Spinner), m = l(), g = D(() => /* @__PURE__ */ M(mr, {
		backgroundColor: "var(--flxTheme-spinner-backgroundColor, #ffffff)",
		borderColor: "var(--flxTheme-spinner-accentColor, transparent)",
		visualType: "custom",
		size: "small",
		type: "indeterminate",
		className: p ?? "",
		text: u
	}), [u, p]), _ = D(() => {
		let t = null;
		return s === void 0 ? null : (t = e?.[s], c === "action" && e?.defaultAction && (t = e.defaultAction), c === "upload" && e?.defaultUpload && (t = e.defaultUpload), e?.actions?.[s] && (t = e.actions[s]), /* @__PURE__ */ M(pr, {
			open: !0,
			container: m,
			className: On("flx-loader-modal", [`flx-loader-overlay ${s}`]),
			children: t ?? g
		}));
	}, [
		s,
		c,
		e,
		g,
		m
	]), v = ge(Pe(1), !1), y = ge(Pe(-1), !1), b = ge(Fe, !1), x = k("@@sys_close");
	return /* @__PURE__ */ M(br.Provider, { children: /* @__PURE__ */ Tr("div", {
		className: On("flx-process-renderer", { readonly: nt() }),
		children: [
			/* @__PURE__ */ M(XS, {}),
			/* @__PURE__ */ M(Lr, {}),
			_ || null,
			/* @__PURE__ */ Tr(se, {
				fallback: /* @__PURE__ */ M(h, { children: _ }),
				children: [/* @__PURE__ */ M(KS, { config: i }), /* @__PURE__ */ M(KS, { config: a })]
			}),
			nt() && (y || v || b) ? /* @__PURE__ */ M("div", {
				className: "flx-template-navigation-buttons",
				children: /* @__PURE__ */ M(gr, {
					className: f,
					children: /* @__PURE__ */ M(_r, { children: /* @__PURE__ */ Tr("div", {
						className: "flx-template-navigation-actions",
						children: [b ? /* @__PURE__ */ M($n, {
							className: d,
							variant: "text",
							icon: "left",
							iconComponent: /* @__PURE__ */ M(fr, { name: "caretLeft" }),
							onClick: () => Ht(),
							children: x
						}) : null, /* @__PURE__ */ Tr("div", {
							className: "flx-template-navigation-actions-buttons",
							children: [y ? /* @__PURE__ */ M($n, {
								className: d,
								variant: "fill",
								icon: "center",
								iconComponent: /* @__PURE__ */ M(fr, { name: "arrowLeft" }),
								onClick: () => Rt(-1),
								children: "Previous"
							}) : null, v ? /* @__PURE__ */ M($n, {
								className: d,
								variant: "fill",
								icon: "center",
								iconComponent: /* @__PURE__ */ M(fr, { name: "arrowRight" }),
								onClick: () => Rt(1),
								children: "Next"
							}) : null]
						})]
					}) })
				})
			}) : null
		]
	}) });
});
$S.displayName = "App";
//#endregion
//#region libs/sdk/react/src/components/sdk/process-renderer/ProcessRenderer.tsx
function eC({ apiUrl: e, authToken: t, language: n, themeId: r, processName: i, resourceId: a, processStartData: o, processApiPath: s, isDraft: c, trigger: l, staticAssetsPath: u, validators: d, components: f, projectInfo: p, buildId: m, workspaceId: h, organizationId: g, locale: _, cache: v, legacyHttpVersion: y, requestInterceptors: b, responseInterceptors: x, onProcessEnded: S, onProcessStarted: C, customLoader: w }) {
	let ee = O(t);
	ee.current = t;
	let te = O(o);
	te.current = o;
	let ne = O(d);
	ne.current = d;
	let ie = O(f);
	ie.current = f, fe(() => {
		t && (ze()?.isAnonymousMode || an(t));
	}, [t]), de(() => {
		S && ke(S);
	}, [S]), de(() => {
		C && Ae(C);
	}, [C]), de(() => {
		Oe({
			requestInterceptors: b,
			responseInterceptors: x
		});
	}, [b, x]), de(() => {
		Et({
			apiUrl: e,
			authToken: ee.current,
			language: n,
			themeId: r,
			processName: i,
			processStartData: te.current,
			processApiPath: s,
			isDraft: c,
			staticAssetsPath: u,
			appInfo: {
				appId: p?.projectId,
				appVersionId: p?.appVersionId,
				selectedProcessResourceId: p?.selectedProcessResourceId
			},
			buildId: m,
			workspaceId: h,
			organizationId: g,
			locale: _,
			cache: v,
			legacyHttpVersion: y,
			resourceId: a,
			trigger: l,
			fw: "react"
		});
		let t = et() === null;
		return t && re.initCustomValidators({ ...ne.current }), De(ie.current ?? {}), () => {
			t && re.clearCustomValidators(), Xt();
		};
	}, [
		y,
		p?.projectId,
		p?.appVersionId,
		p?.selectedProcessResourceId,
		m,
		h,
		g,
		e,
		n,
		r,
		i,
		s,
		c,
		u,
		_,
		v,
		a,
		l
	]);
	let ae = ge(Wt.stream$, 0);
	return /* @__PURE__ */ M($S, { customLoader: w }, ae);
}
//#endregion
//#region libs/sdk/react/src/components/sdk/process-renderer/FlxProcessRendererPortal.tsx
function tC(e) {
	let [t, n] = pe(void 0), r = E((e) => {
		n(e ?? void 0);
	}, []);
	return /* @__PURE__ */ M("div", {
		ref: r,
		style: { position: "relative" },
		children: /* @__PURE__ */ M(u.Provider, {
			value: t,
			children: /* @__PURE__ */ M(eC, { ...e })
		})
	});
}
//#endregion
//#region libs/sdk/react/src/lib/contexts/ScrollRegistryContext.tsx
var nC = ce({ register: () => {} }), rC = () => ue(nC), iC = /* @__PURE__ */ r({
	FlxModalWrapper: () => aC,
	default: () => aC
}), aC = ({ config: e, modalDismissed: t }) => {
	let { displayOptions: { flowxProps: n, style: r } } = e, i = j(A.Button), a = j(A.Modal), o = j(A.ModalHeader), s = Yn({
		styles: r,
		component: A.Modal,
		flowxProps: n
	}), c = Yn({
		styles: r,
		component: A.ModalHeader,
		flowxProps: n
	}), u = C({
		prop: n?.title || "",
		config: e
	}), d = C({
		prop: n?.subtitle || "",
		config: e
	}), f = C({
		prop: n?.modalDismissAlert?.title || "",
		config: e
	}), p = C({
		prop: n?.modalDismissAlert?.message || "",
		config: e
	}), m = C({
		prop: n?.modalDismissAlert?.cancelLabel || "",
		config: e
	}), h = C({
		prop: n?.modalDismissAlert?.confirmLabel || "",
		config: e
	});
	y(e, !0), b(e, !0), WS(e, n);
	let [_, v] = pe(!1), [x, S] = pe(!0), w = O(null), ee = O(null), te = he((e) => e.pipe(Pn(0), Un(([e, t]) => Mn([Me(e).pipe(Wn(ln(e, t))), rt]))), [e.processInstanceUuid, e.id]);
	_e(te, ([[t, n], r]) => {
		S(r?.id === e.id && r?.context === e.context || n?.some((e) => t.some((t) => t.currentNodeId === e.nodeDefinitionId && t.currentContext === e.context)));
	});
	let ne = E(async () => {
		if (v(!1), S(!1), Mt(e)) try {
			await Ue(e.processInstanceUuid);
		} catch {}
		et() !== null && zt.currentEntry?.ephemeral?.modalId && zt.pop(), Re(), t?.();
	}, [e, t]), re = E(() => {
		n?.showDismissConfirmationAlert ? v(!0) : ne();
	}, [ne, n?.showDismissConfirmationAlert]), ie = E((e) => {
		e ? ne() : v(!1);
	}, [ne]), ae = E((e) => {
		e && ee.current?.focus();
	}, []), oe = E(() => {
		n?.canDismissModal && re();
	}, [re, n?.canDismissModal]), se = E(() => {
		n?.canDismissModal && n?.closeOnBackdropClick && re();
	}, [
		re,
		n?.canDismissModal,
		n?.closeOnBackdropClick
	]), ce = g("@@sys_a11y_modal_close"), T = Jn(A.ModalHeader, "closeIcon"), le = (T ? ft(T) : void 0) ?? void 0, ue = l();
	return /* @__PURE__ */ M(pr, {
		ref: w,
		container: ue,
		closeIconAriaLabel: ce || "Close",
		closeIconPath: le,
		open: x,
		dismissible: n?.canDismissModal,
		onOpenChange: (e) => !e && oe(),
		onBackdropClick: () => se(),
		"data-testid": n?.dataTestId,
		className: On(a, o, ...s),
		headerClassName: On(o, ...c),
		panelClass: n?.panelClass,
		backdropClass: n?.backdropClass,
		title: u,
		subTitle: d,
		alertDialog: /* @__PURE__ */ M(Fr.Root, {
			open: _,
			onOpenChangeComplete: ae,
			children: /* @__PURE__ */ M(Fr.Portal, {
				container: w,
				children: /* @__PURE__ */ Tr(Fr.Popup, {
					initialFocus: !1,
					className: "flx-modal-wrapper-dismiss-sheet",
					children: [
						/* @__PURE__ */ M(Fr.Title, {
							className: "title",
							children: f
						}),
						/* @__PURE__ */ M(Fr.Description, {
							className: "message",
							children: p
						}),
						/* @__PURE__ */ Tr("div", {
							className: "buttons",
							children: [/* @__PURE__ */ M(Fr.Close, {
								onClick: () => ie(!1),
								render: /* @__PURE__ */ M($n, {
									ref: ee,
									variant: "ghost",
									className: i,
									children: m
								})
							}), /* @__PURE__ */ M(Fr.Close, {
								onClick: () => ie(!0),
								render: /* @__PURE__ */ M($n, {
									className: i,
									children: h
								})
							})]
						})
					]
				})
			})
		}),
		children: /* @__PURE__ */ M(KS, {
			config: e,
			collectionPrototypeInstanceMeta: e.prototypeInstanceMeta
		})
	});
}, oC = () => {
	let e = ge(Vt, null), t = D(() => e ? gt(e) : null, [e]), n = he(() => Cn.pipe(zn((e) => e.searchParams.get("modalId")), In(), Ln((e) => !e)));
	_e(n, () => {
		Re();
	});
	let r = he(() => Vt.pipe(In(), Hn(1), Ln((e) => e === null)));
	return _e(r, () => {
		dn("modal-dismiss");
	}), t ? /* @__PURE__ */ M(aC, { config: t }) : null;
};
//#endregion
//#region libs/sdk/react/src/components/sdk/header/FlxHeader.tsx
function sC(e) {
	return e?.positionType === "fixed" ? {
		position: "sticky",
		top: 0,
		zIndex: 3
	} : Kn(e ?? {});
}
var cC = ({ config: e }) => {
	let { displayOptions: { flowxProps: t, style: n }, flowxUuid: r } = e, i = j(A.Container), a = Yn({
		styles: {
			widthType: "fill",
			...n
		},
		component: A.Container,
		flowxProps: t
	}), o = Xn({
		styles: n,
		className: "&.flx-header"
	}), s = Fh(sC(n?.position));
	return /* @__PURE__ */ M("header", {
		"data-uniqueid": r,
		"data-testid": t?.dataTestId,
		className: On(i, o, ...a, s, "flx-container", "flx-header"),
		children: /* @__PURE__ */ M(KS, { config: e })
	});
};
cC.displayName = "FlxHeader";
//#endregion
//#region libs/sdk/react/src/components/sdk/footer/FlxFooter.tsx
function lC(e) {
	return e?.positionType === "fixed" ? {
		position: "sticky",
		bottom: 0,
		marginTop: "auto",
		zIndex: 3
	} : Kn(e ?? {});
}
var uC = ({ config: e }) => {
	let { displayOptions: { flowxProps: t, style: n }, flowxUuid: r } = e, i = j(A.Container), a = Yn({
		styles: {
			widthType: "fill",
			...n
		},
		component: A.Container,
		flowxProps: t
	}), o = Xn({
		styles: n,
		className: "&.flx-footer"
	}), s = Fh(lC(n?.position));
	return /* @__PURE__ */ M("div", {
		className: On(s),
		children: /* @__PURE__ */ M("footer", {
			"data-uniqueid": r,
			"data-testid": t?.dataTestId,
			className: On(i, o, ...a, "flx-container", "flx-footer"),
			children: /* @__PURE__ */ M(KS, { config: e })
		})
	});
};
uC.displayName = "FlxFooter";
//#endregion
//#region libs/sdk/react/src/components/ui-flow-renderer/UiFlowAccessDenied.tsx
function dC({ reason: e = "access-denied", onStartNewSession: t }) {
	let n = j(A.AccessDenied), r = j(A.Button), i = _t(e);
	return /* @__PURE__ */ Tr("div", {
		className: `flx-ui-flow-access-denied ${n ?? ""}`,
		"data-testid": "ui-flow-access-denied",
		children: [
			/* @__PURE__ */ M("h1", {
				"data-testid": "ui-flow-access-denied-title",
				children: i.title
			}),
			/* @__PURE__ */ M("p", {
				"data-testid": "ui-flow-access-denied-description",
				children: i.description
			}),
			/* @__PURE__ */ M($n, {
				variant: "fill",
				className: r ?? "",
				onClick: t,
				"data-testid": "ui-flow-access-denied-cta",
				children: i.cta
			})
		]
	});
}
//#endregion
//#region libs/sdk/react/src/components/ui-flow-renderer/UiFlowRenderer.tsx
var fC = () => {
	let e = ut(xt("viewId")) ?? bt()[0];
	return p(e ? [e, ...vt().filter((t) => jt(t, e.flowxUuid))] : []);
};
function pC({ item: e }) {
	let t = e.config, n = e.label, r = C({
		prop: n,
		config: t
	});
	return /* @__PURE__ */ M(wr, { children: r });
}
function mC({ processApiPath: e, apiUrl: t, authToken: n, language: r, themeId: a, uiFlowName: o, appInfo: c, isDraft: u, staticAssetsPath: d, buildId: f, workspaceId: p, organizationId: m, locale: g, cache: _, startParams: v, components: y, validators: b, resourceDefinitionId: x, onSteady: S }) {
	let [C, w] = pe(null), [ee, te] = pe(!1), ne = O(ee);
	ne.current = ee;
	let [ie, ae] = pe(null), oe = O(null), ce = O(n);
	ce.current = n;
	let T = O(b);
	T.current = b;
	let ue = O(y);
	ue.current = y;
	let me = O(v);
	me.current = v;
	let ve = O(S);
	ve.current = S, fe(() => {
		n && (ze()?.isAnonymousMode || an(n));
	}, [n]);
	let ye = he(() => zt.currentState$), xe = ge(ye, null), Se = ge(wn, []), Ce = ge(pn, []), we = he(() => _n.pipe(JS(({ showLoader: e, loaderType: t, loaderText: n }) => ({
		showLoader: e,
		loaderType: t,
		loaderText: n
	})), In())), { showLoader: Te, loaderText: Ee } = ge(we, {
		showLoader: void 0,
		loaderType: void 0,
		loaderText: void 0
	}), Oe = ge(fn, null), ke = D(() => {
		let e = Ce?.find((e) => e.componentIdentifier === be.BREADCRUMBS);
		return e ? {
			flowxUuid: e.flowxUuid,
			dataTestId: e.displayOptions.flowxProps.dataTestId,
			showHomeIcon: e.displayOptions.flowxProps.showHomeIcon,
			maxItems: e.displayOptions.flowxProps.collapseMode === "NONE" ? null : e.displayOptions.flowxProps.maxVisibleItems,
			style: e.displayOptions.style
		} : null;
	}, [Ce]), Ae = D(() => Ce?.find((e) => e.componentIdentifier === be.CHAT) || null, [Ce]), Me = D(() => Ce?.find((e) => e.componentIdentifier === be.HEADER) ?? null, [Ce]), Ne = D(() => Ce?.find((e) => e.componentIdentifier === be.FOOTER) ?? null, [Ce]), Pe = !!Ne && Ne.displayOptions?.style?.position?.positionType === "fixed", Fe = j(A.Breadcrumbs), Ie = j(A.BreadcrumbItem), Le = Yn({
		styles: ke?.style ?? {},
		component: A.Breadcrumbs
	}), Re = j(A.Spinner), Be = he(() => zt.navigation$);
	_e(Be, (e) => {
		if (e.type === "pop" || e.type === "reset") {
			let t = e.previousEntry?.ephemeral;
			ne.current && !t?.modalId && (xn("processUuid", null), ne.current = !1, te(!1), ae(null));
			let n = e.entry?.route?.viewId;
			if (n && !ne.current) {
				let e = gt(n);
				je(e ?? null);
			}
		}
	}), de(() => {
		let n = !1, i = sn(), s = xt("processUuid"), l = !!i?.ephemeral?.processUuid && !!s;
		(i?.ephemeral?.modalId || l) && zt.seed(i.route, i.ephemeral), te(!1), ae(null);
		async function h() {
			let i = await At({
				authToken: ce.current,
				apiUrl: t,
				staticAssetsPath: d,
				workspaceId: p,
				organizationId: m,
				appInfo: {
					appId: c.appId,
					appVersionId: c.appVersionId,
					selectedProcessResourceId: c.selectedProcessResourceId
				},
				buildId: f,
				uiFlowName: o,
				themeId: a,
				language: r,
				locale: g,
				isDraft: u,
				cache: _,
				startParams: me.current,
				processApiPath: e,
				resourceDefinitionId: x,
				fw: "react"
			}), s = yt();
			if (l && s === !1) ae({
				processResourceId: "",
				processStartData: {}
			}), te(!0);
			else if (await fC(), n) return;
			w(i), ve.current && (await Tn(), n || ve.current?.());
		}
		return h(), re.initCustomValidators({ ...T.current }), De(ue.current ?? {}), () => {
			n = !0, re.clearCustomValidators(), Jt(), hS(), VS(), qt(), Zt(), Yt();
		};
	}, [
		t,
		r,
		a,
		o,
		u,
		d,
		p,
		c.appId,
		c.appVersionId,
		c.selectedProcessResourceId,
		f,
		m,
		g,
		_,
		e,
		x
	]);
	let Ve = he(() => hn);
	_e(Ve, (e) => {
		let t = xt("processUuid");
		e === !1 && t && !ne.current ? (ne.current = !0, ae({
			processResourceId: "",
			processStartData: {}
		}), te(!0)) : e === !0 && ne.current && (ne.current = !1, te(!1), ae(null));
	});
	let He = E((e, t, n, r) => {
		let i = xt("viewId") ?? "";
		zt.push({ viewId: i }, { processUuid: "pending" }), le(() => {
			ae({
				processResourceId: e,
				processStartData: t,
				...n && { appId: n },
				...r && { buildId: r }
			}), te(!0);
		});
	}, []), Ue = ge(gn, null), We = O(/* @__PURE__ */ new Map()), Ge = E((e) => {
		let t = We.current.get(e) || document.getElementById(e);
		return t ? (t.scrollIntoView({ behavior: "smooth" }), !0) : !1;
	}, []), Ke = E((e, t) => {
		if (t) {
			We.current.set(e, t);
			let n = xe?.route?.viewId, r = xt("viewId");
			(n || r) === e && setTimeout(() => Ge(e), 100);
		} else We.current.delete(e);
	}, [xe, Ge]), qe = E(({ flowxUuid: e }) => {
		if (!e) return;
		let t = xt("viewId"), n = Object.fromEntries(new URLSearchParams(window.location.search)), { urlUpdateParams: r } = en(t, e, n), i = new URL(window.location.href);
		for (let [e, t] of Object.entries(r)) t == null ? i.searchParams.delete(e) : i.searchParams.set(e, t);
		zt.push({ viewId: e }, {}, i.toString()), Sn(r), Ge(e) || setTimeout(() => Ge(e), 100), dn("navigation", e);
	}, [Ge]);
	de(() => {
		if (ee) return;
		let e = xe?.route?.viewId, t = xt("viewId"), n = e || t;
		n && Ge(n);
	}, [
		xe,
		ee,
		Ge
	]);
	let Je = he(() => Cn.pipe(zn((e) => e.searchParams.get("viewId")), In(), Hn(1)));
	_e(Je, (e) => {
		ct() || dn("navigation", e ?? void 0);
	});
	let Ye = he(() => mn.stream$);
	_e(Ye, (e) => {
		e?.processResourceId && He(e.processResourceId, e.processStartData ?? {}, e.appId, e.buildId);
	});
	let Xe = D(() => {
		let e = ze(), t = typeof ie?.appId == "string" ? ie.appId : void 0, n = typeof ie?.buildId == "string" ? ie.buildId : void 0;
		return {
			projectId: t || e?.appInfo?.appId || c.appId,
			appVersionId: n || e?.buildId || f
		};
	}, [
		c.appId,
		f,
		ie?.appId,
		ie?.buildId
	]), Ze = D(() => Se.map((e) => ({
		label: "displayOptions" in e && "flowxProps" in e.displayOptions && "title" in e.displayOptions.flowxProps ? e.displayOptions.flowxProps.title : "",
		config: e,
		onClick: () => qe({ flowxUuid: e.flowxUuid })
	})), [Se, qe]), Qe = k("@@sys_a11y_breadcrumb"), $e = l(), et = D(() => Te === void 0 ? null : /* @__PURE__ */ M(pr, {
		open: !0,
		container: $e,
		className: Dn("flx-loader-modal", [`flx-loader-overlay ${Te}`]),
		children: /* @__PURE__ */ M(mr, {
			backgroundColor: "var(--flxTheme-spinner-backgroundColor, #ffffff)",
			borderColor: "var(--flxTheme-spinner-accentColor, transparent)",
			visualType: "custom",
			size: "small",
			type: "indeterminate",
			className: Re ?? "",
			text: Ee
		})
	}), [
		Te,
		Ee,
		Re,
		$e
	]), tt = D(() => ({ register: Ke }), [Ke]), nt = E(async () => {
		let e = await cn();
		e && (await fC(), w(e));
	}, []);
	if (!C && !Oe) return /* @__PURE__ */ M(Lr, {});
	let rt = Jn(A.Breadcrumbs, "homeIcon"), it = Jn(A.Breadcrumbs, "separatorIcon"), at = rt ? /* @__PURE__ */ M(vr, { path: rt ? pt(rt) : void 0 }) : null, ot = it ? /* @__PURE__ */ M(vr, { path: it ? pt(it) : void 0 }) : null;
	return ee ? /* @__PURE__ */ M(eC, {
		apiUrl: t,
		authToken: n,
		processApiPath: e,
		language: r,
		themeId: a,
		resourceId: ie?.processResourceId,
		processStartData: ie?.processStartData,
		isDraft: !1,
		staticAssetsPath: d,
		workspaceId: p,
		organizationId: m,
		locale: g,
		cache: _,
		projectInfo: Xe,
		trigger: "action"
	}) : /* @__PURE__ */ M(br.Provider, { children: /* @__PURE__ */ M("div", {
		ref: oe,
		className: Dn("flx-ui-flow-renderer-root", { "flx-ui-flow-fill": Pe }),
		children: /* @__PURE__ */ Tr(i.Provider, {
			value: oe,
			children: [/* @__PURE__ */ M(Lr, {}), /* @__PURE__ */ Tr(se, {
				fallback: /* @__PURE__ */ M(h, {}),
				children: [et || null, Oe ? /* @__PURE__ */ M(dC, {
					reason: Oe,
					onStartNewSession: nt
				}) : /* @__PURE__ */ Tr(wr, { children: [
					Me ? /* @__PURE__ */ M(cC, { config: Me }) : null,
					ke ? /* @__PURE__ */ M(Qn, {
						"data-uniqueid": ke.flowxUuid,
						"data-testid": ke.dataTestId,
						items: Ze,
						maxVisibleItems: ke?.maxItems,
						homeElement: ke?.showHomeIcon ? at : null,
						separator: ot,
						className: Dn(Fe, Ie, ...Le),
						ariaLabel: Qe,
						renderItem: (e) => /* @__PURE__ */ M(pC, { item: e })
					}) : null,
					Ae ? /* @__PURE__ */ M(s, { config: Ae }) : null,
					/* @__PURE__ */ Tr(nC.Provider, {
						value: tt,
						children: [Ue && /* @__PURE__ */ M(KS, { config: Ue }), /* @__PURE__ */ M(oC, {})]
					}),
					Ne ? /* @__PURE__ */ M(uC, { config: Ne }) : null
				] })]
			})]
		})
	}) });
}
//#endregion
//#region libs/sdk/react/src/components/ui-flow-renderer/FlxUiFlowRendererPortal.tsx
function hC(e) {
	let [t, n] = pe(void 0), r = E((e) => {
		n(e ?? void 0);
	}, []);
	return /* @__PURE__ */ M("div", {
		ref: r,
		style: {
			position: "relative",
			height: "100%"
		},
		children: /* @__PURE__ */ M(u.Provider, {
			value: t,
			children: /* @__PURE__ */ M(mC, { ...e })
		})
	});
}
//#endregion
//#region libs/sdk/react/src/components/template-renderer/FlxTemplateRenderer.tsx
function gC({ apiUrl: e, authToken: t, processApiPath: n, staticAssetsPath: r, projectId: i, projectVersionId: a, workspaceId: o, organizationId: s, dataModel: c, themeId: l, locale: u, language: d, reusableStartData: f, templateConfig: p, customComponents: m, ccMappings: h, onDataStoreChanged: g }) {
	let _ = O(t);
	_.current = t;
	let v = O(c);
	v.current = c;
	let y = O(f);
	y.current = f;
	let b = O(p);
	b.current = p;
	let x = O(m);
	x.current = m;
	let S = O(h);
	S.current = h;
	let C = O(g);
	C.current = g, fe(() => {
		t && an(t);
	}, [t]), de(() => {
		Dt({
			apiUrl: e,
			authToken: _.current,
			processApiPath: n,
			staticAssetsPath: r,
			appInfo: {
				appId: i,
				appVersionId: a
			},
			themeId: l,
			language: d,
			locale: u,
			reusableStartData: y.current,
			templateConfig: b.current,
			workspaceId: o,
			organizationId: s,
			dataModel: v.current,
			customComponents: x.current,
			ccMappings: S.current
		});
		let t = lt().subscribe((e) => {
			C.current?.(e);
		});
		return () => {
			t.unsubscribe(), Jt(), hS(), VS(), Xt();
		};
	}, [
		e,
		n,
		r,
		i,
		a,
		o,
		s,
		l,
		d,
		u
	]);
	let w = ge(rn, null);
	return w ? /* @__PURE__ */ M(br.Provider, { children: /* @__PURE__ */ M(KS, { config: w.rootTemplates }) }) : null;
}
//#endregion
//#region libs/sdk/react/src/components/template-renderer/FlxTemplateRendererPortal.tsx
function _C(e) {
	let [t, n] = pe(void 0), r = E((e) => {
		n(e ?? void 0);
	}, []);
	return /* @__PURE__ */ M("div", {
		ref: r,
		style: {
			position: "relative",
			height: "100%"
		},
		children: /* @__PURE__ */ M(u.Provider, {
			value: t,
			children: /* @__PURE__ */ M(gC, { ...e })
		})
	});
}
//#endregion
//#region libs/sdk/react/src/components/sdk/chat-renderer/FlxChatRendererContent.tsx
var vC = ({ messages: t, reasoning: n, showSuggestedPrompts: r, agentSuggestions: i, chatConfig: a, chatIcons: o, avatars: s, classNames: c, onSendMessage: u, onSendSuggestedPrompt: d, onSendConfiguredPrompt: f, onMessageCopied: p, onNewChat: m, headerControls: h, onVoiceMessage: g, showVoiceInput: _, activeView: v = "chat", onHistory: y, onBackFromHistory: b, chatSessions: x, onSelectSession: S, onLoadMoreSessions: C, hasMoreSessions: w, loadingMoreSessions: ee, emptyStateText: te, searchValue: ne, onSearchChange: re, onSearchClear: ie, searchPlaceholder: ae, searchClearAriaLabel: oe, searchIcons: se, searchHighlightText: ce, sessionGroupLabels: T, headerTooltips: le, headerActionIcons: E, hasMoreMessages: ue, loadingMore: de, onLoadMore: fe, voiceLabels: O, sendAriaLabel: pe, sendTooltip: me, stopAriaLabel: he, stopTooltip: ge, voiceMicAriaLabel: _e, onStopResponse: ve, inputDisabled: ye = !1, inputDisabledTooltip: be, showFileUpload: xe, fileAccept: Se, fileMaxFiles: Ce, fileMaxFilesSize: we, fileInvalidTypeError: Te, fileCountExceededError: Ee, fileSizeExceededError: De, attachmentsUploadError: Oe, attachments: ke, onAttachmentsChange: Ae, onAttachmentsMessage: je, attachmentsLabels: Me, downloadFile: Ne, messageActionsConfig: Pe, messageTimeGroupLabels: Fe, locale: Ie, feedbackTarget: Le, onFeedbackChange: Re, onFeedbackSubmit: Be, onFeedbackRemove: Ve, onFeedbackCancel: He }) => {
	let Ue = l(), We = (e, t) => {
		if (!Pe || e.isWelcome) return;
		let n = !!e.audioUrl || !!e.voiceMessageStatus, r = Pe.showCopyAction && !n && !!e.content && !e.hasError, i = Pe.showTimestamp && !!Fe && !!e.timestamp, a = Pe.showResponseFeedback && e.sender === "receiver" && !!e.messageId && !n && !!e.content && !e.hasError;
		if (!r && !i && !a) return;
		let s = e.timestamp instanceof Date ? e.timestamp.toISOString() : e.timestamp;
		return /* @__PURE__ */ M(sr, {
			className: c.chatMessageActions || void 0,
			showTimestamp: i,
			showCopyAction: r,
			timestampLabel: i && Fe && e.timestamp ? $e(e.timestamp, Fe, Ie) : void 0,
			timestampTooltip: i && s ? Qe(s, Ie) : void 0,
			copyText: e.content,
			copyIconPath: o.messageActionsIcons?.copyIcon,
			copySuccessIconPath: o.messageActionsIcons?.copySuccessIcon,
			copyAriaLabel: Pe.copyAriaLabel,
			copiedAriaLabel: Pe.copiedAriaLabel,
			onCopied: p,
			tooltipClassName: c.helperTooltip || void 0,
			alwaysVisible: t,
			dataTestId: Pe.dataTestId,
			showResponseFeedback: a,
			feedback: e.feedback?.value ?? null,
			thumbUpIconPath: o.messageActionsIcons?.thumbUpIcon,
			thumbUpSelectedIconPath: o.messageActionsIcons?.thumbUpSelectedIcon,
			thumbDownIconPath: o.messageActionsIcons?.thumbDownIcon,
			thumbDownSelectedIconPath: o.messageActionsIcons?.thumbDownSelectedIcon,
			thumbsUpAriaLabel: Pe.thumbsUpAriaLabel,
			thumbsDownAriaLabel: Pe.thumbsDownAriaLabel,
			onFeedbackChange: (t) => Re?.(e.messageId, t),
			readOnly: ye
		});
	}, Ge = t[t.length - 1]?.sender !== "receiver" || ye ? void 0 : i?.length && !n ? /* @__PURE__ */ M(dr, {
		prompts: i,
		onPromptSelected: d,
		className: c.chatSuggestedPrompts || void 0,
		tooltipClassName: c.helperTooltip || void 0
	}) : r && a?.suggestedPrompts?.length ? /* @__PURE__ */ M(dr, {
		prompts: a.suggestedPrompts,
		title: a.suggestedPromptsTitle,
		onPromptSelected: (e) => f ? f(e) : u(e.label),
		className: c.chatSuggestedPrompts || void 0,
		tooltipClassName: c.helperTooltip || void 0
	}) : void 0, Ke = {
		displayMode: "fill",
		buttonClassName: c.chatHeaderButton || void 0,
		newChatLabel: a?.newChatLabel,
		onNewChat: ye ? void 0 : m,
		newChatIcon: E?.newChatIcon ?? void 0,
		backIcon: E?.backIcon ?? void 0,
		newChatTooltip: le?.newChat,
		historyTooltip: le?.history,
		backTooltip: le?.back,
		tooltipClassName: c.helperTooltip || void 0
	}, qe = D(() => !x?.length || !T ? [] : St(x, T), [x, T]);
	return v === "history" ? /* @__PURE__ */ M(nr, {
		className: c.chatHistory || void 0,
		headerClassName: c.chatHeader || void 0,
		onBack: b,
		emptyStateText: te,
		title: a?.historyTitle,
		onLoadMore: C,
		hasMore: w,
		loadingMore: ee,
		searchValue: ne,
		onSearchChange: re,
		onSearchClear: ie,
		searchPlaceholder: ae,
		searchClearAriaLabel: oe,
		searchIconPath: se?.searchIcon,
		searchClearIconPath: se?.clearIcon,
		searchClassName: c.chatHistorySearch || void 0,
		...Ke,
		children: qe.map((e) => /* @__PURE__ */ M(ir, {
			title: e.title,
			className: c.chatHistorySection || void 0,
			children: e.sessions.map((e) => /* @__PURE__ */ M(rr, {
				sessionId: e.sessionId,
				summary: e.summary,
				active: e.active,
				createdAt: e.createdAt,
				snippet: e.snippet,
				highlightText: ce,
				onSelectSession: S,
				className: c.chatHistoryItem || void 0,
				tooltipClassName: c.helperTooltip || void 0,
				locale: ze()?.locale
			}, e.sessionId))
		}, e.code))
	}) : /* @__PURE__ */ Tr(er, {
		className: c.chat || void 0,
		children: [
			/* @__PURE__ */ Tr("div", {
				className: "flx-chat-header-wrapper",
				children: [/* @__PURE__ */ M(tr, {
					className: c.chatHeader || void 0,
					chatAvatar: s.header,
					title: a?.title,
					subtitle: a?.subtitle,
					showSeparator: a?.showSeparator,
					onHistory: y,
					historyIcon: E?.historyIcon ?? void 0,
					...Ke
				}), h && /* @__PURE__ */ M("div", {
					className: "flx-chat-header-controls-slot",
					children: h
				})]
			}),
			/* @__PURE__ */ Tr(lr, {
				hasMoreMessages: ue,
				loadingMore: de,
				onLoadMore: fe,
				className: c.chatMessages || void 0,
				children: [t.map(({ id: t, messageId: n, feedback: r, sender: i, content: l, hasError: u, audioUrl: d, voiceMessageStatus: f, audioDuration: p, onRetryVoice: m, files: h, timestamp: g }, _, v) => /* @__PURE__ */ M(or, {
					message: {
						id: t,
						messageId: n,
						feedback: r,
						sender: i,
						content: l,
						hasError: u,
						audioUrl: d,
						voiceMessageStatus: f,
						audioDuration: p,
						onRetryVoice: m,
						files: h,
						timestamp: g
					},
					messageActions: We(v[_], _ === v.length - 1),
					suggestedPrompts: _ === v.length - 1 ? Ge : void 0,
					chatAvatar: i === "receiver" ? s.agent : void 0,
					errorIcon: o.errorIcon || void 0,
					errorMessage: a?.errorMessage,
					fetchAudio: e,
					voicePlayIconPath: o.voiceMessageIcons?.playIcon,
					voicePauseIconPath: o.voiceMessageIcons?.pauseIcon,
					voiceRetryIconPath: o.voiceMessageIcons?.retryIcon,
					voiceSendingLabel: O?.sendingLabel,
					voiceErrorLabel: O?.errorLabel,
					voiceRetryAriaLabel: O?.retryAriaLabel,
					voiceMessageLabel: O?.messageLabel,
					voicePlayAriaLabel: O?.messagePlayAriaLabel,
					voicePauseAriaLabel: O?.messagePauseAriaLabel,
					voiceProgressAriaLabel: O?.progressAriaLabel,
					downloadIconPath: o.fileDownloadIcon || void 0,
					downloadFile: Ne,
					attachmentsLabels: Me,
					className: On(i === "receiver" ? c.chatAgentMessage || void 0 : c.chatUserMessage || void 0, i !== "receiver" && c.chatUserFileAttachments, u && c.chatErrorMessage)
				}, `${t}-${i}`)), n ? /* @__PURE__ */ M(ur, {
					className: On(c.chatAgentMessage),
					message: a?.thinkingMessage,
					avatar: s.agent
				}) : null]
			}),
			Pe ? /* @__PURE__ */ M(cr, {
				open: !!Le,
				title: Pe.feedbackTitle,
				reasons: Pe.feedbackReasons,
				reason: Le?.feedback?.reason ?? null,
				comment: Le?.feedback?.comment ?? null,
				isEdit: !!Le?.feedback,
				placeholder: Pe.feedbackPlaceholder,
				commentError: Pe.feedbackCommentError,
				cancelLabel: Pe.feedbackCancelLabel,
				submitLabel: Pe.feedbackSubmitLabel,
				removeLabel: Pe.feedbackRemoveLabel,
				onSubmit: (e) => Be?.(e),
				onCancel: () => He?.(),
				onRemove: () => Ve?.(),
				className: c.feedbackModal || void 0,
				headerClassName: c.feedbackModalHeader || void 0,
				bodyClassName: c.chatMessageFeedback || void 0,
				textAreaClassName: c.feedbackTextArea || void 0,
				errorClassName: c.feedbackError || void 0,
				buttonClassName: c.button || void 0,
				container: Ue
			}) : null,
			/* @__PURE__ */ M(ar, {
				sendMessage: u,
				inputPlaceholder: a?.inputPlaceholder || "Type your message...",
				className: On(c.chatInputArea, c.chatInputFileAttachments) || void 0,
				textAreaClassName: c.textArea || void 0,
				buttonClassName: c.button || c.chatHeaderButton || void 0,
				messageInput: "",
				sendDisabled: n,
				inputDisabled: ye,
				inputDisabledTooltip: be,
				onStopResponse: ve,
				stopIconPath: o.stopIcon || void 0,
				maxInputRows: a?.maxInputRows,
				sendIconPath: o.sendIcon || void 0,
				sendAriaLabel: pe,
				sendTooltip: me,
				stopAriaLabel: he,
				stopTooltip: ge,
				tooltipClassName: c.helperTooltip || void 0,
				voiceMicIconPath: o.voiceMicIcon || void 0,
				voiceMicAriaLabel: _e,
				onVoiceMessage: g,
				showVoiceInput: _ && !ye,
				voiceCancelIconPath: o.voiceInputIcons?.cancelIcon,
				voiceConfirmIconPath: o.voiceInputIcons?.confirmIcon,
				voiceDeleteIconPath: o.voiceInputIcons?.deleteIcon,
				voicePlayIconPath: o.voiceInputIcons?.playIcon,
				voicePauseIconPath: o.voiceInputIcons?.pauseIcon,
				voiceListeningLabel: O?.listeningLabel,
				voiceMessageLabel: O?.voiceMessageLabel,
				voiceCancelAriaLabel: O?.cancelAriaLabel,
				voiceConfirmAriaLabel: O?.confirmAriaLabel,
				voiceDeleteAriaLabel: O?.deleteAriaLabel,
				voicePlayAriaLabel: O?.inputPlayAriaLabel,
				voicePauseAriaLabel: O?.inputPauseAriaLabel,
				voiceProgressAriaLabel: O?.progressAriaLabel,
				showFileUpload: xe && !ye,
				accept: Se,
				maxFiles: Ce,
				maxFilesSize: we,
				invalidFileTypeError: Te,
				filesExceededError: Ee,
				filesSizeExceededError: De,
				uploadError: Oe,
				attachIconPath: o.attachFileIcon || void 0,
				deleteIconPath: o.fileDeleteIcon || void 0,
				attachmentsLabels: Me,
				attachments: ke,
				onAttachmentsChange: Ae,
				onAttachmentsMessage: je
			})
		]
	});
}, yC = (e) => {
	if (!e || typeof e != "object") return null;
	let t = e.value, n = e.appId, r = `${typeof n == "string" ? n : ""}${typeof t == "string" ? t : ""}`;
	return r ? ft(r) ?? null : null;
}, bC = (e, t) => {
	let n = Jn(e, t);
	return n ? ft(n) ?? null : null;
}, xC = (e) => {
	if (!e || typeof e != "object" || Array.isArray(e)) return;
	let t = e;
	if (typeof t.src == "string" && typeof t.alt == "string") return {
		src: t.src,
		alt: t.alt
	};
}, SC = (e, t = !1) => {
	let n = D(() => ({
		welcomeMessage: e?.welcomeMessage,
		thinkingMessage: e?.thinkingMessage,
		title: e?.title,
		subtitle: e?.subtitle,
		showChatIcon: e?.showChatIcon,
		showSeparator: e?.showSeparator,
		newChatLabel: e?.newChatLabel,
		errorMessage: e?.errorMessage,
		canRegenerate: e?.canRegenerate,
		regenerateLabel: e?.regenerateLabel,
		inputPlaceholder: e?.inputPlaceholder,
		maxInputRows: e?.maxInputRows,
		suggestedPrompts: Bt(e?.suggestedPrompts),
		suggestedPromptsTitle: e?.suggestedPromptsTitle,
		historyTitle: e?.historyTitle
	}), [e]), r = D(() => ({
		headerIcon: yC(e?.headerIcon) ?? bC(A.ChatHeader, "headerIcon"),
		agentIcon: yC(e?.agentIcon) ?? bC(A.ChatAgentMessage, "agentIcon"),
		sendIcon: yC(e?.sendIcon) ?? bC(A.ChatInputArea, "sendMessageIcon"),
		stopIcon: bC(A.ChatInputArea, "stopResponseIcon"),
		errorIcon: bC(A.ChatErrorMessage, "errorIcon"),
		voiceMicIcon: bC(A.ChatInputArea, "voiceInputIcon"),
		attachFileIcon: bC(A.ChatInputArea, "attachFileIcon"),
		fileDeleteIcon: bC(A.ChatInputFileItem, "deleteIcon"),
		fileDownloadIcon: bC(A.ChatUserFileItem, "downloadIcon"),
		voiceInputIcons: {
			cancelIcon: bC(A.ChatVoiceInput, "cancelIcon"),
			confirmIcon: bC(A.ChatVoiceInput, "confirmIcon"),
			deleteIcon: bC(A.ChatVoiceInput, "deleteIcon"),
			playIcon: bC(A.ChatVoiceInput, "playIcon"),
			pauseIcon: bC(A.ChatVoiceInput, "pauseIcon")
		},
		voiceMessageIcons: {
			playIcon: bC(A.ChatUserVoiceMessage, "playIcon"),
			pauseIcon: bC(A.ChatUserVoiceMessage, "pauseIcon"),
			retryIcon: bC(A.ChatUserVoiceMessage, "retryIcon")
		},
		messageActionsIcons: {
			copyIcon: bC(A.ChatMessageActions, "copyIcon"),
			copySuccessIcon: bC(A.ChatMessageActions, "copySuccessIcon"),
			thumbUpIcon: bC(A.ChatMessageActions, "thumbUpIcon"),
			thumbUpSelectedIcon: bC(A.ChatMessageActions, "thumbUpSelectedIcon"),
			thumbDownIcon: bC(A.ChatMessageActions, "thumbDownIcon"),
			thumbDownSelectedIcon: bC(A.ChatMessageActions, "thumbDownSelectedIcon")
		}
	}), [
		e?.headerIcon,
		e?.agentIcon,
		e?.sendIcon,
		t
	]), i = D(() => ({
		newChatIcon: bC(A.ChatHeader, "newChatIcon"),
		historyIcon: bC(A.ChatHeader, "historyIcon"),
		backIcon: bC(A.ChatHeader, "backIcon")
	}), [t]), a = D(() => ({
		searchIcon: bC(A.ChatHistorySearch, "searchIcon"),
		clearIcon: bC(A.ChatHistorySearch, "clearIcon")
	}), [t]);
	return {
		chatConfig: n,
		chatIcons: r,
		chatHeaderAvatar: D(() => {
			if (e?.showChatIcon !== !1) return r.headerIcon ? {
				src: r.headerIcon,
				alt: "Chat header icon"
			} : xC(e?.chatAvatar);
		}, [
			e?.showChatIcon,
			e?.chatAvatar,
			r.headerIcon
		]),
		headerActionIcons: i,
		searchIcons: a
	};
}, CC = () => {
	let [e, t] = pe([]), [n, r] = pe(null), [i, a] = pe(!0), [o, s] = pe(!1), c = D(() => Mn([Le.stream$, Ee.stream$]).pipe(zn(([e, t]) => ({
		store: e,
		currentId: t
	}))), []);
	return _e(c, ({ store: e, currentId: n }) => {
		r(n);
		let i = Object.entries(e).map(([e, t]) => ({
			sessionId: e,
			summary: t.summary,
			messageCount: t.messageCount,
			active: e === n,
			createdAt: t.createdAt
		}));
		t(i);
	}), _e(Be.stream$, (e) => {
		a(e.hasMore), s(e.loading);
	}), {
		sessions: e,
		activeSessionId: n,
		selectSession: E((e) => {
			on(e), xn("chatSessionId", e), Pt(e);
		}, []),
		hasMoreSessions: i,
		loadingMoreSessions: o
	};
}, wC = (e) => D(() => ({
	chat: [
		j(A.Chat),
		j(A.ChatVoiceInput),
		j(A.ChatUserVoiceMessage)
	].filter(Boolean).join(" ") || null,
	chatHeader: j(A.ChatHeader),
	chatMessages: j(A.ChatMessages),
	chatMessageActions: j(A.ChatMessageActions),
	chatMessageFeedback: [j(A.ChatMessageFeedback), j(A.ChatMessageFeedbackReason)].filter(Boolean).join(" ") || null,
	chatInputArea: j(A.ChatInputArea),
	chatUserMessage: j(A.ChatUserMessage),
	chatAgentMessage: j(A.ChatAgentMessage),
	chatErrorMessage: j(A.ChatErrorMessage),
	chatInput: j(A.ChatInput),
	chatHeaderButton: j(A.ChatHeaderButton),
	chatInputFileAttachments: [j(A.ChatInputFileAttachments), j(A.ChatInputFileItem)].filter(Boolean).join(" ") || null,
	chatUserFileAttachments: [j(A.ChatUserFileAttachments), j(A.ChatUserFileItem)].filter(Boolean).join(" ") || null,
	chatSuggestedPrompts: [
		j(A.ChatSuggestedPrompts),
		j(A.ChatSuggestedPromptsSection),
		j(A.ChatSuggestedPromptsItem)
	].filter(Boolean).join(" ") || null,
	chatHistory: j(A.ChatHistory),
	chatHistoryItem: j(A.ChatHistoryItem),
	chatHistorySection: j(A.ChatHistorySection),
	chatHistorySearch: j(A.ChatHistorySearch),
	helperTooltip: j(A.HelperTooltip),
	textArea: j(A.ChatInput),
	button: j(A.Button),
	feedbackTextArea: j(A.Textarea),
	feedbackError: j(A.Error),
	feedbackModal: j(A.Modal),
	feedbackModalHeader: j(A.ModalHeader)
}), [e]), TC, EC = /* @__PURE__ */ new Uint8Array(16);
function DC() {
	if (!TC && (TC = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !TC)) throw Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
	return TC(EC);
}
//#endregion
//#region node_modules/uuid/dist/esm-browser/stringify.js
var OC = [];
for (let e = 0; e < 256; ++e) OC.push((e + 256).toString(16).slice(1));
function kC(e, t = 0) {
	return OC[e[t + 0]] + OC[e[t + 1]] + OC[e[t + 2]] + OC[e[t + 3]] + "-" + OC[e[t + 4]] + OC[e[t + 5]] + "-" + OC[e[t + 6]] + OC[e[t + 7]] + "-" + OC[e[t + 8]] + OC[e[t + 9]] + "-" + OC[e[t + 10]] + OC[e[t + 11]] + OC[e[t + 12]] + OC[e[t + 13]] + OC[e[t + 14]] + OC[e[t + 15]];
}
var AC = { randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto) };
//#endregion
//#region node_modules/uuid/dist/esm-browser/v4.js
function jC(e, t, n) {
	if (AC.randomUUID && !t && !e) return AC.randomUUID();
	e ||= {};
	let r = e.random || (e.rng || DC)();
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		n ||= 0;
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return kC(r);
}
//#endregion
//#region libs/sdk/react/src/components/sdk/chat-renderer/utils/messageUtils.ts
var MC = (e) => ({
	id: jC(),
	content: e,
	sender: "receiver",
	timestamp: /* @__PURE__ */ new Date(),
	isWelcome: !0
}), NC = (e, t) => e.filter((e) => e.message || e.type === ye.AUDIO || e.type === ye.ATTACHMENTS).map((e) => {
	let n = e._id ?? jC(), r = e.type === ye.AUDIO, i;
	if (r && e.audioFile?.downloadPath) {
		let { apiUrl: t } = ze();
		i = `${t}/document/${e.audioFile.downloadPath}`;
	}
	let a = e.type === ye.ATTACHMENTS, o;
	if (a && e.files?.length) {
		let { apiUrl: t } = ze();
		o = e.files.map((e) => {
			let n = e.originalFileName || e.downloadPath.split("/").pop() || e.downloadPath;
			return {
				name: n,
				extension: xr(n),
				mimeType: e.mimeType ?? "",
				downloadUrl: `${t}/document/${e.downloadPath}`
			};
		});
	}
	return {
		id: n,
		messageId: e.messageId,
		feedback: e.feedback ?? null,
		content: r ? "" : e.message,
		sender: e.actor === "human" ? "sender" : "receiver",
		timestamp: $t(n, e.timestamp, t),
		...i ? { audioUrl: i } : {},
		...r && e.audioFile?.duration ? { audioDuration: e.audioFile.duration } : {},
		...o ? { files: o } : {},
		...e.suggestions?.length ? { suggestions: e.suggestions } : {}
	};
}), PC = (e, t, r = {}) => {
	let { authToken: i, apiUrl: o, staticAssetsPath: s, language: c, locale: l, themeId: u, projectId: d, workspaceId: f, buildId: p, cache: m = !0, source: h } = e, [g, _] = pe(!1), [v, y] = pe(() => t ? [MC(t)] : []), [b, C] = pe(!1), [w, ee] = pe(!0), [ne, re] = pe([]), [ie, ae] = pe(!1), [oe, se] = pe(!1), [ce, T] = pe(null), le = O(null), ue = O(null), fe = O(null), me = O(/* @__PURE__ */ new Map()), he = x(r), { applyCachedAudioUrls: ge, seedCache: ve } = a(v, y), { pendingVoice: be, handleVoiceMessage: xe, handleRetryVoice: Se, clearPendingVoice: Ce, checkAndClearPendingVoice: we } = S(ve, le, C, r.voiceInput), { attachments: Te, setAttachments: Ee, uploadError: De, handleAttachmentsMessage: Oe, clearAttachments: ke } = n(le, he.textMessageSent), Ae = D(() => ({
		authToken: i,
		apiUrl: o,
		staticAssetsPath: s,
		language: c,
		locale: l,
		themeId: u,
		projectId: d,
		workspaceId: f,
		buildId: p,
		cache: m,
		source: h
	}), [
		i,
		o,
		s,
		c,
		l,
		u,
		d,
		f,
		p,
		m,
		h
	]);
	return de(() => {
		let e = !0;
		return _(!1), y(t ? [MC(t)] : []), C(!1), T(null), Ce(), wt({
			authToken: i,
			apiUrl: o,
			staticAssetsPath: s,
			language: c,
			locale: l,
			themeId: u,
			workspaceId: f,
			buildId: p,
			source: h,
			appInfo: {
				appId: d,
				appVersionId: p
			},
			cache: m
		}).then(({ sendMessage: t, chat$: n, loadMoreMessages: r, stopResponse: i }) => {
			e && (le.current = t, ue.current = r, fe.current = i, _(!0), T(n));
		}), () => {
			e = !1, qt();
		};
	}, [
		Ae,
		i,
		o,
		s,
		c,
		l,
		u,
		f,
		p,
		m,
		h,
		d,
		t,
		Ce
	]), _e(ce ?? jn, ({ chatHistory: e, loading: n, hasMoreMessages: r, loadingMore: i }) => {
		if (C(n), ae(r ?? !1), se(i ?? !1), ee(!e?.length), !e?.length) re([]), y(t ? [MC(t)] : []);
		else {
			re(st(e));
			let t = NC(e, me.current);
			we(t), y(ge(t));
		}
	}), {
		chatLoaded: g,
		messages: D(() => te(v, be, (e, t) => ({
			id: e.id,
			content: "",
			sender: "sender",
			timestamp: /* @__PURE__ */ new Date(),
			voiceMessageStatus: e.status,
			audioDuration: e.duration,
			onRetryVoice: t,
			...e.downloadUrl ? { audioUrl: e.downloadUrl } : {}
		}), Se), [
			v,
			be,
			Se
		]),
		reasoning: b,
		showSuggestedPrompts: w,
		agentSuggestions: ne,
		handleSendMessage: E((e) => {
			le.current && (le.current(e), he.textMessageSent());
		}, [he]),
		handleSendSuggestedPrompt: E((e) => {
			le.current && (le.current(e.label, {
				type: ye.SUGGESTED_PROMPT,
				label: e.label,
				prompt: e.prompt || ""
			}), he.agentPromptSelected());
		}, [he]),
		handleSendConfiguredPrompt: E((e) => {
			le.current && (le.current(e.label), he.configuredPromptSelected(e.label));
		}, [he]),
		handleNewChat: E(() => {
			let e = Tt();
			xn("chatSessionId", e), me.current.clear(), y(t ? [MC(t)] : []), C(!1), ee(!0), re([]), Ce(), ke();
		}, [
			t,
			Ce,
			ke
		]),
		handleVoiceMessage: xe,
		hasMoreMessages: ie,
		loadingMore: oe,
		handleLoadMore: E(() => {
			ie && !oe && ue.current?.();
		}, [ie, oe]),
		handleStopResponse: E(() => {
			fe.current?.();
		}, []),
		attachments: Te,
		onAttachmentsChange: Ee,
		attachmentsUploadError: De,
		handleAttachmentsMessage: Oe
	};
}, FC = (e) => {
	let { analytics: t } = e, n = e.chatConfig?.suggestedPrompts, r = e.messageActions?.feedbackReasons, i = D(() => Ie({
		analytics: t,
		suggestedPrompts: n,
		feedbackReasons: r
	}), [
		t,
		n,
		r
	]), a = x(i), s = PC(e, e.chatConfig?.welcomeMessage, i), c = SC(e.chatConfig, s.chatLoaded), l = wC(s.chatLoaded), u = CC(), d = o(e.source.id), f = w(i.messageActions), [p, m] = pe("chat"), h = D(() => c.chatIcons.agentIcon ? {
		src: c.chatIcons.agentIcon,
		alt: "Chat agent icon"
	} : c.chatHeaderAvatar, [c.chatHeaderAvatar, c.chatIcons.agentIcon]), g = E(async () => {
		try {
			await Ft(e.source.id);
		} catch (e) {
			console.error("Failed to load conversations list", e);
		}
		m("history");
	}, [e.source.id]), _ = E(() => {
		d.clearSearch(), m("chat");
	}, [d.clearSearch]), v = E(async () => {
		await It(e.source.id);
	}, [e.source.id]), y = E(() => {
		s.handleNewChat(), m("chat");
	}, [s.handleNewChat]), b = E((e) => {
		u.selectSession(e), d.clearSearch(), m("chat");
	}, [u.selectSession, d.clearSearch]), S = D(() => ({
		newChat: k("@@sys_chat_tooltip_new_chat"),
		history: k("@@sys_chat_tooltip_chat_history"),
		back: k("@@sys_chat_tooltip_back")
	}), [s.chatLoaded]), C = D(() => k("@@sys_chat_conversations_empty_state"), [s.chatLoaded]), { searchPlaceholder: ee, searchClearAriaLabel: te, noSearchResultsText: ne } = D(() => ({
		searchPlaceholder: k("@@sys_chat_conversations_search_placeholder"),
		searchClearAriaLabel: k("@@sys_a11y_conversations_search_clear"),
		noSearchResultsText: k("@@sys_chat_conversations_no_results")
	}), [s.chatLoaded]), re = D(() => ({
		sys_chat_time_group_today: k("@@sys_chat_time_group_today"),
		sys_chat_time_group_yesterday: k("@@sys_chat_time_group_yesterday"),
		sys_chat_time_group_previous_7_days: k("@@sys_chat_time_group_previous_7_days"),
		sys_chat_time_group_previous_30_days: k("@@sys_chat_time_group_previous_30_days"),
		sys_chat_time_group_older: k("@@sys_chat_time_group_older")
	}), [s.chatLoaded]), ie = D(() => ({
		listeningLabel: k("@@sys_chat_voice_input_recording"),
		voiceMessageLabel: k("@@sys_chat_voice_input_message"),
		cancelAriaLabel: k("@@sys_a11y_chat_voice_input_cancel"),
		confirmAriaLabel: k("@@sys_a11y_chat_voice_input_confirm"),
		deleteAriaLabel: k("@@sys_a11y_chat_voice_input_delete"),
		inputPlayAriaLabel: k("@@sys_a11y_chat_voice_input_play"),
		inputPauseAriaLabel: k("@@sys_a11y_chat_voice_input_pause"),
		sendingLabel: k("@@sys_chat_voice_message_sending"),
		messageLabel: k("@@sys_chat_voice_message"),
		errorLabel: k("@@sys_chat_voice_message_error"),
		messagePlayAriaLabel: k("@@sys_a11y_chat_voice_message_play"),
		messagePauseAriaLabel: k("@@sys_a11y_chat_voice_message_pause"),
		retryAriaLabel: k("@@sys_a11y_chat_voice_message_retry"),
		progressAriaLabel: k("@@sys_a11y_chat_voice_message_progress")
	}), [s.chatLoaded]), ae = D(() => k("@@sys_a11y_chat_voice_input_record"), [s.chatLoaded]), { sendAriaLabel: oe, sendTooltip: se, stopAriaLabel: ce, stopTooltip: T } = D(() => ({
		sendAriaLabel: k("@@sys_a11y_chat_submit_message"),
		sendTooltip: k("@@sys_chat_submit_message"),
		stopAriaLabel: k("@@sys_a11y_chat_cancel_request"),
		stopTooltip: k("@@sys_chat_cancel_request")
	}), [s.chatLoaded]), le = D(() => ({
		attachAriaLabel: k("@@sys_a11y_chat_attach_files"),
		removeAriaLabel: k("@@sys_a11y_chat_remove_file"),
		downloadAriaLabel: k("@@sys_a11y_chat_download_file")
	}), [s.chatLoaded]), ue = D(() => {
		let t = e.fileUpload;
		return {
			showFileUpload: t?.enabled ?? !1,
			accept: t?.accept ?? "*/*",
			maxFiles: t?.maxFiles,
			maxFilesSize: t?.maxFilesSize,
			invalidTypeError: t?.invalidFileTypeError || "This format is not accepted",
			countExceededError: t?.filesExceededError || "Only maximum 10 files allowed",
			sizeExceededError: t?.filesSizeExceededError || "This file is too large"
		};
	}, [e.fileUpload]), de = D(() => {
		let t = e.messageActions;
		if (t?.enabled !== !1) return Qt(t, k);
	}, [e.messageActions, s.chatLoaded]), fe = D(() => Ne(k), [s.chatLoaded]), O = E(async (e) => {
		if (!e.downloadUrl) return;
		let t = await Ke(e.downloadUrl);
		if (!t) return;
		let n = URL.createObjectURL(t), r = document.createElement("a");
		r.href = n, r.download = e.name, r.click(), URL.revokeObjectURL(n);
	}, []);
	return D(() => ({
		chatLoaded: s.chatLoaded,
		messages: s.messages,
		reasoning: s.reasoning,
		showSuggestedPrompts: s.showSuggestedPrompts,
		agentSuggestions: s.agentSuggestions,
		handleSendMessage: s.handleSendMessage,
		handleSendSuggestedPrompt: s.handleSendSuggestedPrompt,
		handleSendConfiguredPrompt: s.handleSendConfiguredPrompt,
		handleMessageCopied: a.messageCopied,
		handleNewChat: y,
		handleVoiceMessage: s.handleVoiceMessage,
		chatConfig: c.chatConfig,
		chatIcons: c.chatIcons,
		chatHeaderAvatar: c.chatHeaderAvatar,
		chatAgentAvatar: h,
		classNames: l,
		activeView: p,
		chatSessions: d.isSearchActive ? d.searchSessions : u.sessions,
		handleOpenHistory: g,
		handleCloseHistory: _,
		handleSelectSession: b,
		handleLoadMoreSessions: v,
		hasMoreSessions: !d.isSearchActive && u.hasMoreSessions,
		loadingMoreSessions: d.isSearchActive ? d.searchLoading : u.loadingMoreSessions,
		hasMoreMessages: s.hasMoreMessages,
		loadingMore: s.loadingMore,
		handleLoadMore: s.handleLoadMore,
		handleStopResponse: s.handleStopResponse,
		emptyStateText: d.isSearchActive ? d.searchLoading ? "" : ne : C,
		searchValue: d.searchText,
		handleSearchChange: d.onSearchChange,
		handleSearchClear: d.clearSearch,
		searchPlaceholder: ee,
		searchClearAriaLabel: te,
		searchIcons: c.searchIcons,
		searchHighlightText: d.appliedQuery,
		sessionGroupLabels: re,
		headerTooltips: S,
		headerActionIcons: c.headerActionIcons,
		voiceLabels: ie,
		sendAriaLabel: oe,
		sendTooltip: se,
		stopAriaLabel: ce,
		stopTooltip: T,
		voiceMicAriaLabel: ae,
		attachments: s.attachments,
		onAttachmentsChange: s.onAttachmentsChange,
		attachmentsUploadError: s.attachmentsUploadError,
		handleAttachmentsMessage: s.handleAttachmentsMessage,
		downloadAttachment: O,
		attachmentsLabels: le,
		fileUploadConfig: ue,
		messageActionsConfig: de,
		messageTimeGroupLabels: fe,
		locale: e.locale,
		feedbackTarget: f.feedbackTarget,
		handleFeedbackChange: f.handleFeedbackChange,
		handleFeedbackSubmit: f.handleFeedbackSubmit,
		handleFeedbackRemove: f.handleFeedbackRemove,
		handleFeedbackCancel: f.handleFeedbackCancel
	}), [
		s.chatLoaded,
		s.messages,
		s.reasoning,
		s.showSuggestedPrompts,
		s.agentSuggestions,
		s.handleSendMessage,
		s.handleSendSuggestedPrompt,
		s.handleSendConfiguredPrompt,
		a,
		y,
		s.handleVoiceMessage,
		s.hasMoreMessages,
		s.loadingMore,
		s.handleLoadMore,
		s.handleStopResponse,
		s.attachments,
		s.onAttachmentsChange,
		s.attachmentsUploadError,
		s.handleAttachmentsMessage,
		O,
		le,
		ue,
		de,
		fe,
		e.locale,
		c.chatConfig,
		c.chatIcons,
		c.chatHeaderAvatar,
		c.headerActionIcons,
		h,
		l,
		p,
		u.sessions,
		u.hasMoreSessions,
		u.loadingMoreSessions,
		d.isSearchActive,
		d.searchSessions,
		d.searchLoading,
		d.searchText,
		d.onSearchChange,
		d.clearSearch,
		d.appliedQuery,
		c.searchIcons,
		ee,
		te,
		ne,
		g,
		_,
		b,
		v,
		C,
		re,
		S,
		ie,
		ae,
		f.feedbackTarget,
		f.handleFeedbackChange,
		f.handleFeedbackSubmit,
		f.handleFeedbackRemove,
		f.handleFeedbackCancel
	]);
}, IC = (e) => {
	let t = FC(e);
	return t.chatLoaded ? /* @__PURE__ */ M(br.Provider, { children: /* @__PURE__ */ M("div", {
		className: "flx-chat-renderer",
		children: /* @__PURE__ */ M(vC, {
			messages: t.messages,
			reasoning: t.reasoning,
			showSuggestedPrompts: t.showSuggestedPrompts,
			agentSuggestions: t.agentSuggestions,
			chatConfig: t.chatConfig,
			chatIcons: t.chatIcons,
			avatars: {
				header: t.chatHeaderAvatar,
				agent: t.chatAgentAvatar
			},
			classNames: t.classNames,
			onSendMessage: t.handleSendMessage,
			onSendSuggestedPrompt: t.handleSendSuggestedPrompt,
			onSendConfiguredPrompt: t.handleSendConfiguredPrompt,
			onMessageCopied: t.handleMessageCopied,
			onNewChat: t.handleNewChat,
			onVoiceMessage: t.handleVoiceMessage,
			showVoiceInput: !0,
			activeView: t.activeView,
			onHistory: t.handleOpenHistory,
			onBackFromHistory: t.handleCloseHistory,
			chatSessions: t.chatSessions,
			onSelectSession: t.handleSelectSession,
			onLoadMoreSessions: t.handleLoadMoreSessions,
			hasMoreSessions: t.hasMoreSessions,
			loadingMoreSessions: t.loadingMoreSessions,
			hasMoreMessages: t.hasMoreMessages,
			loadingMore: t.loadingMore,
			onLoadMore: t.handleLoadMore,
			emptyStateText: t.emptyStateText,
			searchValue: t.searchValue,
			onSearchChange: t.handleSearchChange,
			onSearchClear: t.handleSearchClear,
			searchPlaceholder: t.searchPlaceholder,
			searchClearAriaLabel: t.searchClearAriaLabel,
			searchIcons: t.searchIcons,
			searchHighlightText: t.searchHighlightText,
			sessionGroupLabels: t.sessionGroupLabels,
			headerTooltips: t.headerTooltips,
			headerActionIcons: t.headerActionIcons,
			voiceLabels: t.voiceLabels,
			sendAriaLabel: t.sendAriaLabel,
			sendTooltip: t.sendTooltip,
			stopAriaLabel: t.stopAriaLabel,
			stopTooltip: t.stopTooltip,
			voiceMicAriaLabel: t.voiceMicAriaLabel,
			onStopResponse: t.handleStopResponse,
			inputDisabled: e.inputDisabled ?? !1,
			inputDisabledTooltip: k("@@sys_chat_disabled_input"),
			showFileUpload: t.fileUploadConfig.showFileUpload,
			fileAccept: t.fileUploadConfig.accept,
			fileMaxFiles: t.fileUploadConfig.maxFiles,
			fileMaxFilesSize: t.fileUploadConfig.maxFilesSize,
			fileInvalidTypeError: t.fileUploadConfig.invalidTypeError,
			fileCountExceededError: t.fileUploadConfig.countExceededError,
			fileSizeExceededError: t.fileUploadConfig.sizeExceededError,
			attachmentsUploadError: t.attachmentsUploadError,
			attachments: t.attachments,
			onAttachmentsChange: t.onAttachmentsChange,
			onAttachmentsMessage: t.handleAttachmentsMessage,
			attachmentsLabels: t.attachmentsLabels,
			downloadFile: t.downloadAttachment,
			messageActionsConfig: t.messageActionsConfig,
			messageTimeGroupLabels: t.messageTimeGroupLabels,
			locale: t.locale,
			feedbackTarget: t.feedbackTarget,
			onFeedbackChange: (e, n) => t.handleFeedbackChange(e, n, t.messages.find((t) => t.messageId === e && t.sender === "receiver")?.feedback ?? null),
			onFeedbackSubmit: t.handleFeedbackSubmit,
			onFeedbackRemove: t.handleFeedbackRemove,
			onFeedbackCancel: t.handleFeedbackCancel
		})
	}) }) : /* @__PURE__ */ M("div", {
		className: "flx-chat-renderer-loading",
		children: /* @__PURE__ */ M(mr, { visualType: "custom" })
	});
}, LC = (e, t) => {
	let [n, r] = pe([]);
	return de(() => {
		at(e, t).then(r);
	}, [e, t]), n;
};
//#endregion
//#region libs/sdk/react/src/lib/custom-component-runtime/CustomComponentTest.tsx
function RC({ customComponentInfo: e }) {
	let [t, n] = pe(0);
	return de(() => (Xt(), kt(e), n((e) => e + 1), () => {
		Xt();
	}), [e]), /* @__PURE__ */ M(KS, { config: Lt(e.componentDefinitions) }, t);
}
//#endregion
//#region libs/sdk/react/src/index.ts
var zC = /* @__PURE__ */ r({
	FlxChatRenderer: () => IC,
	FlxCustomComponentTest: () => RC,
	FlxProcessRenderer: () => eC,
	FlxProcessRendererPortal: () => tC,
	FlxTaskManager: () => ie,
	FlxTemplateRenderer: () => gC,
	FlxTemplateRendererPortal: () => _C,
	FlxUiFlowRenderer: () => mC,
	FlxUiFlowRendererPortal: () => hC,
	SseMessageType: () => Se,
	SseTaskEventType: () => Ce,
	SseTaskMessageType: () => we,
	TaskActions: () => Te,
	fetchBulkAssignees: () => Ge,
	fetchTaskAssignees: () => qe,
	fetchTaskComments: () => Je,
	fetchTaskHistory: () => Ye,
	fetchView: () => Xe,
	fetchViewTasks: () => Ze,
	getEnumeration: () => at,
	getEnumerationOptions: () => ot,
	getStaticAsset: () => dt,
	getSubstitutionTag: () => mt,
	getTaskManagerResources: () => ht,
	initSseConnection: () => Ot,
	removeComment: () => Kt,
	saveComment: () => tn,
	updateBulkTaskAction: () => vn,
	updateTaskAction: () => yn,
	updateTaskPriority: () => bn,
	useBoolExpression: () => ne,
	useComputedValue: () => ee,
	useDynamicValue: () => C,
	useEnumeration: () => LC
});
//#endregion
export { rC as A, bn as C, hC as D, gC as E, LS as F, eC as M, KS as N, mC as O, WS as P, yn as S, _C as T, ht as _, LC as a, tn as b, we as c, qe as d, Je as f, ot as g, Ze as h, mt as i, tC as j, iC as k, Te as l, Xe as m, at as n, Se as o, Ye as p, dt as r, Ce as s, RC as t, Ge as u, Ot as v, IC as w, vn as x, Kt as y };
